/* tslint:disable */
/* eslint-disable */
/**
 * Grieg - Lyric - Flattened
 * The Lyric variant of Grieg contains APIs for consumption by the front-end
 *
 * The version of the OpenAPI document: 2.20.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
import type { RequestArgs } from "./base";
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from "./base";

/**
 *
 * @export
 * @interface ActionResult
 */
export interface ActionResult {
  /**
   *
   * @type {boolean}
   * @memberof ActionResult
   */
  result: boolean;
  /**
   *
   * @type {string}
   * @memberof ActionResult
   */
  message?: string;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof ActionResult
   */
  metadata?: { [key: string]: any };
}
/**
 *
 * @export
 * @interface AdminTaskTypeListExternal
 */
export interface AdminTaskTypeListExternal {
  /**
   *
   * @type {Array<AdminTaskTypeListExternalTaskTypes>}
   * @memberof AdminTaskTypeListExternal
   */
  taskTypes?: Array<AdminTaskTypeListExternalTaskTypes>;
}
/**
 *
 * @export
 * @interface AdminTaskTypeListExternalTaskTypes
 */
export interface AdminTaskTypeListExternalTaskTypes {
  /**
   *
   * @type {string}
   * @memberof AdminTaskTypeListExternalTaskTypes
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof AdminTaskTypeListExternalTaskTypes
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof AdminTaskTypeListExternalTaskTypes
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof AdminTaskTypeListExternalTaskTypes
   */
  name?: string;
}
/**
 *
 * @export
 * @interface AdminTaskTypeReadExternal
 */
export interface AdminTaskTypeReadExternal {
  /**
   *
   * @type {string}
   * @memberof AdminTaskTypeReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof AdminTaskTypeReadExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof AdminTaskTypeReadExternal
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof AdminTaskTypeReadExternal
   */
  name?: string;
  /**
   *
   * @type {AdminTaskTypeReadExternalRestriction}
   * @memberof AdminTaskTypeReadExternal
   */
  restriction?: AdminTaskTypeReadExternalRestriction;
}
/**
 *
 * @export
 * @interface AdminTaskTypeReadExternalRestriction
 */
export interface AdminTaskTypeReadExternalRestriction {
  /**
   *
   * @type {boolean}
   * @memberof AdminTaskTypeReadExternalRestriction
   */
  restricted: boolean;
  /**
   * List of allowed teams (from relationships)
   * @type {Array<string>}
   * @memberof AdminTaskTypeReadExternalRestriction
   */
  allowedTeams?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof AdminTaskTypeReadExternalRestriction
   */
  requirePrimaryAssetRead?: boolean;
}
/**
 *
 * @export
 * @interface AdminTaskTypeUpdate
 */
export interface AdminTaskTypeUpdate {
  /**
   *
   * @type {AdminTaskTypeReadExternalRestriction}
   * @memberof AdminTaskTypeUpdate
   */
  restriction: AdminTaskTypeReadExternalRestriction;
}
/**
 *
 * @export
 * @interface AdminTaskTypeWriteExternal
 */
export interface AdminTaskTypeWriteExternal {
  /**
   *
   * @type {string}
   * @memberof AdminTaskTypeWriteExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof AdminTaskTypeWriteExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof AdminTaskTypeWriteExternal
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof AdminTaskTypeWriteExternal
   */
  name?: string;
}
/**
 *
 * @export
 * @interface AskAgentConfig
 */
export interface AskAgentConfig {
  /**
   *
   * @type {string}
   * @memberof AskAgentConfig
   */
  mode: AskAgentConfigModeEnum;
  /**
   *
   * @type {string}
   * @memberof AskAgentConfig
   */
  secondaryHost?: string;
  /**
   *
   * @type {string}
   * @memberof AskAgentConfig
   */
  accountSid?: string;
  /**
   *
   * @type {{ [key: string]: AskAgentConfigSettingsValue; }}
   * @memberof AskAgentConfig
   */
  settings?: { [key: string]: AskAgentConfigSettingsValue };
}

export const AskAgentConfigModeEnum = {
  Primary: "PRIMARY",
  Secondary: "SECONDARY",
} as const;

export type AskAgentConfigModeEnum = (typeof AskAgentConfigModeEnum)[keyof typeof AskAgentConfigModeEnum];

/**
 * @type AskAgentConfigSettingsValue
 * @export
 */
export type AskAgentConfigSettingsValue = object | string;

/**
 *
 * @export
 * @interface AssetChatDetails
 */
export interface AssetChatDetails {
  /**
   *
   * @type {string}
   * @memberof AssetChatDetails
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof AssetChatDetails
   */
  description?: string;
  /**
   *
   * @type {PrincipalChatDetailsConnectionDetails}
   * @memberof AssetChatDetails
   */
  connectionDetails?: PrincipalChatDetailsConnectionDetails;
  /**
   *
   * @type {Array<string>}
   * @memberof AssetChatDetails
   */
  availableLanguages?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof AssetChatDetails
   */
  conversationUrn?: string;
  /**
   *
   * @type {string}
   * @memberof AssetChatDetails
   */
  conversationTypeUrn?: string;
}
/**
 *
 * @export
 * @interface AssetCreate
 */
export interface AssetCreate {
  /**
   *
   * @type {string}
   * @memberof AssetCreate
   */
  assetTypeUid?: string;
  /**
   *
   * @type {string}
   * @memberof AssetCreate
   */
  title?: string;
  /**
   *
   * @type {boolean}
   * @memberof AssetCreate
   */
  active: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AssetCreate
   */
  primary?: boolean;
  /**
   *
   * @type {string}
   * @memberof AssetCreate
   */
  description?: string;
  /**
   *
   * @type {AssetDiscoverability}
   * @memberof AssetCreate
   */
  discoverability?: AssetDiscoverability;
  /**
   *
   * @type {boolean}
   * @memberof AssetCreate
   */
  inheritParentAccess?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AssetCreate
   */
  grantChildrenAccess?: boolean;
  /**
   *
   * @type {AssetSearchResultExternalLocation}
   * @memberof AssetCreate
   */
  location?: AssetSearchResultExternalLocation;
  /**
   *
   * @type {string}
   * @memberof AssetCreate
   */
  "3dTour"?: string;
  /**
   *
   * @type {string}
   * @memberof AssetCreate
   */
  serviceLevelUid?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof AssetCreate
   */
  enabledOptionalTaskTypeUids?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof AssetCreate
   */
  timezone?: string;
  /**
   *
   * @type {string}
   * @memberof AssetCreate
   */
  holidayCalendarUid?: string;
  /**
   *
   * @type {Array<AssetCreateTaskTypeSettings>}
   * @memberof AssetCreate
   */
  taskTypeSettings?: Array<AssetCreateTaskTypeSettings>;
  /**
   *
   * @type {AssetCreateOnSiteAssistant}
   * @memberof AssetCreate
   */
  onSiteAssistant?: AssetCreateOnSiteAssistant;
  /**
   *
   * @type {Array<AssetCreateQuickLinks>}
   * @memberof AssetCreate
   */
  quickLinks?: Array<AssetCreateQuickLinks>;
  /**
   *
   * @type {Array<AssetReadExternalOfferings>}
   * @memberof AssetCreate
   */
  offerings?: Array<AssetReadExternalOfferings>;
  /**
   *
   * @type {AssetTypeReadExternalDefaultInheritance}
   * @memberof AssetCreate
   */
  inheritance?: AssetTypeReadExternalDefaultInheritance;
  /**
   *
   * @type {Array<TaskTypeDisabledMessage>}
   * @memberof AssetCreate
   */
  disabledMessages?: Array<TaskTypeDisabledMessage>;
  /**
   *
   * @type {AssetCreateTokenRegistration}
   * @memberof AssetCreate
   */
  tokenRegistration?: AssetCreateTokenRegistration;
  /**
   *
   * @type {Array<AssetCreateRelationships>}
   * @memberof AssetCreate
   */
  relationships?: Array<AssetCreateRelationships>;
  /**
   *
   * @type {Array<AssetCreateMedia>}
   * @memberof AssetCreate
   */
  media?: Array<AssetCreateMedia>;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof AssetCreate
   */
  extendedMetadata?: { [key: string]: any };
  /**
   *
   * @type {TaskFullExternalLink}
   * @memberof AssetCreate
   */
  externalLink?: TaskFullExternalLink;
}

/**
 *
 * @export
 * @interface AssetCreateMedia
 */
export interface AssetCreateMedia {
  /**
   *
   * @type {FileRef}
   * @memberof AssetCreateMedia
   */
  file: FileRef;
  /**
   *
   * @type {string}
   * @memberof AssetCreateMedia
   */
  addedAt: string;
}
/**
 *
 * @export
 * @interface AssetCreateOnSiteAssistant
 */
export interface AssetCreateOnSiteAssistant {
  /**
   *
   * @type {boolean}
   * @memberof AssetCreateOnSiteAssistant
   */
  enabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof AssetCreateOnSiteAssistant
   */
  accessCode?: string;
  /**
   *
   * @type {string}
   * @memberof AssetCreateOnSiteAssistant
   */
  shortLinkUid?: string;
}
/**
 *
 * @export
 * @interface AssetCreateQuickLinks
 */
export interface AssetCreateQuickLinks {
  /**
   *
   * @type {string}
   * @memberof AssetCreateQuickLinks
   */
  title?: string;
  /**
   *
   * @type {FileRef}
   * @memberof AssetCreateQuickLinks
   */
  image?: FileRef;
  /**
   *
   * @type {AssetCreateQuickLinksQuickLinkAction}
   * @memberof AssetCreateQuickLinks
   */
  quickLinkAction?: AssetCreateQuickLinksQuickLinkAction;
}
/**
 * @type AssetCreateQuickLinksQuickLinkAction
 * @export
 */
export type AssetCreateQuickLinksQuickLinkAction =
  | AssetCreateQuickLinksQuickLinkActionOneOf
  | AssetReadExternalQuickLinksQuickLinkActionOneOf1;

/**
 *
 * @export
 * @interface AssetCreateQuickLinksQuickLinkActionOneOf
 */
export interface AssetCreateQuickLinksQuickLinkActionOneOf {
  /**
   *
   * @type {string}
   * @memberof AssetCreateQuickLinksQuickLinkActionOneOf
   */
  taskTypeUid?: string;
}
/**
 *
 * @export
 * @interface AssetCreateRelationships
 */
export interface AssetCreateRelationships {
  /**
   *
   * @type {RelationshipLabel}
   * @memberof AssetCreateRelationships
   */
  relationshipLabel: RelationshipLabel;
  /**
   *
   * @type {string}
   * @memberof AssetCreateRelationships
   */
  bParty: string;
}

/**
 *
 * @export
 * @interface AssetCreateTaskTypeSettings
 */
export interface AssetCreateTaskTypeSettings {
  /**
   *
   * @type {string}
   * @memberof AssetCreateTaskTypeSettings
   */
  taskTypeUid: string;
  /**
   *
   * @type {string}
   * @memberof AssetCreateTaskTypeSettings
   */
  autoAssignUserUid?: string;
  /**
   *
   * @type {string}
   * @memberof AssetCreateTaskTypeSettings
   */
  autoAssignTeamUid?: string;
  /**
   *
   * @type {boolean}
   * @memberof AssetCreateTaskTypeSettings
   */
  holidayCalendarApplies?: boolean;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof AssetCreateTaskTypeSettings
   */
  outOfHoursMessage?: { [key: string]: string };
  /**
   *
   * @type {Array<AssetServiceHours>}
   * @memberof AssetCreateTaskTypeSettings
   */
  serviceHours?: Array<AssetServiceHours>;
}
/**
 *
 * @export
 * @interface AssetCreateTokenRegistration
 */
export interface AssetCreateTokenRegistration {
  /**
   *
   * @type {boolean}
   * @memberof AssetCreateTokenRegistration
   */
  enabled: boolean;
  /**
   *
   * @type {string}
   * @memberof AssetCreateTokenRegistration
   */
  token?: string;
  /**
   *
   * @type {string}
   * @memberof AssetCreateTokenRegistration
   */
  shortLinkUid?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof AssetCreateTokenRegistration
   */
  autoLinkOrgUids?: Array<string>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const AssetDiscoverability = {
  Public: "PUBLIC",
  Open: "OPEN",
  Restricted: "RESTRICTED",
  Private: "PRIVATE",
} as const;

export type AssetDiscoverability = (typeof AssetDiscoverability)[keyof typeof AssetDiscoverability];

/**
 *
 * @export
 * @interface AssetExportCreate
 */
export interface AssetExportCreate {
  /**
   *
   * @type {string}
   * @memberof AssetExportCreate
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof AssetExportCreate
   */
  timezone: string;
  /**
   *
   * @type {string}
   * @memberof AssetExportCreate
   */
  freeText?: string;
  /**
   *
   * @type {string}
   * @memberof AssetExportCreate
   */
  format: AssetExportCreateFormatEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof AssetExportCreate
   */
  fields?: Array<AssetExportCreateFieldsEnum>;
  /**
   *
   * @type {SearchAssetFilter}
   * @memberof AssetExportCreate
   */
  filter?: SearchAssetFilter;
  /**
   *
   * @type {SearchAssetSort}
   * @memberof AssetExportCreate
   */
  sort?: SearchAssetSort;
}

export const AssetExportCreateFormatEnum = {
  Standard: "STANDARD",
  ExcelCompatible: "EXCEL_COMPATIBLE",
} as const;

export type AssetExportCreateFormatEnum =
  (typeof AssetExportCreateFormatEnum)[keyof typeof AssetExportCreateFormatEnum];
export const AssetExportCreateFieldsEnum = {
  AssetDetails: "ASSET_DETAILS",
  AssetSettings: "ASSET_SETTINGS",
  RegistrationToken: "REGISTRATION_TOKEN",
  OnsiteAssistant: "ONSITE_ASSISTANT",
} as const;

export type AssetExportCreateFieldsEnum =
  (typeof AssetExportCreateFieldsEnum)[keyof typeof AssetExportCreateFieldsEnum];

/**
 *
 * @export
 * @interface AssetExportReadExternal
 */
export interface AssetExportReadExternal {
  /**
   *
   * @type {string}
   * @memberof AssetExportReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof AssetExportReadExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof AssetExportReadExternal
   */
  name: string;
  /**
   * Language code including locale
   * @type {string}
   * @memberof AssetExportReadExternal
   */
  languageCode: string;
  /**
   *
   * @type {string}
   * @memberof AssetExportReadExternal
   */
  timezone: string;
  /**
   *
   * @type {number}
   * @memberof AssetExportReadExternal
   */
  resultCount?: number;
  /**
   *
   * @type {TaskExportReadExternalProgress}
   * @memberof AssetExportReadExternal
   */
  progress: TaskExportReadExternalProgress;
  /**
   *
   * @type {string}
   * @memberof AssetExportReadExternal
   */
  requestedAt: string;
  /**
   *
   * @type {string}
   * @memberof AssetExportReadExternal
   */
  freeText?: string;
  /**
   *
   * @type {string}
   * @memberof AssetExportReadExternal
   */
  format: AssetExportReadExternalFormatEnum;
  /**
   *
   * @type {UserRefHydrated}
   * @memberof AssetExportReadExternal
   */
  createdBy: UserRefHydrated;
  /**
   *
   * @type {string}
   * @memberof AssetExportReadExternal
   */
  type: AssetExportReadExternalTypeEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof AssetExportReadExternal
   */
  fields: Array<AssetExportReadExternalFieldsEnum>;
  /**
   *
   * @type {SearchAssetFilter}
   * @memberof AssetExportReadExternal
   */
  filter: SearchAssetFilter;
  /**
   *
   * @type {SearchAssetSort}
   * @memberof AssetExportReadExternal
   */
  sort: SearchAssetSort;
}

export const AssetExportReadExternalFormatEnum = {
  Standard: "STANDARD",
  ExcelCompatible: "EXCEL_COMPATIBLE",
} as const;

export type AssetExportReadExternalFormatEnum =
  (typeof AssetExportReadExternalFormatEnum)[keyof typeof AssetExportReadExternalFormatEnum];
export const AssetExportReadExternalTypeEnum = {
  Asset: "ASSET",
} as const;

export type AssetExportReadExternalTypeEnum =
  (typeof AssetExportReadExternalTypeEnum)[keyof typeof AssetExportReadExternalTypeEnum];
export const AssetExportReadExternalFieldsEnum = {
  AssetDetails: "ASSET_DETAILS",
  AssetSettings: "ASSET_SETTINGS",
  RegistrationToken: "REGISTRATION_TOKEN",
  OnsiteAssistant: "ONSITE_ASSISTANT",
} as const;

export type AssetExportReadExternalFieldsEnum =
  (typeof AssetExportReadExternalFieldsEnum)[keyof typeof AssetExportReadExternalFieldsEnum];

/**
 *
 * @export
 * @interface AssetFilterValuesExternal
 */
export interface AssetFilterValuesExternal {
  /**
   *
   * @type {Array<ExtendedMetadataAttributeFilterSummaryExternal>}
   * @memberof AssetFilterValuesExternal
   */
  extendedMetadata?: Array<ExtendedMetadataAttributeFilterSummaryExternal>;
}
/**
 *
 * @export
 * @interface AssetNoteCreate
 */
export interface AssetNoteCreate {
  /**
   *
   * @type {string}
   * @memberof AssetNoteCreate
   */
  uid?: string;
  /**
   *
   * @type {string}
   * @memberof AssetNoteCreate
   */
  body: string;
  /**
   *
   * @type {boolean}
   * @memberof AssetNoteCreate
   */
  pinned?: boolean;
  /**
   *
   * @type {string}
   * @memberof AssetNoteCreate
   */
  assetUid: string;
}
/**
 *
 * @export
 * @interface AssetNoteUpdate
 */
export interface AssetNoteUpdate {
  /**
   *
   * @type {string}
   * @memberof AssetNoteUpdate
   */
  body?: string;
  /**
   *
   * @type {boolean}
   * @memberof AssetNoteUpdate
   */
  pinned?: boolean;
  /**
   *
   * @type {string}
   * @memberof AssetNoteUpdate
   */
  assetUid: string;
}
/**
 *
 * @export
 * @interface AssetNoteWriteResponse
 */
export interface AssetNoteWriteResponse {
  /**
   *
   * @type {string}
   * @memberof AssetNoteWriteResponse
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof AssetNoteWriteResponse
   */
  body: string;
  /**
   *
   * @type {boolean}
   * @memberof AssetNoteWriteResponse
   */
  pinned?: boolean;
}
/**
 *
 * @export
 * @interface AssetReadExternal
 */
export interface AssetReadExternal {
  /**
   *
   * @type {string}
   * @memberof AssetReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof AssetReadExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof AssetReadExternal
   */
  assetRef?: string;
  /**
   *
   * @type {string}
   * @memberof AssetReadExternal
   */
  assetTypeUid: string;
  /**
   *
   * @type {boolean}
   * @memberof AssetReadExternal
   */
  primary?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AssetReadExternal
   */
  active: boolean;
  /**
   *
   * @type {AssetDiscoverability}
   * @memberof AssetReadExternal
   */
  discoverability?: AssetDiscoverability;
  /**
   *
   * @type {boolean}
   * @memberof AssetReadExternal
   */
  inheritParentAccess?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AssetReadExternal
   */
  grantChildrenAccess?: boolean;
  /**
   *
   * @type {string}
   * @memberof AssetReadExternal
   */
  timezone?: string;
  /**
   *
   * @type {string}
   * @memberof AssetReadExternal
   */
  holidayCalendarUid?: string;
  /**
   *
   * @type {string}
   * @memberof AssetReadExternal
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof AssetReadExternal
   */
  description?: string;
  /**
   *
   * @type {AssetSearchResultExternalLocation}
   * @memberof AssetReadExternal
   */
  location?: AssetSearchResultExternalLocation;
  /**
   *
   * @type {string}
   * @memberof AssetReadExternal
   */
  "3dTour"?: string;
  /**
   *
   * @type {Array<AssetReadExternalOfferings>}
   * @memberof AssetReadExternal
   */
  offerings?: Array<AssetReadExternalOfferings>;
  /**
   *
   * @type {Array<TaskTypeDisabledMessage>}
   * @memberof AssetReadExternal
   */
  disabledMessages?: Array<TaskTypeDisabledMessage>;
  /**
   *
   * @type {Array<AssetReadExternalAssetNotes>}
   * @memberof AssetReadExternal
   */
  assetNotes?: Array<AssetReadExternalAssetNotes>;
  /**
   *
   * @type {AssetReadExternalOnSiteAssistant}
   * @memberof AssetReadExternal
   */
  onSiteAssistant?: AssetReadExternalOnSiteAssistant;
  /**
   *
   * @type {Array<AssetSummaryExternal>}
   * @memberof AssetReadExternal
   */
  ancestors?: Array<AssetSummaryExternal>;
  /**
   *
   * @type {Array<AssetReadExternalQuickLinks>}
   * @memberof AssetReadExternal
   */
  quickLinks?: Array<AssetReadExternalQuickLinks>;
  /**
   *
   * @type {Array<AssetReadExternalAllowedTaskTypes>}
   * @memberof AssetReadExternal
   */
  allowedTaskTypes?: Array<AssetReadExternalAllowedTaskTypes>;
  /**
   *
   * @type {AssetReadExternalTokenRegistration}
   * @memberof AssetReadExternal
   */
  tokenRegistration?: AssetReadExternalTokenRegistration;
  /**
   *
   * @type {AssetReadExternalServiceLevel}
   * @memberof AssetReadExternal
   */
  serviceLevel?: AssetReadExternalServiceLevel;
  /**
   *
   * @type {AssetReadExternalInheritance}
   * @memberof AssetReadExternal
   */
  inheritance?: AssetReadExternalInheritance;
  /**
   *
   * @type {Array<AssetSummaryExternalMedia>}
   * @memberof AssetReadExternal
   */
  media?: Array<AssetSummaryExternalMedia>;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof AssetReadExternal
   */
  extendedMetadata?: { [key: string]: any };
  /**
   *
   * @type {Array<TaskFullLinkedTeams>}
   * @memberof AssetReadExternal
   */
  linkedTeams?: Array<TaskFullLinkedTeams>;
  /**
   *
   * @type {Array<TaskFullLinkedTags>}
   * @memberof AssetReadExternal
   */
  linkedTags?: Array<TaskFullLinkedTags>;
  /**
   *
   * @type {Array<TaskFullLinkedAssets>}
   * @memberof AssetReadExternal
   */
  linkedAssets?: Array<TaskFullLinkedAssets>;
  /**
   *
   * @type {Array<TaskFullLinkedOrgs>}
   * @memberof AssetReadExternal
   */
  linkedOrgs?: Array<TaskFullLinkedOrgs>;
  /**
   *
   * @type {Array<TaskFullLinkedUsers>}
   * @memberof AssetReadExternal
   */
  linkedUsers?: Array<TaskFullLinkedUsers>;
  /**
   *
   * @type {ChangeSummary}
   * @memberof AssetReadExternal
   */
  changeSummary?: ChangeSummary;
  /**
   *
   * @type {TaskFullExternalLink}
   * @memberof AssetReadExternal
   */
  externalLink?: TaskFullExternalLink;
}

/**
 *
 * @export
 * @interface AssetReadExternalAllowedTaskTypes
 */
export interface AssetReadExternalAllowedTaskTypes {
  /**
   *
   * @type {TaskTypeSummaryExternal}
   * @memberof AssetReadExternalAllowedTaskTypes
   */
  taskType?: TaskTypeSummaryExternal;
  /**
   *
   * @type {boolean}
   * @memberof AssetReadExternalAllowedTaskTypes
   */
  default?: boolean;
  /**
   *
   * @type {AssetReadExternalTaskTypeSettings}
   * @memberof AssetReadExternalAllowedTaskTypes
   */
  taskTypeSettings?: AssetReadExternalTaskTypeSettings;
}
/**
 *
 * @export
 * @interface AssetReadExternalAssetNotes
 */
export interface AssetReadExternalAssetNotes {
  /**
   *
   * @type {string}
   * @memberof AssetReadExternalAssetNotes
   */
  uid?: string;
  /**
   *
   * @type {string}
   * @memberof AssetReadExternalAssetNotes
   */
  assetUid: string;
  /**
   *
   * @type {string}
   * @memberof AssetReadExternalAssetNotes
   */
  body: string;
  /**
   *
   * @type {boolean}
   * @memberof AssetReadExternalAssetNotes
   */
  pinned?: boolean;
  /**
   *
   * @type {UserSummaryExternal}
   * @memberof AssetReadExternalAssetNotes
   */
  author?: UserSummaryExternal;
  /**
   *
   * @type {ChangeSummary}
   * @memberof AssetReadExternalAssetNotes
   */
  changeSummary?: ChangeSummary;
}
/**
 *
 * @export
 * @interface AssetReadExternalInheritance
 */
export interface AssetReadExternalInheritance {
  /**
   *
   * @type {AssetReadExternalInheritanceSections}
   * @memberof AssetReadExternalInheritance
   */
  sections?: AssetReadExternalInheritanceSections;
  /**
   *
   * @type {{ [key: string]: AssetReadExternalInheritanceSectionsAllowedTaskTypes; }}
   * @memberof AssetReadExternalInheritance
   */
  extendedMetadataGroups?: { [key: string]: AssetReadExternalInheritanceSectionsAllowedTaskTypes };
}
/**
 *
 * @export
 * @interface AssetReadExternalInheritanceSections
 */
export interface AssetReadExternalInheritanceSections {
  /**
   *
   * @type {AssetReadExternalInheritanceSectionsAllowedTaskTypes}
   * @memberof AssetReadExternalInheritanceSections
   */
  allowedTaskTypes?: AssetReadExternalInheritanceSectionsAllowedTaskTypes;
  /**
   *
   * @type {AssetReadExternalInheritanceSectionsAllowedTaskTypes}
   * @memberof AssetReadExternalInheritanceSections
   */
  location?: AssetReadExternalInheritanceSectionsAllowedTaskTypes;
  /**
   *
   * @type {AssetReadExternalInheritanceSectionsAllowedTaskTypes}
   * @memberof AssetReadExternalInheritanceSections
   */
  offerings?: AssetReadExternalInheritanceSectionsAllowedTaskTypes;
  /**
   *
   * @type {AssetReadExternalInheritanceSectionsAllowedTaskTypes}
   * @memberof AssetReadExternalInheritanceSections
   */
  serviceLevel?: AssetReadExternalInheritanceSectionsAllowedTaskTypes;
  /**
   *
   * @type {AssetReadExternalInheritanceSectionsAllowedTaskTypes}
   * @memberof AssetReadExternalInheritanceSections
   */
  quickLinks?: AssetReadExternalInheritanceSectionsAllowedTaskTypes;
}
/**
 *
 * @export
 * @interface AssetReadExternalInheritanceSectionsAllowedTaskTypes
 */
export interface AssetReadExternalInheritanceSectionsAllowedTaskTypes {
  /**
   *
   * @type {string}
   * @memberof AssetReadExternalInheritanceSectionsAllowedTaskTypes
   */
  sourceAssetUid: string;
}
/**
 *
 * @export
 * @interface AssetReadExternalOfferings
 */
export interface AssetReadExternalOfferings {
  /**
   *
   * @type {string}
   * @memberof AssetReadExternalOfferings
   */
  offeringUid: string;
  /**
   *
   * @type {string}
   * @memberof AssetReadExternalOfferings
   */
  productCatalogueUid: string;
}
/**
 *
 * @export
 * @interface AssetReadExternalOnSiteAssistant
 */
export interface AssetReadExternalOnSiteAssistant {
  /**
   *
   * @type {boolean}
   * @memberof AssetReadExternalOnSiteAssistant
   */
  enabled?: boolean;
  /**
   *
   * @type {ShortLinkExpanded}
   * @memberof AssetReadExternalOnSiteAssistant
   */
  shortLink?: ShortLinkExpanded;
}
/**
 *
 * @export
 * @interface AssetReadExternalQuickLinks
 */
export interface AssetReadExternalQuickLinks {
  /**
   *
   * @type {string}
   * @memberof AssetReadExternalQuickLinks
   */
  title?: string;
  /**
   *
   * @type {FilePath}
   * @memberof AssetReadExternalQuickLinks
   */
  image?: FilePath;
  /**
   *
   * @type {AssetReadExternalQuickLinksQuickLinkAction}
   * @memberof AssetReadExternalQuickLinks
   */
  quickLinkAction?: AssetReadExternalQuickLinksQuickLinkAction;
}
/**
 * @type AssetReadExternalQuickLinksQuickLinkAction
 * @export
 */
export type AssetReadExternalQuickLinksQuickLinkAction =
  | AssetReadExternalQuickLinksQuickLinkActionOneOf
  | AssetReadExternalQuickLinksQuickLinkActionOneOf1;

/**
 *
 * @export
 * @interface AssetReadExternalQuickLinksQuickLinkActionOneOf
 */
export interface AssetReadExternalQuickLinksQuickLinkActionOneOf {
  /**
   *
   * @type {TaskTypeSummaryExternal}
   * @memberof AssetReadExternalQuickLinksQuickLinkActionOneOf
   */
  taskType?: TaskTypeSummaryExternal;
}
/**
 *
 * @export
 * @interface AssetReadExternalQuickLinksQuickLinkActionOneOf1
 */
export interface AssetReadExternalQuickLinksQuickLinkActionOneOf1 {
  /**
   *
   * @type {string}
   * @memberof AssetReadExternalQuickLinksQuickLinkActionOneOf1
   */
  externalUrl?: string;
}
/**
 *
 * @export
 * @interface AssetReadExternalServiceLevel
 */
export interface AssetReadExternalServiceLevel {
  /**
   *
   * @type {string}
   * @memberof AssetReadExternalServiceLevel
   */
  uid?: string;
  /**
   *
   * @type {string}
   * @memberof AssetReadExternalServiceLevel
   */
  name?: string;
}
/**
 *
 * @export
 * @interface AssetReadExternalTaskTypeSettings
 */
export interface AssetReadExternalTaskTypeSettings {
  /**
   *
   * @type {UserSummaryExternal}
   * @memberof AssetReadExternalTaskTypeSettings
   */
  autoAssignUser?: UserSummaryExternal;
  /**
   *
   * @type {TeamSummary}
   * @memberof AssetReadExternalTaskTypeSettings
   */
  autoAssignTeam?: TeamSummary;
  /**
   *
   * @type {boolean}
   * @memberof AssetReadExternalTaskTypeSettings
   */
  holidayCalendarApplies?: boolean;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof AssetReadExternalTaskTypeSettings
   */
  outOfHoursMessage?: { [key: string]: string };
  /**
   *
   * @type {Array<AssetServiceHours>}
   * @memberof AssetReadExternalTaskTypeSettings
   */
  serviceHours?: Array<AssetServiceHours>;
}
/**
 *
 * @export
 * @interface AssetReadExternalTokenRegistration
 */
export interface AssetReadExternalTokenRegistration {
  /**
   *
   * @type {boolean}
   * @memberof AssetReadExternalTokenRegistration
   */
  enabled: boolean;
  /**
   *
   * @type {string}
   * @memberof AssetReadExternalTokenRegistration
   */
  token?: string;
  /**
   *
   * @type {ShortLinkExpanded}
   * @memberof AssetReadExternalTokenRegistration
   */
  shortLink?: ShortLinkExpanded;
  /**
   *
   * @type {Array<OrgSummaryExternal>}
   * @memberof AssetReadExternalTokenRegistration
   */
  autoLinkOrgs?: Array<OrgSummaryExternal>;
}
/**
 *
 * @export
 * @interface AssetRefHydrated
 */
export interface AssetRefHydrated {
  /**
   *
   * @type {string}
   * @memberof AssetRefHydrated
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof AssetRefHydrated
   */
  urn: string;
  /**
   *
   * @type {boolean}
   * @memberof AssetRefHydrated
   */
  primary?: boolean;
  /**
   *
   * @type {string}
   * @memberof AssetRefHydrated
   */
  assetRef?: string;
  /**
   *
   * @type {string}
   * @memberof AssetRefHydrated
   */
  assetTypeUid: string;
  /**
   *
   * @type {string}
   * @memberof AssetRefHydrated
   */
  title: string;
  /**
   *
   * @type {Array<AssetSummaryExternalMedia>}
   * @memberof AssetRefHydrated
   */
  media?: Array<AssetSummaryExternalMedia>;
  /**
   *
   * @type {AssetSummaryExternalIcon}
   * @memberof AssetRefHydrated
   */
  icon?: AssetSummaryExternalIcon;
}
/**
 *
 * @export
 * @interface AssetSearchResultExternal
 */
export interface AssetSearchResultExternal {
  /**
   *
   * @type {string}
   * @memberof AssetSearchResultExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof AssetSearchResultExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof AssetSearchResultExternal
   */
  assetRef?: string;
  /**
   *
   * @type {string}
   * @memberof AssetSearchResultExternal
   */
  title: string;
  /**
   *
   * @type {AssetSearchResultExternalLocation}
   * @memberof AssetSearchResultExternal
   */
  location?: AssetSearchResultExternalLocation;
  /**
   *
   * @type {boolean}
   * @memberof AssetSearchResultExternal
   */
  primary?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AssetSearchResultExternal
   */
  active: boolean;
  /**
   *
   * @type {AssetTypeSummaryExternal}
   * @memberof AssetSearchResultExternal
   */
  assetType?: AssetTypeSummaryExternal;
  /**
   *
   * @type {Array<AssetSummaryExternalMedia>}
   * @memberof AssetSearchResultExternal
   */
  media?: Array<AssetSummaryExternalMedia>;
  /**
   * Distance from the search point
   * @type {number}
   * @memberof AssetSearchResultExternal
   */
  distanceFromPoint?: number;
  /**
   *
   * @type {Array<AssetSummaryExternal>}
   * @memberof AssetSearchResultExternal
   */
  ancestors?: Array<AssetSummaryExternal>;
}
/**
 *
 * @export
 * @interface AssetSearchResultExternalLocation
 */
export interface AssetSearchResultExternalLocation {
  /**
   *
   * @type {string}
   * @memberof AssetSearchResultExternalLocation
   */
  streetAddress?: string;
  /**
   *
   * @type {string}
   * @memberof AssetSearchResultExternalLocation
   */
  locality?: string;
  /**
   *
   * @type {string}
   * @memberof AssetSearchResultExternalLocation
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof AssetSearchResultExternalLocation
   */
  province?: string;
  /**
   *
   * @type {string}
   * @memberof AssetSearchResultExternalLocation
   */
  postalCode?: string;
  /**
   *
   * @type {string}
   * @memberof AssetSearchResultExternalLocation
   */
  country?: string;
  /**
   *
   * @type {number}
   * @memberof AssetSearchResultExternalLocation
   */
  latitude?: number;
  /**
   *
   * @type {number}
   * @memberof AssetSearchResultExternalLocation
   */
  longitude?: number;
}
/**
 *
 * @export
 * @interface AssetServiceHours
 */
export interface AssetServiceHours {
  /**
   *
   * @type {Array<DayOfWeekAndHolidays>}
   * @memberof AssetServiceHours
   */
  days: Array<DayOfWeekAndHolidays>;
  /**
   *
   * @type {string}
   * @memberof AssetServiceHours
   */
  fromTime: string;
  /**
   *
   * @type {string}
   * @memberof AssetServiceHours
   */
  toTime: string;
}
/**
 *
 * @export
 * @interface AssetSummaryAncestralExternal
 */
export interface AssetSummaryAncestralExternal {
  /**
   *
   * @type {string}
   * @memberof AssetSummaryAncestralExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof AssetSummaryAncestralExternal
   */
  urn: string;
  /**
   *
   * @type {boolean}
   * @memberof AssetSummaryAncestralExternal
   */
  primary?: boolean;
  /**
   *
   * @type {string}
   * @memberof AssetSummaryAncestralExternal
   */
  assetRef?: string;
  /**
   *
   * @type {string}
   * @memberof AssetSummaryAncestralExternal
   */
  assetTypeUid: string;
  /**
   *
   * @type {string}
   * @memberof AssetSummaryAncestralExternal
   */
  title: string;
  /**
   *
   * @type {Array<AssetSummaryExternalMedia>}
   * @memberof AssetSummaryAncestralExternal
   */
  media?: Array<AssetSummaryExternalMedia>;
  /**
   *
   * @type {AssetSummaryExternalIcon}
   * @memberof AssetSummaryAncestralExternal
   */
  icon?: AssetSummaryExternalIcon;
  /**
   *
   * @type {Array<AssetSummaryExternal>}
   * @memberof AssetSummaryAncestralExternal
   */
  ancestors?: Array<AssetSummaryExternal>;
}
/**
 *
 * @export
 * @interface AssetSummaryExternal
 */
export interface AssetSummaryExternal {
  /**
   *
   * @type {string}
   * @memberof AssetSummaryExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof AssetSummaryExternal
   */
  urn: string;
  /**
   *
   * @type {boolean}
   * @memberof AssetSummaryExternal
   */
  primary?: boolean;
  /**
   *
   * @type {string}
   * @memberof AssetSummaryExternal
   */
  assetRef?: string;
  /**
   *
   * @type {string}
   * @memberof AssetSummaryExternal
   */
  assetTypeUid: string;
  /**
   *
   * @type {string}
   * @memberof AssetSummaryExternal
   */
  title: string;
  /**
   *
   * @type {Array<AssetSummaryExternalMedia>}
   * @memberof AssetSummaryExternal
   */
  media?: Array<AssetSummaryExternalMedia>;
  /**
   *
   * @type {AssetSummaryExternalIcon}
   * @memberof AssetSummaryExternal
   */
  icon?: AssetSummaryExternalIcon;
}
/**
 *
 * @export
 * @interface AssetSummaryExternalIcon
 */
export interface AssetSummaryExternalIcon {
  /**
   *
   * @type {string}
   * @memberof AssetSummaryExternalIcon
   */
  iconPath?: string;
  /**
   *
   * @type {string}
   * @memberof AssetSummaryExternalIcon
   */
  iconColourMask?: string;
}
/**
 *
 * @export
 * @interface AssetSummaryExternalMedia
 */
export interface AssetSummaryExternalMedia {
  /**
   *
   * @type {FilePath}
   * @memberof AssetSummaryExternalMedia
   */
  file: FilePath;
  /**
   *
   * @type {string}
   * @memberof AssetSummaryExternalMedia
   */
  addedAt: string;
}
/**
 *
 * @export
 * @interface AssetTypeListExternal
 */
export interface AssetTypeListExternal {
  /**
   *
   * @type {Array<AssetTypeListExternalAssetTypes>}
   * @memberof AssetTypeListExternal
   */
  assetTypes?: Array<AssetTypeListExternalAssetTypes>;
}
/**
 *
 * @export
 * @interface AssetTypeListExternalAssetTypes
 */
export interface AssetTypeListExternalAssetTypes {
  /**
   *
   * @type {string}
   * @memberof AssetTypeListExternalAssetTypes
   */
  uid?: string;
  /**
   *
   * @type {string}
   * @memberof AssetTypeListExternalAssetTypes
   */
  urn?: string;
  /**
   *
   * @type {AssetSummaryExternalIcon}
   * @memberof AssetTypeListExternalAssetTypes
   */
  icon?: AssetSummaryExternalIcon;
  /**
   *
   * @type {string}
   * @memberof AssetTypeListExternalAssetTypes
   */
  displayName?: string;
}
/**
 *
 * @export
 * @interface AssetTypeReadExternal
 */
export interface AssetTypeReadExternal {
  /**
   *
   * @type {string}
   * @memberof AssetTypeReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof AssetTypeReadExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof AssetTypeReadExternal
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof AssetTypeReadExternal
   */
  name: string;
  /**
   *
   * @type {boolean}
   * @memberof AssetTypeReadExternal
   */
  active: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AssetTypeReadExternal
   */
  defaultPrimary?: boolean;
  /**
   *
   * @type {AssetDiscoverability}
   * @memberof AssetTypeReadExternal
   */
  defaultDiscoverability: AssetDiscoverability;
  /**
   *
   * @type {boolean}
   * @memberof AssetTypeReadExternal
   */
  defaultInheritParentAccess: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AssetTypeReadExternal
   */
  defaultGrantChildrenAccess: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof AssetTypeReadExternal
   */
  allowedOfferings?: Array<string>;
  /**
   *
   * @type {DefaultAssetView}
   * @memberof AssetTypeReadExternal
   */
  defaultView?: DefaultAssetView;
  /**
   *
   * @type {AssetTypeReadExternalDefaultInheritance}
   * @memberof AssetTypeReadExternal
   */
  defaultInheritance?: AssetTypeReadExternalDefaultInheritance;
  /**
   *
   * @type {Array<AssetTypeSummaryExternal>}
   * @memberof AssetTypeReadExternal
   */
  allowedChildAssetTypes?: Array<AssetTypeSummaryExternal>;
  /**
   *
   * @type {Array<AssetTypeSummaryExternal>}
   * @memberof AssetTypeReadExternal
   */
  allowedParentAssetTypes?: Array<AssetTypeSummaryExternal>;
  /**
   *
   * @type {Array<AssetTypeReadExternalAllowedTaskTypes>}
   * @memberof AssetTypeReadExternal
   */
  allowedTaskTypes?: Array<AssetTypeReadExternalAllowedTaskTypes>;
  /**
   *
   * @type {Array<AssetTypeReadExternalExtMetadataConfig>}
   * @memberof AssetTypeReadExternal
   */
  extMetadataConfig?: Array<AssetTypeReadExternalExtMetadataConfig>;
  /**
   *
   * @type {string}
   * @memberof AssetTypeReadExternal
   */
  displayName?: string;
  /**
   *
   * @type {AssetSummaryExternalIcon}
   * @memberof AssetTypeReadExternal
   */
  icon?: AssetSummaryExternalIcon;
}

/**
 *
 * @export
 * @interface AssetTypeReadExternalAllowedTaskTypes
 */
export interface AssetTypeReadExternalAllowedTaskTypes {
  [key: string]: any;

  /**
   *
   * @type {TaskTypeSummaryExternal}
   * @memberof AssetTypeReadExternalAllowedTaskTypes
   */
  taskType?: TaskTypeSummaryExternal;
  /**
   *
   * @type {boolean}
   * @memberof AssetTypeReadExternalAllowedTaskTypes
   */
  default?: boolean;
}
/**
 *
 * @export
 * @interface AssetTypeReadExternalDefaultInheritance
 */
export interface AssetTypeReadExternalDefaultInheritance {
  /**
   *
   * @type {Array<InheritanceSections>}
   * @memberof AssetTypeReadExternalDefaultInheritance
   */
  sections?: Array<InheritanceSections>;
  /**
   * JSON element name of an extended metadata group
   * @type {Array<string>}
   * @memberof AssetTypeReadExternalDefaultInheritance
   */
  extendedMetadataGroups?: Array<string>;
}
/**
 *
 * @export
 * @interface AssetTypeReadExternalExtMetadataConfig
 */
export interface AssetTypeReadExternalExtMetadataConfig {
  /**
   *
   * @type {ExtendedMetadataConfigReadExternal}
   * @memberof AssetTypeReadExternalExtMetadataConfig
   */
  extMetadataGroupConfig?: ExtendedMetadataConfigReadExternal;
}
/**
 *
 * @export
 * @interface AssetTypeSummaryExternal
 */
export interface AssetTypeSummaryExternal {
  /**
   *
   * @type {string}
   * @memberof AssetTypeSummaryExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof AssetTypeSummaryExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof AssetTypeSummaryExternal
   */
  displayName: string;
  /**
   *
   * @type {AssetSummaryExternalIcon}
   * @memberof AssetTypeSummaryExternal
   */
  icon?: AssetSummaryExternalIcon;
}
/**
 *
 * @export
 * @interface AssetUpdate
 */
export interface AssetUpdate {
  /**
   *
   * @type {string}
   * @memberof AssetUpdate
   */
  title?: string;
  /**
   *
   * @type {boolean}
   * @memberof AssetUpdate
   */
  active?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AssetUpdate
   */
  primary?: boolean;
  /**
   *
   * @type {string}
   * @memberof AssetUpdate
   */
  description?: string;
  /**
   *
   * @type {AssetDiscoverability}
   * @memberof AssetUpdate
   */
  discoverability?: AssetDiscoverability;
  /**
   *
   * @type {boolean}
   * @memberof AssetUpdate
   */
  inheritParentAccess?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AssetUpdate
   */
  grantChildrenAccess?: boolean;
  /**
   *
   * @type {AssetSearchResultExternalLocation}
   * @memberof AssetUpdate
   */
  location?: AssetSearchResultExternalLocation;
  /**
   *
   * @type {string}
   * @memberof AssetUpdate
   */
  "3dTour"?: string;
  /**
   *
   * @type {string}
   * @memberof AssetUpdate
   */
  serviceLevelUid?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof AssetUpdate
   */
  enabledOptionalTaskTypeUids?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof AssetUpdate
   */
  timezone?: string;
  /**
   *
   * @type {string}
   * @memberof AssetUpdate
   */
  holidayCalendarUid?: string;
  /**
   *
   * @type {Array<AssetCreateTaskTypeSettings>}
   * @memberof AssetUpdate
   */
  taskTypeSettings?: Array<AssetCreateTaskTypeSettings>;
  /**
   *
   * @type {AssetCreateOnSiteAssistant}
   * @memberof AssetUpdate
   */
  onSiteAssistant?: AssetCreateOnSiteAssistant;
  /**
   *
   * @type {Array<AssetCreateQuickLinks>}
   * @memberof AssetUpdate
   */
  quickLinks?: Array<AssetCreateQuickLinks>;
  /**
   *
   * @type {Array<AssetReadExternalOfferings>}
   * @memberof AssetUpdate
   */
  offerings?: Array<AssetReadExternalOfferings>;
  /**
   *
   * @type {AssetTypeReadExternalDefaultInheritance}
   * @memberof AssetUpdate
   */
  inheritance?: AssetTypeReadExternalDefaultInheritance;
  /**
   *
   * @type {Array<TaskTypeDisabledMessage>}
   * @memberof AssetUpdate
   */
  disabledMessages?: Array<TaskTypeDisabledMessage>;
  /**
   *
   * @type {AssetCreateTokenRegistration}
   * @memberof AssetUpdate
   */
  tokenRegistration?: AssetCreateTokenRegistration;
  /**
   *
   * @type {Array<AssetCreateMedia>}
   * @memberof AssetUpdate
   */
  media?: Array<AssetCreateMedia>;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof AssetUpdate
   */
  extendedMetadata?: { [key: string]: any };
  /**
   *
   * @type {TaskFullExternalLink}
   * @memberof AssetUpdate
   */
  externalLink?: TaskFullExternalLink;
}

/**
 *
 * @export
 * @interface AssetWriteResponse
 */
export interface AssetWriteResponse {
  /**
   *
   * @type {string}
   * @memberof AssetWriteResponse
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof AssetWriteResponse
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof AssetWriteResponse
   */
  assetRef?: string;
  /**
   *
   * @type {string}
   * @memberof AssetWriteResponse
   */
  title: string;
}
/**
 *
 * @export
 * @interface BrandCreate
 */
export interface BrandCreate {
  /**
   * Whether currently active
   * @type {boolean}
   * @memberof BrandCreate
   */
  active: boolean;
  /**
   * Whether this is the default brand for the tenant
   * @type {boolean}
   * @memberof BrandCreate
   */
  defaultBrand: boolean;
  /**
   * Name of the brand for display
   * @type {string}
   * @memberof BrandCreate
   */
  name: string;
  /**
   * The greeting to be displayed
   * @type {string}
   * @memberof BrandCreate
   */
  greeting: string;
  /**
   *
   * @type {FileRef}
   * @memberof BrandCreate
   */
  logo?: FileRef;
  /**
   * Alternative tenant host to use (if applicable)
   * @type {string}
   * @memberof BrandCreate
   */
  altTenantHost?: string;
  /**
   *
   * @type {string}
   * @memberof BrandCreate
   */
  orgUrn?: string;
  /**
   * An inbound or outbound phone line
   * @type {string}
   * @memberof BrandCreate
   */
  defaultQueue?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof BrandCreate
   */
  inboundLines?: Array<string>;
  /**
   * E.164 format phone number
   * @type {string}
   * @memberof BrandCreate
   */
  outboundLine?: string;
  /**
   *
   * @type {Array<BrandServiceHours>}
   * @memberof BrandCreate
   */
  serviceHours?: Array<BrandServiceHours>;
  /**
   *
   * @type {BrandFullListExternalTransfers}
   * @memberof BrandCreate
   */
  transfers?: BrandFullListExternalTransfers;
}
/**
 *
 * @export
 * @interface BrandFullListExternal
 */
export interface BrandFullListExternal {
  /**
   *
   * @type {Array<BrandFullListExternalBrands>}
   * @memberof BrandFullListExternal
   */
  brands?: Array<BrandFullListExternalBrands>;
}
/**
 *
 * @export
 * @interface BrandFullListExternalBrands
 */
export interface BrandFullListExternalBrands {
  /**
   *
   * @type {string}
   * @memberof BrandFullListExternalBrands
   */
  slug: string;
  /**
   *
   * @type {string}
   * @memberof BrandFullListExternalBrands
   */
  urn: string;
  /**
   * Whether this is the default brand for the tenant
   * @type {boolean}
   * @memberof BrandFullListExternalBrands
   */
  defaultBrand: boolean;
  /**
   * Name of the brand for display
   * @type {string}
   * @memberof BrandFullListExternalBrands
   */
  name: string;
  /**
   * The greeting to be displayed
   * @type {string}
   * @memberof BrandFullListExternalBrands
   */
  greeting?: string;
  /**
   * Alternative tenant host to use (if applicable)
   * @type {string}
   * @memberof BrandFullListExternalBrands
   */
  altTenantHost?: string;
  /**
   *
   * @type {string}
   * @memberof BrandFullListExternalBrands
   */
  orgUrn?: string;
  /**
   * An inbound or outbound phone line
   * @type {string}
   * @memberof BrandFullListExternalBrands
   */
  defaultQueue?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof BrandFullListExternalBrands
   */
  inboundLines?: Array<string>;
  /**
   * E.164 format phone number
   * @type {string}
   * @memberof BrandFullListExternalBrands
   */
  outboundLine?: string;
  /**
   *
   * @type {Array<BrandServiceHours>}
   * @memberof BrandFullListExternalBrands
   */
  serviceHours?: Array<BrandServiceHours>;
  /**
   *
   * @type {BrandFullListExternalTransfers}
   * @memberof BrandFullListExternalBrands
   */
  transfers?: BrandFullListExternalTransfers;
  /**
   *
   * @type {FilePath}
   * @memberof BrandFullListExternalBrands
   */
  logo?: FilePath;
}
/**
 *
 * @export
 * @interface BrandFullListExternalTransfers
 */
export interface BrandFullListExternalTransfers {
  /**
   *
   * @type {Array<BrandFullListExternalTransfersExternal>}
   * @memberof BrandFullListExternalTransfers
   */
  external?: Array<BrandFullListExternalTransfersExternal>;
  /**
   *
   * @type {Array<BrandFullListExternalTransfersQueues>}
   * @memberof BrandFullListExternalTransfers
   */
  queues?: Array<BrandFullListExternalTransfersQueues>;
  /**
   *
   * @type {Array<BrandFullListExternalTransfersStudioFlows>}
   * @memberof BrandFullListExternalTransfers
   */
  studioFlows?: Array<BrandFullListExternalTransfersStudioFlows>;
}
/**
 *
 * @export
 * @interface BrandFullListExternalTransfersExternal
 */
export interface BrandFullListExternalTransfersExternal {
  /**
   *
   * @type {string}
   * @memberof BrandFullListExternalTransfersExternal
   */
  name?: string;
  /**
   * E.164 format phone number
   * @type {string}
   * @memberof BrandFullListExternalTransfersExternal
   */
  phoneNumber?: string;
}
/**
 *
 * @export
 * @interface BrandFullListExternalTransfersQueues
 */
export interface BrandFullListExternalTransfersQueues {
  /**
   *
   * @type {string}
   * @memberof BrandFullListExternalTransfersQueues
   */
  name?: string;
  /**
   * An inbound or outbound phone line
   * @type {string}
   * @memberof BrandFullListExternalTransfersQueues
   */
  queue?: string;
}
/**
 *
 * @export
 * @interface BrandFullListExternalTransfersStudioFlows
 */
export interface BrandFullListExternalTransfersStudioFlows {
  /**
   *
   * @type {string}
   * @memberof BrandFullListExternalTransfersStudioFlows
   */
  name?: string;
  /**
   * An inbound or outbound phone line
   * @type {string}
   * @memberof BrandFullListExternalTransfersStudioFlows
   */
  studioFlow?: string;
}
/**
 *
 * @export
 * @interface BrandList
 */
export interface BrandList {
  /**
   *
   * @type {Array<BrandListBrands>}
   * @memberof BrandList
   */
  brands?: Array<BrandListBrands>;
  /**
   *
   * @type {ExportsListExternalPage}
   * @memberof BrandList
   */
  page?: ExportsListExternalPage;
}
/**
 *
 * @export
 * @interface BrandListBrands
 */
export interface BrandListBrands {
  /**
   *
   * @type {string}
   * @memberof BrandListBrands
   */
  slug: string;
  /**
   *
   * @type {string}
   * @memberof BrandListBrands
   */
  urn: string;
  /**
   * Whether currently active
   * @type {boolean}
   * @memberof BrandListBrands
   */
  active: boolean;
  /**
   * Whether this is the default brand for the tenant
   * @type {boolean}
   * @memberof BrandListBrands
   */
  defaultBrand: boolean;
  /**
   * Name of the brand for display
   * @type {string}
   * @memberof BrandListBrands
   */
  name: string;
}
/**
 *
 * @export
 * @interface BrandRead
 */
export interface BrandRead {
  /**
   *
   * @type {string}
   * @memberof BrandRead
   */
  slug: string;
  /**
   *
   * @type {string}
   * @memberof BrandRead
   */
  urn: string;
  /**
   * Whether currently active
   * @type {boolean}
   * @memberof BrandRead
   */
  active: boolean;
  /**
   * Whether this is the default brand for the tenant
   * @type {boolean}
   * @memberof BrandRead
   */
  defaultBrand: boolean;
  /**
   * Name of the brand for display
   * @type {string}
   * @memberof BrandRead
   */
  name: string;
  /**
   * The greeting to be displayed
   * @type {string}
   * @memberof BrandRead
   */
  greeting: string;
  /**
   *
   * @type {FileRef}
   * @memberof BrandRead
   */
  logo?: FileRef;
  /**
   * Alternative tenant host to use (if applicable)
   * @type {string}
   * @memberof BrandRead
   */
  altTenantHost?: string;
  /**
   *
   * @type {string}
   * @memberof BrandRead
   */
  orgUrn?: string;
  /**
   * An inbound or outbound phone line
   * @type {string}
   * @memberof BrandRead
   */
  defaultQueue?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof BrandRead
   */
  inboundLines?: Array<string>;
  /**
   * E.164 format phone number
   * @type {string}
   * @memberof BrandRead
   */
  outboundLine?: string;
  /**
   *
   * @type {Array<BrandServiceHours>}
   * @memberof BrandRead
   */
  serviceHours?: Array<BrandServiceHours>;
  /**
   *
   * @type {BrandFullListExternalTransfers}
   * @memberof BrandRead
   */
  transfers?: BrandFullListExternalTransfers;
}
/**
 *
 * @export
 * @interface BrandReadExternal
 */
export interface BrandReadExternal {
  /**
   *
   * @type {string}
   * @memberof BrandReadExternal
   */
  slug: string;
  /**
   *
   * @type {string}
   * @memberof BrandReadExternal
   */
  urn: string;
  /**
   * Whether currently active
   * @type {boolean}
   * @memberof BrandReadExternal
   */
  active: boolean;
  /**
   * Whether this is the default brand for the tenant
   * @type {boolean}
   * @memberof BrandReadExternal
   */
  defaultBrand: boolean;
  /**
   * Name of the brand for display
   * @type {string}
   * @memberof BrandReadExternal
   */
  name: string;
  /**
   * The greeting to be displayed
   * @type {string}
   * @memberof BrandReadExternal
   */
  greeting: string;
  /**
   * Ordered list of applicable notices
   * @type {Array<BrandReadExternalNotices>}
   * @memberof BrandReadExternal
   */
  notices?: Array<BrandReadExternalNotices>;
  /**
   * Alternative tenant host to use (if applicable)
   * @type {string}
   * @memberof BrandReadExternal
   */
  altTenantHost?: string;
  /**
   *
   * @type {string}
   * @memberof BrandReadExternal
   */
  orgUrn?: string;
  /**
   * An inbound or outbound phone line
   * @type {string}
   * @memberof BrandReadExternal
   */
  defaultQueue?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof BrandReadExternal
   */
  inboundLines?: Array<string>;
  /**
   * E.164 format phone number
   * @type {string}
   * @memberof BrandReadExternal
   */
  outboundLine?: string;
  /**
   *
   * @type {Array<BrandServiceHours>}
   * @memberof BrandReadExternal
   */
  serviceHours?: Array<BrandServiceHours>;
  /**
   *
   * @type {BrandFullListExternalTransfers}
   * @memberof BrandReadExternal
   */
  transfers?: BrandFullListExternalTransfers;
  /**
   *
   * @type {FilePath}
   * @memberof BrandReadExternal
   */
  logo?: FilePath;
}
/**
 *
 * @export
 * @interface BrandReadExternalNotices
 */
export interface BrandReadExternalNotices {
  /**
   *
   * @type {string}
   * @memberof BrandReadExternalNotices
   */
  uid?: string;
  /**
   *
   * @type {string}
   * @memberof BrandReadExternalNotices
   */
  message?: string;
}
/**
 *
 * @export
 * @interface BrandServiceHours
 */
export interface BrandServiceHours {
  /**
   *
   * @type {Array<DayOfWeek>}
   * @memberof BrandServiceHours
   */
  days?: Array<DayOfWeek>;
  /**
   *
   * @type {string}
   * @memberof BrandServiceHours
   */
  fromTime?: string;
  /**
   *
   * @type {string}
   * @memberof BrandServiceHours
   */
  toTime?: string;
}
/**
 *
 * @export
 * @interface BrandSummaryExternal
 */
export interface BrandSummaryExternal {
  /**
   *
   * @type {string}
   * @memberof BrandSummaryExternal
   */
  slug: string;
  /**
   * Name of the brand for display
   * @type {string}
   * @memberof BrandSummaryExternal
   */
  name: string;
  /**
   *
   * @type {FilePath}
   * @memberof BrandSummaryExternal
   */
  logo?: FilePath;
}
/**
 *
 * @export
 * @interface BrandUpdate
 */
export interface BrandUpdate {
  /**
   * Whether currently active
   * @type {boolean}
   * @memberof BrandUpdate
   */
  active?: boolean;
  /**
   * Whether this is the default brand for the tenant
   * @type {boolean}
   * @memberof BrandUpdate
   */
  defaultBrand?: boolean;
  /**
   * Name of the brand for display
   * @type {string}
   * @memberof BrandUpdate
   */
  name?: string;
  /**
   * The greeting to be displayed
   * @type {string}
   * @memberof BrandUpdate
   */
  greeting?: string;
  /**
   *
   * @type {FileRef}
   * @memberof BrandUpdate
   */
  logo?: FileRef;
  /**
   * Alternative tenant host to use (if applicable)
   * @type {string}
   * @memberof BrandUpdate
   */
  altTenantHost?: string;
  /**
   *
   * @type {string}
   * @memberof BrandUpdate
   */
  orgUrn?: string;
  /**
   * An inbound or outbound phone line
   * @type {string}
   * @memberof BrandUpdate
   */
  defaultQueue?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof BrandUpdate
   */
  inboundLines?: Array<string>;
  /**
   * E.164 format phone number
   * @type {string}
   * @memberof BrandUpdate
   */
  outboundLine?: string;
  /**
   *
   * @type {Array<BrandServiceHours>}
   * @memberof BrandUpdate
   */
  serviceHours?: Array<BrandServiceHours>;
  /**
   *
   * @type {BrandFullListExternalTransfers}
   * @memberof BrandUpdate
   */
  transfers?: BrandFullListExternalTransfers;
}
/**
 *
 * @export
 * @enum {string}
 */

export const CallAgentRole = {
  CallCoach: "CALL_COACH",
  CallAgent: "CALL_AGENT",
  InternalTo: "INTERNAL_TO",
  InternalFrom: "INTERNAL_FROM",
  MissedCall: "MISSED_CALL",
  RejectedCall: "REJECTED_CALL",
} as const;

export type CallAgentRole = (typeof CallAgentRole)[keyof typeof CallAgentRole];

/**
 *
 * @export
 * @enum {string}
 */

export const CallDirection = {
  Inbound: "INBOUND",
  Outbound: "OUTBOUND",
  Internal: "INTERNAL",
} as const;

export type CallDirection = (typeof CallDirection)[keyof typeof CallDirection];

/**
 *
 * @export
 * @enum {string}
 */

export const CallDisconnectedBy = {
  Caller: "CALLER",
  Callee: "CALLEE",
  Unknown: "UNKNOWN",
} as const;

export type CallDisconnectedBy = (typeof CallDisconnectedBy)[keyof typeof CallDisconnectedBy];

/**
 *
 * @export
 * @enum {string}
 */

export const CallOutcome = {
  Placed: "PLACED",
  Cancelled: "CANCELLED",
  AgentNewTask: "AGENT_NEW_TASK",
  AgentExistingTask: "AGENT_EXISTING_TASK",
  AgentAnswered: "AGENT_ANSWERED",
  QueueAbandoned: "QUEUE_ABANDONED",
  IvrTransferred: "IVR_TRANSFERRED",
  IvrHandOff: "IVR_HAND_OFF",
  IvrNewTask: "IVR_NEW_TASK",
  IvrExistingTask: "IVR_EXISTING_TASK",
  IvrAnswered: "IVR_ANSWERED",
  IvrAbandoned: "IVR_ABANDONED",
  Unknown: "UNKNOWN",
} as const;

export type CallOutcome = (typeof CallOutcome)[keyof typeof CallOutcome];

/**
 *
 * @export
 * @interface CallRecordEvents
 */
export interface CallRecordEvents {
  /**
   *
   * @type {Array<CallRecordEventsEventsInner>}
   * @memberof CallRecordEvents
   */
  events?: Array<CallRecordEventsEventsInner>;
}
/**
 * @type CallRecordEventsEventsInner
 * @export
 */
export type CallRecordEventsEventsInner =
  | ({ eventType: "COACHINGSTARTED" } & CoachingStartedEventType)
  | ({ eventType: "COACHINGSTOPPED" } & CoachingStoppedEventType)
  | ({ eventType: "FLOWSTARTED" } & FlowStartedEventType)
  | ({ eventType: "HANDOFFSMS" } & HandOffSmsEventType)
  | ({ eventType: "IVRRESOLVED" } & IvrResolvedEventType)
  | ({ eventType: "MUTED" } & MutedEventType)
  | ({ eventType: "OFFHOLD" } & OffHoldEventType)
  | ({ eventType: "ONHOLD" } & OnHoldEventType)
  | ({ eventType: "PARTICIPANTJOIN" } & ParticipantJoinedEventType)
  | ({ eventType: "PARTICIPANTLEAVE" } & ParticipantLeaveEventType)
  | ({ eventType: "PRIMARYCALLEND" } & PrimaryCallEndEventType)
  | ({ eventType: "PRIMARYCALLSTART" } & PrimaryCallStartEventType)
  | ({ eventType: "RESVACCEPTED" } & ReservationAcceptedEventType)
  | ({ eventType: "RESVCANCELLED" } & ReservatonCancelledEventType)
  | ({ eventType: "RESVCOMPLETED" } & ReservationCompletedEventType)
  | ({ eventType: "RESVCREATED" } & ReservationCreatedEventType)
  | ({ eventType: "RESVREJECTED" } & ReservationRejectedEventType)
  | ({ eventType: "RESVTIMEOUT" } & ReservationTimeoutEventType)
  | ({ eventType: "RESVWRAPUP" } & ReservationWrapUpEventType)
  | ({ eventType: "TASKCANCELLED" } & TaskCancelledEventType)
  | ({ eventType: "TASKCOMPLETED" } & TaskCompletedEventType)
  | ({ eventType: "TASKCREATED" } & TaskCreatedEventType)
  | ({ eventType: "TASKDELETED" } & TaskDeletedEventType)
  | ({ eventType: "TASKQUEUEENTERED" } & TaskQueueEnteredEventType)
  | ({ eventType: "TASKQUEUEMOVED" } & TaskQueueMovedEventType)
  | ({ eventType: "TASKUPDATED" } & TaskUpdatedEventType)
  | ({ eventType: "TASKWRAPUP" } & TaskWrapUpEventType)
  | ({ eventType: "TRANSFERCANCELLED" } & TransferCancelledEventType)
  | ({ eventType: "TRANSFERCOMPLETED" } & TransferCompletedEventType)
  | ({ eventType: "TRANSFERFAILED" } & TransferFailedEventType)
  | ({ eventType: "TRANSFERINITIATED" } & TransferInitiatedEventType)
  | ({ eventType: "UNMUTED" } & UnmutedEventType);

/**
 * @type CallRecordReadExternal
 * @export
 */
export type CallRecordReadExternal = CallRecordReadFullExternal | CallRecordReadSimpleExternal;

/**
 *
 * @export
 * @interface CallRecordReadFullExternal
 */
export interface CallRecordReadFullExternal {
  /**
   *
   * @type {string}
   * @memberof CallRecordReadFullExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof CallRecordReadFullExternal
   */
  urn: string;
  /**
   *
   * @type {boolean}
   * @memberof CallRecordReadFullExternal
   */
  active: boolean;
  /**
   *
   * @type {CallOutcome}
   * @memberof CallRecordReadFullExternal
   */
  outcome?: CallOutcome;
  /**
   *
   * @type {CallDirection}
   * @memberof CallRecordReadFullExternal
   */
  direction?: CallDirection;
  /**
   *
   * @type {CallRecordSearchResultExternalCustomerCall}
   * @memberof CallRecordReadFullExternal
   */
  customerCall?: CallRecordSearchResultExternalCustomerCall;
  /**
   *
   * @type {string}
   * @memberof CallRecordReadFullExternal
   */
  twilioLine?: string;
  /**
   *
   * @type {string}
   * @memberof CallRecordReadFullExternal
   */
  conferenceSid?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CallRecordReadFullExternal
   */
  taskSids?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof CallRecordReadFullExternal
   */
  startAt?: string;
  /**
   *
   * @type {string}
   * @memberof CallRecordReadFullExternal
   */
  endAt?: string;
  /**
   *
   * @type {boolean}
   * @memberof CallRecordReadFullExternal
   */
  newTask?: boolean;
  /**
   *
   * @type {CallStage}
   * @memberof CallRecordReadFullExternal
   */
  callStage?: CallStage;
  /**
   *
   * @type {CallRecordSearchResultExternalNotes}
   * @memberof CallRecordReadFullExternal
   */
  notes?: CallRecordSearchResultExternalNotes;
  /**
   *
   * @type {CallRecordSearchResultExternalLatestQueue}
   * @memberof CallRecordReadFullExternal
   */
  latestQueue?: CallRecordSearchResultExternalLatestQueue;
  /**
   *
   * @type {string}
   * @memberof CallRecordReadFullExternal
   */
  completedAt?: string;
  /**
   *
   * @type {Array<CallRecordReadFullExternalThirdParties>}
   * @memberof CallRecordReadFullExternal
   */
  thirdParties?: Array<CallRecordReadFullExternalThirdParties>;
  /**
   *
   * @type {CallRecordSearchResultExternalTimings}
   * @memberof CallRecordReadFullExternal
   */
  timings?: CallRecordSearchResultExternalTimings;
  /**
   *
   * @type {Array<CallRecordSearchResultExternalRecordings>}
   * @memberof CallRecordReadFullExternal
   */
  recordings?: Array<CallRecordSearchResultExternalRecordings>;
  /**
   *
   * @type {BrandSummaryExternal}
   * @memberof CallRecordReadFullExternal
   */
  brand?: BrandSummaryExternal;
  /**
   *
   * @type {UserRefHydrated}
   * @memberof CallRecordReadFullExternal
   */
  customer?: UserRefHydrated;
  /**
   *
   * @type {AssetRefHydrated}
   * @memberof CallRecordReadFullExternal
   */
  asset?: AssetRefHydrated;
  /**
   *
   * @type {Array<CallRecordSearchResultExternalAgents>}
   * @memberof CallRecordReadFullExternal
   */
  agents?: Array<CallRecordSearchResultExternalAgents>;
  /**
   *
   * @type {TaskRefHydrated}
   * @memberof CallRecordReadFullExternal
   */
  task?: TaskRefHydrated;
  /**
   *
   * @type {string}
   * @memberof CallRecordReadFullExternal
   */
  view: CallRecordReadFullExternalViewEnum;
}

export const CallRecordReadFullExternalViewEnum = {
  Full: "FULL",
} as const;

export type CallRecordReadFullExternalViewEnum =
  (typeof CallRecordReadFullExternalViewEnum)[keyof typeof CallRecordReadFullExternalViewEnum];

/**
 *
 * @export
 * @interface CallRecordReadFullExternalThirdParties
 */
export interface CallRecordReadFullExternalThirdParties {
  /**
   *
   * @type {string}
   * @memberof CallRecordReadFullExternalThirdParties
   */
  thirdPartyLine?: string;
  /**
   *
   * @type {number}
   * @memberof CallRecordReadFullExternalThirdParties
   */
  duration?: number;
  /**
   *
   * @type {string}
   * @memberof CallRecordReadFullExternalThirdParties
   */
  savedNumberName?: string;
}
/**
 *
 * @export
 * @interface CallRecordReadSimpleExternal
 */
export interface CallRecordReadSimpleExternal {
  /**
   *
   * @type {string}
   * @memberof CallRecordReadSimpleExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof CallRecordReadSimpleExternal
   */
  urn: string;
  /**
   *
   * @type {boolean}
   * @memberof CallRecordReadSimpleExternal
   */
  active: boolean;
  /**
   *
   * @type {CallDirection}
   * @memberof CallRecordReadSimpleExternal
   */
  direction?: CallDirection;
  /**
   *
   * @type {CallRecordSearchResultExternalCustomerCall}
   * @memberof CallRecordReadSimpleExternal
   */
  customerCall?: CallRecordSearchResultExternalCustomerCall;
  /**
   *
   * @type {string}
   * @memberof CallRecordReadSimpleExternal
   */
  twilioLine?: string;
  /**
   *
   * @type {string}
   * @memberof CallRecordReadSimpleExternal
   */
  startAt?: string;
  /**
   *
   * @type {UserRefHydrated}
   * @memberof CallRecordReadSimpleExternal
   */
  customer?: UserRefHydrated;
  /**
   *
   * @type {AssetRefHydrated}
   * @memberof CallRecordReadSimpleExternal
   */
  asset?: AssetRefHydrated;
  /**
   *
   * @type {TaskRefHydrated}
   * @memberof CallRecordReadSimpleExternal
   */
  task?: TaskRefHydrated;
  /**
   *
   * @type {string}
   * @memberof CallRecordReadSimpleExternal
   */
  view: CallRecordReadSimpleExternalViewEnum;
}

export const CallRecordReadSimpleExternalViewEnum = {
  Simple: "SIMPLE",
} as const;

export type CallRecordReadSimpleExternalViewEnum =
  (typeof CallRecordReadSimpleExternalViewEnum)[keyof typeof CallRecordReadSimpleExternalViewEnum];

/**
 *
 * @export
 * @interface CallRecordRecordingTranscript
 */
export interface CallRecordRecordingTranscript {
  /**
   *
   * @type {string}
   * @memberof CallRecordRecordingTranscript
   */
  status: CallRecordRecordingTranscriptStatusEnum;
  /**
   *
   * @type {string}
   * @memberof CallRecordRecordingTranscript
   */
  requestedAt?: string;
  /**
   *
   * @type {string}
   * @memberof CallRecordRecordingTranscript
   */
  generatedAt?: string;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof CallRecordRecordingTranscript
   */
  transcript?: { [key: string]: any };
}

export const CallRecordRecordingTranscriptStatusEnum = {
  Generating: "GENERATING",
  Generated: "GENERATED",
  Failed: "FAILED",
} as const;

export type CallRecordRecordingTranscriptStatusEnum =
  (typeof CallRecordRecordingTranscriptStatusEnum)[keyof typeof CallRecordRecordingTranscriptStatusEnum];

/**
 *
 * @export
 * @interface CallRecordSearchResultExternal
 */
export interface CallRecordSearchResultExternal {
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternal
   */
  urn: string;
  /**
   *
   * @type {boolean}
   * @memberof CallRecordSearchResultExternal
   */
  active?: boolean;
  /**
   *
   * @type {CallOutcome}
   * @memberof CallRecordSearchResultExternal
   */
  outcome?: CallOutcome;
  /**
   *
   * @type {CallDirection}
   * @memberof CallRecordSearchResultExternal
   */
  direction?: CallDirection;
  /**
   *
   * @type {CallRecordSearchResultExternalCustomerCall}
   * @memberof CallRecordSearchResultExternal
   */
  customerCall?: CallRecordSearchResultExternalCustomerCall;
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternal
   */
  twilioLine?: string;
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternal
   */
  conferenceSid?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CallRecordSearchResultExternal
   */
  taskSids?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternal
   */
  startAt?: string;
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternal
   */
  endAt?: string;
  /**
   *
   * @type {CallStage}
   * @memberof CallRecordSearchResultExternal
   */
  callStage?: CallStage;
  /**
   *
   * @type {CallRecordSearchResultExternalLatestQueue}
   * @memberof CallRecordSearchResultExternal
   */
  latestQueue?: CallRecordSearchResultExternalLatestQueue;
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternal
   */
  completedAt?: string;
  /**
   *
   * @type {CallRecordSearchResultExternalTimings}
   * @memberof CallRecordSearchResultExternal
   */
  timings?: CallRecordSearchResultExternalTimings;
  /**
   *
   * @type {Array<CallRecordSearchResultExternalRecordings>}
   * @memberof CallRecordSearchResultExternal
   */
  recordings?: Array<CallRecordSearchResultExternalRecordings>;
  /**
   *
   * @type {CallRecordSearchResultExternalNotes}
   * @memberof CallRecordSearchResultExternal
   */
  notes?: CallRecordSearchResultExternalNotes;
  /**
   *
   * @type {BrandSummaryExternal}
   * @memberof CallRecordSearchResultExternal
   */
  brand?: BrandSummaryExternal;
  /**
   *
   * @type {UserRefHydrated}
   * @memberof CallRecordSearchResultExternal
   */
  customer?: UserRefHydrated;
  /**
   *
   * @type {AssetRefHydrated}
   * @memberof CallRecordSearchResultExternal
   */
  asset?: AssetRefHydrated;
  /**
   *
   * @type {TaskRefHydrated}
   * @memberof CallRecordSearchResultExternal
   */
  task?: TaskRefHydrated;
  /**
   *
   * @type {Array<CallRecordSearchResultExternalAgents>}
   * @memberof CallRecordSearchResultExternal
   */
  agents?: Array<CallRecordSearchResultExternalAgents>;
}

/**
 *
 * @export
 * @interface CallRecordSearchResultExternalAgents
 */
export interface CallRecordSearchResultExternalAgents {
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternalAgents
   */
  contactUri?: string;
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternalAgents
   */
  workerSid?: string;
  /**
   *
   * @type {UserRefHydrated}
   * @memberof CallRecordSearchResultExternalAgents
   */
  user?: UserRefHydrated;
  /**
   *
   * @type {CallAgentRole}
   * @memberof CallRecordSearchResultExternalAgents
   */
  callRole?: CallAgentRole;
  /**
   *
   * @type {number}
   * @memberof CallRecordSearchResultExternalAgents
   */
  duration?: number;
}

/**
 *
 * @export
 * @interface CallRecordSearchResultExternalCustomerCall
 */
export interface CallRecordSearchResultExternalCustomerCall {
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternalCustomerCall
   */
  callSid?: string;
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternalCustomerCall
   */
  customerLine?: string;
  /**
   *
   * @type {CallDisconnectedBy}
   * @memberof CallRecordSearchResultExternalCustomerCall
   */
  disconnectedBy?: CallDisconnectedBy;
}

/**
 *
 * @export
 * @interface CallRecordSearchResultExternalLatestQueue
 */
export interface CallRecordSearchResultExternalLatestQueue {
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternalLatestQueue
   */
  queueSid?: string;
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternalLatestQueue
   */
  queueName?: string;
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternalLatestQueue
   */
  enteredAt?: string;
}
/**
 *
 * @export
 * @interface CallRecordSearchResultExternalNotes
 */
export interface CallRecordSearchResultExternalNotes {
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternalNotes
   */
  assistantNotes?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CallRecordSearchResultExternalNotes
   */
  callNotes?: Array<string>;
}
/**
 *
 * @export
 * @interface CallRecordSearchResultExternalRecordings
 */
export interface CallRecordSearchResultExternalRecordings {
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternalRecordings
   */
  recordingUid?: string;
  /**
   *
   * @type {CallRecordingHosting}
   * @memberof CallRecordSearchResultExternalRecordings
   */
  hosting?: CallRecordingHosting;
  /**
   *
   * @type {CallRecordingType}
   * @memberof CallRecordSearchResultExternalRecordings
   */
  recordingType?: CallRecordingType;
  /**
   *
   * @type {number}
   * @memberof CallRecordSearchResultExternalRecordings
   */
  duration?: number;
  /**
   *
   * @type {number}
   * @memberof CallRecordSearchResultExternalRecordings
   */
  channels?: number;
  /**
   *
   * @type {string}
   * @memberof CallRecordSearchResultExternalRecordings
   */
  start?: string;
}

/**
 *
 * @export
 * @interface CallRecordSearchResultExternalTimings
 */
export interface CallRecordSearchResultExternalTimings {
  /**
   *
   * @type {number}
   * @memberof CallRecordSearchResultExternalTimings
   */
  ivr?: number;
  /**
   *
   * @type {number}
   * @memberof CallRecordSearchResultExternalTimings
   */
  ring?: number;
  /**
   *
   * @type {number}
   * @memberof CallRecordSearchResultExternalTimings
   */
  queue?: number;
  /**
   *
   * @type {number}
   * @memberof CallRecordSearchResultExternalTimings
   */
  hold?: number;
  /**
   *
   * @type {number}
   * @memberof CallRecordSearchResultExternalTimings
   */
  customerTalk?: number;
  /**
   *
   * @type {number}
   * @memberof CallRecordSearchResultExternalTimings
   */
  handling?: number;
  /**
   *
   * @type {number}
   * @memberof CallRecordSearchResultExternalTimings
   */
  wrapUp?: number;
  /**
   *
   * @type {number}
   * @memberof CallRecordSearchResultExternalTimings
   */
  customerDuration?: number;
  /**
   *
   * @type {number}
   * @memberof CallRecordSearchResultExternalTimings
   */
  totalDuration?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const CallRecordingHosting = {
  Twilio: "TWILIO",
  Ap: "AP",
} as const;

export type CallRecordingHosting = (typeof CallRecordingHosting)[keyof typeof CallRecordingHosting];

/**
 *
 * @export
 * @enum {string}
 */

export const CallRecordingType = {
  Conference: "CONFERENCE",
  PrimaryCall: "PRIMARY_CALL",
} as const;

export type CallRecordingType = (typeof CallRecordingType)[keyof typeof CallRecordingType];

/**
 *
 * @export
 * @enum {string}
 */

export const CallStage = {
  Ivr: "IVR",
  Queue: "QUEUE",
  Agent: "AGENT",
} as const;

export type CallStage = (typeof CallStage)[keyof typeof CallStage];

/**
 *
 * @export
 * @interface ChangeSummary
 */
export interface ChangeSummary {
  /**
   *
   * @type {string}
   * @memberof ChangeSummary
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof ChangeSummary
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof ChangeSummary
   */
  lastModifiedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ChangeSummary
   */
  lastModifiedBy?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ChannelPreferenceChannel = {
  None: "NONE",
  Email: "EMAIL",
  Sms: "SMS",
} as const;

export type ChannelPreferenceChannel = (typeof ChannelPreferenceChannel)[keyof typeof ChannelPreferenceChannel];

/**
 *
 * @export
 * @interface ChannelPreferenceTypeListExternal
 */
export interface ChannelPreferenceTypeListExternal {
  /**
   *
   * @type {Array<ChannelPreferenceTypeListExternalChannelPreferenceTypes>}
   * @memberof ChannelPreferenceTypeListExternal
   */
  channelPreferenceTypes?: Array<ChannelPreferenceTypeListExternalChannelPreferenceTypes>;
}
/**
 *
 * @export
 * @interface ChannelPreferenceTypeListExternalChannelPreferenceTypes
 */
export interface ChannelPreferenceTypeListExternalChannelPreferenceTypes {
  /**
   *
   * @type {string}
   * @memberof ChannelPreferenceTypeListExternalChannelPreferenceTypes
   */
  uid: string;
  /**
   *
   * @type {Array<ChannelPreferenceChannel>}
   * @memberof ChannelPreferenceTypeListExternalChannelPreferenceTypes
   */
  allowedChannels: Array<ChannelPreferenceChannel>;
  /**
   *
   * @type {ChannelPreferenceChannel}
   * @memberof ChannelPreferenceTypeListExternalChannelPreferenceTypes
   */
  defaultChannel: ChannelPreferenceChannel;
  /**
   *
   * @type {boolean}
   * @memberof ChannelPreferenceTypeListExternalChannelPreferenceTypes
   */
  allowMultiple: boolean;
  /**
   *
   * @type {Array<RoleSlug>}
   * @memberof ChannelPreferenceTypeListExternalChannelPreferenceTypes
   */
  roles: Array<RoleSlug>;
  /**
   *
   * @type {string}
   * @memberof ChannelPreferenceTypeListExternalChannelPreferenceTypes
   */
  displayName: string;
}

/**
 *
 * @export
 * @interface CoachingStartedEventType
 */
export interface CoachingStartedEventType {
  /**
   *
   * @type {string}
   * @memberof CoachingStartedEventType
   */
  eventType: CoachingStartedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof CoachingStartedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof CoachingStartedEventType
   */
  participant?: string;
}

export const CoachingStartedEventTypeEventTypeEnum = {
  CoachingStarted: "COACHING_STARTED",
} as const;

export type CoachingStartedEventTypeEventTypeEnum =
  (typeof CoachingStartedEventTypeEventTypeEnum)[keyof typeof CoachingStartedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface CoachingStoppedEventType
 */
export interface CoachingStoppedEventType {
  /**
   *
   * @type {string}
   * @memberof CoachingStoppedEventType
   */
  eventType: CoachingStoppedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof CoachingStoppedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof CoachingStoppedEventType
   */
  participant?: string;
}

export const CoachingStoppedEventTypeEventTypeEnum = {
  CoachingStopped: "COACHING_STOPPED",
} as const;

export type CoachingStoppedEventTypeEventTypeEnum =
  (typeof CoachingStoppedEventTypeEventTypeEnum)[keyof typeof CoachingStoppedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const CommsChannelSlug = {
  Email: "EMAIL",
  Sms: "SMS",
  Phone: "PHONE",
  Whatsapp: "WHATSAPP",
} as const;

export type CommsChannelSlug = (typeof CommsChannelSlug)[keyof typeof CommsChannelSlug];

/**
 *
 * @export
 * @interface ContactIdentityCreateResponse
 */
export interface ContactIdentityCreateResponse {
  /**
   *
   * @type {string}
   * @memberof ContactIdentityCreateResponse
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ContactIdentityCreateResponse
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof ContactIdentityCreateResponse
   */
  userUrn?: string;
}
/**
 *
 * @export
 * @interface ContactIdentityRecord
 */
export interface ContactIdentityRecord {
  /**
   *
   * @type {string}
   * @memberof ContactIdentityRecord
   */
  uid?: string;
  /**
   *
   * @type {string}
   * @memberof ContactIdentityRecord
   */
  urn?: string;
  /**
   *
   * @type {ContactIdentityRecordExternalSource}
   * @memberof ContactIdentityRecord
   */
  externalSource?: ContactIdentityRecordExternalSource;
  /**
   *
   * @type {string}
   * @memberof ContactIdentityRecord
   */
  givenName?: string;
  /**
   *
   * @type {string}
   * @memberof ContactIdentityRecord
   */
  familyName?: string;
  /**
   * E.164 format phone number
   * @type {string}
   * @memberof ContactIdentityRecord
   */
  phoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ContactIdentityRecord
   */
  email?: string;
  /**
   *
   * @type {boolean}
   * @memberof ContactIdentityRecord
   */
  emailVerified?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ContactIdentityRecord
   */
  phoneVerified?: boolean;
  /**
   *
   * @type {string}
   * @memberof ContactIdentityRecord
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof ContactIdentityRecord
   */
  lastModifiedAt?: string;
}
/**
 *
 * @export
 * @interface ContactIdentityRecordExternalSource
 */
export interface ContactIdentityRecordExternalSource {
  /**
   *
   * @type {string}
   * @memberof ContactIdentityRecordExternalSource
   */
  systemName: string;
  /**
   *
   * @type {string}
   * @memberof ContactIdentityRecordExternalSource
   */
  systemId: string;
}
/**
 *
 * @export
 * @interface ConversationRecordExternal
 */
export interface ConversationRecordExternal {
  /**
   *
   * @type {string}
   * @memberof ConversationRecordExternal
   */
  uid?: string;
  /**
   *
   * @type {string}
   * @memberof ConversationRecordExternal
   */
  urn?: string;
  /**
   *
   * @type {string}
   * @memberof ConversationRecordExternal
   */
  conversationTypeUrn?: string;
  /**
   *
   * @type {FlowChannel}
   * @memberof ConversationRecordExternal
   */
  channel?: FlowChannel;
  /**
   * Whether this conversation is for a guest user
   * @type {boolean}
   * @memberof ConversationRecordExternal
   */
  guest?: boolean;
  /**
   *
   * @type {string}
   * @memberof ConversationRecordExternal
   */
  startedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ConversationRecordExternal
   */
  endedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ConversationRecordExternal
   */
  status?: ConversationRecordExternalStatusEnum;
  /**
   * User supplied rating for the conversation
   * @type {number}
   * @memberof ConversationRecordExternal
   */
  ratingScore?: number;
  /**
   *
   * @type {Array<{ [key: string]: any; }>}
   * @memberof ConversationRecordExternal
   */
  history?: Array<{ [key: string]: any }>;
  /**
   *
   * @type {boolean}
   * @memberof ConversationRecordExternal
   */
  joinable?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ConversationRecordExternal
   */
  userInteraction?: boolean;
  /**
   *
   * @type {string}
   * @memberof ConversationRecordExternal
   */
  lastTranscribedAt?: string;
  /**
   *
   * @type {UserSummaryExternal}
   * @memberof ConversationRecordExternal
   */
  user?: UserSummaryExternal;
  /**
   *
   * @type {Array<FilePath>}
   * @memberof ConversationRecordExternal
   */
  media?: Array<FilePath>;
}

export const ConversationRecordExternalStatusEnum = {
  Pending: "PENDING",
  Started: "STARTED",
  Complete: "COMPLETE",
} as const;

export type ConversationRecordExternalStatusEnum =
  (typeof ConversationRecordExternalStatusEnum)[keyof typeof ConversationRecordExternalStatusEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const DayOfWeek = {
  Mon: "MON",
  Tue: "TUE",
  Wed: "WED",
  Thu: "THU",
  Fri: "FRI",
  Sat: "SAT",
  Sun: "SUN",
} as const;

export type DayOfWeek = (typeof DayOfWeek)[keyof typeof DayOfWeek];

/**
 *
 * @export
 * @enum {string}
 */

export const DayOfWeekAndHolidays = {
  Mon: "MON",
  Tue: "TUE",
  Wed: "WED",
  Thu: "THU",
  Fri: "FRI",
  Sat: "SAT",
  Sun: "SUN",
  Hols: "HOLS",
} as const;

export type DayOfWeekAndHolidays = (typeof DayOfWeekAndHolidays)[keyof typeof DayOfWeekAndHolidays];

/**
 *
 * @export
 * @enum {string}
 */

export const DefaultAssetView = {
  Photos: "PHOTOS",
  FirstExtMetadata: "FIRST_EXT_METADATA",
  LinkedTasks: "LINKED_TASKS",
  LinkedAssets: "LINKED_ASSETS",
  LinkedPeople: "LINKED_PEOPLE",
  QuickLinks: "QUICK_LINKS",
  TaskTypes: "TASK_TYPES",
  RegToken: "REG_TOKEN",
  OnSiteAssistant: "ON_SITE_ASSISTANT",
  Security: "SECURITY",
} as const;

export type DefaultAssetView = (typeof DefaultAssetView)[keyof typeof DefaultAssetView];

/**
 *
 * @export
 * @interface ErrorModel
 */
export interface ErrorModel {
  /**
   *
   * @type {string}
   * @memberof ErrorModel
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ErrorModel
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof ErrorModel
   */
  message: string;
}
/**
 *
 * @export
 * @interface ExportsListExternal
 */
export interface ExportsListExternal {
  /**
   *
   * @type {Array<ExportsListExternalExports>}
   * @memberof ExportsListExternal
   */
  exports?: Array<ExportsListExternalExports>;
  /**
   *
   * @type {ExportsListExternalPage}
   * @memberof ExportsListExternal
   */
  page?: ExportsListExternalPage;
}
/**
 *
 * @export
 * @interface ExportsListExternalExports
 */
export interface ExportsListExternalExports {
  /**
   *
   * @type {string}
   * @memberof ExportsListExternalExports
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ExportsListExternalExports
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof ExportsListExternalExports
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ExportsListExternalExports
   */
  type: ExportsListExternalExportsTypeEnum;
  /**
   *
   * @type {number}
   * @memberof ExportsListExternalExports
   */
  resultCount?: number;
  /**
   *
   * @type {TaskExportReadExternalProgress}
   * @memberof ExportsListExternalExports
   */
  progress: TaskExportReadExternalProgress;
  /**
   *
   * @type {string}
   * @memberof ExportsListExternalExports
   */
  requestedAt: string;
  /**
   *
   * @type {UserRefHydrated}
   * @memberof ExportsListExternalExports
   */
  createdBy: UserRefHydrated;
}

export const ExportsListExternalExportsTypeEnum = {
  Task: "TASK",
  Asset: "ASSET",
  User: "USER",
  Org: "ORG",
  Team: "TEAM",
} as const;

export type ExportsListExternalExportsTypeEnum =
  (typeof ExportsListExternalExportsTypeEnum)[keyof typeof ExportsListExternalExportsTypeEnum];

/**
 *
 * @export
 * @interface ExportsListExternalPage
 */
export interface ExportsListExternalPage {
  /**
   *
   * @type {string}
   * @memberof ExportsListExternalPage
   */
  nextPageToken?: string;
  /**
   *
   * @type {number}
   * @memberof ExportsListExternalPage
   */
  pageSize?: number;
}
/**
 *
 * @export
 * @interface ExtendedMetadataAttributeConfigReadExternal
 */
export interface ExtendedMetadataAttributeConfigReadExternal {
  /**
   *
   * @type {string}
   * @memberof ExtendedMetadataAttributeConfigReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedMetadataAttributeConfigReadExternal
   */
  jsonElementName: string;
  /**
   *
   * @type {ExtendedMetadataDataType}
   * @memberof ExtendedMetadataAttributeConfigReadExternal
   */
  dataType: ExtendedMetadataDataType;
  /**
   *
   * @type {string}
   * @memberof ExtendedMetadataAttributeConfigReadExternal
   */
  required?: ExtendedMetadataAttributeConfigReadExternalRequiredEnum;
  /**
   *
   * @type {ExtendedMetadataAttributeConfigReadExternalValidationRules}
   * @memberof ExtendedMetadataAttributeConfigReadExternal
   */
  validationRules?: ExtendedMetadataAttributeConfigReadExternalValidationRules;
  /**
   * Whether this attribute can be used in filters
   * @type {boolean}
   * @memberof ExtendedMetadataAttributeConfigReadExternal
   */
  filterable?: boolean;
  /**
   * Whether the UI should disable the input for this field
   * @type {boolean}
   * @memberof ExtendedMetadataAttributeConfigReadExternal
   */
  uiEditDisabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof ExtendedMetadataAttributeConfigReadExternal
   */
  displayName?: string;
}

export const ExtendedMetadataAttributeConfigReadExternalRequiredEnum = {
  Soft: "SOFT",
  Hard: "HARD",
  None: "NONE",
} as const;

export type ExtendedMetadataAttributeConfigReadExternalRequiredEnum =
  (typeof ExtendedMetadataAttributeConfigReadExternalRequiredEnum)[keyof typeof ExtendedMetadataAttributeConfigReadExternalRequiredEnum];

/**
 *
 * @export
 * @interface ExtendedMetadataAttributeConfigReadExternalValidationRules
 */
export interface ExtendedMetadataAttributeConfigReadExternalValidationRules {
  /**
   *
   * @type {string}
   * @memberof ExtendedMetadataAttributeConfigReadExternalValidationRules
   */
  regex?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ExtendedMetadataAttributeConfigReadExternalValidationRules
   */
  allowedValues?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ExtendedMetadataAttributeConfigReadExternalValidationRules
   */
  minValue?: number;
  /**
   *
   * @type {number}
   * @memberof ExtendedMetadataAttributeConfigReadExternalValidationRules
   */
  maxValue?: number;
}
/**
 *
 * @export
 * @interface ExtendedMetadataAttributeFilterSummaryExternal
 */
export interface ExtendedMetadataAttributeFilterSummaryExternal {
  /**
   * Qualified json elementname in group.attributeformat
   * @type {string}
   * @memberof ExtendedMetadataAttributeFilterSummaryExternal
   */
  qualifiedJsonElementName: string;
  /**
   *
   * @type {ExtendedMetadataDataType}
   * @memberof ExtendedMetadataAttributeFilterSummaryExternal
   */
  dataType: ExtendedMetadataDataType;
  /**
   *
   * @type {ExtendedMetadataAttributeConfigReadExternalValidationRules}
   * @memberof ExtendedMetadataAttributeFilterSummaryExternal
   */
  validationRules?: ExtendedMetadataAttributeConfigReadExternalValidationRules;
  /**
   *
   * @type {string}
   * @memberof ExtendedMetadataAttributeFilterSummaryExternal
   */
  displayName: string;
}

/**
 *
 * @export
 * @interface ExtendedMetadataConfigReadExternal
 */
export interface ExtendedMetadataConfigReadExternal {
  /**
   *
   * @type {string}
   * @memberof ExtendedMetadataConfigReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedMetadataConfigReadExternal
   */
  jsonElementName: string;
  /**
   * Whether this group should be used in a synopsis of the object
   * @type {boolean}
   * @memberof ExtendedMetadataConfigReadExternal
   */
  synopsis?: boolean;
  /**
   *
   * @type {Array<ExtendedMetadataAttributeConfigReadExternal>}
   * @memberof ExtendedMetadataConfigReadExternal
   */
  attributes?: Array<ExtendedMetadataAttributeConfigReadExternal>;
  /**
   *
   * @type {ExtendedMetadataConfigReadExternalRolePolicy}
   * @memberof ExtendedMetadataConfigReadExternal
   */
  rolePolicy?: ExtendedMetadataConfigReadExternalRolePolicy;
  /**
   *
   * @type {string}
   * @memberof ExtendedMetadataConfigReadExternal
   */
  displayName?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedMetadataConfigReadExternal
   */
  guidance?: string;
}
/**
 *
 * @export
 * @interface ExtendedMetadataConfigReadExternalRolePolicy
 */
export interface ExtendedMetadataConfigReadExternalRolePolicy {
  /**
   *
   * @type {Array<PermissionRole>}
   * @memberof ExtendedMetadataConfigReadExternalRolePolicy
   */
  readRoles?: Array<PermissionRole>;
  /**
   *
   * @type {Array<PermissionRole>}
   * @memberof ExtendedMetadataConfigReadExternalRolePolicy
   */
  writeRoles?: Array<PermissionRole>;
  /**
   *
   * @type {Array<PermissionRole>}
   * @memberof ExtendedMetadataConfigReadExternalRolePolicy
   */
  useRoles?: Array<PermissionRole>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ExtendedMetadataDataType = {
  String: "STRING",
  Multilinestring: "MULTILINESTRING",
  Integer: "INTEGER",
  Number: "NUMBER",
  Datetime: "DATETIME",
  Date: "DATE",
  Boolean: "BOOLEAN",
  File: "FILE",
  Multifile: "MULTIFILE",
  Label: "LABEL",
  Daytime: "DAYTIME",
  Daytimerange: "DAYTIMERANGE",
  Multilangstring: "MULTILANGSTRING",
} as const;

export type ExtendedMetadataDataType = (typeof ExtendedMetadataDataType)[keyof typeof ExtendedMetadataDataType];

/**
 * @type ExternalLinkSource
 * @export
 */
export type ExternalLinkSource = ExternalLinkSourceOneOf | ExternalLinkSourceOneOf1;

/**
 *
 * @export
 * @interface ExternalLinkSourceOneOf
 */
export interface ExternalLinkSourceOneOf {
  /**
   *
   * @type {string}
   * @memberof ExternalLinkSourceOneOf
   */
  principal: string;
  /**
   *
   * @type {LinkType}
   * @memberof ExternalLinkSourceOneOf
   */
  linkType: LinkType;
  /**
   *
   * @type {string}
   * @memberof ExternalLinkSourceOneOf
   */
  context?: string;
}

/**
 *
 * @export
 * @interface ExternalLinkSourceOneOf1
 */
export interface ExternalLinkSourceOneOf1 {
  /**
   *
   * @type {string}
   * @memberof ExternalLinkSourceOneOf1
   */
  fullPath: string;
}
/**
 *
 * @export
 * @interface FilePath
 */
export interface FilePath {
  /**
   *
   * @type {string}
   * @memberof FilePath
   */
  fileUrn?: string;
  /**
   *
   * @type {string}
   * @memberof FilePath
   */
  filePath?: string;
}
/**
 *
 * @export
 * @interface FileRef
 */
export interface FileRef {
  /**
   *
   * @type {string}
   * @memberof FileRef
   */
  fileRef?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const FlowChannel = {
  Webchat: "webchat",
  Call: "call",
  Whatsapp: "whatsapp",
  Sms: "sms",
} as const;

export type FlowChannel = (typeof FlowChannel)[keyof typeof FlowChannel];

/**
 *
 * @export
 * @interface FlowStartedEventType
 */
export interface FlowStartedEventType {
  /**
   *
   * @type {string}
   * @memberof FlowStartedEventType
   */
  eventType: FlowStartedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof FlowStartedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof FlowStartedEventType
   */
  flowSid?: string;
}

export const FlowStartedEventTypeEventTypeEnum = {
  FlowStarted: "FLOW_STARTED",
} as const;

export type FlowStartedEventTypeEventTypeEnum =
  (typeof FlowStartedEventTypeEventTypeEnum)[keyof typeof FlowStartedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface GeoPoint
 */
export interface GeoPoint {
  /**
   *
   * @type {number}
   * @memberof GeoPoint
   */
  latitude?: number;
  /**
   *
   * @type {number}
   * @memberof GeoPoint
   */
  longitude?: number;
}
/**
 *
 * @export
 * @interface GuestChatDetails
 */
export interface GuestChatDetails {
  /**
   *
   * @type {PrincipalChatDetailsConnectionDetails}
   * @memberof GuestChatDetails
   */
  connectionDetails?: PrincipalChatDetailsConnectionDetails;
  /**
   *
   * @type {Array<string>}
   * @memberof GuestChatDetails
   */
  availableLanguages?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof GuestChatDetails
   */
  conversationUrn?: string;
  /**
   *
   * @type {string}
   * @memberof GuestChatDetails
   */
  conversationTypeUrn?: string;
}
/**
 *
 * @export
 * @interface HandOffSend
 */
export interface HandOffSend {
  /**
   *
   * @type {string}
   * @memberof HandOffSend
   */
  inviteType: string;
  /**
   *
   * @type {string}
   * @memberof HandOffSend
   */
  user?: string;
  /**
   *
   * @type {NewManagerConversationExternalStartContext}
   * @memberof HandOffSend
   */
  startContext?: NewManagerConversationExternalStartContext;
  /**
   * E.164 format phone number
   * @type {string}
   * @memberof HandOffSend
   */
  recipient: string;
  /**
   * A call ID
   * @type {string}
   * @memberof HandOffSend
   */
  callSid: string;
}
/**
 *
 * @export
 * @interface HandOffSmsEventType
 */
export interface HandOffSmsEventType {
  /**
   *
   * @type {string}
   * @memberof HandOffSmsEventType
   */
  eventType: HandOffSmsEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof HandOffSmsEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof HandOffSmsEventType
   */
  callSid?: string;
}

export const HandOffSmsEventTypeEventTypeEnum = {
  HandOffSms: "HAND_OFF_SMS",
} as const;

export type HandOffSmsEventTypeEventTypeEnum =
  (typeof HandOffSmsEventTypeEventTypeEnum)[keyof typeof HandOffSmsEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface HealthCheckSummary
 */
export interface HealthCheckSummary {
  /**
   * The version of the service currently running
   * @type {string}
   * @memberof HealthCheckSummary
   */
  version?: string;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof HealthCheckSummary
   */
  additionalChecks?: { [key: string]: any };
}
/**
 *
 * @export
 * @interface HolidayCalendarCreate
 */
export interface HolidayCalendarCreate {
  /**
   *
   * @type {string}
   * @memberof HolidayCalendarCreate
   */
  name: string;
  /**
   *
   * @type {Array<HolidayCalendarListDates>}
   * @memberof HolidayCalendarCreate
   */
  dates: Array<HolidayCalendarListDates>;
}
/**
 *
 * @export
 * @interface HolidayCalendarList
 */
export interface HolidayCalendarList {
  /**
   *
   * @type {Array<HolidayCalendarListHolidayCalendars>}
   * @memberof HolidayCalendarList
   */
  holidayCalendars?: Array<HolidayCalendarListHolidayCalendars>;
}
/**
 *
 * @export
 * @interface HolidayCalendarListDates
 */
export interface HolidayCalendarListDates {
  /**
   *
   * @type {string}
   * @memberof HolidayCalendarListDates
   */
  holidayName: string;
  /**
   *
   * @type {string}
   * @memberof HolidayCalendarListDates
   */
  date: string;
}
/**
 *
 * @export
 * @interface HolidayCalendarListHolidayCalendars
 */
export interface HolidayCalendarListHolidayCalendars {
  /**
   *
   * @type {string}
   * @memberof HolidayCalendarListHolidayCalendars
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof HolidayCalendarListHolidayCalendars
   */
  name: string;
  /**
   *
   * @type {Array<HolidayCalendarListDates>}
   * @memberof HolidayCalendarListHolidayCalendars
   */
  dates: Array<HolidayCalendarListDates>;
}
/**
 *
 * @export
 * @interface HolidayCalendarRead
 */
export interface HolidayCalendarRead {
  /**
   *
   * @type {string}
   * @memberof HolidayCalendarRead
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof HolidayCalendarRead
   */
  name: string;
  /**
   *
   * @type {Array<HolidayCalendarListDates>}
   * @memberof HolidayCalendarRead
   */
  dates: Array<HolidayCalendarListDates>;
}
/**
 *
 * @export
 * @interface HolidayCalendarUpdate
 */
export interface HolidayCalendarUpdate {
  /**
   *
   * @type {string}
   * @memberof HolidayCalendarUpdate
   */
  name?: string;
  /**
   *
   * @type {Array<HolidayCalendarListDates>}
   * @memberof HolidayCalendarUpdate
   */
  dates?: Array<HolidayCalendarListDates>;
}
/**
 *
 * @export
 * @interface HolidayCalendarWriteResponse
 */
export interface HolidayCalendarWriteResponse {
  /**
   *
   * @type {string}
   * @memberof HolidayCalendarWriteResponse
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof HolidayCalendarWriteResponse
   */
  name: string;
  /**
   *
   * @type {Array<HolidayCalendarListDates>}
   * @memberof HolidayCalendarWriteResponse
   */
  dates: Array<HolidayCalendarListDates>;
}
/**
 * Sections of an asset that can be inherited
 * @export
 * @enum {string}
 */

export const InheritanceSections = {
  AllowedTaskTypes: "allowedTaskTypes",
  Location: "location",
  Offerings: "offerings",
  ServiceLevel: "serviceLevel",
  QuickLinks: "quickLinks",
} as const;

export type InheritanceSections = (typeof InheritanceSections)[keyof typeof InheritanceSections];

/**
 * @type InlineResponse200
 * @export
 */
export type InlineResponse200 =
  | AssetExportReadExternal
  | OrgExportReadExternal
  | TaskExportReadExternal
  | TeamExportReadExternal
  | UserExportReadExternal;

/**
 * @type InlineResponse201
 * @export
 */
export type InlineResponse201 = TaskExportReadExternal;

/**
 * @type InlineResponse2011
 * @export
 */
export type InlineResponse2011 = AssetExportReadExternal;

/**
 * @type InlineResponse2012
 * @export
 */
export type InlineResponse2012 = UserExportReadExternal;

/**
 * @type InlineResponse2013
 * @export
 */
export type InlineResponse2013 = OrgExportReadExternal;

/**
 * @type InlineResponse2014
 * @export
 */
export type InlineResponse2014 = TeamExportReadExternal;

/**
 *
 * @export
 * @enum {string}
 */

export const IvrResolution = {
  Handled: "HANDLED",
  Transferred: "TRANSFERRED",
  HandOff: "HAND_OFF",
} as const;

export type IvrResolution = (typeof IvrResolution)[keyof typeof IvrResolution];

/**
 *
 * @export
 * @interface IvrResolved
 */
export interface IvrResolved {
  /**
   * A call ID
   * @type {string}
   * @memberof IvrResolved
   */
  callSid: string;
  /**
   *
   * @type {IvrResolution}
   * @memberof IvrResolved
   */
  resolution: IvrResolution;
  /**
   *
   * @type {string}
   * @memberof IvrResolved
   */
  userUid?: string;
  /**
   *
   * @type {string}
   * @memberof IvrResolved
   */
  assetUid?: string;
  /**
   *
   * @type {string}
   * @memberof IvrResolved
   */
  taskUid?: string;
  /**
   *
   * @type {boolean}
   * @memberof IvrResolved
   */
  newTask?: boolean;
  /**
   *
   * @type {string}
   * @memberof IvrResolved
   */
  brandSlug?: string;
}

/**
 *
 * @export
 * @interface IvrResolvedEventType
 */
export interface IvrResolvedEventType {
  /**
   *
   * @type {string}
   * @memberof IvrResolvedEventType
   */
  eventType: IvrResolvedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof IvrResolvedEventType
   */
  eventAt: string;
  /**
   *
   * @type {IvrResolution}
   * @memberof IvrResolvedEventType
   */
  resolution?: IvrResolution;
  /**
   *
   * @type {string}
   * @memberof IvrResolvedEventType
   */
  callSid?: string;
}

export const IvrResolvedEventTypeEventTypeEnum = {
  IvrResolved: "IVR_RESOLVED",
} as const;

export type IvrResolvedEventTypeEventTypeEnum =
  (typeof IvrResolvedEventTypeEventTypeEnum)[keyof typeof IvrResolvedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface JoinChat
 */
export interface JoinChat {
  /**
   *
   * @type {string}
   * @memberof JoinChat
   */
  conversationUid: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const LinkType = {
  TaskLink: "TASK_LINK",
  AssetLink: "ASSET_LINK",
  OnSiteLink: "ON_SITE_LINK",
  AssetRegLink: "ASSET_REG_LINK",
  OrgRegLink: "ORG_REG_LINK",
  TaskMessageThreadLink: "TASK_MESSAGE_THREAD_LINK",
  OutboundConversation: "OUTBOUND_CONVERSATION",
  FileLink: "FILE_LINK",
} as const;

export type LinkType = (typeof LinkType)[keyof typeof LinkType];

/**
 *
 * @export
 * @interface MessageSearchResultExternal
 */
export interface MessageSearchResultExternal {
  /**
   *
   * @type {string}
   * @memberof MessageSearchResultExternal
   */
  created?: string;
  /**
   *
   * @type {string}
   * @memberof MessageSearchResultExternal
   */
  lastUpdated?: string;
  /**
   *
   * @type {string}
   * @memberof MessageSearchResultExternal
   */
  taskUid?: string;
  /**
   *
   * @type {boolean}
   * @memberof MessageSearchResultExternal
   */
  unread?: boolean;
  /**
   *
   * @type {Array<UserSummaryExternal>}
   * @memberof MessageSearchResultExternal
   */
  participants?: Array<UserSummaryExternal>;
  /**
   *
   * @type {MessageSearchResultMessage}
   * @memberof MessageSearchResultExternal
   */
  message?: MessageSearchResultMessage;
}
/**
 * @type MessageSearchResultMessage
 * @export
 */
export type MessageSearchResultMessage =
  | MessageSearchResultMessageCall
  | MessageSearchResultMessageConversation
  | MessageSearchResultMessageThread;

/**
 *
 * @export
 * @interface MessageSearchResultMessageCall
 */
export interface MessageSearchResultMessageCall {
  /**
   *
   * @type {string}
   * @memberof MessageSearchResultMessageCall
   */
  callRecordUid?: string;
  /**
   *
   * @type {CallDirection}
   * @memberof MessageSearchResultMessageCall
   */
  direction?: CallDirection;
}

/**
 *
 * @export
 * @interface MessageSearchResultMessageConversation
 */
export interface MessageSearchResultMessageConversation {
  /**
   *
   * @type {string}
   * @memberof MessageSearchResultMessageConversation
   */
  conversationUid?: string;
  /**
   *
   * @type {number}
   * @memberof MessageSearchResultMessageConversation
   */
  ratingScore?: number;
}
/**
 *
 * @export
 * @interface MessageSearchResultMessageThread
 */
export interface MessageSearchResultMessageThread {
  /**
   *
   * @type {string}
   * @memberof MessageSearchResultMessageThread
   */
  threadUid?: string;
  /**
   *
   * @type {string}
   * @memberof MessageSearchResultMessageThread
   */
  subject?: string;
}
/**
 *
 * @export
 * @interface MessageSendRequest
 */
export interface MessageSendRequest {
  /**
   *
   * @type {ThreadMessageRequestMessageBody}
   * @memberof MessageSendRequest
   */
  messageBody: ThreadMessageRequestMessageBody;
  /**
   *
   * @type {ThreadMessageType}
   * @memberof MessageSendRequest
   */
  messageType: ThreadMessageType;
  /**
   *
   * @type {string}
   * @memberof MessageSendRequest
   */
  source?: string;
  /**
   *
   * @type {boolean}
   * @memberof MessageSendRequest
   */
  replyAllowed: boolean;
  /**
   *
   * @type {string}
   * @memberof MessageSendRequest
   */
  threadUid: string;
  /**
   *
   * @type {ThreadGetResponseExternalFollowOnAction}
   * @memberof MessageSendRequest
   */
  followOnAction?: ThreadGetResponseExternalFollowOnAction;
}

/**
 *
 * @export
 * @interface MutedEventType
 */
export interface MutedEventType {
  /**
   *
   * @type {string}
   * @memberof MutedEventType
   */
  eventType: MutedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof MutedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof MutedEventType
   */
  participant?: string;
}

export const MutedEventTypeEventTypeEnum = {
  Muted: "MUTED",
} as const;

export type MutedEventTypeEventTypeEnum =
  (typeof MutedEventTypeEventTypeEnum)[keyof typeof MutedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface NewConversationAssetExternal
 */
export interface NewConversationAssetExternal {
  /**
   *
   * @type {string}
   * @memberof NewConversationAssetExternal
   */
  accessCode: string;
  /**
   * Current session JWT if available
   * @type {string}
   * @memberof NewConversationAssetExternal
   */
  sessionToken?: string;
  /**
   *
   * @type {NewManagerConversationExternalStartContext}
   * @memberof NewConversationAssetExternal
   */
  startContext?: NewManagerConversationExternalStartContext;
}
/**
 *
 * @export
 * @interface NewConversationTaskTypeExternal
 */
export interface NewConversationTaskTypeExternal {
  /**
   *
   * @type {NewManagerConversationExternalStartContext}
   * @memberof NewConversationTaskTypeExternal
   */
  startContext?: NewManagerConversationExternalStartContext;
}
/**
 * Request for a new file
 * @export
 * @interface NewFile
 */
export interface NewFile {
  /**
   * Path part of filename
   * @type {string}
   * @memberof NewFile
   */
  pathPrefix: string;
  /**
   * File name to upload
   * @type {string}
   * @memberof NewFile
   */
  filename: string;
  /**
   * Whether the given file required sensitive handling
   * @type {boolean}
   * @memberof NewFile
   */
  sensitive?: boolean;
  /**
   * Whether to allow for static access
   * @type {boolean}
   * @memberof NewFile
   */
  allowStatic?: boolean;
}
/**
 *
 * @export
 * @interface NewManagerConversationExternal
 */
export interface NewManagerConversationExternal {
  /**
   *
   * @type {NewManagerConversationExternalStartContext}
   * @memberof NewManagerConversationExternal
   */
  startContext?: NewManagerConversationExternalStartContext;
}
/**
 *
 * @export
 * @interface NewManagerConversationExternalStartContext
 */
export interface NewManagerConversationExternalStartContext {
  /**
   *
   * @type {string}
   * @memberof NewManagerConversationExternalStartContext
   */
  asset?: string;
  /**
   *
   * @type {string}
   * @memberof NewManagerConversationExternalStartContext
   */
  assetType?: string;
  /**
   *
   * @type {string}
   * @memberof NewManagerConversationExternalStartContext
   */
  task?: string;
  /**
   *
   * @type {string}
   * @memberof NewManagerConversationExternalStartContext
   */
  taskType?: string;
  /**
   *
   * @type {string}
   * @memberof NewManagerConversationExternalStartContext
   */
  org?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof NewManagerConversationExternalStartContext
   */
  flags?: Array<string>;
}
/**
 *
 * @export
 * @interface NewOutboundConversationExternal
 */
export interface NewOutboundConversationExternal {
  /**
   *
   * @type {string}
   * @memberof NewOutboundConversationExternal
   */
  inviteCode?: string;
  /**
   *
   * @type {string}
   * @memberof NewOutboundConversationExternal
   */
  accessCode?: string;
}
/**
 *
 * @export
 * @interface NewPrincipalConversationExternal
 */
export interface NewPrincipalConversationExternal {
  /**
   *
   * @type {NewManagerConversationExternalStartContext}
   * @memberof NewPrincipalConversationExternal
   */
  startContext?: NewManagerConversationExternalStartContext;
}
/**
 *
 * @export
 * @interface NewTokenConversationExternal
 */
export interface NewTokenConversationExternal {
  /**
   *
   * @type {NewManagerConversationExternalStartContext}
   * @memberof NewTokenConversationExternal
   */
  startContext?: NewManagerConversationExternalStartContext;
  /**
   *
   * @type {string}
   * @memberof NewTokenConversationExternal
   */
  startToken: string;
}
/**
 *
 * @export
 * @interface NoticeCreate
 */
export interface NoticeCreate {
  /**
   * Title of the notice for admin
   * @type {string}
   * @memberof NoticeCreate
   */
  title: string;
  /**
   * Message to be played
   * @type {string}
   * @memberof NoticeCreate
   */
  message: string;
  /**
   * Whether currently active
   * @type {boolean}
   * @memberof NoticeCreate
   */
  active: boolean;
  /**
   *
   * @type {NoticeListScope}
   * @memberof NoticeCreate
   */
  scope: NoticeListScope;
}
/**
 *
 * @export
 * @interface NoticeList
 */
export interface NoticeList {
  /**
   *
   * @type {Array<NoticeListNotices>}
   * @memberof NoticeList
   */
  notices?: Array<NoticeListNotices>;
  /**
   *
   * @type {ExportsListExternalPage}
   * @memberof NoticeList
   */
  page?: ExportsListExternalPage;
}
/**
 *
 * @export
 * @interface NoticeListNotices
 */
export interface NoticeListNotices {
  /**
   *
   * @type {string}
   * @memberof NoticeListNotices
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof NoticeListNotices
   */
  urn: string;
  /**
   * Title of the notice for admin
   * @type {string}
   * @memberof NoticeListNotices
   */
  title: string;
  /**
   * Message to be played
   * @type {string}
   * @memberof NoticeListNotices
   */
  message: string;
  /**
   * Whether currently active
   * @type {boolean}
   * @memberof NoticeListNotices
   */
  active: boolean;
  /**
   *
   * @type {NoticeListScope}
   * @memberof NoticeListNotices
   */
  scope: NoticeListScope;
}
/**
 *
 * @export
 * @interface NoticeListScope
 */
export interface NoticeListScope {
  /**
   * Whether it appleis across all brands
   * @type {boolean}
   * @memberof NoticeListScope
   */
  global: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof NoticeListScope
   */
  brands?: Array<string>;
}
/**
 *
 * @export
 * @interface NoticeRead
 */
export interface NoticeRead {
  /**
   *
   * @type {string}
   * @memberof NoticeRead
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof NoticeRead
   */
  urn: string;
  /**
   * Title of the notice for admin
   * @type {string}
   * @memberof NoticeRead
   */
  title: string;
  /**
   * Message to be played
   * @type {string}
   * @memberof NoticeRead
   */
  message: string;
  /**
   * Whether currently active
   * @type {boolean}
   * @memberof NoticeRead
   */
  active: boolean;
  /**
   *
   * @type {NoticeListScope}
   * @memberof NoticeRead
   */
  scope: NoticeListScope;
}
/**
 *
 * @export
 * @interface NoticeUpdate
 */
export interface NoticeUpdate {
  /**
   * Title of the notice for admin
   * @type {string}
   * @memberof NoticeUpdate
   */
  title?: string;
  /**
   * Message to be played
   * @type {string}
   * @memberof NoticeUpdate
   */
  message?: string;
  /**
   * Whether currently active
   * @type {boolean}
   * @memberof NoticeUpdate
   */
  active?: boolean;
  /**
   *
   * @type {NoticeListScope}
   * @memberof NoticeUpdate
   */
  scope?: NoticeListScope;
}
/**
 *
 * @export
 * @interface OffHoldEventType
 */
export interface OffHoldEventType {
  /**
   *
   * @type {string}
   * @memberof OffHoldEventType
   */
  eventType: OffHoldEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof OffHoldEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof OffHoldEventType
   */
  participant?: string;
}

export const OffHoldEventTypeEventTypeEnum = {
  OffHold: "OFF_HOLD",
} as const;

export type OffHoldEventTypeEventTypeEnum =
  (typeof OffHoldEventTypeEventTypeEnum)[keyof typeof OffHoldEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface OfferingListExternal
 */
export interface OfferingListExternal {
  /**
   *
   * @type {Array<OfferingListExternalOfferings>}
   * @memberof OfferingListExternal
   */
  offerings?: Array<OfferingListExternalOfferings>;
}
/**
 *
 * @export
 * @interface OfferingListExternalOfferings
 */
export interface OfferingListExternalOfferings {
  /**
   *
   * @type {string}
   * @memberof OfferingListExternalOfferings
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof OfferingListExternalOfferings
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof OfferingListExternalOfferings
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof OfferingListExternalOfferings
   */
  displayName: string;
}
/**
 *
 * @export
 * @interface OnHoldEventType
 */
export interface OnHoldEventType {
  /**
   *
   * @type {string}
   * @memberof OnHoldEventType
   */
  eventType: OnHoldEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof OnHoldEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof OnHoldEventType
   */
  participant?: string;
}

export const OnHoldEventTypeEventTypeEnum = {
  OnHold: "ON_HOLD",
} as const;

export type OnHoldEventTypeEventTypeEnum =
  (typeof OnHoldEventTypeEventTypeEnum)[keyof typeof OnHoldEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface OrgCreate
 */
export interface OrgCreate {
  /**
   *
   * @type {string}
   * @memberof OrgCreate
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof OrgCreate
   */
  description?: string;
  /**
   *
   * @type {OrgTypeSlug}
   * @memberof OrgCreate
   */
  orgTypeSlug: OrgTypeSlug;
  /**
   *
   * @type {FileRef}
   * @memberof OrgCreate
   */
  profilePhoto?: FileRef;
  /**
   *
   * @type {OrgCreateTokenRegistration}
   * @memberof OrgCreate
   */
  tokenRegistration?: OrgCreateTokenRegistration;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof OrgCreate
   */
  extendedMetadata?: { [key: string]: any };
  /**
   *
   * @type {TaskFullExternalLink}
   * @memberof OrgCreate
   */
  externalLink?: TaskFullExternalLink;
}

/**
 *
 * @export
 * @interface OrgCreateTokenRegistration
 */
export interface OrgCreateTokenRegistration {
  /**
   *
   * @type {boolean}
   * @memberof OrgCreateTokenRegistration
   */
  enabled: boolean;
  /**
   *
   * @type {string}
   * @memberof OrgCreateTokenRegistration
   */
  token?: string;
  /**
   *
   * @type {string}
   * @memberof OrgCreateTokenRegistration
   */
  shortLinkUid?: string;
}
/**
 *
 * @export
 * @interface OrgExportCreate
 */
export interface OrgExportCreate {
  /**
   *
   * @type {string}
   * @memberof OrgExportCreate
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof OrgExportCreate
   */
  timezone: string;
  /**
   *
   * @type {string}
   * @memberof OrgExportCreate
   */
  freeText?: string;
  /**
   *
   * @type {string}
   * @memberof OrgExportCreate
   */
  format: OrgExportCreateFormatEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof OrgExportCreate
   */
  fields?: Array<OrgExportCreateFieldsEnum>;
  /**
   *
   * @type {SearchOrgFilter}
   * @memberof OrgExportCreate
   */
  filter?: SearchOrgFilter;
  /**
   *
   * @type {SearchOrgSort}
   * @memberof OrgExportCreate
   */
  sort?: SearchOrgSort;
}

export const OrgExportCreateFormatEnum = {
  Standard: "STANDARD",
  ExcelCompatible: "EXCEL_COMPATIBLE",
} as const;

export type OrgExportCreateFormatEnum = (typeof OrgExportCreateFormatEnum)[keyof typeof OrgExportCreateFormatEnum];
export const OrgExportCreateFieldsEnum = {
  RegistrationToken: "REGISTRATION_TOKEN",
} as const;

export type OrgExportCreateFieldsEnum = (typeof OrgExportCreateFieldsEnum)[keyof typeof OrgExportCreateFieldsEnum];

/**
 *
 * @export
 * @interface OrgExportReadExternal
 */
export interface OrgExportReadExternal {
  /**
   *
   * @type {string}
   * @memberof OrgExportReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof OrgExportReadExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof OrgExportReadExternal
   */
  name: string;
  /**
   * Language code including locale
   * @type {string}
   * @memberof OrgExportReadExternal
   */
  languageCode: string;
  /**
   *
   * @type {string}
   * @memberof OrgExportReadExternal
   */
  timezone: string;
  /**
   *
   * @type {number}
   * @memberof OrgExportReadExternal
   */
  resultCount?: number;
  /**
   *
   * @type {TaskExportReadExternalProgress}
   * @memberof OrgExportReadExternal
   */
  progress: TaskExportReadExternalProgress;
  /**
   *
   * @type {string}
   * @memberof OrgExportReadExternal
   */
  requestedAt: string;
  /**
   *
   * @type {string}
   * @memberof OrgExportReadExternal
   */
  freeText?: string;
  /**
   *
   * @type {string}
   * @memberof OrgExportReadExternal
   */
  format: OrgExportReadExternalFormatEnum;
  /**
   *
   * @type {UserRefHydrated}
   * @memberof OrgExportReadExternal
   */
  createdBy: UserRefHydrated;
  /**
   *
   * @type {string}
   * @memberof OrgExportReadExternal
   */
  type: OrgExportReadExternalTypeEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof OrgExportReadExternal
   */
  fields: Array<OrgExportReadExternalFieldsEnum>;
  /**
   *
   * @type {SearchOrgFilter}
   * @memberof OrgExportReadExternal
   */
  filter: SearchOrgFilter;
  /**
   *
   * @type {SearchOrgSort}
   * @memberof OrgExportReadExternal
   */
  sort: SearchOrgSort;
}

export const OrgExportReadExternalFormatEnum = {
  Standard: "STANDARD",
  ExcelCompatible: "EXCEL_COMPATIBLE",
} as const;

export type OrgExportReadExternalFormatEnum =
  (typeof OrgExportReadExternalFormatEnum)[keyof typeof OrgExportReadExternalFormatEnum];
export const OrgExportReadExternalTypeEnum = {
  Org: "ORG",
} as const;

export type OrgExportReadExternalTypeEnum =
  (typeof OrgExportReadExternalTypeEnum)[keyof typeof OrgExportReadExternalTypeEnum];
export const OrgExportReadExternalFieldsEnum = {
  RegistrationToken: "REGISTRATION_TOKEN",
} as const;

export type OrgExportReadExternalFieldsEnum =
  (typeof OrgExportReadExternalFieldsEnum)[keyof typeof OrgExportReadExternalFieldsEnum];

/**
 *
 * @export
 * @interface OrgFilterValuesExternal
 */
export interface OrgFilterValuesExternal {
  /**
   *
   * @type {Array<ExtendedMetadataAttributeFilterSummaryExternal>}
   * @memberof OrgFilterValuesExternal
   */
  extendedMetadata?: Array<ExtendedMetadataAttributeFilterSummaryExternal>;
}
/**
 *
 * @export
 * @interface OrgReadExternal
 */
export interface OrgReadExternal {
  /**
   *
   * @type {string}
   * @memberof OrgReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof OrgReadExternal
   */
  urn: string;
  /**
   *
   * @type {OrgTypeSlug}
   * @memberof OrgReadExternal
   */
  orgTypeSlug: OrgTypeSlug;
  /**
   *
   * @type {string}
   * @memberof OrgReadExternal
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof OrgReadExternal
   */
  name: string;
  /**
   *
   * @type {OrgReadExternalTokenRegistration}
   * @memberof OrgReadExternal
   */
  tokenRegistration?: OrgReadExternalTokenRegistration;
  /**
   *
   * @type {FilePath}
   * @memberof OrgReadExternal
   */
  profilePhoto?: FilePath;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof OrgReadExternal
   */
  extendedMetadata?: { [key: string]: any };
  /**
   *
   * @type {Array<TaskFullLinkedUsers>}
   * @memberof OrgReadExternal
   */
  linkedUsers?: Array<TaskFullLinkedUsers>;
  /**
   *
   * @type {TaskFullExternalLink}
   * @memberof OrgReadExternal
   */
  externalLink?: TaskFullExternalLink;
  /**
   *
   * @type {ChangeSummary}
   * @memberof OrgReadExternal
   */
  changeSummary?: ChangeSummary;
}

/**
 *
 * @export
 * @interface OrgReadExternalTokenRegistration
 */
export interface OrgReadExternalTokenRegistration {
  /**
   *
   * @type {boolean}
   * @memberof OrgReadExternalTokenRegistration
   */
  enabled: boolean;
  /**
   *
   * @type {string}
   * @memberof OrgReadExternalTokenRegistration
   */
  token?: string;
  /**
   *
   * @type {ShortLinkExpanded}
   * @memberof OrgReadExternalTokenRegistration
   */
  shortLink?: ShortLinkExpanded;
}
/**
 *
 * @export
 * @interface OrgSearchResultExternal
 */
export interface OrgSearchResultExternal {
  /**
   *
   * @type {string}
   * @memberof OrgSearchResultExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof OrgSearchResultExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof OrgSearchResultExternal
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof OrgSearchResultExternal
   */
  description?: string;
  /**
   *
   * @type {OrgTypeSlug}
   * @memberof OrgSearchResultExternal
   */
  orgTypeSlug: OrgTypeSlug;
  /**
   *
   * @type {FilePath}
   * @memberof OrgSearchResultExternal
   */
  profilePhoto?: FilePath;
}

/**
 *
 * @export
 * @interface OrgSummaryExternal
 */
export interface OrgSummaryExternal {
  /**
   *
   * @type {string}
   * @memberof OrgSummaryExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof OrgSummaryExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof OrgSummaryExternal
   */
  name: string;
  /**
   *
   * @type {OrgTypeSlug}
   * @memberof OrgSummaryExternal
   */
  orgTypeSlug: OrgTypeSlug;
  /**
   *
   * @type {FilePath}
   * @memberof OrgSummaryExternal
   */
  profilePhoto?: FilePath;
}

/**
 *
 * @export
 * @interface OrgTypeExtMetadataReadExternal
 */
export interface OrgTypeExtMetadataReadExternal {
  /**
   *
   * @type {Array<RoleExtMetadataReadExternalExtMetadataConfig>}
   * @memberof OrgTypeExtMetadataReadExternal
   */
  extMetadataConfig: Array<RoleExtMetadataReadExternalExtMetadataConfig>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const OrgTypeSlug = {
  Supplier: "SUPPLIER",
  Owner: "OWNER",
  ServiceUser: "SERVICE_USER",
} as const;

export type OrgTypeSlug = (typeof OrgTypeSlug)[keyof typeof OrgTypeSlug];

/**
 *
 * @export
 * @interface OrgUpdate
 */
export interface OrgUpdate {
  /**
   *
   * @type {string}
   * @memberof OrgUpdate
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof OrgUpdate
   */
  description?: string;
  /**
   *
   * @type {FileRef}
   * @memberof OrgUpdate
   */
  profilePhoto?: FileRef;
  /**
   *
   * @type {OrgCreateTokenRegistration}
   * @memberof OrgUpdate
   */
  tokenRegistration?: OrgCreateTokenRegistration;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof OrgUpdate
   */
  extendedMetadata?: { [key: string]: any };
  /**
   *
   * @type {TaskFullExternalLink}
   * @memberof OrgUpdate
   */
  externalLink?: TaskFullExternalLink;
}
/**
 *
 * @export
 * @interface OrgWriteResponse
 */
export interface OrgWriteResponse {
  /**
   *
   * @type {string}
   * @memberof OrgWriteResponse
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof OrgWriteResponse
   */
  urn: string;
  /**
   *
   * @type {OrgTypeSlug}
   * @memberof OrgWriteResponse
   */
  orgTypeSlug: OrgTypeSlug;
  /**
   *
   * @type {string}
   * @memberof OrgWriteResponse
   */
  name: string;
}

/**
 *
 * @export
 * @interface ParticipantJoinedEventType
 */
export interface ParticipantJoinedEventType {
  /**
   *
   * @type {string}
   * @memberof ParticipantJoinedEventType
   */
  eventType: ParticipantJoinedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ParticipantJoinedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof ParticipantJoinedEventType
   */
  participant?: string;
}

export const ParticipantJoinedEventTypeEventTypeEnum = {
  ParticipantJoin: "PARTICIPANT_JOIN",
} as const;

export type ParticipantJoinedEventTypeEventTypeEnum =
  (typeof ParticipantJoinedEventTypeEventTypeEnum)[keyof typeof ParticipantJoinedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface ParticipantLeaveEventType
 */
export interface ParticipantLeaveEventType {
  /**
   *
   * @type {string}
   * @memberof ParticipantLeaveEventType
   */
  eventType: ParticipantLeaveEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ParticipantLeaveEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof ParticipantLeaveEventType
   */
  participant?: string;
}

export const ParticipantLeaveEventTypeEventTypeEnum = {
  ParticipantLeave: "PARTICIPANT_LEAVE",
} as const;

export type ParticipantLeaveEventTypeEventTypeEnum =
  (typeof ParticipantLeaveEventTypeEventTypeEnum)[keyof typeof ParticipantLeaveEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface PerformanceStatsFilter
 */
export interface PerformanceStatsFilter {
  /**
   *
   * @type {Array<string>}
   * @memberof PerformanceStatsFilter
   */
  linkedAsset?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof PerformanceStatsFilter
   */
  linkedAssetAncestor?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof PerformanceStatsFilter
   */
  taskType?: Array<string>;
  /**
   *
   * @type {SearchElementDateRange}
   * @memberof PerformanceStatsFilter
   */
  created?: SearchElementDateRange;
}
/**
 *
 * @export
 * @interface PerformanceStatsInternal
 */
export interface PerformanceStatsInternal {
  /**
   *
   * @type {Array<PerformanceStatsInternalResponseStatuses>}
   * @memberof PerformanceStatsInternal
   */
  responseStatuses: Array<PerformanceStatsInternalResponseStatuses>;
  /**
   *
   * @type {Array<PerformanceStatsInternalResponseStatuses>}
   * @memberof PerformanceStatsInternal
   */
  resolutionStatuses: Array<PerformanceStatsInternalResponseStatuses>;
  /**
   *
   * @type {Array<PerformanceStatsInternalResponseStatuses>}
   * @memberof PerformanceStatsInternal
   */
  dueStatuses: Array<PerformanceStatsInternalResponseStatuses>;
  /**
   *
   * @type {Array<PerformanceStatsInternalTaskStatuses>}
   * @memberof PerformanceStatsInternal
   */
  taskStatuses: Array<PerformanceStatsInternalTaskStatuses>;
  /**
   *
   * @type {Array<PerformanceStatsInternalTaskTypes>}
   * @memberof PerformanceStatsInternal
   */
  taskTypes: Array<PerformanceStatsInternalTaskTypes>;
  /**
   *
   * @type {Array<PerformanceStatsInternalTaskPriorities>}
   * @memberof PerformanceStatsInternal
   */
  taskPriorities: Array<PerformanceStatsInternalTaskPriorities>;
}
/**
 *
 * @export
 * @interface PerformanceStatsInternalResponseStatuses
 */
export interface PerformanceStatsInternalResponseStatuses {
  /**
   *
   * @type {SlaCurrentStatusReadOnly}
   * @memberof PerformanceStatsInternalResponseStatuses
   */
  status: SlaCurrentStatusReadOnly;
  /**
   *
   * @type {number}
   * @memberof PerformanceStatsInternalResponseStatuses
   */
  count: number;
}

/**
 *
 * @export
 * @interface PerformanceStatsInternalTaskPriorities
 */
export interface PerformanceStatsInternalTaskPriorities {
  /**
   *
   * @type {string}
   * @memberof PerformanceStatsInternalTaskPriorities
   */
  taskPriorityUid: string;
  /**
   *
   * @type {number}
   * @memberof PerformanceStatsInternalTaskPriorities
   */
  averageTimeToRespond?: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceStatsInternalTaskPriorities
   */
  averageTimeToResolve?: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceStatsInternalTaskPriorities
   */
  averageTimeToClose?: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceStatsInternalTaskPriorities
   */
  count: number;
}
/**
 *
 * @export
 * @interface PerformanceStatsInternalTaskStatuses
 */
export interface PerformanceStatsInternalTaskStatuses {
  /**
   *
   * @type {string}
   * @memberof PerformanceStatsInternalTaskStatuses
   */
  taskStatusUid: string;
  /**
   *
   * @type {number}
   * @memberof PerformanceStatsInternalTaskStatuses
   */
  count: number;
}
/**
 *
 * @export
 * @interface PerformanceStatsInternalTaskTypes
 */
export interface PerformanceStatsInternalTaskTypes {
  /**
   *
   * @type {string}
   * @memberof PerformanceStatsInternalTaskTypes
   */
  taskTypeUid: string;
  /**
   *
   * @type {number}
   * @memberof PerformanceStatsInternalTaskTypes
   */
  count: number;
}
/**
 *
 * @export
 * @interface PerformanceStatsRequest
 */
export interface PerformanceStatsRequest {
  /**
   *
   * @type {PerformanceStatsFilter}
   * @memberof PerformanceStatsRequest
   */
  filter?: PerformanceStatsFilter;
  /**
   *
   * @type {string}
   * @memberof PerformanceStatsRequest
   */
  oboUser?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const PermissionRole = {
  Svcusr: "SVCUSR",
  Supp: "SUPP",
  Manager: "MANAGER",
  SvcusrSpr: "SVCUSR_SPR",
  Agent: "AGENT",
  AgentSpr: "AGENT_SPR",
  ClientAdmin: "CLIENT_ADMIN",
  PlatAdmin: "PLAT_ADMIN",
  Owner: "OWNER",
  OwnerSpr: "OWNER_SPR",
  SuppSpr: "SUPP_SPR",
} as const;

export type PermissionRole = (typeof PermissionRole)[keyof typeof PermissionRole];

/**
 *
 * @export
 * @interface PersonSearchResultExternal
 */
export interface PersonSearchResultExternal {
  /**
   *
   * @type {string}
   * @memberof PersonSearchResultExternal
   */
  personScope: PersonSearchResultExternalPersonScopeEnum;
  /**
   *
   * @type {string}
   * @memberof PersonSearchResultExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchResultExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchResultExternal
   */
  givenName?: string;
  /**
   *
   * @type {string}
   * @memberof PersonSearchResultExternal
   */
  familyName?: string;
  /**
   *
   * @type {RoleSlug}
   * @memberof PersonSearchResultExternal
   */
  roleSlug?: RoleSlug;
  /**
   *
   * @type {RegistrationStatus}
   * @memberof PersonSearchResultExternal
   */
  registrationStatus?: RegistrationStatus;
  /**
   *
   * @type {boolean}
   * @memberof PersonSearchResultExternal
   */
  vip?: boolean;
  /**
   *
   * @type {FilePath}
   * @memberof PersonSearchResultExternal
   */
  profilePhoto?: FilePath;
  /**
   *
   * @type {string}
   * @memberof PersonSearchResultExternal
   */
  name?: string;
  /**
   *
   * @type {OrgTypeSlug}
   * @memberof PersonSearchResultExternal
   */
  orgTypeSlug?: OrgTypeSlug;
}

export const PersonSearchResultExternalPersonScopeEnum = {
  User: "USER",
  Org: "ORG",
  Team: "TEAM",
} as const;

export type PersonSearchResultExternalPersonScopeEnum =
  (typeof PersonSearchResultExternalPersonScopeEnum)[keyof typeof PersonSearchResultExternalPersonScopeEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const PolicyAction = {
  Fetch: "FETCH",
  NestedFetch: "NESTED_FETCH",
  List: "LIST",
  Use: "USE",
  Update: "UPDATE",
  Delete: "DELETE",
} as const;

export type PolicyAction = (typeof PolicyAction)[keyof typeof PolicyAction];

/**
 *
 * @export
 * @interface PolicyAnswer
 */
export interface PolicyAnswer {
  /**
   *
   * @type {Array<PolicyAnswerResults>}
   * @memberof PolicyAnswer
   */
  results: Array<PolicyAnswerResults>;
}
/**
 *
 * @export
 * @interface PolicyAnswerResults
 */
export interface PolicyAnswerResults {
  /**
   *
   * @type {string}
   * @memberof PolicyAnswerResults
   */
  resource: string;
  /**
   *
   * @type {PolicyOutcome}
   * @memberof PolicyAnswerResults
   */
  result: PolicyOutcome;
}

/**
 *
 * @export
 * @interface PolicyCheckExternal
 */
export interface PolicyCheckExternal {
  /**
   *
   * @type {PolicyAction}
   * @memberof PolicyCheckExternal
   */
  action: PolicyAction;
  /**
   *
   * @type {Set<string>}
   * @memberof PolicyCheckExternal
   */
  resources: Set<string>;
}

/**
 *
 * @export
 * @enum {string}
 */

export const PolicyOutcome = {
  Grant: "GRANT",
  Deny: "DENY",
  PolicyDocumentNotFound: "POLICY_DOCUMENT_NOT_FOUND",
  PolicyDocumentError: "POLICY_DOCUMENT_ERROR",
} as const;

export type PolicyOutcome = (typeof PolicyOutcome)[keyof typeof PolicyOutcome];

/**
 *
 * @export
 * @interface PrimaryCallEndEventType
 */
export interface PrimaryCallEndEventType {
  /**
   *
   * @type {string}
   * @memberof PrimaryCallEndEventType
   */
  eventType: PrimaryCallEndEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PrimaryCallEndEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof PrimaryCallEndEventType
   */
  callSid?: string;
}

export const PrimaryCallEndEventTypeEventTypeEnum = {
  PrimaryCallEnd: "PRIMARY_CALL_END",
} as const;

export type PrimaryCallEndEventTypeEventTypeEnum =
  (typeof PrimaryCallEndEventTypeEventTypeEnum)[keyof typeof PrimaryCallEndEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface PrimaryCallStartEventType
 */
export interface PrimaryCallStartEventType {
  /**
   *
   * @type {string}
   * @memberof PrimaryCallStartEventType
   */
  eventType: PrimaryCallStartEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PrimaryCallStartEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof PrimaryCallStartEventType
   */
  callSid?: string;
}

export const PrimaryCallStartEventTypeEventTypeEnum = {
  PrimaryCallStart: "PRIMARY_CALL_START",
} as const;

export type PrimaryCallStartEventTypeEventTypeEnum =
  (typeof PrimaryCallStartEventTypeEventTypeEnum)[keyof typeof PrimaryCallStartEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface PrincipalChatDetails
 */
export interface PrincipalChatDetails {
  /**
   *
   * @type {PrincipalChatDetailsConnectionDetails}
   * @memberof PrincipalChatDetails
   */
  connectionDetails?: PrincipalChatDetailsConnectionDetails;
  /**
   *
   * @type {Array<string>}
   * @memberof PrincipalChatDetails
   */
  availableLanguages?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof PrincipalChatDetails
   */
  conversationUrn?: string;
}
/**
 * Provider specific connection details
 * @export
 * @interface PrincipalChatDetailsConnectionDetails
 */
export interface PrincipalChatDetailsConnectionDetails {
  /**
   *
   * @type {string}
   * @memberof PrincipalChatDetailsConnectionDetails
   */
  token?: string;
  /**
   *
   * @type {string}
   * @memberof PrincipalChatDetailsConnectionDetails
   */
  streamUrl?: string;
  /**
   *
   * @type {string}
   * @memberof PrincipalChatDetailsConnectionDetails
   */
  conversationId?: string;
  /**
   *
   * @type {number}
   * @memberof PrincipalChatDetailsConnectionDetails
   */
  expires_in?: number;
}
/**
 *
 * @export
 * @interface ProductAdminSummaryExternal
 */
export interface ProductAdminSummaryExternal {
  /**
   *
   * @type {string}
   * @memberof ProductAdminSummaryExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ProductAdminSummaryExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof ProductAdminSummaryExternal
   */
  productTypeUid: string;
  /**
   *
   * @type {string}
   * @memberof ProductAdminSummaryExternal
   */
  title: string;
  /**
   *
   * @type {ProductStatus}
   * @memberof ProductAdminSummaryExternal
   */
  status: ProductStatus;
  /**
   *
   * @type {number}
   * @memberof ProductAdminSummaryExternal
   */
  price?: number;
  /**
   *
   * @type {AssetSummaryExternalMedia}
   * @memberof ProductAdminSummaryExternal
   */
  image?: AssetSummaryExternalMedia;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof ProductAdminSummaryExternal
   */
  extendedMetadata?: { [key: string]: any };
}

/**
 *
 * @export
 * @interface ProductCatalogueCreate
 */
export interface ProductCatalogueCreate {
  /**
   *
   * @type {string}
   * @memberof ProductCatalogueCreate
   */
  title: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ProductCatalogueCreate
   */
  allowedOfferings?: Array<string>;
  /**
   *
   * @type {Array<ProductCatalogueCreateProducts>}
   * @memberof ProductCatalogueCreate
   */
  products?: Array<ProductCatalogueCreateProducts>;
}
/**
 *
 * @export
 * @interface ProductCatalogueCreateProducts
 */
export interface ProductCatalogueCreateProducts {
  /**
   *
   * @type {string}
   * @memberof ProductCatalogueCreateProducts
   */
  productUid: string;
  /**
   *
   * @type {number}
   * @memberof ProductCatalogueCreateProducts
   */
  cataloguePrice?: number;
  /**
   *
   * @type {boolean}
   * @memberof ProductCatalogueCreateProducts
   */
  priceOverride?: boolean;
}
/**
 *
 * @export
 * @interface ProductCatalogueReadAdminExternal
 */
export interface ProductCatalogueReadAdminExternal {
  /**
   *
   * @type {string}
   * @memberof ProductCatalogueReadAdminExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ProductCatalogueReadAdminExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof ProductCatalogueReadAdminExternal
   */
  title: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ProductCatalogueReadAdminExternal
   */
  allowedOfferings?: Array<string>;
  /**
   *
   * @type {Array<ProductCatalogueReadAdminExternalProducts>}
   * @memberof ProductCatalogueReadAdminExternal
   */
  products?: Array<ProductCatalogueReadAdminExternalProducts>;
  /**
   *
   * @type {Array<TaskFullLinkedOrgs>}
   * @memberof ProductCatalogueReadAdminExternal
   */
  linkedOrgs?: Array<TaskFullLinkedOrgs>;
}
/**
 *
 * @export
 * @interface ProductCatalogueReadAdminExternalProducts
 */
export interface ProductCatalogueReadAdminExternalProducts {
  /**
   *
   * @type {number}
   * @memberof ProductCatalogueReadAdminExternalProducts
   */
  cataloguePrice?: number;
  /**
   *
   * @type {boolean}
   * @memberof ProductCatalogueReadAdminExternalProducts
   */
  priceOverride?: boolean;
  /**
   *
   * @type {ProductAdminSummaryExternal}
   * @memberof ProductCatalogueReadAdminExternalProducts
   */
  productSummary: ProductAdminSummaryExternal;
}
/**
 *
 * @export
 * @interface ProductCatalogueReadExternal
 */
export interface ProductCatalogueReadExternal {
  /**
   *
   * @type {string}
   * @memberof ProductCatalogueReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ProductCatalogueReadExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof ProductCatalogueReadExternal
   */
  title: string;
  /**
   *
   * @type {Array<ProductSummaryExternal>}
   * @memberof ProductCatalogueReadExternal
   */
  products?: Array<ProductSummaryExternal>;
}
/**
 *
 * @export
 * @interface ProductCatalogueSearchResultExternal
 */
export interface ProductCatalogueSearchResultExternal {
  /**
   *
   * @type {string}
   * @memberof ProductCatalogueSearchResultExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ProductCatalogueSearchResultExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof ProductCatalogueSearchResultExternal
   */
  title: string;
  /**
   *
   * @type {Array<ProductCatalogueSearchResultExternalProducts>}
   * @memberof ProductCatalogueSearchResultExternal
   */
  products?: Array<ProductCatalogueSearchResultExternalProducts>;
}
/**
 *
 * @export
 * @interface ProductCatalogueSearchResultExternalProducts
 */
export interface ProductCatalogueSearchResultExternalProducts {
  /**
   *
   * @type {number}
   * @memberof ProductCatalogueSearchResultExternalProducts
   */
  cataloguePrice?: number;
  /**
   *
   * @type {boolean}
   * @memberof ProductCatalogueSearchResultExternalProducts
   */
  priceOverride?: boolean;
  /**
   *
   * @type {ProductNestedSummary}
   * @memberof ProductCatalogueSearchResultExternalProducts
   */
  productSummary: ProductNestedSummary;
}
/**
 *
 * @export
 * @interface ProductCatalogueUpdate
 */
export interface ProductCatalogueUpdate {
  /**
   *
   * @type {string}
   * @memberof ProductCatalogueUpdate
   */
  title?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ProductCatalogueUpdate
   */
  allowedOfferings?: Array<string>;
  /**
   *
   * @type {Array<ProductCatalogueCreateProducts>}
   * @memberof ProductCatalogueUpdate
   */
  products?: Array<ProductCatalogueCreateProducts>;
}
/**
 *
 * @export
 * @interface ProductCatalogueWriteResponse
 */
export interface ProductCatalogueWriteResponse {
  /**
   *
   * @type {string}
   * @memberof ProductCatalogueWriteResponse
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ProductCatalogueWriteResponse
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof ProductCatalogueWriteResponse
   */
  title: string;
}
/**
 *
 * @export
 * @interface ProductCreate
 */
export interface ProductCreate {
  /**
   *
   * @type {string}
   * @memberof ProductCreate
   */
  productTypeUid: string;
  /**
   *
   * @type {string}
   * @memberof ProductCreate
   */
  title: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ProductCreate
   */
  displayTitle?: { [key: string]: string };
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ProductCreate
   */
  displaySubTitle?: { [key: string]: string };
  /**
   *
   * @type {ProductStatus}
   * @memberof ProductCreate
   */
  status: ProductStatus;
  /**
   *
   * @type {number}
   * @memberof ProductCreate
   */
  price: number;
  /**
   *
   * @type {ProductCreateImage}
   * @memberof ProductCreate
   */
  image?: ProductCreateImage | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof ProductCreate
   */
  extendedMetadata?: { [key: string]: any };
}

/**
 *
 * @export
 * @interface ProductCreateImage
 */
export interface ProductCreateImage {
  /**
   *
   * @type {FileRef}
   * @memberof ProductCreateImage
   */
  file: FileRef;
  /**
   *
   * @type {string}
   * @memberof ProductCreateImage
   */
  addedAt: string;
}
/**
 *
 * @export
 * @interface ProductFilterValuesExternal
 */
export interface ProductFilterValuesExternal {
  /**
   *
   * @type {Array<ExtendedMetadataAttributeFilterSummaryExternal>}
   * @memberof ProductFilterValuesExternal
   */
  extendedMetadata?: Array<ExtendedMetadataAttributeFilterSummaryExternal>;
}
/**
 *
 * @export
 * @interface ProductNestedSummary
 */
export interface ProductNestedSummary {
  /**
   *
   * @type {string}
   * @memberof ProductNestedSummary
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ProductNestedSummary
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof ProductNestedSummary
   */
  productTypeUid: string;
  /**
   *
   * @type {string}
   * @memberof ProductNestedSummary
   */
  title: string;
  /**
   *
   * @type {ProductStatus}
   * @memberof ProductNestedSummary
   */
  status: ProductStatus;
  /**
   *
   * @type {number}
   * @memberof ProductNestedSummary
   */
  price?: number;
}

/**
 *
 * @export
 * @interface ProductReadExternal
 */
export interface ProductReadExternal {
  /**
   *
   * @type {string}
   * @memberof ProductReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ProductReadExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof ProductReadExternal
   */
  productTypeUid: string;
  /**
   *
   * @type {string}
   * @memberof ProductReadExternal
   */
  title: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ProductReadExternal
   */
  displayTitle?: { [key: string]: string };
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ProductReadExternal
   */
  displaySubTitle?: { [key: string]: string };
  /**
   *
   * @type {ProductStatus}
   * @memberof ProductReadExternal
   */
  status: ProductStatus;
  /**
   *
   * @type {number}
   * @memberof ProductReadExternal
   */
  price?: number;
  /**
   *
   * @type {AssetSummaryExternalMedia}
   * @memberof ProductReadExternal
   */
  image?: AssetSummaryExternalMedia;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof ProductReadExternal
   */
  extendedMetadata?: { [key: string]: any };
}

/**
 *
 * @export
 * @interface ProductSearchResultExternal
 */
export interface ProductSearchResultExternal {
  /**
   *
   * @type {string}
   * @memberof ProductSearchResultExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ProductSearchResultExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof ProductSearchResultExternal
   */
  productTypeUid: string;
  /**
   *
   * @type {string}
   * @memberof ProductSearchResultExternal
   */
  title: string;
  /**
   *
   * @type {ProductStatus}
   * @memberof ProductSearchResultExternal
   */
  status: ProductStatus;
  /**
   *
   * @type {number}
   * @memberof ProductSearchResultExternal
   */
  price?: number;
  /**
   *
   * @type {AssetSummaryExternalMedia}
   * @memberof ProductSearchResultExternal
   */
  image?: AssetSummaryExternalMedia;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ProductStatus = {
  Active: "ACTIVE",
  Inactive: "INACTIVE",
  Discontinued: "DISCONTINUED",
} as const;

export type ProductStatus = (typeof ProductStatus)[keyof typeof ProductStatus];

/**
 *
 * @export
 * @interface ProductSummaryExternal
 */
export interface ProductSummaryExternal {
  /**
   *
   * @type {string}
   * @memberof ProductSummaryExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ProductSummaryExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof ProductSummaryExternal
   */
  productTypeUid: string;
  /**
   *
   * @type {string}
   * @memberof ProductSummaryExternal
   */
  title: string;
  /**
   *
   * @type {ProductStatus}
   * @memberof ProductSummaryExternal
   */
  status: ProductStatus;
  /**
   *
   * @type {number}
   * @memberof ProductSummaryExternal
   */
  resolvedPrice: number;
  /**
   *
   * @type {AssetSummaryExternalMedia}
   * @memberof ProductSummaryExternal
   */
  image?: AssetSummaryExternalMedia;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof ProductSummaryExternal
   */
  extendedMetadata?: { [key: string]: any };
}

/**
 *
 * @export
 * @interface ProductTypeListExternal
 */
export interface ProductTypeListExternal {
  /**
   *
   * @type {Array<ProductTypeListExternalProductTypes>}
   * @memberof ProductTypeListExternal
   */
  productTypes?: Array<ProductTypeListExternalProductTypes>;
}
/**
 *
 * @export
 * @interface ProductTypeListExternalProductTypes
 */
export interface ProductTypeListExternalProductTypes {
  /**
   *
   * @type {string}
   * @memberof ProductTypeListExternalProductTypes
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ProductTypeListExternalProductTypes
   */
  displayName?: string;
}
/**
 *
 * @export
 * @interface ProductTypeReadExternal
 */
export interface ProductTypeReadExternal {
  /**
   *
   * @type {string}
   * @memberof ProductTypeReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ProductTypeReadExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof ProductTypeReadExternal
   */
  displayName: string;
  /**
   *
   * @type {Array<AssetTypeReadExternalExtMetadataConfig>}
   * @memberof ProductTypeReadExternal
   */
  extMetadataConfig?: Array<AssetTypeReadExternalExtMetadataConfig>;
}
/**
 *
 * @export
 * @interface ProductUpdate
 */
export interface ProductUpdate {
  /**
   *
   * @type {string}
   * @memberof ProductUpdate
   */
  title?: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ProductUpdate
   */
  displayTitle?: { [key: string]: string };
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof ProductUpdate
   */
  displaySubTitle?: { [key: string]: string };
  /**
   *
   * @type {ProductStatus}
   * @memberof ProductUpdate
   */
  status?: ProductStatus;
  /**
   *
   * @type {number}
   * @memberof ProductUpdate
   */
  price?: number;
  /**
   *
   * @type {ProductCreateImage}
   * @memberof ProductUpdate
   */
  image?: ProductCreateImage | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof ProductUpdate
   */
  extendedMetadata?: { [key: string]: any };
}

/**
 *
 * @export
 * @interface ProductWriteResponse
 */
export interface ProductWriteResponse {
  /**
   *
   * @type {string}
   * @memberof ProductWriteResponse
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ProductWriteResponse
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof ProductWriteResponse
   */
  productTypeUid: string;
  /**
   *
   * @type {string}
   * @memberof ProductWriteResponse
   */
  title: string;
  /**
   *
   * @type {ProductStatus}
   * @memberof ProductWriteResponse
   */
  status: ProductStatus;
  /**
   *
   * @type {number}
   * @memberof ProductWriteResponse
   */
  price?: number;
}

/**
 *
 * @export
 * @interface ProfileReadExternal
 */
export interface ProfileReadExternal {
  /**
   *
   * @type {string}
   * @memberof ProfileReadExternal
   */
  uid?: string;
  /**
   *
   * @type {string}
   * @memberof ProfileReadExternal
   */
  givenName?: string;
  /**
   *
   * @type {string}
   * @memberof ProfileReadExternal
   */
  familyName?: string;
  /**
   *
   * @type {RoleSlug}
   * @memberof ProfileReadExternal
   */
  roleSlug?: RoleSlug;
  /**
   *
   * @type {boolean}
   * @memberof ProfileReadExternal
   */
  skipMobile?: boolean;
  /**
   *
   * @type {Array<ProfileReadExternalCommsChannels>}
   * @memberof ProfileReadExternal
   */
  commsChannels?: Array<ProfileReadExternalCommsChannels>;
  /**
   * Language code including locale
   * @type {string}
   * @memberof ProfileReadExternal
   */
  preferredLanguage?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ProfileReadExternal
   */
  userFeatureFlags?: Array<string>;
  /**
   *
   * @type {ProfileReadExternalAskAgentRoles}
   * @memberof ProfileReadExternal
   */
  askAgentRoles?: ProfileReadExternalAskAgentRoles;
  /**
   *
   * @type {ProfileReadExternalConsent}
   * @memberof ProfileReadExternal
   */
  consent?: ProfileReadExternalConsent;
  /**
   *
   * @type {Array<ProfileReadExternalChannelPreferences>}
   * @memberof ProfileReadExternal
   */
  channelPreferences?: Array<ProfileReadExternalChannelPreferences>;
  /**
   *
   * @type {string}
   * @memberof ProfileReadExternal
   */
  email?: string;
  /**
   * E.164 format phone number
   * @type {string}
   * @memberof ProfileReadExternal
   */
  phoneNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof ProfileReadExternal
   */
  emailVerified?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ProfileReadExternal
   */
  phoneVerified?: boolean;
  /**
   *
   * @type {FilePath}
   * @memberof ProfileReadExternal
   */
  profilePhoto?: FilePath;
  /**
   *
   * @type {TaskFullExternalLink}
   * @memberof ProfileReadExternal
   */
  externalLink?: TaskFullExternalLink;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof ProfileReadExternal
   */
  extendedMetadata?: { [key: string]: any };
}

/**
 *
 * @export
 * @interface ProfileReadExternalAskAgentRoles
 */
export interface ProfileReadExternalAskAgentRoles {
  /**
   *
   * @type {TwilioFlexRole}
   * @memberof ProfileReadExternalAskAgentRoles
   */
  twilioFlexRole: TwilioFlexRole;
  /**
   *
   * @type {Array<TwilioFlexInsightsRole>}
   * @memberof ProfileReadExternalAskAgentRoles
   */
  twilioFlexInsightsRoles?: Array<TwilioFlexInsightsRole>;
}

/**
 *
 * @export
 * @interface ProfileReadExternalChannelPreferences
 */
export interface ProfileReadExternalChannelPreferences {
  /**
   *
   * @type {string}
   * @memberof ProfileReadExternalChannelPreferences
   */
  channelPreferenceTypeUid: string;
  /**
   *
   * @type {Array<ChannelPreferenceChannel>}
   * @memberof ProfileReadExternalChannelPreferences
   */
  channels: Array<ChannelPreferenceChannel>;
}
/**
 *
 * @export
 * @interface ProfileReadExternalCommsChannels
 */
export interface ProfileReadExternalCommsChannels {
  /**
   *
   * @type {CommsChannelSlug}
   * @memberof ProfileReadExternalCommsChannels
   */
  commsChannelSlug?: CommsChannelSlug;
  /**
   *
   * @type {boolean}
   * @memberof ProfileReadExternalCommsChannels
   */
  allowed?: boolean;
}

/**
 *
 * @export
 * @interface ProfileReadExternalConsent
 */
export interface ProfileReadExternalConsent {
  /**
   *
   * @type {boolean}
   * @memberof ProfileReadExternalConsent
   */
  cookieConsent?: boolean;
  /**
   *
   * @type {string}
   * @memberof ProfileReadExternalConsent
   */
  cookieConsentLastUpdated?: string;
}
/**
 *
 * @export
 * @interface ProfileUpdateExternal
 */
export interface ProfileUpdateExternal {
  /**
   *
   * @type {string}
   * @memberof ProfileUpdateExternal
   */
  givenName?: string;
  /**
   *
   * @type {string}
   * @memberof ProfileUpdateExternal
   */
  familyName?: string;
  /**
   *
   * @type {boolean}
   * @memberof ProfileUpdateExternal
   */
  skipMobile?: boolean;
  /**
   *
   * @type {FileRef}
   * @memberof ProfileUpdateExternal
   */
  profilePhoto?: FileRef;
  /**
   * Language code including locale
   * @type {string}
   * @memberof ProfileUpdateExternal
   */
  preferredLanguage?: string;
  /**
   *
   * @type {Array<ProfileReadExternalCommsChannels>}
   * @memberof ProfileUpdateExternal
   */
  commsChannels?: Array<ProfileReadExternalCommsChannels>;
  /**
   *
   * @type {ProfileReadExternalConsent}
   * @memberof ProfileUpdateExternal
   */
  consent?: ProfileReadExternalConsent;
  /**
   *
   * @type {Array<ProfileReadExternalChannelPreferences>}
   * @memberof ProfileUpdateExternal
   */
  channelPreferences?: Array<ProfileReadExternalChannelPreferences>;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof ProfileUpdateExternal
   */
  extendedMetadata?: { [key: string]: any };
}
/**
 *
 * @export
 * @enum {string}
 */

export const RegistrationStatus = {
  InvitePending: "INVITE_PENDING",
  SelfRegConf: "SELF_REG_CONF",
  TokenRegConf: "TOKEN_REG_CONF",
  InviteAccepted: "INVITE_ACCEPTED",
} as const;

export type RegistrationStatus = (typeof RegistrationStatus)[keyof typeof RegistrationStatus];

/**
 *
 * @export
 * @interface RelationshipCreate
 */
export interface RelationshipCreate {
  /**
   *
   * @type {string}
   * @memberof RelationshipCreate
   */
  aParty: string;
  /**
   *
   * @type {RelationshipLabel}
   * @memberof RelationshipCreate
   */
  relationshipLabel: RelationshipLabel;
  /**
   *
   * @type {string}
   * @memberof RelationshipCreate
   */
  bParty: string;
}

/**
 *
 * @export
 * @interface RelationshipDeleteExternal
 */
export interface RelationshipDeleteExternal {
  /**
   *
   * @type {RelationshipListRelationships}
   * @memberof RelationshipDeleteExternal
   */
  relationshipKey: RelationshipListRelationships;
}
/**
 *
 * @export
 * @enum {string}
 */

export const RelationshipLabel = {
  AllowedTeam: "ALLOWED_TEAM",
  AssetChild: "ASSET_CHILD",
  AssetParent: "ASSET_PARENT",
  AssetLinkedOrg: "ASSET_LINKED_ORG",
  AssetLinkedTeam: "ASSET_LINKED_TEAM",
  AssetLinkedUser: "ASSET_LINKED_USER",
  AssetTag: "ASSET_TAG",
  AssignedTeam: "ASSIGNED_TEAM",
  AssignedUser: "ASSIGNED_USER",
  LinkedTask: "LINKED_TASK",
  OrgMember: "ORG_MEMBER",
  TaskLinkedOrg: "TASK_LINKED_ORG",
  TaskLinkedTeam: "TASK_LINKED_TEAM",
  TaskLinkedUser: "TASK_LINKED_USER",
  TaskMergedTo: "TASK_MERGED_TO",
  TaskOtherAsset: "TASK_OTHER_ASSET",
  TaskPrincipalAsset: "TASK_PRINCIPAL_ASSET",
  TaskInitiator: "TASK_INITIATOR",
  TaskTag: "TASK_TAG",
  TeamMember: "TEAM_MEMBER",
  ProductCatalogueLinkedOrg: "PRODUCT_CATALOGUE_LINKED_ORG",
} as const;

export type RelationshipLabel = (typeof RelationshipLabel)[keyof typeof RelationshipLabel];

/**
 *
 * @export
 * @interface RelationshipList
 */
export interface RelationshipList {
  /**
   *
   * @type {Array<RelationshipListRelationships>}
   * @memberof RelationshipList
   */
  relationships?: Array<RelationshipListRelationships>;
}
/**
 *
 * @export
 * @interface RelationshipListRelationships
 */
export interface RelationshipListRelationships {
  /**
   *
   * @type {string}
   * @memberof RelationshipListRelationships
   */
  aParty: string;
  /**
   *
   * @type {RelationshipLabel}
   * @memberof RelationshipListRelationships
   */
  relationshipLabel: RelationshipLabel;
  /**
   *
   * @type {string}
   * @memberof RelationshipListRelationships
   */
  bParty: string;
}

/**
 *
 * @export
 * @interface RelationshipMultiCreate
 */
export interface RelationshipMultiCreate {
  /**
   *
   * @type {RelationshipLabel}
   * @memberof RelationshipMultiCreate
   */
  relationshipLabel: RelationshipLabel;
  /**
   *
   * @type {Array<RelationshipMultiCreateParties>}
   * @memberof RelationshipMultiCreate
   */
  parties: Array<RelationshipMultiCreateParties>;
}

/**
 *
 * @export
 * @interface RelationshipMultiCreateParties
 */
export interface RelationshipMultiCreateParties {
  /**
   *
   * @type {string}
   * @memberof RelationshipMultiCreateParties
   */
  bParty: string;
  /**
   *
   * @type {string}
   * @memberof RelationshipMultiCreateParties
   */
  aParty: string;
}
/**
 *
 * @export
 * @interface RelationshipUpdate
 */
export interface RelationshipUpdate {
  /**
   *
   * @type {RelationshipListRelationships}
   * @memberof RelationshipUpdate
   */
  relationshipKey: RelationshipListRelationships;
  /**
   *
   * @type {RelationshipLabel}
   * @memberof RelationshipUpdate
   */
  relationshipLabel: RelationshipLabel;
}

/**
 *
 * @export
 * @interface RelationshipWriteResponse
 */
export interface RelationshipWriteResponse {
  /**
   *
   * @type {string}
   * @memberof RelationshipWriteResponse
   */
  aParty: string;
  /**
   *
   * @type {RelationshipLabel}
   * @memberof RelationshipWriteResponse
   */
  relationshipLabel: RelationshipLabel;
  /**
   *
   * @type {string}
   * @memberof RelationshipWriteResponse
   */
  bParty: string;
}

/**
 *
 * @export
 * @interface ReservationAcceptedEventType
 */
export interface ReservationAcceptedEventType {
  /**
   *
   * @type {string}
   * @memberof ReservationAcceptedEventType
   */
  eventType: ReservationAcceptedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ReservationAcceptedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof ReservationAcceptedEventType
   */
  reservationSid?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationAcceptedEventType
   */
  workerSid?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationAcceptedEventType
   */
  workerName?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationAcceptedEventType
   */
  taskSid?: string;
}

export const ReservationAcceptedEventTypeEventTypeEnum = {
  ResvAccepted: "RESV_ACCEPTED",
} as const;

export type ReservationAcceptedEventTypeEventTypeEnum =
  (typeof ReservationAcceptedEventTypeEventTypeEnum)[keyof typeof ReservationAcceptedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface ReservationCompletedEventType
 */
export interface ReservationCompletedEventType {
  /**
   *
   * @type {string}
   * @memberof ReservationCompletedEventType
   */
  eventType: ReservationCompletedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ReservationCompletedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof ReservationCompletedEventType
   */
  reservationSid?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationCompletedEventType
   */
  workerSid?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationCompletedEventType
   */
  workerName?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationCompletedEventType
   */
  taskSid?: string;
}

export const ReservationCompletedEventTypeEventTypeEnum = {
  ResvCompleted: "RESV_COMPLETED",
} as const;

export type ReservationCompletedEventTypeEventTypeEnum =
  (typeof ReservationCompletedEventTypeEventTypeEnum)[keyof typeof ReservationCompletedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface ReservationCreatedEventType
 */
export interface ReservationCreatedEventType {
  /**
   *
   * @type {string}
   * @memberof ReservationCreatedEventType
   */
  eventType: ReservationCreatedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ReservationCreatedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof ReservationCreatedEventType
   */
  reservationSid?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationCreatedEventType
   */
  workerSid?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationCreatedEventType
   */
  workerName?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationCreatedEventType
   */
  taskSid?: string;
}

export const ReservationCreatedEventTypeEventTypeEnum = {
  ResvCreated: "RESV_CREATED",
} as const;

export type ReservationCreatedEventTypeEventTypeEnum =
  (typeof ReservationCreatedEventTypeEventTypeEnum)[keyof typeof ReservationCreatedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface ReservationRejectedEventType
 */
export interface ReservationRejectedEventType {
  /**
   *
   * @type {string}
   * @memberof ReservationRejectedEventType
   */
  eventType: ReservationRejectedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ReservationRejectedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof ReservationRejectedEventType
   */
  reservationSid?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationRejectedEventType
   */
  workerSid?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationRejectedEventType
   */
  workerName?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationRejectedEventType
   */
  taskSid?: string;
}

export const ReservationRejectedEventTypeEventTypeEnum = {
  ResvRejected: "RESV_REJECTED",
} as const;

export type ReservationRejectedEventTypeEventTypeEnum =
  (typeof ReservationRejectedEventTypeEventTypeEnum)[keyof typeof ReservationRejectedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface ReservationTimeoutEventType
 */
export interface ReservationTimeoutEventType {
  /**
   *
   * @type {string}
   * @memberof ReservationTimeoutEventType
   */
  eventType: ReservationTimeoutEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ReservationTimeoutEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof ReservationTimeoutEventType
   */
  reservationSid?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationTimeoutEventType
   */
  workerSid?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationTimeoutEventType
   */
  workerName?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationTimeoutEventType
   */
  taskSid?: string;
}

export const ReservationTimeoutEventTypeEventTypeEnum = {
  ResvTimeout: "RESV_TIMEOUT",
} as const;

export type ReservationTimeoutEventTypeEventTypeEnum =
  (typeof ReservationTimeoutEventTypeEventTypeEnum)[keyof typeof ReservationTimeoutEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface ReservationWrapUpEventType
 */
export interface ReservationWrapUpEventType {
  /**
   *
   * @type {string}
   * @memberof ReservationWrapUpEventType
   */
  eventType: ReservationWrapUpEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ReservationWrapUpEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof ReservationWrapUpEventType
   */
  reservationSid?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationWrapUpEventType
   */
  workerSid?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationWrapUpEventType
   */
  workerName?: string;
  /**
   *
   * @type {string}
   * @memberof ReservationWrapUpEventType
   */
  taskSid?: string;
}

export const ReservationWrapUpEventTypeEventTypeEnum = {
  ResvWrapup: "RESV_WRAPUP",
} as const;

export type ReservationWrapUpEventTypeEventTypeEnum =
  (typeof ReservationWrapUpEventTypeEventTypeEnum)[keyof typeof ReservationWrapUpEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface ReservatonCancelledEventType
 */
export interface ReservatonCancelledEventType {
  /**
   *
   * @type {string}
   * @memberof ReservatonCancelledEventType
   */
  eventType: ReservatonCancelledEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ReservatonCancelledEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof ReservatonCancelledEventType
   */
  reservationSid?: string;
  /**
   *
   * @type {string}
   * @memberof ReservatonCancelledEventType
   */
  workerSid?: string;
  /**
   *
   * @type {string}
   * @memberof ReservatonCancelledEventType
   */
  workerName?: string;
  /**
   *
   * @type {string}
   * @memberof ReservatonCancelledEventType
   */
  taskSid?: string;
}

export const ReservatonCancelledEventTypeEventTypeEnum = {
  ResvCancelled: "RESV_CANCELLED",
} as const;

export type ReservatonCancelledEventTypeEventTypeEnum =
  (typeof ReservatonCancelledEventTypeEventTypeEnum)[keyof typeof ReservatonCancelledEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface RoleExtMetadataReadExternal
 */
export interface RoleExtMetadataReadExternal {
  /**
   *
   * @type {Array<RoleExtMetadataReadExternalExtMetadataConfig>}
   * @memberof RoleExtMetadataReadExternal
   */
  extMetadataConfig: Array<RoleExtMetadataReadExternalExtMetadataConfig>;
}
/**
 *
 * @export
 * @interface RoleExtMetadataReadExternalExtMetadataConfig
 */
export interface RoleExtMetadataReadExternalExtMetadataConfig {
  /**
   *
   * @type {ExtendedMetadataConfigReadExternal}
   * @memberof RoleExtMetadataReadExternalExtMetadataConfig
   */
  extMetadataGroupConfig?: ExtendedMetadataConfigReadExternal;
  /**
   *
   * @type {number}
   * @memberof RoleExtMetadataReadExternalExtMetadataConfig
   */
  order?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const RoleSlug = {
  Unreg: "UNREG",
  Svcusr: "SVCUSR",
  SvcusrSpr: "SVCUSR_SPR",
  Agent: "AGENT",
  AgentSpr: "AGENT_SPR",
  ClientAdmin: "CLIENT_ADMIN",
  PlatAdmin: "PLAT_ADMIN",
  Owner: "OWNER",
  OwnerSpr: "OWNER_SPR",
  Supp: "SUPP",
  SuppSpr: "SUPP_SPR",
} as const;

export type RoleSlug = (typeof RoleSlug)[keyof typeof RoleSlug];

/**
 *
 * @export
 * @interface SearchAssetFilter
 */
export interface SearchAssetFilter {
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAssetFilter
   */
  assetParent?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAssetFilter
   */
  linkedUser?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAssetFilter
   */
  linkedOrg?: Array<string>;
  /**
   *
   * @type {SearchElementDateRange}
   * @memberof SearchAssetFilter
   */
  created?: SearchElementDateRange;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAssetFilter
   */
  assetType?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof SearchAssetFilter
   */
  descendentOfAsset?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAssetFilter
   */
  allowedTaskType?: Array<string>;
  /**
   *
   * @type {Array<boolean>}
   * @memberof SearchAssetFilter
   */
  primary?: Array<boolean>;
  /**
   *
   * @type {Array<boolean>}
   * @memberof SearchAssetFilter
   */
  active?: Array<boolean>;
  /**
   *
   * @type {Array<AssetDiscoverability>}
   * @memberof SearchAssetFilter
   */
  discoverability?: Array<AssetDiscoverability>;
  /**
   *
   * @type {Array<boolean>}
   * @memberof SearchAssetFilter
   */
  linkedToMe?: Array<boolean>;
  /**
   *
   * @type {SearchAssetFilterGeoLocation}
   * @memberof SearchAssetFilter
   */
  geoLocation?: SearchAssetFilterGeoLocation;
  /**
   *
   * @type {SearchAssetFilterGeoArea}
   * @memberof SearchAssetFilter
   */
  geoArea?: SearchAssetFilterGeoArea;
  /**
   *
   * @type {Array<boolean>}
   * @memberof SearchAssetFilter
   */
  inheritanceEnabled?: Array<boolean>;
  /**
   *
   * @type {SearchAssetFilterInheritFrom}
   * @memberof SearchAssetFilter
   */
  inheritFrom?: SearchAssetFilterInheritFrom;
  /**
   *
   * @type {{ [key: string]: SearchExtendedMetadataFilterCriteria; }}
   * @memberof SearchAssetFilter
   */
  extendedMetadata?: { [key: string]: SearchExtendedMetadataFilterCriteria };
}
/**
 * Search within an area
 * @export
 * @interface SearchAssetFilterGeoArea
 */
export interface SearchAssetFilterGeoArea {
  /**
   *
   * @type {Array<GeoPoint>}
   * @memberof SearchAssetFilterGeoArea
   */
  points?: Array<GeoPoint>;
}
/**
 * Search around a point
 * @export
 * @interface SearchAssetFilterGeoLocation
 */
export interface SearchAssetFilterGeoLocation {
  /**
   *
   * @type {GeoPoint}
   * @memberof SearchAssetFilterGeoLocation
   */
  point?: GeoPoint;
  /**
   * Max distance in metres
   * @type {number}
   * @memberof SearchAssetFilterGeoLocation
   */
  maxDistance?: number;
}
/**
 * @type SearchAssetFilterInheritFrom
 * @export
 */
export type SearchAssetFilterInheritFrom = SearchAssetFilterInheritFromOneOf | SearchAssetFilterInheritFromOneOf1;

/**
 *
 * @export
 * @interface SearchAssetFilterInheritFromOneOf
 */
export interface SearchAssetFilterInheritFromOneOf {
  /**
   *
   * @type {string}
   * @memberof SearchAssetFilterInheritFromOneOf
   */
  sourceAssetUid: string;
  /**
   *
   * @type {InheritanceSections}
   * @memberof SearchAssetFilterInheritFromOneOf
   */
  section: InheritanceSections;
}

/**
 *
 * @export
 * @interface SearchAssetFilterInheritFromOneOf1
 */
export interface SearchAssetFilterInheritFromOneOf1 {
  /**
   *
   * @type {string}
   * @memberof SearchAssetFilterInheritFromOneOf1
   */
  sourceAssetUid: string;
  /**
   *
   * @type {string}
   * @memberof SearchAssetFilterInheritFromOneOf1
   */
  extendedMetadataGroup: string;
}
/**
 *
 * @export
 * @interface SearchAssetRequest
 */
export interface SearchAssetRequest {
  /**
   *
   * @type {string}
   * @memberof SearchAssetRequest
   */
  freeText?: string;
  /**
   *
   * @type {SearchAssetFilter}
   * @memberof SearchAssetRequest
   */
  filter?: SearchAssetFilter;
  /**
   *
   * @type {SearchAssetSort}
   * @memberof SearchAssetRequest
   */
  sort?: SearchAssetSort;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAssetRequest
   */
  extendedMetadataStats?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof SearchAssetRequest
   */
  page: number;
  /**
   *
   * @type {number}
   * @memberof SearchAssetRequest
   */
  pageSize?: number;
  /**
   *
   * @type {string}
   * @memberof SearchAssetRequest
   */
  oboUser?: string;
}

/**
 *
 * @export
 * @interface SearchAssetResultExternal
 */
export interface SearchAssetResultExternal {
  /**
   *
   * @type {SearchResultsSummary}
   * @memberof SearchAssetResultExternal
   */
  summary?: SearchResultsSummary;
  /**
   *
   * @type {SearchAssetStats}
   * @memberof SearchAssetResultExternal
   */
  stats?: SearchAssetStats;
  /**
   *
   * @type {Array<AssetSearchResultExternal>}
   * @memberof SearchAssetResultExternal
   */
  results?: Array<AssetSearchResultExternal>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const SearchAssetSort = {
  Relevance: "RELEVANCE",
  TitleDesc: "TITLE_DESC",
  TitleAsc: "TITLE_ASC",
  CreatedDesc: "CREATED_DESC",
  CreatedAsc: "CREATED_ASC",
  Closest: "CLOSEST",
} as const;

export type SearchAssetSort = (typeof SearchAssetSort)[keyof typeof SearchAssetSort];

/**
 *
 * @export
 * @interface SearchAssetStats
 */
export interface SearchAssetStats {
  [key: string]: Array<SearchStatsGenericValueInner> | any;

  /**
   *
   * @type {Array<SearchAssetStatsActive>}
   * @memberof SearchAssetStats
   */
  active?: Array<SearchAssetStatsActive>;
  /**
   * Count by asset type
   * @type {Array<SearchStatsElement>}
   * @memberof SearchAssetStats
   */
  assetTypes?: Array<SearchStatsElement>;
  /**
   *
   * @type {Array<SearchAssetStatsDiscoverabilities>}
   * @memberof SearchAssetStats
   */
  discoverabilities?: Array<SearchAssetStatsDiscoverabilities>;
}
/**
 *
 * @export
 * @interface SearchAssetStatsActive
 */
export interface SearchAssetStatsActive {
  /**
   *
   * @type {boolean}
   * @memberof SearchAssetStatsActive
   */
  value?: boolean;
  /**
   *
   * @type {number}
   * @memberof SearchAssetStatsActive
   */
  count?: number;
}
/**
 *
 * @export
 * @interface SearchAssetStatsDiscoverabilities
 */
export interface SearchAssetStatsDiscoverabilities {
  /**
   *
   * @type {AssetDiscoverability}
   * @memberof SearchAssetStatsDiscoverabilities
   */
  discoverability?: AssetDiscoverability;
  /**
   *
   * @type {number}
   * @memberof SearchAssetStatsDiscoverabilities
   */
  count?: number;
}

/**
 *
 * @export
 * @interface SearchAutocompleteRequest
 */
export interface SearchAutocompleteRequest {
  /**
   *
   * @type {string}
   * @memberof SearchAutocompleteRequest
   */
  freeText?: string;
}
/**
 *
 * @export
 * @interface SearchAutocompleteResult
 */
export interface SearchAutocompleteResult {
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAutocompleteResult
   */
  suggestions?: Array<string>;
}
/**
 *
 * @export
 * @interface SearchCallRecordFilter
 */
export interface SearchCallRecordFilter {
  /**
   *
   * @type {Array<CallDirection>}
   * @memberof SearchCallRecordFilter
   */
  direction?: Array<CallDirection>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchCallRecordFilter
   */
  customerNumber?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchCallRecordFilter
   */
  twilioLine?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchCallRecordFilter
   */
  brandSlug?: Array<string>;
  /**
   *
   * @type {SearchCallRecordFilterAgentUserRole}
   * @memberof SearchCallRecordFilter
   */
  agentUserRole?: SearchCallRecordFilterAgentUserRole;
  /**
   *
   * @type {Array<CallAgentRole>}
   * @memberof SearchCallRecordFilter
   */
  callRole?: Array<CallAgentRole>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchCallRecordFilter
   */
  agentUser?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchCallRecordFilter
   */
  customerUser?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchCallRecordFilter
   */
  asset?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchCallRecordFilter
   */
  task?: Array<string>;
  /**
   *
   * @type {SearchElementDateRange}
   * @memberof SearchCallRecordFilter
   */
  startAt?: SearchElementDateRange;
  /**
   *
   * @type {SearchElementDateRange}
   * @memberof SearchCallRecordFilter
   */
  endAt?: SearchElementDateRange;
  /**
   *
   * @type {SearchElementDateRange}
   * @memberof SearchCallRecordFilter
   */
  completedAt?: SearchElementDateRange;
  /**
   *
   * @type {Array<boolean>}
   * @memberof SearchCallRecordFilter
   */
  active?: Array<boolean>;
  /**
   *
   * @type {Array<CallOutcome>}
   * @memberof SearchCallRecordFilter
   */
  outcome?: Array<CallOutcome>;
  /**
   *
   * @type {SearchExtendedMetadataStringFilter}
   * @memberof SearchCallRecordFilter
   */
  latestQueueName?: SearchExtendedMetadataStringFilter;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchCallRecordFilter
   */
  latestQueueSid?: Array<string>;
  /**
   *
   * @type {Array<CallDisconnectedBy>}
   * @memberof SearchCallRecordFilter
   */
  disconnectedBy?: Array<CallDisconnectedBy>;
  /**
   *
   * @type {SearchExtendedMetadataNumberFilter}
   * @memberof SearchCallRecordFilter
   */
  timeQueue?: SearchExtendedMetadataNumberFilter;
  /**
   *
   * @type {SearchExtendedMetadataNumberFilter}
   * @memberof SearchCallRecordFilter
   */
  timeCustomerTalk?: SearchExtendedMetadataNumberFilter;
  /**
   *
   * @type {SearchExtendedMetadataNumberFilter}
   * @memberof SearchCallRecordFilter
   */
  timeTotalDuration?: SearchExtendedMetadataNumberFilter;
  /**
   *
   * @type {Array<boolean>}
   * @memberof SearchCallRecordFilter
   */
  recordingsAvailable?: Array<boolean>;
}
/**
 *
 * @export
 * @interface SearchCallRecordFilterAgentUserRole
 */
export interface SearchCallRecordFilterAgentUserRole {
  /**
   *
   * @type {Array<string>}
   * @memberof SearchCallRecordFilterAgentUserRole
   */
  agentUser: Array<string>;
  /**
   *
   * @type {Array<CallAgentRole>}
   * @memberof SearchCallRecordFilterAgentUserRole
   */
  callRole: Array<CallAgentRole>;
}
/**
 *
 * @export
 * @interface SearchCallRecordRequest
 */
export interface SearchCallRecordRequest {
  /**
   *
   * @type {SearchCallRecordFilter}
   * @memberof SearchCallRecordRequest
   */
  filter?: SearchCallRecordFilter;
  /**
   *
   * @type {SearchCallRecordSort}
   * @memberof SearchCallRecordRequest
   */
  sort?: SearchCallRecordSort;
  /**
   *
   * @type {number}
   * @memberof SearchCallRecordRequest
   */
  page: number;
}

/**
 *
 * @export
 * @interface SearchCallRecordResultExternal
 */
export interface SearchCallRecordResultExternal {
  /**
   *
   * @type {SearchResultsSummary}
   * @memberof SearchCallRecordResultExternal
   */
  summary?: SearchResultsSummary;
  /**
   *
   * @type {SearchCallRecordStats}
   * @memberof SearchCallRecordResultExternal
   */
  stats?: SearchCallRecordStats;
  /**
   *
   * @type {Array<CallRecordSearchResultExternal>}
   * @memberof SearchCallRecordResultExternal
   */
  results?: Array<CallRecordSearchResultExternal>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const SearchCallRecordSort = {
  StartAsc: "START_ASC",
  StartDesc: "START_DESC",
  TotalDurationAsc: "TOTAL_DURATION_ASC",
  TotalDurationDesc: "TOTAL_DURATION_DESC",
  IvrAsc: "IVR_ASC",
  IvrDesc: "IVR_DESC",
  RingAsc: "RING_ASC",
  RingDesc: "RING_DESC",
  QueueAsc: "QUEUE_ASC",
  QueueDesc: "QUEUE_DESC",
  HoldAsc: "HOLD_ASC",
  HoldDesc: "HOLD_DESC",
  CustomerTalkAsc: "CUSTOMER_TALK_ASC",
  CustomerTalkDesc: "CUSTOMER_TALK_DESC",
  HandlingAsc: "HANDLING_ASC",
  HandlingDesc: "HANDLING_DESC",
  WrapUpAsc: "WRAP_UP_ASC",
  WrapUpDesc: "WRAP_UP_DESC",
  CustomerDurationAsc: "CUSTOMER_DURATION_ASC",
  CustomerDurationDesc: "CUSTOMER_DURATION_DESC",
} as const;

export type SearchCallRecordSort = (typeof SearchCallRecordSort)[keyof typeof SearchCallRecordSort];

/**
 *
 * @export
 * @interface SearchCallRecordStats
 */
export interface SearchCallRecordStats {
  /**
   *
   * @type {Array<SearchCallRecordStatsOutcomes>}
   * @memberof SearchCallRecordStats
   */
  outcomes?: Array<SearchCallRecordStatsOutcomes>;
  /**
   *
   * @type {Array<SearchCallRecordStatsDirections>}
   * @memberof SearchCallRecordStats
   */
  directions?: Array<SearchCallRecordStatsDirections>;
  /**
   *
   * @type {Array<SearchCallRecordStatsBrandSlugs>}
   * @memberof SearchCallRecordStats
   */
  brandSlugs?: Array<SearchCallRecordStatsBrandSlugs>;
}
/**
 *
 * @export
 * @interface SearchCallRecordStatsBrandSlugs
 */
export interface SearchCallRecordStatsBrandSlugs {
  /**
   *
   * @type {string}
   * @memberof SearchCallRecordStatsBrandSlugs
   */
  brand?: string;
  /**
   *
   * @type {number}
   * @memberof SearchCallRecordStatsBrandSlugs
   */
  count?: number;
}
/**
 *
 * @export
 * @interface SearchCallRecordStatsDirections
 */
export interface SearchCallRecordStatsDirections {
  /**
   *
   * @type {CallDirection}
   * @memberof SearchCallRecordStatsDirections
   */
  direction?: CallDirection;
  /**
   *
   * @type {number}
   * @memberof SearchCallRecordStatsDirections
   */
  count?: number;
}

/**
 *
 * @export
 * @interface SearchCallRecordStatsOutcomes
 */
export interface SearchCallRecordStatsOutcomes {
  /**
   *
   * @type {CallOutcome}
   * @memberof SearchCallRecordStatsOutcomes
   */
  outcome?: CallOutcome;
  /**
   *
   * @type {number}
   * @memberof SearchCallRecordStatsOutcomes
   */
  count?: number;
}

/**
 *
 * @export
 * @interface SearchElementDateRange
 */
export interface SearchElementDateRange {
  /**
   *
   * @type {string}
   * @memberof SearchElementDateRange
   */
  before?: string;
  /**
   *
   * @type {string}
   * @memberof SearchElementDateRange
   */
  after?: string;
}
/**
 *
 * @export
 * @interface SearchExtendedMetadataBooleanFilter
 */
export interface SearchExtendedMetadataBooleanFilter {
  /**
   *
   * @type {boolean}
   * @memberof SearchExtendedMetadataBooleanFilter
   */
  equals?: boolean;
}
/**
 *
 * @export
 * @interface SearchExtendedMetadataDateFilter
 */
export interface SearchExtendedMetadataDateFilter {
  /**
   *
   * @type {string}
   * @memberof SearchExtendedMetadataDateFilter
   */
  before?: string;
  /**
   *
   * @type {string}
   * @memberof SearchExtendedMetadataDateFilter
   */
  after?: string;
}
/**
 * @type SearchExtendedMetadataFilterCriteria
 * @export
 */
export type SearchExtendedMetadataFilterCriteria =
  | SearchExtendedMetadataBooleanFilter
  | SearchExtendedMetadataDateFilter
  | SearchExtendedMetadataNumberFilter
  | SearchExtendedMetadataStringFilter;

/**
 *
 * @export
 * @interface SearchExtendedMetadataNumberFilter
 */
export interface SearchExtendedMetadataNumberFilter {
  /**
   *
   * @type {number}
   * @memberof SearchExtendedMetadataNumberFilter
   */
  equals?: number;
  /**
   *
   * @type {number}
   * @memberof SearchExtendedMetadataNumberFilter
   */
  lte?: number;
  /**
   *
   * @type {number}
   * @memberof SearchExtendedMetadataNumberFilter
   */
  lt?: number;
  /**
   *
   * @type {number}
   * @memberof SearchExtendedMetadataNumberFilter
   */
  gt?: number;
  /**
   *
   * @type {number}
   * @memberof SearchExtendedMetadataNumberFilter
   */
  gte?: number;
}
/**
 *
 * @export
 * @interface SearchExtendedMetadataStringFilter
 */
export interface SearchExtendedMetadataStringFilter {
  /**
   *
   * @type {string}
   * @memberof SearchExtendedMetadataStringFilter
   */
  equals?: string;
  /**
   *
   * @type {string}
   * @memberof SearchExtendedMetadataStringFilter
   */
  contains?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchExtendedMetadataStringFilter
   */
  in?: Array<string>;
}
/**
 *
 * @export
 * @interface SearchMessageFilter
 */
export interface SearchMessageFilter {
  /**
   *
   * @type {Array<SearchMessageType>}
   * @memberof SearchMessageFilter
   */
  messageType?: Array<SearchMessageType>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchMessageFilter
   */
  taskUid?: Array<string>;
  /**
   *
   * @type {SearchElementDateRange}
   * @memberof SearchMessageFilter
   */
  created?: SearchElementDateRange;
  /**
   *
   * @type {SearchElementDateRange}
   * @memberof SearchMessageFilter
   */
  lastUpdated?: SearchElementDateRange;
  /**
   *
   * @type {Array<number>}
   * @memberof SearchMessageFilter
   */
  conversationRating?: Array<number>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchMessageFilter
   */
  participantUid?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof SearchMessageFilter
   */
  unread?: boolean;
}
/**
 *
 * @export
 * @interface SearchMessageRequest
 */
export interface SearchMessageRequest {
  /**
   *
   * @type {string}
   * @memberof SearchMessageRequest
   */
  freeText?: string;
  /**
   *
   * @type {SearchMessageFilter}
   * @memberof SearchMessageRequest
   */
  filter?: SearchMessageFilter;
  /**
   *
   * @type {SearchMessageSort}
   * @memberof SearchMessageRequest
   */
  sort?: SearchMessageSort;
  /**
   *
   * @type {number}
   * @memberof SearchMessageRequest
   */
  page: number;
}

/**
 *
 * @export
 * @interface SearchMessageResultExternal
 */
export interface SearchMessageResultExternal {
  /**
   *
   * @type {SearchResultsSummary}
   * @memberof SearchMessageResultExternal
   */
  summary?: SearchResultsSummary;
  /**
   *
   * @type {SearchMessageStats}
   * @memberof SearchMessageResultExternal
   */
  stats?: SearchMessageStats;
  /**
   *
   * @type {Array<MessageSearchResultExternal>}
   * @memberof SearchMessageResultExternal
   */
  results?: Array<MessageSearchResultExternal>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const SearchMessageSort = {
  Relevance: "RELEVANCE",
  CreatedDesc: "CREATED_DESC",
  CreatedAsc: "CREATED_ASC",
  LastUpdatedDesc: "LAST_UPDATED_DESC",
  LastUpdatedAsc: "LAST_UPDATED_ASC",
} as const;

export type SearchMessageSort = (typeof SearchMessageSort)[keyof typeof SearchMessageSort];

/**
 *
 * @export
 * @interface SearchMessageStats
 */
export interface SearchMessageStats {
  /**
   *
   * @type {number}
   * @memberof SearchMessageStats
   */
  unreads?: number;
  /**
   *
   * @type {number}
   * @memberof SearchMessageStats
   */
  threads?: number;
  /**
   *
   * @type {number}
   * @memberof SearchMessageStats
   */
  conversations?: number;
  /**
   *
   * @type {number}
   * @memberof SearchMessageStats
   */
  calls?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const SearchMessageType = {
  Thread: "THREAD",
  Conversation: "CONVERSATION",
  Call: "CALL",
} as const;

export type SearchMessageType = (typeof SearchMessageType)[keyof typeof SearchMessageType];

/**
 *
 * @export
 * @interface SearchOrgFilter
 */
export interface SearchOrgFilter {
  /**
   *
   * @type {Array<string>}
   * @memberof SearchOrgFilter
   */
  linkedUser?: Array<string>;
  /**
   *
   * @type {Array<OrgTypeSlug>}
   * @memberof SearchOrgFilter
   */
  orgType?: Array<OrgTypeSlug>;
  /**
   *
   * @type {{ [key: string]: SearchExtendedMetadataFilterCriteria; }}
   * @memberof SearchOrgFilter
   */
  extendedMetadata?: { [key: string]: SearchExtendedMetadataFilterCriteria };
}
/**
 *
 * @export
 * @interface SearchOrgRequest
 */
export interface SearchOrgRequest {
  /**
   *
   * @type {string}
   * @memberof SearchOrgRequest
   */
  freeText?: string;
  /**
   *
   * @type {SearchOrgFilter}
   * @memberof SearchOrgRequest
   */
  filter?: SearchOrgFilter;
  /**
   *
   * @type {SearchOrgSort}
   * @memberof SearchOrgRequest
   */
  sort?: SearchOrgSort;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchOrgRequest
   */
  extendedMetadataStats?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof SearchOrgRequest
   */
  page: number;
  /**
   *
   * @type {number}
   * @memberof SearchOrgRequest
   */
  pageSize?: number;
  /**
   *
   * @type {string}
   * @memberof SearchOrgRequest
   */
  oboUser?: string;
}

/**
 *
 * @export
 * @interface SearchOrgResultExternal
 */
export interface SearchOrgResultExternal {
  /**
   *
   * @type {SearchResultsSummary}
   * @memberof SearchOrgResultExternal
   */
  summary?: SearchResultsSummary;
  /**
   *
   * @type {SearchOrgStats}
   * @memberof SearchOrgResultExternal
   */
  stats?: SearchOrgStats;
  /**
   *
   * @type {Array<OrgSearchResultExternal>}
   * @memberof SearchOrgResultExternal
   */
  results?: Array<OrgSearchResultExternal>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const SearchOrgSort = {
  Relevance: "RELEVANCE",
  NameDesc: "NAME_DESC",
  NameAsc: "NAME_ASC",
  CreatedDesc: "CREATED_DESC",
  CreatedAsc: "CREATED_ASC",
} as const;

export type SearchOrgSort = (typeof SearchOrgSort)[keyof typeof SearchOrgSort];

/**
 *
 * @export
 * @interface SearchOrgStats
 */
export interface SearchOrgStats {
  [key: string]: Array<SearchStatsGenericValueInner> | any;

  /**
   * Count by org type
   * @type {Array<SearchOrgStatsOrgTypes>}
   * @memberof SearchOrgStats
   */
  orgTypes?: Array<SearchOrgStatsOrgTypes>;
}
/**
 *
 * @export
 * @interface SearchOrgStatsOrgTypes
 */
export interface SearchOrgStatsOrgTypes {
  /**
   *
   * @type {OrgTypeSlug}
   * @memberof SearchOrgStatsOrgTypes
   */
  orgType?: OrgTypeSlug;
  /**
   *
   * @type {number}
   * @memberof SearchOrgStatsOrgTypes
   */
  count?: number;
}

/**
 *
 * @export
 * @interface SearchPeopleFilter
 */
export interface SearchPeopleFilter {
  /**
   *
   * @type {Array<string>}
   * @memberof SearchPeopleFilter
   */
  scope?: Array<SearchPeopleFilterScopeEnum>;
}

export const SearchPeopleFilterScopeEnum = {
  Users: "USERS",
  Teams: "TEAMS",
  Orgs: "ORGS",
} as const;

export type SearchPeopleFilterScopeEnum =
  (typeof SearchPeopleFilterScopeEnum)[keyof typeof SearchPeopleFilterScopeEnum];

/**
 *
 * @export
 * @interface SearchPeopleRequest
 */
export interface SearchPeopleRequest {
  /**
   *
   * @type {string}
   * @memberof SearchPeopleRequest
   */
  freeText?: string;
  /**
   *
   * @type {SearchPeopleFilter}
   * @memberof SearchPeopleRequest
   */
  filter?: SearchPeopleFilter;
  /**
   *
   * @type {number}
   * @memberof SearchPeopleRequest
   */
  page: number;
  /**
   *
   * @type {number}
   * @memberof SearchPeopleRequest
   */
  pageSize?: number;
  /**
   *
   * @type {string}
   * @memberof SearchPeopleRequest
   */
  oboUser?: string;
}
/**
 *
 * @export
 * @interface SearchPeopleResultExternal
 */
export interface SearchPeopleResultExternal {
  /**
   *
   * @type {SearchResultsSummary}
   * @memberof SearchPeopleResultExternal
   */
  summary?: SearchResultsSummary;
  /**
   *
   * @type {SearchPeopleStats}
   * @memberof SearchPeopleResultExternal
   */
  stats?: SearchPeopleStats;
  /**
   *
   * @type {Array<PersonSearchResultExternal>}
   * @memberof SearchPeopleResultExternal
   */
  results?: Array<PersonSearchResultExternal>;
}
/**
 *
 * @export
 * @interface SearchPeopleStats
 */
export interface SearchPeopleStats {
  /**
   *
   * @type {Array<SearchPeopleStatsEntityTypes>}
   * @memberof SearchPeopleStats
   */
  entityTypes?: Array<SearchPeopleStatsEntityTypes>;
}
/**
 *
 * @export
 * @interface SearchPeopleStatsEntityTypes
 */
export interface SearchPeopleStatsEntityTypes {
  /**
   *
   * @type {string}
   * @memberof SearchPeopleStatsEntityTypes
   */
  value: SearchPeopleStatsEntityTypesValueEnum;
  /**
   *
   * @type {number}
   * @memberof SearchPeopleStatsEntityTypes
   */
  count: number;
}

export const SearchPeopleStatsEntityTypesValueEnum = {
  User: "USER",
  Team: "TEAM",
  Org: "ORG",
} as const;

export type SearchPeopleStatsEntityTypesValueEnum =
  (typeof SearchPeopleStatsEntityTypesValueEnum)[keyof typeof SearchPeopleStatsEntityTypesValueEnum];

/**
 *
 * @export
 * @interface SearchProductCatalogueFilter
 */
export interface SearchProductCatalogueFilter {
  /**
   *
   * @type {Array<string>}
   * @memberof SearchProductCatalogueFilter
   */
  uid?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchProductCatalogueFilter
   */
  offering?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchProductCatalogueFilter
   */
  product?: Array<string>;
}
/**
 *
 * @export
 * @interface SearchProductCatalogueRequest
 */
export interface SearchProductCatalogueRequest {
  /**
   *
   * @type {string}
   * @memberof SearchProductCatalogueRequest
   */
  freeText?: string;
  /**
   *
   * @type {SearchProductCatalogueFilter}
   * @memberof SearchProductCatalogueRequest
   */
  filter?: SearchProductCatalogueFilter;
  /**
   *
   * @type {SearchProductCatalogueSort}
   * @memberof SearchProductCatalogueRequest
   */
  sort?: SearchProductCatalogueSort;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchProductCatalogueRequest
   */
  extendedMetadataStats?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof SearchProductCatalogueRequest
   */
  page: number;
  /**
   *
   * @type {number}
   * @memberof SearchProductCatalogueRequest
   */
  pageSize?: number;
  /**
   *
   * @type {string}
   * @memberof SearchProductCatalogueRequest
   */
  oboUser?: string;
}

/**
 *
 * @export
 * @interface SearchProductCatalogueResultExternal
 */
export interface SearchProductCatalogueResultExternal {
  /**
   *
   * @type {SearchResultsSummary}
   * @memberof SearchProductCatalogueResultExternal
   */
  summary?: SearchResultsSummary;
  /**
   *
   * @type {{ [key: string]: Array<SearchStatsGenericValueInner>; }}
   * @memberof SearchProductCatalogueResultExternal
   */
  stats?: { [key: string]: Array<SearchStatsGenericValueInner> };
  /**
   *
   * @type {Array<ProductCatalogueSearchResultExternal>}
   * @memberof SearchProductCatalogueResultExternal
   */
  results?: Array<ProductCatalogueSearchResultExternal>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const SearchProductCatalogueSort = {
  Relevance: "RELEVANCE",
  TitleDesc: "TITLE_DESC",
  TitleAsc: "TITLE_ASC",
} as const;

export type SearchProductCatalogueSort = (typeof SearchProductCatalogueSort)[keyof typeof SearchProductCatalogueSort];

/**
 *
 * @export
 * @interface SearchProductFilter
 */
export interface SearchProductFilter {
  /**
   *
   * @type {Array<ProductStatus>}
   * @memberof SearchProductFilter
   */
  status?: Array<ProductStatus>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchProductFilter
   */
  productType?: Array<string>;
  /**
   *
   * @type {{ [key: string]: SearchExtendedMetadataFilterCriteria; }}
   * @memberof SearchProductFilter
   */
  extendedMetadata?: { [key: string]: SearchExtendedMetadataFilterCriteria };
}
/**
 *
 * @export
 * @interface SearchProductRequest
 */
export interface SearchProductRequest {
  /**
   *
   * @type {string}
   * @memberof SearchProductRequest
   */
  freeText?: string;
  /**
   *
   * @type {SearchProductFilter}
   * @memberof SearchProductRequest
   */
  filter?: SearchProductFilter;
  /**
   *
   * @type {SearchProductSort}
   * @memberof SearchProductRequest
   */
  sort?: SearchProductSort;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchProductRequest
   */
  extendedMetadataStats?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof SearchProductRequest
   */
  page: number;
  /**
   *
   * @type {number}
   * @memberof SearchProductRequest
   */
  pageSize?: number;
  /**
   *
   * @type {string}
   * @memberof SearchProductRequest
   */
  oboUser?: string;
}

/**
 *
 * @export
 * @interface SearchProductResultExternal
 */
export interface SearchProductResultExternal {
  /**
   *
   * @type {SearchResultsSummary}
   * @memberof SearchProductResultExternal
   */
  summary?: SearchResultsSummary;
  /**
   *
   * @type {SearchProductStats}
   * @memberof SearchProductResultExternal
   */
  stats?: SearchProductStats;
  /**
   *
   * @type {Array<ProductSearchResultExternal>}
   * @memberof SearchProductResultExternal
   */
  results?: Array<ProductSearchResultExternal>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const SearchProductSort = {
  Relevance: "RELEVANCE",
  TitleDesc: "TITLE_DESC",
  TitleAsc: "TITLE_ASC",
} as const;

export type SearchProductSort = (typeof SearchProductSort)[keyof typeof SearchProductSort];

/**
 *
 * @export
 * @interface SearchProductStats
 */
export interface SearchProductStats {
  [key: string]: Array<SearchStatsGenericValueInner> | any;

  /**
   *
   * @type {Array<SearchStatsElement>}
   * @memberof SearchProductStats
   */
  productTypes?: Array<SearchStatsElement>;
  /**
   *
   * @type {Array<SearchProductStatsStatuses>}
   * @memberof SearchProductStats
   */
  statuses?: Array<SearchProductStatsStatuses>;
}
/**
 *
 * @export
 * @interface SearchProductStatsStatuses
 */
export interface SearchProductStatsStatuses {
  /**
   *
   * @type {ProductStatus}
   * @memberof SearchProductStatsStatuses
   */
  status?: ProductStatus;
  /**
   *
   * @type {number}
   * @memberof SearchProductStatsStatuses
   */
  count?: number;
}

/**
 *
 * @export
 * @interface SearchResultsSummary
 */
export interface SearchResultsSummary {
  /**
   * Total matching results
   * @type {number}
   * @memberof SearchResultsSummary
   */
  totalResults?: number;
  /**
   * Total number of pages
   * @type {number}
   * @memberof SearchResultsSummary
   */
  totalPages?: number;
}
/**
 *
 * @export
 * @interface SearchStatsElement
 */
export interface SearchStatsElement {
  /**
   *
   * @type {string}
   * @memberof SearchStatsElement
   */
  uid?: string;
  /**
   *
   * @type {number}
   * @memberof SearchStatsElement
   */
  count?: number;
}
/**
 *
 * @export
 * @interface SearchStatsGenericValueInner
 */
export interface SearchStatsGenericValueInner {
  /**
   *
   * @type {string}
   * @memberof SearchStatsGenericValueInner
   */
  value?: string;
  /**
   *
   * @type {number}
   * @memberof SearchStatsGenericValueInner
   */
  count?: number;
}
/**
 *
 * @export
 * @interface SearchTagRequest
 */
export interface SearchTagRequest {
  /**
   *
   * @type {string}
   * @memberof SearchTagRequest
   */
  freeText?: string;
  /**
   *
   * @type {SearchTagSort}
   * @memberof SearchTagRequest
   */
  sort?: SearchTagSort;
  /**
   *
   * @type {number}
   * @memberof SearchTagRequest
   */
  page: number;
  /**
   *
   * @type {number}
   * @memberof SearchTagRequest
   */
  pageSize?: number;
  /**
   *
   * @type {string}
   * @memberof SearchTagRequest
   */
  oboUser?: string;
}

/**
 *
 * @export
 * @interface SearchTagResultExternal
 */
export interface SearchTagResultExternal {
  /**
   *
   * @type {SearchResultsSummary}
   * @memberof SearchTagResultExternal
   */
  summary?: SearchResultsSummary;
  /**
   *
   * @type {Array<TagSearchResult>}
   * @memberof SearchTagResultExternal
   */
  results?: Array<TagSearchResult>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const SearchTagSort = {
  Relevance: "RELEVANCE",
  NameDesc: "NAME_DESC",
  NameAsc: "NAME_ASC",
} as const;

export type SearchTagSort = (typeof SearchTagSort)[keyof typeof SearchTagSort];

/**
 *
 * @export
 * @interface SearchTaskFilter
 */
export interface SearchTaskFilter {
  /**
   *
   * @type {Array<string>}
   * @memberof SearchTaskFilter
   */
  linkedAsset?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchTaskFilter
   */
  primaryAssetAncestor?: Array<string>;
  /**
   *
   * @type {Array<TaskAssignedTo>}
   * @memberof SearchTaskFilter
   */
  assignedTo?: Array<TaskAssignedTo>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchTaskFilter
   */
  assignedUser?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof SearchTaskFilter
   */
  actionOn?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchTaskFilter
   */
  assignedTeam?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchTaskFilter
   */
  linkedUser?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchTaskFilter
   */
  linkedOrg?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchTaskFilter
   */
  linkedTeam?: Array<string>;
  /**
   *
   * @type {SearchElementDateRange}
   * @memberof SearchTaskFilter
   */
  created?: SearchElementDateRange;
  /**
   *
   * @type {SearchElementDateRange}
   * @memberof SearchTaskFilter
   */
  resolutionDueDate?: SearchElementDateRange;
  /**
   *
   * @type {SearchElementDateRange}
   * @memberof SearchTaskFilter
   */
  resolutionDueDateTime?: SearchElementDateRange;
  /**
   *
   * @type {SearchElementDateRange}
   * @memberof SearchTaskFilter
   */
  responseDueDateTime?: SearchElementDateRange;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchTaskFilter
   */
  priority?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchTaskFilter
   */
  status?: Array<string>;
  /**
   *
   * @type {Array<TaskStatusType>}
   * @memberof SearchTaskFilter
   */
  statusType?: Array<TaskStatusType>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchTaskFilter
   */
  serviceLevel?: Array<string>;
  /**
   *
   * @type {Array<SlaCurrentStatus>}
   * @memberof SearchTaskFilter
   */
  responseSlaStatus?: Array<SlaCurrentStatus>;
  /**
   *
   * @type {Array<SlaCurrentStatus>}
   * @memberof SearchTaskFilter
   */
  resolutionSlaStatus?: Array<SlaCurrentStatus>;
  /**
   *
   * @type {Array<SlaCurrentStatus>}
   * @memberof SearchTaskFilter
   */
  dueSlaStatus?: Array<SlaCurrentStatus>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchTaskFilter
   */
  taskType?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchTaskFilter
   */
  resolutionReason?: Array<string>;
  /**
   *
   * @type {{ [key: string]: SearchExtendedMetadataFilterCriteria; }}
   * @memberof SearchTaskFilter
   */
  extendedMetadata?: { [key: string]: SearchExtendedMetadataFilterCriteria };
}
/**
 *
 * @export
 * @interface SearchTaskRequest
 */
export interface SearchTaskRequest {
  /**
   *
   * @type {string}
   * @memberof SearchTaskRequest
   */
  freeText?: string;
  /**
   *
   * @type {SearchTaskFilter}
   * @memberof SearchTaskRequest
   */
  filter?: SearchTaskFilter;
  /**
   *
   * @type {SearchTaskSort}
   * @memberof SearchTaskRequest
   */
  sort?: SearchTaskSort;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchTaskRequest
   */
  extendedMetadataStats?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof SearchTaskRequest
   */
  page: number;
  /**
   *
   * @type {number}
   * @memberof SearchTaskRequest
   */
  pageSize?: number;
  /**
   *
   * @type {string}
   * @memberof SearchTaskRequest
   */
  oboUser?: string;
}

/**
 *
 * @export
 * @interface SearchTaskResultExternal
 */
export interface SearchTaskResultExternal {
  /**
   *
   * @type {SearchResultsSummary}
   * @memberof SearchTaskResultExternal
   */
  summary?: SearchResultsSummary;
  /**
   *
   * @type {SearchTaskStats}
   * @memberof SearchTaskResultExternal
   */
  stats?: SearchTaskStats;
  /**
   *
   * @type {Array<TaskSearchResultExternal>}
   * @memberof SearchTaskResultExternal
   */
  results?: Array<TaskSearchResultExternal>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const SearchTaskSort = {
  Relevance: "RELEVANCE",
  Recommended: "RECOMMENDED",
  CreatedDesc: "CREATED_DESC",
  CreatedAsc: "CREATED_ASC",
} as const;

export type SearchTaskSort = (typeof SearchTaskSort)[keyof typeof SearchTaskSort];

/**
 *
 * @export
 * @interface SearchTaskStats
 */
export interface SearchTaskStats {
  [key: string]: Array<SearchStatsGenericValueInner> | any;

  /**
   * Count by task status
   * @type {Array<SearchStatsElement>}
   * @memberof SearchTaskStats
   */
  statuses?: Array<SearchStatsElement>;
  /**
   * Count by task priority
   * @type {Array<SearchStatsElement>}
   * @memberof SearchTaskStats
   */
  priorities?: Array<SearchStatsElement>;
  /**
   * Count by task type
   * @type {Array<SearchStatsElement>}
   * @memberof SearchTaskStats
   */
  taskTypes?: Array<SearchStatsElement>;
  /**
   * Count by resolution reasons
   * @type {Array<SearchStatsElement>}
   * @memberof SearchTaskStats
   */
  resolutionReasons?: Array<SearchStatsElement>;
  /**
   * Count by status type
   * @type {Array<SearchTaskStatsStatusTypes>}
   * @memberof SearchTaskStats
   */
  statusTypes?: Array<SearchTaskStatsStatusTypes>;
  /**
   * Count by response SLA status
   * @type {Array<SearchTaskStatsResponseSlaStatuses>}
   * @memberof SearchTaskStats
   */
  responseSlaStatuses?: Array<SearchTaskStatsResponseSlaStatuses>;
  /**
   * Count by resolution SLA status
   * @type {Array<SearchTaskStatsResponseSlaStatuses>}
   * @memberof SearchTaskStats
   */
  resolutionSlaStatuses?: Array<SearchTaskStatsResponseSlaStatuses>;
  /**
   * Count by due SLA status
   * @type {Array<SearchTaskStatsResponseSlaStatuses>}
   * @memberof SearchTaskStats
   */
  dueSlaStatuses?: Array<SearchTaskStatsResponseSlaStatuses>;
}
/**
 *
 * @export
 * @interface SearchTaskStatsResponseSlaStatuses
 */
export interface SearchTaskStatsResponseSlaStatuses {
  /**
   *
   * @type {SlaCurrentStatus}
   * @memberof SearchTaskStatsResponseSlaStatuses
   */
  statusType?: SlaCurrentStatus;
  /**
   *
   * @type {number}
   * @memberof SearchTaskStatsResponseSlaStatuses
   */
  count?: number;
}

/**
 *
 * @export
 * @interface SearchTaskStatsStatusTypes
 */
export interface SearchTaskStatsStatusTypes {
  /**
   *
   * @type {TaskStatusType}
   * @memberof SearchTaskStatsStatusTypes
   */
  statusType?: TaskStatusType;
  /**
   *
   * @type {number}
   * @memberof SearchTaskStatsStatusTypes
   */
  count?: number;
}

/**
 *
 * @export
 * @interface SearchTeamFilter
 */
export interface SearchTeamFilter {
  /**
   *
   * @type {Array<string>}
   * @memberof SearchTeamFilter
   */
  linkedUser?: Array<string>;
}
/**
 *
 * @export
 * @interface SearchTeamRequest
 */
export interface SearchTeamRequest {
  /**
   *
   * @type {string}
   * @memberof SearchTeamRequest
   */
  freeText?: string;
  /**
   *
   * @type {SearchTeamFilter}
   * @memberof SearchTeamRequest
   */
  filter?: SearchTeamFilter;
  /**
   *
   * @type {SearchTeamSort}
   * @memberof SearchTeamRequest
   */
  sort?: SearchTeamSort;
  /**
   *
   * @type {number}
   * @memberof SearchTeamRequest
   */
  page: number;
  /**
   *
   * @type {number}
   * @memberof SearchTeamRequest
   */
  pageSize?: number;
  /**
   *
   * @type {string}
   * @memberof SearchTeamRequest
   */
  oboUser?: string;
}

/**
 *
 * @export
 * @interface SearchTeamResultExternal
 */
export interface SearchTeamResultExternal {
  /**
   *
   * @type {SearchResultsSummary}
   * @memberof SearchTeamResultExternal
   */
  summary?: SearchResultsSummary;
  /**
   *
   * @type {Array<TeamSearchResult>}
   * @memberof SearchTeamResultExternal
   */
  results?: Array<TeamSearchResult>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const SearchTeamSort = {
  Relevance: "RELEVANCE",
  NameDesc: "NAME_DESC",
  NameAsc: "NAME_ASC",
  CreatedDesc: "CREATED_DESC",
  CreatedAsc: "CREATED_ASC",
} as const;

export type SearchTeamSort = (typeof SearchTeamSort)[keyof typeof SearchTeamSort];

/**
 *
 * @export
 * @interface SearchUserFilter
 */
export interface SearchUserFilter {
  /**
   *
   * @type {Array<RoleSlug>}
   * @memberof SearchUserFilter
   */
  role?: Array<RoleSlug>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchUserFilter
   */
  org?: Array<string>;
  /**
   *
   * @type {Array<boolean>}
   * @memberof SearchUserFilter
   */
  vip?: Array<boolean>;
  /**
   * Include users that are enabled / disabled - defaults to only enabled
   * @type {Array<boolean>}
   * @memberof SearchUserFilter
   */
  enabled?: Array<boolean>;
  /**
   * Filter by the presence of a feature flag (e.g. `aa`)
   * @type {Array<string>}
   * @memberof SearchUserFilter
   */
  userFeatureFlags?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof SearchUserFilter
   */
  email?: string;
  /**
   * E.164 format phone number
   * @type {string}
   * @memberof SearchUserFilter
   */
  phoneNumber?: string;
  /**
   *
   * @type {SearchUserFilterMembership}
   * @memberof SearchUserFilter
   */
  membership?: SearchUserFilterMembership;
  /**
   *
   * @type {Array<RegistrationStatus>}
   * @memberof SearchUserFilter
   */
  registrationStatus?: Array<RegistrationStatus>;
  /**
   *
   * @type {{ [key: string]: SearchExtendedMetadataFilterCriteria; }}
   * @memberof SearchUserFilter
   */
  extendedMetadata?: { [key: string]: SearchExtendedMetadataFilterCriteria };
}
/**
 *
 * @export
 * @interface SearchUserFilterMembership
 */
export interface SearchUserFilterMembership {
  /**
   *
   * @type {Array<string>}
   * @memberof SearchUserFilterMembership
   */
  org?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchUserFilterMembership
   */
  team?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchUserFilterMembership
   */
  user?: Array<string>;
}
/**
 *
 * @export
 * @interface SearchUserRequest
 */
export interface SearchUserRequest {
  /**
   *
   * @type {string}
   * @memberof SearchUserRequest
   */
  freeText?: string;
  /**
   *
   * @type {SearchUserFilter}
   * @memberof SearchUserRequest
   */
  filter?: SearchUserFilter;
  /**
   *
   * @type {SearchUserSort}
   * @memberof SearchUserRequest
   */
  sort?: SearchUserSort;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchUserRequest
   */
  extendedMetadataStats?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof SearchUserRequest
   */
  page: number;
  /**
   *
   * @type {number}
   * @memberof SearchUserRequest
   */
  pageSize?: number;
  /**
   *
   * @type {string}
   * @memberof SearchUserRequest
   */
  oboUser?: string;
}

/**
 *
 * @export
 * @interface SearchUserResultExternal
 */
export interface SearchUserResultExternal {
  /**
   *
   * @type {SearchResultsSummary}
   * @memberof SearchUserResultExternal
   */
  summary?: SearchResultsSummary;
  /**
   *
   * @type {SearchUserStats}
   * @memberof SearchUserResultExternal
   */
  stats?: SearchUserStats;
  /**
   *
   * @type {Array<UserSearchResultExternal>}
   * @memberof SearchUserResultExternal
   */
  results?: Array<UserSearchResultExternal>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const SearchUserSort = {
  Relevance: "RELEVANCE",
  GivenNameDesc: "GIVEN_NAME_DESC",
  GivenNameAsc: "GIVEN_NAME_ASC",
  FamilyNameDesc: "FAMILY_NAME_DESC",
  FamilyNameAsc: "FAMILY_NAME_ASC",
  CreatedDesc: "CREATED_DESC",
  CreatedAsc: "CREATED_ASC",
} as const;

export type SearchUserSort = (typeof SearchUserSort)[keyof typeof SearchUserSort];

/**
 *
 * @export
 * @interface SearchUserStats
 */
export interface SearchUserStats {
  [key: string]: Array<SearchStatsGenericValueInner> | any;

  /**
   * Count by role
   * @type {Array<SearchUserStatsRoles>}
   * @memberof SearchUserStats
   */
  roles?: Array<SearchUserStatsRoles>;
}
/**
 *
 * @export
 * @interface SearchUserStatsRoles
 */
export interface SearchUserStatsRoles {
  /**
   *
   * @type {RoleSlug}
   * @memberof SearchUserStatsRoles
   */
  role?: RoleSlug;
  /**
   *
   * @type {number}
   * @memberof SearchUserStatsRoles
   */
  count?: number;
}

/**
 *
 * @export
 * @interface ServiceLevelCreate
 */
export interface ServiceLevelCreate {
  /**
   * Admin view of name
   * @type {string}
   * @memberof ServiceLevelCreate
   */
  name: string;
  /**
   * Whether this is the default service level for this tenant
   * @type {boolean}
   * @memberof ServiceLevelCreate
   */
  default?: boolean;
  /**
   *
   * @type {Array<ServiceLevelListServiceLevels>}
   * @memberof ServiceLevelCreate
   */
  serviceLevels?: Array<ServiceLevelListServiceLevels>;
}
/**
 *
 * @export
 * @interface ServiceLevelList
 */
export interface ServiceLevelList {
  /**
   *
   * @type {Array<ServiceLevelListServiceLevels1>}
   * @memberof ServiceLevelList
   */
  serviceLevels?: Array<ServiceLevelListServiceLevels1>;
}
/**
 *
 * @export
 * @interface ServiceLevelListServiceLevels
 */
export interface ServiceLevelListServiceLevels {
  /**
   *
   * @type {string}
   * @memberof ServiceLevelListServiceLevels
   */
  taskPriorityUid: string;
  /**
   *
   * @type {ServiceLevelListSla}
   * @memberof ServiceLevelListServiceLevels
   */
  sla: ServiceLevelListSla;
}
/**
 *
 * @export
 * @interface ServiceLevelListServiceLevels1
 */
export interface ServiceLevelListServiceLevels1 {
  /**
   *
   * @type {string}
   * @memberof ServiceLevelListServiceLevels1
   */
  uid: string;
  /**
   * Admin view of name
   * @type {string}
   * @memberof ServiceLevelListServiceLevels1
   */
  name: string;
  /**
   * Whether this is the default service level for this tenant
   * @type {boolean}
   * @memberof ServiceLevelListServiceLevels1
   */
  default?: boolean;
  /**
   *
   * @type {Array<ServiceLevelListServiceLevels>}
   * @memberof ServiceLevelListServiceLevels1
   */
  serviceLevels?: Array<ServiceLevelListServiceLevels>;
}
/**
 *
 * @export
 * @interface ServiceLevelListSla
 */
export interface ServiceLevelListSla {
  /**
   *
   * @type {boolean}
   * @memberof ServiceLevelListSla
   */
  applies: boolean;
  /**
   *
   * @type {ServiceLevelListSlaResponse}
   * @memberof ServiceLevelListSla
   */
  response?: ServiceLevelListSlaResponse;
  /**
   *
   * @type {ServiceLevelListSlaResponse}
   * @memberof ServiceLevelListSla
   */
  resolution?: ServiceLevelListSlaResponse;
}
/**
 *
 * @export
 * @interface ServiceLevelListSlaResponse
 */
export interface ServiceLevelListSlaResponse {
  /**
   *
   * @type {number}
   * @memberof ServiceLevelListSlaResponse
   */
  targetDuration?: number;
  /**
   *
   * @type {SlaDurationType}
   * @memberof ServiceLevelListSlaResponse
   */
  durationType?: SlaDurationType;
}

/**
 *
 * @export
 * @interface ServiceLevelRead
 */
export interface ServiceLevelRead {
  /**
   *
   * @type {string}
   * @memberof ServiceLevelRead
   */
  uid: string;
  /**
   * Admin view of name
   * @type {string}
   * @memberof ServiceLevelRead
   */
  name: string;
  /**
   * Whether this is the default service level for this tenant
   * @type {boolean}
   * @memberof ServiceLevelRead
   */
  default?: boolean;
  /**
   *
   * @type {Array<ServiceLevelListServiceLevels>}
   * @memberof ServiceLevelRead
   */
  serviceLevels?: Array<ServiceLevelListServiceLevels>;
}
/**
 *
 * @export
 * @interface ServiceLevelUpdate
 */
export interface ServiceLevelUpdate {
  /**
   * Admin view of name
   * @type {string}
   * @memberof ServiceLevelUpdate
   */
  name?: string;
  /**
   * Whether this is the default service level for this tenant
   * @type {boolean}
   * @memberof ServiceLevelUpdate
   */
  default?: boolean;
  /**
   *
   * @type {Array<ServiceLevelListServiceLevels>}
   * @memberof ServiceLevelUpdate
   */
  serviceLevels?: Array<ServiceLevelListServiceLevels>;
}
/**
 *
 * @export
 * @interface SetUnreadRequest
 */
export interface SetUnreadRequest {
  /**
   *
   * @type {boolean}
   * @memberof SetUnreadRequest
   */
  isRead?: boolean;
}
/**
 *
 * @export
 * @interface ShortLinkCreate
 */
export interface ShortLinkCreate {
  /**
   *
   * @type {ExternalLinkSource}
   * @memberof ShortLinkCreate
   */
  linkSource: ExternalLinkSource;
  /**
   *
   * @type {string}
   * @memberof ShortLinkCreate
   */
  linkPath?: string;
}
/**
 *
 * @export
 * @interface ShortLinkExpanded
 */
export interface ShortLinkExpanded {
  /**
   *
   * @type {string}
   * @memberof ShortLinkExpanded
   */
  uid?: string;
  /**
   * The shortened URL at the the link domain
   * @type {string}
   * @memberof ShortLinkExpanded
   */
  shortUrl?: string;
  /**
   *
   * @type {string}
   * @memberof ShortLinkExpanded
   */
  linkPath?: string;
  /**
   *
   * @type {string}
   * @memberof ShortLinkExpanded
   */
  qrDisplayUrl?: string;
  /**
   *
   * @type {string}
   * @memberof ShortLinkExpanded
   */
  qrDownloadSvgUrl?: string;
  /**
   *
   * @type {string}
   * @memberof ShortLinkExpanded
   */
  qrDownloadPngUrl?: string;
}
/**
 *
 * @export
 * @interface ShortLinkFetch
 */
export interface ShortLinkFetch {
  /**
   *
   * @type {string}
   * @memberof ShortLinkFetch
   */
  uid: string;
  /**
   * Reference to third party short link system ID (for short.io, `idString`)
   * @type {string}
   * @memberof ShortLinkFetch
   */
  externalId: string;
  /**
   * THe externallised platform URL
   * @type {string}
   * @memberof ShortLinkFetch
   */
  platformUrl: string;
  /**
   * The shortened URL at the the link domain
   * @type {string}
   * @memberof ShortLinkFetch
   */
  shortUrl: string;
  /**
   *
   * @type {string}
   * @memberof ShortLinkFetch
   */
  linkPath: string;
  /**
   *
   * @type {string}
   * @memberof ShortLinkFetch
   */
  qrDisplayUrl: string;
  /**
   *
   * @type {string}
   * @memberof ShortLinkFetch
   */
  qrDownloadSvgUrl: string;
  /**
   *
   * @type {string}
   * @memberof ShortLinkFetch
   */
  qrDownloadPngUrl: string;
}
/**
 *
 * @export
 * @interface ShortLinkUpdate
 */
export interface ShortLinkUpdate {
  /**
   *
   * @type {string}
   * @memberof ShortLinkUpdate
   */
  linkPath: string;
}
/**
 *
 * @export
 * @interface SimpleLocationResponse
 */
export interface SimpleLocationResponse {
  /**
   *
   * @type {string}
   * @memberof SimpleLocationResponse
   */
  location: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const SlaCurrentDueStatusReadOnly = {
  Running: "RUNNING",
  CompletedOnTime: "COMPLETED_ON_TIME",
  CompletedLate: "COMPLETED_LATE",
  Overdue: "OVERDUE",
} as const;

export type SlaCurrentDueStatusReadOnly =
  (typeof SlaCurrentDueStatusReadOnly)[keyof typeof SlaCurrentDueStatusReadOnly];

/**
 *
 * @export
 * @enum {string}
 */

export const SlaCurrentStatus = {
  Na: "NA",
  Running: "RUNNING",
  Paused: "PAUSED",
  CompletedOnTime: "COMPLETED_ON_TIME",
  CompletedLate: "COMPLETED_LATE",
  Overdue: "OVERDUE",
} as const;

export type SlaCurrentStatus = (typeof SlaCurrentStatus)[keyof typeof SlaCurrentStatus];

/**
 *
 * @export
 * @enum {string}
 */

export const SlaCurrentStatusReadOnly = {
  Na: "NA",
  Running: "RUNNING",
  Paused: "PAUSED",
  CompletedOnTime: "COMPLETED_ON_TIME",
  CompletedLate: "COMPLETED_LATE",
  Overdue: "OVERDUE",
} as const;

export type SlaCurrentStatusReadOnly = (typeof SlaCurrentStatusReadOnly)[keyof typeof SlaCurrentStatusReadOnly];

/**
 *
 * @export
 * @enum {string}
 */

export const SlaDurationType = {
  _247: "24_7",
  ServiceHours: "SERVICE_HOURS",
} as const;

export type SlaDurationType = (typeof SlaDurationType)[keyof typeof SlaDurationType];

/**
 *
 * @export
 * @enum {string}
 */

export const SlaDurationTypeReadOnly = {
  _247: "24_7",
  ServiceHours: "SERVICE_HOURS",
} as const;

export type SlaDurationTypeReadOnly = (typeof SlaDurationTypeReadOnly)[keyof typeof SlaDurationTypeReadOnly];

/**
 *
 * @export
 * @enum {string}
 */

export const SlaType = {
  User: "USER",
  ServiceLevel: "SERVICE_LEVEL",
  None: "NONE",
} as const;

export type SlaType = (typeof SlaType)[keyof typeof SlaType];

/**
 *
 * @export
 * @interface TagCreate
 */
export interface TagCreate {
  /**
   *
   * @type {string}
   * @memberof TagCreate
   */
  name: string;
}
/**
 *
 * @export
 * @interface TagSearchResult
 */
export interface TagSearchResult {
  /**
   *
   * @type {string}
   * @memberof TagSearchResult
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TagSearchResult
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof TagSearchResult
   */
  name: string;
}
/**
 *
 * @export
 * @interface TagSummary
 */
export interface TagSummary {
  /**
   *
   * @type {string}
   * @memberof TagSummary
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TagSummary
   */
  urn?: string;
  /**
   *
   * @type {string}
   * @memberof TagSummary
   */
  name: string;
}
/**
 *
 * @export
 * @interface TagWriteResponse
 */
export interface TagWriteResponse {
  /**
   *
   * @type {string}
   * @memberof TagWriteResponse
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TagWriteResponse
   */
  urn?: string;
  /**
   *
   * @type {string}
   * @memberof TagWriteResponse
   */
  name: string;
}
/**
 *
 * @export
 * @interface TaskActivityConfigReadExternal
 */
export interface TaskActivityConfigReadExternal {
  /**
   *
   * @type {string}
   * @memberof TaskActivityConfigReadExternal
   */
  uid: string;
  /**
   *
   * @type {number}
   * @memberof TaskActivityConfigReadExternal
   */
  maxInstances?: number;
  /**
   *
   * @type {TaskActivityConfigReadExternalActivityAction}
   * @memberof TaskActivityConfigReadExternal
   */
  activityAction: TaskActivityConfigReadExternalActivityAction;
  /**
   *
   * @type {string}
   * @memberof TaskActivityConfigReadExternal
   */
  displayName?: string;
}
/**
 * @type TaskActivityConfigReadExternalActivityAction
 * @export
 */
export type TaskActivityConfigReadExternalActivityAction =
  | TaskActivityConfigReadExternalActivityActionOneOf
  | TaskActivityConfigReadExternalActivityActionOneOf1;

/**
 *
 * @export
 * @interface TaskActivityConfigReadExternalActivityActionOneOf
 */
export interface TaskActivityConfigReadExternalActivityActionOneOf {
  /**
   *
   * @type {TaskActivityConfigReadExternalActivityActionOneOfTaskExtension}
   * @memberof TaskActivityConfigReadExternalActivityActionOneOf
   */
  taskExtension?: TaskActivityConfigReadExternalActivityActionOneOfTaskExtension;
}
/**
 *
 * @export
 * @interface TaskActivityConfigReadExternalActivityActionOneOf1
 */
export interface TaskActivityConfigReadExternalActivityActionOneOf1 {
  /**
   *
   * @type {TaskActivityConfigReadExternalActivityActionOneOf1ExtendedMetadata}
   * @memberof TaskActivityConfigReadExternalActivityActionOneOf1
   */
  extendedMetadata?: TaskActivityConfigReadExternalActivityActionOneOf1ExtendedMetadata;
}
/**
 *
 * @export
 * @interface TaskActivityConfigReadExternalActivityActionOneOf1ExtendedMetadata
 */
export interface TaskActivityConfigReadExternalActivityActionOneOf1ExtendedMetadata {
  /**
   *
   * @type {string}
   * @memberof TaskActivityConfigReadExternalActivityActionOneOf1ExtendedMetadata
   */
  extMetadataGroupConfigUid: string;
}
/**
 *
 * @export
 * @interface TaskActivityConfigReadExternalActivityActionOneOfTaskExtension
 */
export interface TaskActivityConfigReadExternalActivityActionOneOfTaskExtension {
  /**
   *
   * @type {TaskActivityConfigReadExternalActivityActionOneOfTaskExtensionExtension}
   * @memberof TaskActivityConfigReadExternalActivityActionOneOfTaskExtension
   */
  extension?: TaskActivityConfigReadExternalActivityActionOneOfTaskExtensionExtension;
  /**
   * JSON configuraton for use by the extension
   * @type {{ [key: string]: any; }}
   * @memberof TaskActivityConfigReadExternalActivityActionOneOfTaskExtension
   */
  extensionConfigMetadata?: { [key: string]: any };
}
/**
 *
 * @export
 * @interface TaskActivityConfigReadExternalActivityActionOneOfTaskExtensionExtension
 */
export interface TaskActivityConfigReadExternalActivityActionOneOfTaskExtensionExtension {
  /**
   *
   * @type {string}
   * @memberof TaskActivityConfigReadExternalActivityActionOneOfTaskExtensionExtension
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TaskActivityConfigReadExternalActivityActionOneOfTaskExtensionExtension
   */
  uiWidgetPath?: string;
}
/**
 *
 * @export
 * @interface TaskActivityCreate
 */
export interface TaskActivityCreate {
  /**
   *
   * @type {string}
   * @memberof TaskActivityCreate
   */
  taskUid: string;
  /**
   *
   * @type {string}
   * @memberof TaskActivityCreate
   */
  activityConfigUid: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const TaskActivityStatus = {
  Inactive: "INACTIVE",
  Active: "ACTIVE",
  Done: "DONE",
} as const;

export type TaskActivityStatus = (typeof TaskActivityStatus)[keyof typeof TaskActivityStatus];

/**
 *
 * @export
 * @interface TaskActivityUpdateExternal
 */
export interface TaskActivityUpdateExternal {
  /**
   *
   * @type {string}
   * @memberof TaskActivityUpdateExternal
   */
  taskUid: string;
  /**
   *
   * @type {TaskActivityStatus}
   * @memberof TaskActivityUpdateExternal
   */
  activityStatus: TaskActivityStatus;
}

/**
 *
 * @export
 * @interface TaskActivityWriteResponse
 */
export interface TaskActivityWriteResponse {
  /**
   *
   * @type {string}
   * @memberof TaskActivityWriteResponse
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TaskActivityWriteResponse
   */
  urn: string;
  /**
   *
   * @type {TaskActivityStatus}
   * @memberof TaskActivityWriteResponse
   */
  activityStatus?: TaskActivityStatus;
}

/**
 *
 * @export
 * @enum {string}
 */

export const TaskAssignedTo = {
  Me: "ME",
  MyTeams: "MY_TEAMS",
} as const;

export type TaskAssignedTo = (typeof TaskAssignedTo)[keyof typeof TaskAssignedTo];

/**
 *
 * @export
 * @interface TaskCancelledEventType
 */
export interface TaskCancelledEventType {
  /**
   *
   * @type {string}
   * @memberof TaskCancelledEventType
   */
  eventType: TaskCancelledEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TaskCancelledEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof TaskCancelledEventType
   */
  taskSid?: string;
}

export const TaskCancelledEventTypeEventTypeEnum = {
  TaskCancelled: "TASK_CANCELLED",
} as const;

export type TaskCancelledEventTypeEventTypeEnum =
  (typeof TaskCancelledEventTypeEventTypeEnum)[keyof typeof TaskCancelledEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface TaskChangeTaskType
 */
export interface TaskChangeTaskType {
  /**
   *
   * @type {string}
   * @memberof TaskChangeTaskType
   */
  taskTypeUid: string;
  /**
   *
   * @type {string}
   * @memberof TaskChangeTaskType
   */
  priorityUid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskChangeTaskType
   */
  statusUid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskChangeTaskType
   */
  resolutionReasonUid?: string;
}
/**
 *
 * @export
 * @interface TaskCompletedEventType
 */
export interface TaskCompletedEventType {
  /**
   *
   * @type {string}
   * @memberof TaskCompletedEventType
   */
  eventType: TaskCompletedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TaskCompletedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof TaskCompletedEventType
   */
  taskSid?: string;
}

export const TaskCompletedEventTypeEventTypeEnum = {
  TaskCompleted: "TASK_COMPLETED",
} as const;

export type TaskCompletedEventTypeEventTypeEnum =
  (typeof TaskCompletedEventTypeEventTypeEnum)[keyof typeof TaskCompletedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface TaskCreate
 */
export interface TaskCreate {
  /**
   *
   * @type {string}
   * @memberof TaskCreate
   */
  taskTypeUid: string;
  /**
   *
   * @type {string}
   * @memberof TaskCreate
   */
  initiator?: string;
  /**
   *
   * @type {string}
   * @memberof TaskCreate
   */
  title: string;
  /**
   *
   * @type {TaskSource}
   * @memberof TaskCreate
   */
  source: TaskSource;
  /**
   *
   * @type {string}
   * @memberof TaskCreate
   */
  futureActivation?: string;
  /**
   *
   * @type {string}
   * @memberof TaskCreate
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof TaskCreate
   */
  serviceLevelUid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskCreate
   */
  priorityUid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskCreate
   */
  statusUid?: string;
  /**
   *
   * @type {TaskCreateProductOrder}
   * @memberof TaskCreate
   */
  productOrder?: TaskCreateProductOrder;
  /**
   *
   * @type {TaskSearchResultExternalSla}
   * @memberof TaskCreate
   */
  sla?: TaskSearchResultExternalSla;
  /**
   *
   * @type {Array<AssetCreateRelationships>}
   * @memberof TaskCreate
   */
  relationships?: Array<AssetCreateRelationships>;
  /**
   *
   * @type {Array<AssetCreateMedia>}
   * @memberof TaskCreate
   */
  media?: Array<AssetCreateMedia>;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof TaskCreate
   */
  extendedMetadata?: { [key: string]: any };
  /**
   *
   * @type {TaskFullExternalLink}
   * @memberof TaskCreate
   */
  externalLink?: TaskFullExternalLink;
}

/**
 *
 * @export
 * @interface TaskCreateProductOrder
 */
export interface TaskCreateProductOrder {
  /**
   *
   * @type {string}
   * @memberof TaskCreateProductOrder
   */
  offeringUid: string;
  /**
   *
   * @type {Array<TaskCreateProductOrderProducts>}
   * @memberof TaskCreateProductOrder
   */
  products: Array<TaskCreateProductOrderProducts>;
}
/**
 *
 * @export
 * @interface TaskCreateProductOrderProducts
 */
export interface TaskCreateProductOrderProducts {
  /**
   *
   * @type {string}
   * @memberof TaskCreateProductOrderProducts
   */
  productUid: string;
  /**
   *
   * @type {number}
   * @memberof TaskCreateProductOrderProducts
   */
  quantity: number;
  /**
   *
   * @type {number}
   * @memberof TaskCreateProductOrderProducts
   */
  orderedPrice: number;
}
/**
 *
 * @export
 * @interface TaskCreatedEventType
 */
export interface TaskCreatedEventType {
  /**
   *
   * @type {string}
   * @memberof TaskCreatedEventType
   */
  eventType: TaskCreatedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TaskCreatedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof TaskCreatedEventType
   */
  taskSid?: string;
}

export const TaskCreatedEventTypeEventTypeEnum = {
  TaskCreated: "TASK_CREATED",
} as const;

export type TaskCreatedEventTypeEventTypeEnum =
  (typeof TaskCreatedEventTypeEventTypeEnum)[keyof typeof TaskCreatedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface TaskDeletedEventType
 */
export interface TaskDeletedEventType {
  /**
   *
   * @type {string}
   * @memberof TaskDeletedEventType
   */
  eventType: TaskDeletedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TaskDeletedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof TaskDeletedEventType
   */
  taskSid?: string;
}

export const TaskDeletedEventTypeEventTypeEnum = {
  TaskDeleted: "TASK_DELETED",
} as const;

export type TaskDeletedEventTypeEventTypeEnum =
  (typeof TaskDeletedEventTypeEventTypeEnum)[keyof typeof TaskDeletedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface TaskExportCreate
 */
export interface TaskExportCreate {
  /**
   *
   * @type {string}
   * @memberof TaskExportCreate
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof TaskExportCreate
   */
  timezone: string;
  /**
   *
   * @type {string}
   * @memberof TaskExportCreate
   */
  freeText?: string;
  /**
   *
   * @type {string}
   * @memberof TaskExportCreate
   */
  format: TaskExportCreateFormatEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof TaskExportCreate
   */
  fields?: Array<TaskExportCreateFieldsEnum>;
  /**
   *
   * @type {SearchTaskFilter}
   * @memberof TaskExportCreate
   */
  filter?: SearchTaskFilter;
  /**
   *
   * @type {SearchTaskSort}
   * @memberof TaskExportCreate
   */
  sort?: SearchTaskSort;
}

export const TaskExportCreateFormatEnum = {
  Standard: "STANDARD",
  ExcelCompatible: "EXCEL_COMPATIBLE",
} as const;

export type TaskExportCreateFormatEnum = (typeof TaskExportCreateFormatEnum)[keyof typeof TaskExportCreateFormatEnum];
export const TaskExportCreateFieldsEnum = {
  TaskResources: "TASK_RESOURCES",
} as const;

export type TaskExportCreateFieldsEnum = (typeof TaskExportCreateFieldsEnum)[keyof typeof TaskExportCreateFieldsEnum];

/**
 *
 * @export
 * @interface TaskExportReadExternal
 */
export interface TaskExportReadExternal {
  /**
   *
   * @type {string}
   * @memberof TaskExportReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TaskExportReadExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof TaskExportReadExternal
   */
  name: string;
  /**
   * Language code including locale
   * @type {string}
   * @memberof TaskExportReadExternal
   */
  languageCode: string;
  /**
   *
   * @type {string}
   * @memberof TaskExportReadExternal
   */
  timezone: string;
  /**
   *
   * @type {number}
   * @memberof TaskExportReadExternal
   */
  resultCount?: number;
  /**
   *
   * @type {TaskExportReadExternalProgress}
   * @memberof TaskExportReadExternal
   */
  progress: TaskExportReadExternalProgress;
  /**
   *
   * @type {string}
   * @memberof TaskExportReadExternal
   */
  requestedAt: string;
  /**
   *
   * @type {string}
   * @memberof TaskExportReadExternal
   */
  freeText?: string;
  /**
   *
   * @type {string}
   * @memberof TaskExportReadExternal
   */
  format: TaskExportReadExternalFormatEnum;
  /**
   *
   * @type {UserRefHydrated}
   * @memberof TaskExportReadExternal
   */
  createdBy: UserRefHydrated;
  /**
   *
   * @type {string}
   * @memberof TaskExportReadExternal
   */
  type: TaskExportReadExternalTypeEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof TaskExportReadExternal
   */
  fields: Array<TaskExportReadExternalFieldsEnum>;
  /**
   *
   * @type {SearchTaskFilter}
   * @memberof TaskExportReadExternal
   */
  filter: SearchTaskFilter;
  /**
   *
   * @type {SearchTaskSort}
   * @memberof TaskExportReadExternal
   */
  sort: SearchTaskSort;
}

export const TaskExportReadExternalFormatEnum = {
  Standard: "STANDARD",
  ExcelCompatible: "EXCEL_COMPATIBLE",
} as const;

export type TaskExportReadExternalFormatEnum =
  (typeof TaskExportReadExternalFormatEnum)[keyof typeof TaskExportReadExternalFormatEnum];
export const TaskExportReadExternalTypeEnum = {
  Task: "TASK",
} as const;

export type TaskExportReadExternalTypeEnum =
  (typeof TaskExportReadExternalTypeEnum)[keyof typeof TaskExportReadExternalTypeEnum];
export const TaskExportReadExternalFieldsEnum = {
  TaskResources: "TASK_RESOURCES",
} as const;

export type TaskExportReadExternalFieldsEnum =
  (typeof TaskExportReadExternalFieldsEnum)[keyof typeof TaskExportReadExternalFieldsEnum];

/**
 * @type TaskExportReadExternalProgress
 * @export
 */
export type TaskExportReadExternalProgress =
  | TaskExportReadExternalProgressOneOf
  | TaskExportReadExternalProgressOneOf1
  | TaskExportReadExternalProgressOneOf2;

/**
 *
 * @export
 * @interface TaskExportReadExternalProgressOneOf
 */
export interface TaskExportReadExternalProgressOneOf {
  /**
   *
   * @type {string}
   * @memberof TaskExportReadExternalProgressOneOf
   */
  status: TaskExportReadExternalProgressOneOfStatusEnum;
}

export const TaskExportReadExternalProgressOneOfStatusEnum = {
  Pending: "PENDING",
} as const;

export type TaskExportReadExternalProgressOneOfStatusEnum =
  (typeof TaskExportReadExternalProgressOneOfStatusEnum)[keyof typeof TaskExportReadExternalProgressOneOfStatusEnum];

/**
 *
 * @export
 * @interface TaskExportReadExternalProgressOneOf1
 */
export interface TaskExportReadExternalProgressOneOf1 {
  /**
   *
   * @type {string}
   * @memberof TaskExportReadExternalProgressOneOf1
   */
  status: TaskExportReadExternalProgressOneOf1StatusEnum;
  /**
   *
   * @type {string}
   * @memberof TaskExportReadExternalProgressOneOf1
   */
  failedAt: string;
  /**
   *
   * @type {string}
   * @memberof TaskExportReadExternalProgressOneOf1
   */
  failureReason?: string;
}

export const TaskExportReadExternalProgressOneOf1StatusEnum = {
  Failed: "FAILED",
} as const;

export type TaskExportReadExternalProgressOneOf1StatusEnum =
  (typeof TaskExportReadExternalProgressOneOf1StatusEnum)[keyof typeof TaskExportReadExternalProgressOneOf1StatusEnum];

/**
 *
 * @export
 * @interface TaskExportReadExternalProgressOneOf2
 */
export interface TaskExportReadExternalProgressOneOf2 {
  /**
   *
   * @type {string}
   * @memberof TaskExportReadExternalProgressOneOf2
   */
  status: TaskExportReadExternalProgressOneOf2StatusEnum;
  /**
   *
   * @type {string}
   * @memberof TaskExportReadExternalProgressOneOf2
   */
  completedAt: string;
}

export const TaskExportReadExternalProgressOneOf2StatusEnum = {
  Completed: "COMPLETED",
} as const;

export type TaskExportReadExternalProgressOneOf2StatusEnum =
  (typeof TaskExportReadExternalProgressOneOf2StatusEnum)[keyof typeof TaskExportReadExternalProgressOneOf2StatusEnum];

/**
 *
 * @export
 * @interface TaskFilterValuesExternal
 */
export interface TaskFilterValuesExternal {
  /**
   *
   * @type {Array<TaskPriorityReadExternal>}
   * @memberof TaskFilterValuesExternal
   */
  priorities?: Array<TaskPriorityReadExternal>;
  /**
   *
   * @type {Array<TaskStatusSummaryExternal>}
   * @memberof TaskFilterValuesExternal
   */
  statuses?: Array<TaskStatusSummaryExternal>;
  /**
   *
   * @type {Array<TaskTypeFilterExternal>}
   * @memberof TaskFilterValuesExternal
   */
  taskTypes?: Array<TaskTypeFilterExternal>;
  /**
   *
   * @type {Array<ExtendedMetadataAttributeFilterSummaryExternal>}
   * @memberof TaskFilterValuesExternal
   */
  extendedMetadata?: Array<ExtendedMetadataAttributeFilterSummaryExternal>;
}
/**
 *
 * @export
 * @interface TaskFull
 */
export interface TaskFull {
  /**
   *
   * @type {string}
   * @memberof TaskFull
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TaskFull
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof TaskFull
   */
  taskRef: string;
  /**
   *
   * @type {string}
   * @memberof TaskFull
   */
  taskTypeUid: string;
  /**
   *
   * @type {string}
   * @memberof TaskFull
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof TaskFull
   */
  lastStatusChange?: string;
  /**
   *
   * @type {string}
   * @memberof TaskFull
   */
  futureActivation?: string;
  /**
   *
   * @type {string}
   * @memberof TaskFull
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof TaskFull
   */
  serviceLevelUid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskFull
   */
  openedAt?: string;
  /**
   *
   * @type {string}
   * @memberof TaskFull
   */
  closedAt?: string;
  /**
   *
   * @type {TaskFullResolution}
   * @memberof TaskFull
   */
  resolution?: TaskFullResolution;
  /**
   *
   * @type {string}
   * @memberof TaskFull
   */
  priorityUid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskFull
   */
  statusUid?: string;
  /**
   *
   * @type {TaskSearchResultExternalSla}
   * @memberof TaskFull
   */
  sla?: TaskSearchResultExternalSla;
  /**
   *
   * @type {TaskFullProductOrder}
   * @memberof TaskFull
   */
  productOrder?: TaskFullProductOrder;
  /**
   *
   * @type {UserSummaryExternal}
   * @memberof TaskFull
   */
  initiator?: UserSummaryExternal;
  /**
   *
   * @type {Array<TaskFullTaskNotes>}
   * @memberof TaskFull
   */
  taskNotes?: Array<TaskFullTaskNotes>;
  /**
   *
   * @type {Array<TaskFullTaskActivities>}
   * @memberof TaskFull
   */
  taskActivities?: Array<TaskFullTaskActivities>;
  /**
   *
   * @type {Array<AssetSummaryExternalMedia>}
   * @memberof TaskFull
   */
  media?: Array<AssetSummaryExternalMedia>;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof TaskFull
   */
  extendedMetadata?: { [key: string]: any };
  /**
   *
   * @type {Array<TaskFullLinkedTasks>}
   * @memberof TaskFull
   */
  linkedTasks?: Array<TaskFullLinkedTasks>;
  /**
   *
   * @type {Array<TaskFullLinkedTeams>}
   * @memberof TaskFull
   */
  linkedTeams?: Array<TaskFullLinkedTeams>;
  /**
   *
   * @type {Array<TaskFullLinkedTags>}
   * @memberof TaskFull
   */
  linkedTags?: Array<TaskFullLinkedTags>;
  /**
   *
   * @type {Array<TaskFullLinkedAssets>}
   * @memberof TaskFull
   */
  linkedAssets?: Array<TaskFullLinkedAssets>;
  /**
   *
   * @type {Array<TaskFullLinkedUsers>}
   * @memberof TaskFull
   */
  linkedUsers?: Array<TaskFullLinkedUsers>;
  /**
   *
   * @type {Array<TaskFullLinkedOrgs>}
   * @memberof TaskFull
   */
  linkedOrgs?: Array<TaskFullLinkedOrgs>;
  /**
   *
   * @type {TaskFullExternalLink}
   * @memberof TaskFull
   */
  externalLink?: TaskFullExternalLink;
  /**
   *
   * @type {ChangeSummary}
   * @memberof TaskFull
   */
  changeSummary?: ChangeSummary;
  /**
   *
   * @type {number}
   * @memberof TaskFull
   */
  messagesCount?: number;
  /**
   *
   * @type {number}
   * @memberof TaskFull
   */
  userUnreadNotifications?: number;
}
/**
 *
 * @export
 * @interface TaskFullExternalLink
 */
export interface TaskFullExternalLink {
  /**
   *
   * @type {string}
   * @memberof TaskFullExternalLink
   */
  linkTitle: string;
  /**
   *
   * @type {string}
   * @memberof TaskFullExternalLink
   */
  linkUrl: string;
}
/**
 *
 * @export
 * @interface TaskFullLinkedAssets
 */
export interface TaskFullLinkedAssets {
  /**
   *
   * @type {RelationshipLabel}
   * @memberof TaskFullLinkedAssets
   */
  relLabel: RelationshipLabel;
  /**
   *
   * @type {AssetSummaryAncestralExternal}
   * @memberof TaskFullLinkedAssets
   */
  assetSummary: AssetSummaryAncestralExternal;
}

/**
 *
 * @export
 * @interface TaskFullLinkedOrgs
 */
export interface TaskFullLinkedOrgs {
  /**
   *
   * @type {RelationshipLabel}
   * @memberof TaskFullLinkedOrgs
   */
  relLabel: RelationshipLabel;
  /**
   *
   * @type {OrgSummaryExternal}
   * @memberof TaskFullLinkedOrgs
   */
  orgSummary: OrgSummaryExternal;
}

/**
 *
 * @export
 * @interface TaskFullLinkedTags
 */
export interface TaskFullLinkedTags {
  /**
   *
   * @type {RelationshipLabel}
   * @memberof TaskFullLinkedTags
   */
  relLabel: RelationshipLabel;
  /**
   *
   * @type {TagSummary}
   * @memberof TaskFullLinkedTags
   */
  tagSummary: TagSummary;
}

/**
 *
 * @export
 * @interface TaskFullLinkedTasks
 */
export interface TaskFullLinkedTasks {
  /**
   *
   * @type {RelationshipLabel}
   * @memberof TaskFullLinkedTasks
   */
  relLabel: RelationshipLabel;
  /**
   *
   * @type {TaskSummary}
   * @memberof TaskFullLinkedTasks
   */
  taskSummary: TaskSummary;
}

/**
 *
 * @export
 * @interface TaskFullLinkedTeams
 */
export interface TaskFullLinkedTeams {
  /**
   *
   * @type {RelationshipLabel}
   * @memberof TaskFullLinkedTeams
   */
  relLabel: RelationshipLabel;
  /**
   *
   * @type {TeamSummary}
   * @memberof TaskFullLinkedTeams
   */
  teamSummary: TeamSummary;
}

/**
 *
 * @export
 * @interface TaskFullLinkedUsers
 */
export interface TaskFullLinkedUsers {
  /**
   *
   * @type {RelationshipLabel}
   * @memberof TaskFullLinkedUsers
   */
  relLabel: RelationshipLabel;
  /**
   *
   * @type {UserSummaryExternal}
   * @memberof TaskFullLinkedUsers
   */
  userSummary: UserSummaryExternal;
}

/**
 *
 * @export
 * @interface TaskFullProductOrder
 */
export interface TaskFullProductOrder {
  /**
   *
   * @type {string}
   * @memberof TaskFullProductOrder
   */
  offeringUid?: string;
  /**
   *
   * @type {Array<TaskFullProductOrderProducts>}
   * @memberof TaskFullProductOrder
   */
  products?: Array<TaskFullProductOrderProducts>;
}
/**
 *
 * @export
 * @interface TaskFullProductOrderProducts
 */
export interface TaskFullProductOrderProducts {
  /**
   *
   * @type {ProductSummaryExternal}
   * @memberof TaskFullProductOrderProducts
   */
  productSummary?: ProductSummaryExternal;
  /**
   *
   * @type {number}
   * @memberof TaskFullProductOrderProducts
   */
  quantity?: number;
  /**
   *
   * @type {number}
   * @memberof TaskFullProductOrderProducts
   */
  orderedPrice?: number;
}
/**
 *
 * @export
 * @interface TaskFullResolution
 */
export interface TaskFullResolution {
  /**
   *
   * @type {string}
   * @memberof TaskFullResolution
   */
  resolutionReasonUid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskFullResolution
   */
  resolutionNotes?: string;
}
/**
 *
 * @export
 * @interface TaskFullTaskActivities
 */
export interface TaskFullTaskActivities {
  /**
   *
   * @type {string}
   * @memberof TaskFullTaskActivities
   */
  uid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskFullTaskActivities
   */
  urn?: string;
  /**
   *
   * @type {string}
   * @memberof TaskFullTaskActivities
   */
  taskUid?: string;
  /**
   *
   * @type {TaskActivityStatus}
   * @memberof TaskFullTaskActivities
   */
  activityStatus?: TaskActivityStatus;
  /**
   *
   * @type {string}
   * @memberof TaskFullTaskActivities
   */
  activityConfigUid?: string;
}

/**
 *
 * @export
 * @interface TaskFullTaskNotes
 */
export interface TaskFullTaskNotes {
  /**
   *
   * @type {string}
   * @memberof TaskFullTaskNotes
   */
  uid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskFullTaskNotes
   */
  taskUid: string;
  /**
   *
   * @type {string}
   * @memberof TaskFullTaskNotes
   */
  body: string;
  /**
   *
   * @type {boolean}
   * @memberof TaskFullTaskNotes
   */
  pinned?: boolean;
  /**
   *
   * @type {UserSummaryExternal}
   * @memberof TaskFullTaskNotes
   */
  author?: UserSummaryExternal;
  /**
   *
   * @type {ChangeSummary}
   * @memberof TaskFullTaskNotes
   */
  changeSummary?: ChangeSummary;
}
/**
 *
 * @export
 * @interface TaskNoteCreate
 */
export interface TaskNoteCreate {
  /**
   *
   * @type {string}
   * @memberof TaskNoteCreate
   */
  uid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskNoteCreate
   */
  body: string;
  /**
   *
   * @type {boolean}
   * @memberof TaskNoteCreate
   */
  pinned?: boolean;
  /**
   *
   * @type {string}
   * @memberof TaskNoteCreate
   */
  taskUid: string;
}
/**
 *
 * @export
 * @interface TaskNoteUpdate
 */
export interface TaskNoteUpdate {
  /**
   *
   * @type {string}
   * @memberof TaskNoteUpdate
   */
  body?: string;
  /**
   *
   * @type {boolean}
   * @memberof TaskNoteUpdate
   */
  pinned?: boolean;
  /**
   *
   * @type {string}
   * @memberof TaskNoteUpdate
   */
  taskUid: string;
}
/**
 *
 * @export
 * @interface TaskNoteWriteResponse
 */
export interface TaskNoteWriteResponse {
  /**
   *
   * @type {string}
   * @memberof TaskNoteWriteResponse
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TaskNoteWriteResponse
   */
  body: string;
  /**
   *
   * @type {boolean}
   * @memberof TaskNoteWriteResponse
   */
  pinned?: boolean;
}
/**
 *
 * @export
 * @interface TaskPriorityListExternal
 */
export interface TaskPriorityListExternal {
  /**
   *
   * @type {Array<TaskPriorityListExternalTaskPriorities>}
   * @memberof TaskPriorityListExternal
   */
  taskPriorities?: Array<TaskPriorityListExternalTaskPriorities>;
}
/**
 *
 * @export
 * @interface TaskPriorityListExternalTaskPriorities
 */
export interface TaskPriorityListExternalTaskPriorities {
  /**
   *
   * @type {string}
   * @memberof TaskPriorityListExternalTaskPriorities
   */
  uid: string;
  /**
   * Internal name
   * @type {string}
   * @memberof TaskPriorityListExternalTaskPriorities
   */
  name: string;
  /**
   *
   * @type {AssetSummaryExternalIcon}
   * @memberof TaskPriorityListExternalTaskPriorities
   */
  icon?: AssetSummaryExternalIcon;
  /**
   *
   * @type {string}
   * @memberof TaskPriorityListExternalTaskPriorities
   */
  displayName?: string;
}
/**
 *
 * @export
 * @interface TaskPriorityReadExternal
 */
export interface TaskPriorityReadExternal {
  /**
   *
   * @type {string}
   * @memberof TaskPriorityReadExternal
   */
  uid: string;
  /**
   *
   * @type {AssetSummaryExternalIcon}
   * @memberof TaskPriorityReadExternal
   */
  icon?: AssetSummaryExternalIcon;
  /**
   *
   * @type {string}
   * @memberof TaskPriorityReadExternal
   */
  displayName: string;
}
/**
 *
 * @export
 * @interface TaskQueueEnteredEventType
 */
export interface TaskQueueEnteredEventType {
  /**
   *
   * @type {string}
   * @memberof TaskQueueEnteredEventType
   */
  eventType: TaskQueueEnteredEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TaskQueueEnteredEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof TaskQueueEnteredEventType
   */
  taskSid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskQueueEnteredEventType
   */
  queueSid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskQueueEnteredEventType
   */
  queueName?: string;
}

export const TaskQueueEnteredEventTypeEventTypeEnum = {
  TaskQueueEntered: "TASK_QUEUE_ENTERED",
} as const;

export type TaskQueueEnteredEventTypeEventTypeEnum =
  (typeof TaskQueueEnteredEventTypeEventTypeEnum)[keyof typeof TaskQueueEnteredEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface TaskQueueMovedEventType
 */
export interface TaskQueueMovedEventType {
  /**
   *
   * @type {string}
   * @memberof TaskQueueMovedEventType
   */
  eventType: TaskQueueMovedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TaskQueueMovedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof TaskQueueMovedEventType
   */
  taskSid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskQueueMovedEventType
   */
  queueSid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskQueueMovedEventType
   */
  queueName?: string;
}

export const TaskQueueMovedEventTypeEventTypeEnum = {
  TaskQueueMoved: "TASK_QUEUE_MOVED",
} as const;

export type TaskQueueMovedEventTypeEventTypeEnum =
  (typeof TaskQueueMovedEventTypeEventTypeEnum)[keyof typeof TaskQueueMovedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface TaskRefHydrated
 */
export interface TaskRefHydrated {
  /**
   *
   * @type {string}
   * @memberof TaskRefHydrated
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TaskRefHydrated
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof TaskRefHydrated
   */
  taskRef: string;
  /**
   *
   * @type {string}
   * @memberof TaskRefHydrated
   */
  title?: string;
  /**
   *
   * @type {AssetSummaryExternalIcon}
   * @memberof TaskRefHydrated
   */
  icon?: AssetSummaryExternalIcon;
}
/**
 *
 * @export
 * @interface TaskResolutionReasonReadExternal
 */
export interface TaskResolutionReasonReadExternal {
  /**
   *
   * @type {string}
   * @memberof TaskResolutionReasonReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TaskResolutionReasonReadExternal
   */
  slug: string;
  /**
   *
   * @type {string}
   * @memberof TaskResolutionReasonReadExternal
   */
  displayName?: string;
}
/**
 *
 * @export
 * @interface TaskSearchResultExternal
 */
export interface TaskSearchResultExternal {
  /**
   *
   * @type {string}
   * @memberof TaskSearchResultExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TaskSearchResultExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof TaskSearchResultExternal
   */
  taskRef: string;
  /**
   *
   * @type {string}
   * @memberof TaskSearchResultExternal
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof TaskSearchResultExternal
   */
  openedAt?: string;
  /**
   *
   * @type {string}
   * @memberof TaskSearchResultExternal
   */
  closedAt?: string;
  /**
   *
   * @type {string}
   * @memberof TaskSearchResultExternal
   */
  actionOnUserUid?: string;
  /**
   *
   * @type {TaskSearchResultExternalSla}
   * @memberof TaskSearchResultExternal
   */
  sla?: TaskSearchResultExternalSla;
  /**
   *
   * @type {number}
   * @memberof TaskSearchResultExternal
   */
  userUnreadNotifications?: number;
  /**
   *
   * @type {UserSummaryExternal}
   * @memberof TaskSearchResultExternal
   */
  assignedUser?: UserSummaryExternal;
  /**
   *
   * @type {TeamSummary}
   * @memberof TaskSearchResultExternal
   */
  assignedTeam?: TeamSummary;
  /**
   *
   * @type {UserSummaryExternal}
   * @memberof TaskSearchResultExternal
   */
  initiator?: UserSummaryExternal;
  /**
   *
   * @type {AssetSummaryExternal}
   * @memberof TaskSearchResultExternal
   */
  principalAsset?: AssetSummaryExternal;
  /**
   *
   * @type {TaskPriorityReadExternal}
   * @memberof TaskSearchResultExternal
   */
  priority?: TaskPriorityReadExternal;
  /**
   *
   * @type {TaskStatusSummaryExternal}
   * @memberof TaskSearchResultExternal
   */
  status?: TaskStatusSummaryExternal;
  /**
   *
   * @type {TaskTypeSummaryExternal}
   * @memberof TaskSearchResultExternal
   */
  taskType?: TaskTypeSummaryExternal;
}
/**
 *
 * @export
 * @interface TaskSearchResultExternalSla
 */
export interface TaskSearchResultExternalSla {
  /**
   *
   * @type {SlaType}
   * @memberof TaskSearchResultExternalSla
   */
  type?: SlaType;
  /**
   *
   * @type {TaskSearchResultExternalSlaResponse}
   * @memberof TaskSearchResultExternalSla
   */
  response?: TaskSearchResultExternalSlaResponse;
  /**
   *
   * @type {TaskSearchResultExternalSlaResponse}
   * @memberof TaskSearchResultExternalSla
   */
  resolution?: TaskSearchResultExternalSlaResponse;
  /**
   *
   * @type {TaskSearchResultExternalSlaDue}
   * @memberof TaskSearchResultExternalSla
   */
  due?: TaskSearchResultExternalSlaDue;
}

/**
 *
 * @export
 * @interface TaskSearchResultExternalSlaDue
 */
export interface TaskSearchResultExternalSlaDue {
  /**
   *
   * @type {SlaCurrentDueStatusReadOnly}
   * @memberof TaskSearchResultExternalSlaDue
   */
  status?: SlaCurrentDueStatusReadOnly;
  /**
   *
   * @type {string}
   * @memberof TaskSearchResultExternalSlaDue
   */
  dueDate?: string;
  /**
   *
   * @type {string}
   * @memberof TaskSearchResultExternalSlaDue
   */
  startedAt?: string;
  /**
   *
   * @type {string}
   * @memberof TaskSearchResultExternalSlaDue
   */
  stoppedAt?: string;
}

/**
 *
 * @export
 * @interface TaskSearchResultExternalSlaResponse
 */
export interface TaskSearchResultExternalSlaResponse {
  /**
   *
   * @type {SlaCurrentStatusReadOnly}
   * @memberof TaskSearchResultExternalSlaResponse
   */
  status?: SlaCurrentStatusReadOnly;
  /**
   *
   * @type {string}
   * @memberof TaskSearchResultExternalSlaResponse
   */
  dueDateTime?: string;
  /**
   *
   * @type {string}
   * @memberof TaskSearchResultExternalSlaResponse
   */
  startedAt?: string;
  /**
   *
   * @type {string}
   * @memberof TaskSearchResultExternalSlaResponse
   */
  stoppedAt?: string;
  /**
   *
   * @type {SlaDurationTypeReadOnly}
   * @memberof TaskSearchResultExternalSlaResponse
   */
  durationType?: SlaDurationTypeReadOnly;
  /**
   *
   * @type {number}
   * @memberof TaskSearchResultExternalSlaResponse
   */
  targetDuration?: number;
  /**
   *
   * @type {number}
   * @memberof TaskSearchResultExternalSlaResponse
   */
  actualDuration?: number;
}

/**
 *
 * @export
 * @enum {string}
 */

export const TaskSource = {
  Ui: "UI",
  Assistant: "ASSISTANT",
  AaUi: "AA_UI",
  AaIvr: "AA_IVR",
} as const;

export type TaskSource = (typeof TaskSource)[keyof typeof TaskSource];

/**
 *
 * @export
 * @interface TaskStatusReadExternal
 */
export interface TaskStatusReadExternal {
  /**
   *
   * @type {string}
   * @memberof TaskStatusReadExternal
   */
  uid: string;
  /**
   *
   * @type {TaskStatusType}
   * @memberof TaskStatusReadExternal
   */
  statusType: TaskStatusType;
  /**
   * Default status to be used by FE when making a task future scheduled
   * @type {boolean}
   * @memberof TaskStatusReadExternal
   */
  defaultFuture?: boolean;
  /**
   *
   * @type {number}
   * @memberof TaskStatusReadExternal
   */
  progressIndicator: number;
  /**
   *
   * @type {boolean}
   * @memberof TaskStatusReadExternal
   */
  hideFromSelection?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof TaskStatusReadExternal
   */
  normalTransitionStatusUids?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof TaskStatusReadExternal
   */
  displayName?: string;
}

/**
 *
 * @export
 * @interface TaskStatusSummaryExternal
 */
export interface TaskStatusSummaryExternal {
  /**
   *
   * @type {string}
   * @memberof TaskStatusSummaryExternal
   */
  uid: string;
  /**
   *
   * @type {TaskStatusType}
   * @memberof TaskStatusSummaryExternal
   */
  statusType: TaskStatusType;
  /**
   *
   * @type {number}
   * @memberof TaskStatusSummaryExternal
   */
  progressIndicator: number;
  /**
   *
   * @type {boolean}
   * @memberof TaskStatusSummaryExternal
   */
  hideFromSelection?: boolean;
  /**
   *
   * @type {string}
   * @memberof TaskStatusSummaryExternal
   */
  displayName: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const TaskStatusType = {
  Future: "FUTURE",
  Open: "OPEN",
  Closed: "CLOSED",
} as const;

export type TaskStatusType = (typeof TaskStatusType)[keyof typeof TaskStatusType];

/**
 *
 * @export
 * @interface TaskSummary
 */
export interface TaskSummary {
  /**
   *
   * @type {string}
   * @memberof TaskSummary
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TaskSummary
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof TaskSummary
   */
  taskRef: string;
  /**
   *
   * @type {string}
   * @memberof TaskSummary
   */
  title?: string;
  /**
   *
   * @type {AssetSummaryExternalIcon}
   * @memberof TaskSummary
   */
  icon?: AssetSummaryExternalIcon;
}
/**
 *
 * @export
 * @interface TaskSummaryExternal
 */
export interface TaskSummaryExternal {
  /**
   *
   * @type {string}
   * @memberof TaskSummaryExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TaskSummaryExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof TaskSummaryExternal
   */
  taskRef: string;
  /**
   *
   * @type {string}
   * @memberof TaskSummaryExternal
   */
  title?: string;
  /**
   *
   * @type {AssetSummaryExternalIcon}
   * @memberof TaskSummaryExternal
   */
  icon?: AssetSummaryExternalIcon;
}
/**
 *
 * @export
 * @interface TaskTypeDisabledMessage
 */
export interface TaskTypeDisabledMessage {
  /**
   *
   * @type {string}
   * @memberof TaskTypeDisabledMessage
   */
  taskTypeUid?: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof TaskTypeDisabledMessage
   */
  disabledMessage?: { [key: string]: string };
}
/**
 *
 * @export
 * @interface TaskTypeFilterExternal
 */
export interface TaskTypeFilterExternal {
  /**
   *
   * @type {string}
   * @memberof TaskTypeFilterExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TaskTypeFilterExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof TaskTypeFilterExternal
   */
  displayName: string;
  /**
   *
   * @type {AssetSummaryExternalIcon}
   * @memberof TaskTypeFilterExternal
   */
  icon?: AssetSummaryExternalIcon;
}
/**
 *
 * @export
 * @interface TaskTypeGroupListExternal
 */
export interface TaskTypeGroupListExternal {
  /**
   *
   * @type {Array<TaskTypeGroupListExternalTaskTypeGroups>}
   * @memberof TaskTypeGroupListExternal
   */
  taskTypeGroups?: Array<TaskTypeGroupListExternalTaskTypeGroups>;
}
/**
 *
 * @export
 * @interface TaskTypeGroupListExternalTaskTypeGroups
 */
export interface TaskTypeGroupListExternalTaskTypeGroups {
  /**
   *
   * @type {string}
   * @memberof TaskTypeGroupListExternalTaskTypeGroups
   */
  uid: string;
  /**
   *
   * @type {Array<TaskTypeSummaryExternal>}
   * @memberof TaskTypeGroupListExternalTaskTypeGroups
   */
  taskTypes?: Array<TaskTypeSummaryExternal>;
  /**
   *
   * @type {string}
   * @memberof TaskTypeGroupListExternalTaskTypeGroups
   */
  displayName: string;
}
/**
 *
 * @export
 * @interface TaskTypeReadExternal
 */
export interface TaskTypeReadExternal {
  /**
   *
   * @type {string}
   * @memberof TaskTypeReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TaskTypeReadExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof TaskTypeReadExternal
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof TaskTypeReadExternal
   */
  taskTypeGroupUid?: string;
  /**
   *
   * @type {boolean}
   * @memberof TaskTypeReadExternal
   */
  primaryAssetRequired?: boolean;
  /**
   *
   * @type {string}
   * @memberof TaskTypeReadExternal
   */
  descriptionDisplay?: TaskTypeReadExternalDescriptionDisplayEnum;
  /**
   *
   * @type {boolean}
   * @memberof TaskTypeReadExternal
   */
  orderingAllowed?: boolean;
  /**
   *
   * @type {SlaType}
   * @memberof TaskTypeReadExternal
   */
  slaType?: SlaType;
  /**
   *
   * @type {boolean}
   * @memberof TaskTypeReadExternal
   */
  useManagerAssistant?: boolean;
  /**
   *
   * @type {Array<TaskStatusReadExternal>}
   * @memberof TaskTypeReadExternal
   */
  statuses?: Array<TaskStatusReadExternal>;
  /**
   *
   * @type {Array<TaskPriorityReadExternal>}
   * @memberof TaskTypeReadExternal
   */
  priorities?: Array<TaskPriorityReadExternal>;
  /**
   *
   * @type {Array<TaskTypeReadExternalActivities>}
   * @memberof TaskTypeReadExternal
   */
  activities?: Array<TaskTypeReadExternalActivities>;
  /**
   *
   * @type {Array<TaskResolutionReasonReadExternal>}
   * @memberof TaskTypeReadExternal
   */
  resolutionReasons?: Array<TaskResolutionReasonReadExternal>;
  /**
   *
   * @type {Array<TaskTypeReadExternalExtMetadataConfig>}
   * @memberof TaskTypeReadExternal
   */
  extMetadataConfig?: Array<TaskTypeReadExternalExtMetadataConfig>;
  /**
   *
   * @type {TaskTypeSummaryExternalTaskTypeGroup}
   * @memberof TaskTypeReadExternal
   */
  taskTypeGroup?: TaskTypeSummaryExternalTaskTypeGroup;
  /**
   *
   * @type {AssetSummaryExternalIcon}
   * @memberof TaskTypeReadExternal
   */
  icon?: AssetSummaryExternalIcon;
  /**
   *
   * @type {string}
   * @memberof TaskTypeReadExternal
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof TaskTypeReadExternal
   */
  initialActivityDisplayName?: string;
}

export const TaskTypeReadExternalDescriptionDisplayEnum = {
  Never: "NEVER",
  Readonly: "READONLY",
  Write: "WRITE",
} as const;

export type TaskTypeReadExternalDescriptionDisplayEnum =
  (typeof TaskTypeReadExternalDescriptionDisplayEnum)[keyof typeof TaskTypeReadExternalDescriptionDisplayEnum];

/**
 *
 * @export
 * @interface TaskTypeReadExternalActivities
 */
export interface TaskTypeReadExternalActivities {
  /**
   *
   * @type {TaskActivityConfigReadExternal}
   * @memberof TaskTypeReadExternalActivities
   */
  activityConfig?: TaskActivityConfigReadExternal;
  /**
   * Whether the activity is always present on the task
   * @type {boolean}
   * @memberof TaskTypeReadExternalActivities
   */
  default?: boolean;
  /**
   * Whether to hide from front-end selection (only applies if default=false)
   * @type {boolean}
   * @memberof TaskTypeReadExternalActivities
   */
  hideFromSelection?: boolean;
}
/**
 *
 * @export
 * @interface TaskTypeReadExternalExtMetadataConfig
 */
export interface TaskTypeReadExternalExtMetadataConfig {
  /**
   *
   * @type {ExtendedMetadataConfigReadExternal}
   * @memberof TaskTypeReadExternalExtMetadataConfig
   */
  extMetadataGroupConfig?: ExtendedMetadataConfigReadExternal;
  /**
   *
   * @type {boolean}
   * @memberof TaskTypeReadExternalExtMetadataConfig
   */
  showInDetails?: boolean;
}
/**
 *
 * @export
 * @interface TaskTypeSummaryExternal
 */
export interface TaskTypeSummaryExternal {
  /**
   *
   * @type {string}
   * @memberof TaskTypeSummaryExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TaskTypeSummaryExternal
   */
  urn: string;
  /**
   *
   * @type {boolean}
   * @memberof TaskTypeSummaryExternal
   */
  primaryAssetRequired?: boolean;
  /**
   *
   * @type {string}
   * @memberof TaskTypeSummaryExternal
   */
  descriptionDisplay?: TaskTypeSummaryExternalDescriptionDisplayEnum;
  /**
   *
   * @type {boolean}
   * @memberof TaskTypeSummaryExternal
   */
  useManagerAssistant?: boolean;
  /**
   *
   * @type {TaskTypeSummaryExternalTaskTypeGroup}
   * @memberof TaskTypeSummaryExternal
   */
  taskTypeGroup?: TaskTypeSummaryExternalTaskTypeGroup;
  /**
   *
   * @type {AssetSummaryExternalIcon}
   * @memberof TaskTypeSummaryExternal
   */
  icon?: AssetSummaryExternalIcon;
  /**
   *
   * @type {string}
   * @memberof TaskTypeSummaryExternal
   */
  displayName: string;
}

export const TaskTypeSummaryExternalDescriptionDisplayEnum = {
  Never: "NEVER",
  Readonly: "READONLY",
  Write: "WRITE",
} as const;

export type TaskTypeSummaryExternalDescriptionDisplayEnum =
  (typeof TaskTypeSummaryExternalDescriptionDisplayEnum)[keyof typeof TaskTypeSummaryExternalDescriptionDisplayEnum];

/**
 *
 * @export
 * @interface TaskTypeSummaryExternalTaskTypeGroup
 */
export interface TaskTypeSummaryExternalTaskTypeGroup {
  /**
   *
   * @type {string}
   * @memberof TaskTypeSummaryExternalTaskTypeGroup
   */
  displayName?: string;
}
/**
 *
 * @export
 * @interface TaskUpdate
 */
export interface TaskUpdate {
  /**
   *
   * @type {string}
   * @memberof TaskUpdate
   */
  title?: string;
  /**
   *
   * @type {TaskSource}
   * @memberof TaskUpdate
   */
  source?: TaskSource;
  /**
   *
   * @type {string}
   * @memberof TaskUpdate
   */
  futureActivation?: string;
  /**
   *
   * @type {string}
   * @memberof TaskUpdate
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof TaskUpdate
   */
  serviceLevelUid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskUpdate
   */
  priorityUid?: string;
  /**
   *
   * @type {string}
   * @memberof TaskUpdate
   */
  statusUid?: string;
  /**
   *
   * @type {TaskFullResolution}
   * @memberof TaskUpdate
   */
  resolution?: TaskFullResolution;
  /**
   *
   * @type {TaskCreateProductOrder}
   * @memberof TaskUpdate
   */
  productOrder?: TaskCreateProductOrder;
  /**
   *
   * @type {TaskSearchResultExternalSla}
   * @memberof TaskUpdate
   */
  sla?: TaskSearchResultExternalSla;
  /**
   *
   * @type {Array<AssetCreateMedia>}
   * @memberof TaskUpdate
   */
  media?: Array<AssetCreateMedia>;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof TaskUpdate
   */
  extendedMetadata?: { [key: string]: any };
  /**
   *
   * @type {TaskFullExternalLink}
   * @memberof TaskUpdate
   */
  externalLink?: TaskFullExternalLink;
}

/**
 *
 * @export
 * @interface TaskUpdateAssignee
 */
export interface TaskUpdateAssignee {
  /**
   *
   * @type {string}
   * @memberof TaskUpdateAssignee
   */
  taskUid: string;
  /**
   * Remove any assignee
   * @type {boolean}
   * @memberof TaskUpdateAssignee
   */
  unassigned?: boolean;
  /**
   *
   * @type {string}
   * @memberof TaskUpdateAssignee
   */
  assignedUser?: string;
  /**
   *
   * @type {string}
   * @memberof TaskUpdateAssignee
   */
  assignedTeam?: string;
}
/**
 *
 * @export
 * @interface TaskUpdateInitiator
 */
export interface TaskUpdateInitiator {
  /**
   *
   * @type {string}
   * @memberof TaskUpdateInitiator
   */
  taskUid: string;
  /**
   *
   * @type {string}
   * @memberof TaskUpdateInitiator
   */
  initiator?: string;
  /**
   *
   * @type {boolean}
   * @memberof TaskUpdateInitiator
   */
  moveToLinked?: boolean;
}
/**
 *
 * @export
 * @interface TaskUpdatePrincipalAsset
 */
export interface TaskUpdatePrincipalAsset {
  /**
   *
   * @type {string}
   * @memberof TaskUpdatePrincipalAsset
   */
  taskUid: string;
  /**
   *
   * @type {string}
   * @memberof TaskUpdatePrincipalAsset
   */
  principalAssetUid: string;
}
/**
 *
 * @export
 * @interface TaskUpdatedEventType
 */
export interface TaskUpdatedEventType {
  /**
   *
   * @type {string}
   * @memberof TaskUpdatedEventType
   */
  eventType: TaskUpdatedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TaskUpdatedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof TaskUpdatedEventType
   */
  taskSid?: string;
}

export const TaskUpdatedEventTypeEventTypeEnum = {
  TaskUpdated: "TASK_UPDATED",
} as const;

export type TaskUpdatedEventTypeEventTypeEnum =
  (typeof TaskUpdatedEventTypeEventTypeEnum)[keyof typeof TaskUpdatedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface TaskWrapUpEventType
 */
export interface TaskWrapUpEventType {
  /**
   *
   * @type {string}
   * @memberof TaskWrapUpEventType
   */
  eventType: TaskWrapUpEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TaskWrapUpEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof TaskWrapUpEventType
   */
  taskSid?: string;
}

export const TaskWrapUpEventTypeEventTypeEnum = {
  TaskWrapUp: "TASK_WRAP_UP",
} as const;

export type TaskWrapUpEventTypeEventTypeEnum =
  (typeof TaskWrapUpEventTypeEventTypeEnum)[keyof typeof TaskWrapUpEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface TaskWriteResponseExternal
 */
export interface TaskWriteResponseExternal {
  /**
   *
   * @type {string}
   * @memberof TaskWriteResponseExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TaskWriteResponseExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof TaskWriteResponseExternal
   */
  taskRef: string;
}
/**
 *
 * @export
 * @interface TeamCreate
 */
export interface TeamCreate {
  /**
   *
   * @type {string}
   * @memberof TeamCreate
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof TeamCreate
   */
  description?: string;
}
/**
 *
 * @export
 * @interface TeamExportCreate
 */
export interface TeamExportCreate {
  /**
   *
   * @type {string}
   * @memberof TeamExportCreate
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof TeamExportCreate
   */
  timezone: string;
  /**
   *
   * @type {string}
   * @memberof TeamExportCreate
   */
  freeText?: string;
  /**
   *
   * @type {string}
   * @memberof TeamExportCreate
   */
  format: TeamExportCreateFormatEnum;
  /**
   *
   * @type {SearchTeamFilter}
   * @memberof TeamExportCreate
   */
  filter?: SearchTeamFilter;
  /**
   *
   * @type {SearchTeamSort}
   * @memberof TeamExportCreate
   */
  sort?: SearchTeamSort;
}

export const TeamExportCreateFormatEnum = {
  Standard: "STANDARD",
  ExcelCompatible: "EXCEL_COMPATIBLE",
} as const;

export type TeamExportCreateFormatEnum = (typeof TeamExportCreateFormatEnum)[keyof typeof TeamExportCreateFormatEnum];

/**
 *
 * @export
 * @interface TeamExportReadExternal
 */
export interface TeamExportReadExternal {
  /**
   *
   * @type {string}
   * @memberof TeamExportReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TeamExportReadExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof TeamExportReadExternal
   */
  name: string;
  /**
   * Language code including locale
   * @type {string}
   * @memberof TeamExportReadExternal
   */
  languageCode: string;
  /**
   *
   * @type {string}
   * @memberof TeamExportReadExternal
   */
  timezone: string;
  /**
   *
   * @type {number}
   * @memberof TeamExportReadExternal
   */
  resultCount?: number;
  /**
   *
   * @type {TaskExportReadExternalProgress}
   * @memberof TeamExportReadExternal
   */
  progress: TaskExportReadExternalProgress;
  /**
   *
   * @type {string}
   * @memberof TeamExportReadExternal
   */
  requestedAt: string;
  /**
   *
   * @type {string}
   * @memberof TeamExportReadExternal
   */
  freeText?: string;
  /**
   *
   * @type {string}
   * @memberof TeamExportReadExternal
   */
  format: TeamExportReadExternalFormatEnum;
  /**
   *
   * @type {UserRefHydrated}
   * @memberof TeamExportReadExternal
   */
  createdBy: UserRefHydrated;
  /**
   *
   * @type {string}
   * @memberof TeamExportReadExternal
   */
  type: TeamExportReadExternalTypeEnum;
  /**
   *
   * @type {SearchTeamFilter}
   * @memberof TeamExportReadExternal
   */
  filter: SearchTeamFilter;
  /**
   *
   * @type {SearchTeamSort}
   * @memberof TeamExportReadExternal
   */
  sort: SearchTeamSort;
}

export const TeamExportReadExternalFormatEnum = {
  Standard: "STANDARD",
  ExcelCompatible: "EXCEL_COMPATIBLE",
} as const;

export type TeamExportReadExternalFormatEnum =
  (typeof TeamExportReadExternalFormatEnum)[keyof typeof TeamExportReadExternalFormatEnum];
export const TeamExportReadExternalTypeEnum = {
  Team: "TEAM",
} as const;

export type TeamExportReadExternalTypeEnum =
  (typeof TeamExportReadExternalTypeEnum)[keyof typeof TeamExportReadExternalTypeEnum];

/**
 *
 * @export
 * @interface TeamReadExternal
 */
export interface TeamReadExternal {
  /**
   *
   * @type {string}
   * @memberof TeamReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TeamReadExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof TeamReadExternal
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof TeamReadExternal
   */
  description?: string;
  /**
   *
   * @type {Array<TaskFullLinkedAssets>}
   * @memberof TeamReadExternal
   */
  linkedAssets?: Array<TaskFullLinkedAssets>;
  /**
   *
   * @type {Array<TeamReadExternalLinkedTaskTypes>}
   * @memberof TeamReadExternal
   */
  linkedTaskTypes?: Array<TeamReadExternalLinkedTaskTypes>;
  /**
   *
   * @type {Array<TaskFullLinkedUsers>}
   * @memberof TeamReadExternal
   */
  linkedUsers?: Array<TaskFullLinkedUsers>;
  /**
   *
   * @type {ChangeSummary}
   * @memberof TeamReadExternal
   */
  changeSummary?: ChangeSummary;
}
/**
 *
 * @export
 * @interface TeamReadExternalLinkedTaskTypes
 */
export interface TeamReadExternalLinkedTaskTypes {
  /**
   *
   * @type {RelationshipLabel}
   * @memberof TeamReadExternalLinkedTaskTypes
   */
  relLabel: RelationshipLabel;
  /**
   *
   * @type {TaskTypeSummaryExternal}
   * @memberof TeamReadExternalLinkedTaskTypes
   */
  taskTypeSummary: TaskTypeSummaryExternal;
}

/**
 *
 * @export
 * @interface TeamRef
 */
export interface TeamRef {
  /**
   *
   * @type {string}
   * @memberof TeamRef
   */
  teamRef?: string;
}
/**
 *
 * @export
 * @interface TeamSearchResult
 */
export interface TeamSearchResult {
  /**
   *
   * @type {string}
   * @memberof TeamSearchResult
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TeamSearchResult
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof TeamSearchResult
   */
  name: string;
}
/**
 *
 * @export
 * @interface TeamSummary
 */
export interface TeamSummary {
  /**
   *
   * @type {string}
   * @memberof TeamSummary
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TeamSummary
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof TeamSummary
   */
  name: string;
}
/**
 *
 * @export
 * @interface TeamUpdate
 */
export interface TeamUpdate {
  /**
   *
   * @type {string}
   * @memberof TeamUpdate
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof TeamUpdate
   */
  description?: string;
}
/**
 *
 * @export
 * @interface TeamWriteResponse
 */
export interface TeamWriteResponse {
  /**
   *
   * @type {string}
   * @memberof TeamWriteResponse
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof TeamWriteResponse
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof TeamWriteResponse
   */
  name: string;
}
/**
 *
 * @export
 * @interface TenantBot
 */
export interface TenantBot {
  /**
   *
   * @type {string}
   * @memberof TenantBot
   */
  botName?: string;
  /**
   *
   * @type {string}
   * @memberof TenantBot
   */
  principalConversationTypeUrn?: string;
  /**
   *
   * @type {string}
   * @memberof TenantBot
   */
  onSitePrincipalConversationTypeUrn?: string;
  /**
   *
   * @type {string}
   * @memberof TenantBot
   */
  guestPrincipalConversationTypeUrn?: string;
  /**
   *
   * @type {string}
   * @memberof TenantBot
   */
  tokenStartConversationTypeUrn?: string;
  /**
   *
   * @type {string}
   * @memberof TenantBot
   */
  managerConversationTypeUrn?: string;
  /**
   *
   * @type {string}
   * @memberof TenantBot
   */
  avatar?: string;
}
/**
 *
 * @export
 * @interface TenantCognito
 */
export interface TenantCognito {
  /**
   *
   * @type {string}
   * @memberof TenantCognito
   */
  userPool?: string;
  /**
   *
   * @type {string}
   * @memberof TenantCognito
   */
  appClientId?: string;
  /**
   *
   * @type {string}
   * @memberof TenantCognito
   */
  issuer?: string;
}
/**
 * Configuration of the current tenants environment
 * @export
 * @interface TenantConfig
 */
export interface TenantConfig {
  /**
   *
   * @type {string}
   * @memberof TenantConfig
   */
  tenantName?: string;
  /**
   * 3 character currency code
   * @type {string}
   * @memberof TenantConfig
   */
  currencyCode?: string;
  /**
   *
   * @type {TenantDisplay}
   * @memberof TenantConfig
   */
  tenantDisplay?: TenantDisplay;
  /**
   *
   * @type {TenantContact}
   * @memberof TenantConfig
   */
  tenantContact?: TenantContact;
  /**
   *
   * @type {TenantBot}
   * @memberof TenantConfig
   */
  tenantBot?: TenantBot;
  /**
   *
   * @type {TenantCognito}
   * @memberof TenantConfig
   */
  tenantCognito?: TenantCognito;
  /**
   *
   * @type {TenantIntegrations}
   * @memberof TenantConfig
   */
  tenantIntegrations?: TenantIntegrations;
  /**
   *
   * @type {{ [key: string]: boolean; }}
   * @memberof TenantConfig
   */
  featureFlags?: { [key: string]: boolean };
  /**
   *
   * @type {AskAgentConfig}
   * @memberof TenantConfig
   */
  askAgent?: AskAgentConfig;
  /**
   *
   * @type {Array<TenantLanguage>}
   * @memberof TenantConfig
   */
  tenantLanguages?: Array<TenantLanguage>;
  /**
   *
   * @type {Array<TenantSecondaryLanguagesInner>}
   * @memberof TenantConfig
   */
  secondaryLanguages?: Array<TenantSecondaryLanguagesInner>;
}
/**
 *
 * @export
 * @interface TenantContact
 */
export interface TenantContact {
  /**
   * E.164 format phone number
   * @type {string}
   * @memberof TenantContact
   */
  phoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof TenantContact
   */
  email?: string;
}
/**
 *
 * @export
 * @interface TenantDisplay
 */
export interface TenantDisplay {
  /**
   *
   * @type {TenantDisplayPalette}
   * @memberof TenantDisplay
   */
  palette: TenantDisplayPalette;
  /**
   *
   * @type {TenantDisplayLinks}
   * @memberof TenantDisplay
   */
  links: TenantDisplayLinks;
  /**
   *
   * @type {TenantDisplayLogos}
   * @memberof TenantDisplay
   */
  logos: TenantDisplayLogos;
  /**
   *
   * @type {Array<string>}
   * @memberof TenantDisplay
   */
  coverImages?: Array<string>;
}
/**
 *
 * @export
 * @interface TenantDisplayLinks
 */
export interface TenantDisplayLinks {
  /**
   * URL (full or absolute path) to privacy policy
   * @type {string}
   * @memberof TenantDisplayLinks
   */
  privacyPolicyUrl?: string;
  /**
   * URL (full or absolute path) to privacy policy
   * @type {string}
   * @memberof TenantDisplayLinks
   */
  termsOfUseUrl?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayLinks
   */
  landingZonePath?: string;
}
/**
 *
 * @export
 * @interface TenantDisplayLogos
 */
export interface TenantDisplayLogos {
  /**
   * Absolute path or full URL to the logo
   * @type {string}
   * @memberof TenantDisplayLogos
   */
  logo?: string;
  /**
   * Absolute path or full URL to the small logo
   * @type {string}
   * @memberof TenantDisplayLogos
   */
  logoSmall?: string;
  /**
   * Absolute path or full URL to the favicon
   * @type {string}
   * @memberof TenantDisplayLogos
   */
  favicon?: string;
  /**
   * Absolute path or full URL to the touch icon
   * @type {string}
   * @memberof TenantDisplayLogos
   */
  touch?: string;
  /**
   * Absolute path or full URL to the embedded chat icon
   * @type {string}
   * @memberof TenantDisplayLogos
   */
  embed?: string;
  /**
   * Absolute path or full URL to the icon for in-app chat
   * @type {string}
   * @memberof TenantDisplayLogos
   */
  appChat?: string;
}
/**
 *
 * @export
 * @interface TenantDisplayPalette
 */
export interface TenantDisplayPalette {
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  commonBlack?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  commonWhite?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  primaryMain?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  primaryLight?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  primaryDark?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  primaryContrastText?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  secondaryMain?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  secondaryLight?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  secondaryDark?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  secondaryContrastText?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  tertiaryMain?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  tertiaryLight?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  tertiaryDark?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  tertiaryContrastText?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  errorLight?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  errorMain?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  errorDark?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  errorContrastText?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  warningLight?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  warningMain?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  warningDark?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  warningContrastText?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  infoLight?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  infoMain?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  infoDark?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  infoContrastText?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  successLight?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  successMain?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  successDark?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  successContrastText?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  grey50?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  grey100?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  grey200?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  grey300?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  grey400?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  grey500?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  grey600?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  grey700?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  grey800?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  grey900?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  greyA100?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  greyA200?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  greyA400?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  greyA700?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart01?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart02?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart03?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart04?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart05?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart06?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart07?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart08?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart09?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart10?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart11?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart12?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart13?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart14?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart15?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  chart16?: string;
  /**
   *
   * @type {number}
   * @memberof TenantDisplayPalette
   */
  contrastThreshold?: number;
  /**
   *
   * @type {number}
   * @memberof TenantDisplayPalette
   */
  tonalOffset?: number;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  textPrimary?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  textSecondary?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  textDisabled?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  textHint?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  divider?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  backgroundPaper?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  backgroundDefault?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  backgroundLevel2?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  backgroundLevel1?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  actionActive?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  actionHover?: string;
  /**
   *
   * @type {number}
   * @memberof TenantDisplayPalette
   */
  actionHoverOpacity?: number;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  actionSelected?: string;
  /**
   *
   * @type {number}
   * @memberof TenantDisplayPalette
   */
  actionSelectedOpacity?: number;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  actionDisabled?: string;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  actionDisabledBackground?: string;
  /**
   *
   * @type {number}
   * @memberof TenantDisplayPalette
   */
  actionDisabledOpacity?: number;
  /**
   *
   * @type {string}
   * @memberof TenantDisplayPalette
   */
  actionFocus?: string;
  /**
   *
   * @type {number}
   * @memberof TenantDisplayPalette
   */
  actionFocusOpacity?: number;
  /**
   *
   * @type {number}
   * @memberof TenantDisplayPalette
   */
  actionActivatedOpacity?: number;
}
/**
 *
 * @export
 * @interface TenantIntegrations
 */
export interface TenantIntegrations {
  /**
   *
   * @type {number}
   * @memberof TenantIntegrations
   */
  analyticsId?: number;
  /**
   *
   * @type {string}
   * @memberof TenantIntegrations
   */
  mapsKey?: string;
}
/**
 *
 * @export
 * @interface TenantLanguage
 */
export interface TenantLanguage {
  /**
   * Language code including locale
   * @type {string}
   * @memberof TenantLanguage
   */
  languageCode: string;
  /**
   * Language name (in that language)
   * @type {string}
   * @memberof TenantLanguage
   */
  languageName: string;
  /**
   * Flag as to whether this is the default language for the given tenant. Should be set on exactly one of the languages.
   * @type {boolean}
   * @memberof TenantLanguage
   */
  defaultLanguage: boolean;
}
/**
 *
 * @export
 * @interface TenantSecondaryLanguagesInner
 */
export interface TenantSecondaryLanguagesInner {
  /**
   * Language code including locale
   * @type {string}
   * @memberof TenantSecondaryLanguagesInner
   */
  languageCode: string;
  /**
   * Language name (in that language)
   * @type {string}
   * @memberof TenantSecondaryLanguagesInner
   */
  languageName: string;
}
/**
 *
 * @export
 * @interface ThreadGetResponseExternal
 */
export interface ThreadGetResponseExternal {
  /**
   *
   * @type {string}
   * @memberof ThreadGetResponseExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof ThreadGetResponseExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof ThreadGetResponseExternal
   */
  taskUid: string;
  /**
   *
   * @type {boolean}
   * @memberof ThreadGetResponseExternal
   */
  replyAllowed?: boolean;
  /**
   *
   * @type {string}
   * @memberof ThreadGetResponseExternal
   */
  subject: string;
  /**
   *
   * @type {Array<ThreadGetResponseExternalParticipants>}
   * @memberof ThreadGetResponseExternal
   */
  participants: Array<ThreadGetResponseExternalParticipants>;
  /**
   *
   * @type {Array<ThreadGetResponseExternalMessages>}
   * @memberof ThreadGetResponseExternal
   */
  messages: Array<ThreadGetResponseExternalMessages>;
  /**
   *
   * @type {string}
   * @memberof ThreadGetResponseExternal
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof ThreadGetResponseExternal
   */
  updatedAt?: string;
}
/**
 *
 * @export
 * @interface ThreadGetResponseExternalFollowOnAction
 */
export interface ThreadGetResponseExternalFollowOnAction {
  /**
   *
   * @type {string}
   * @memberof ThreadGetResponseExternalFollowOnAction
   */
  actionName?: ThreadGetResponseExternalFollowOnActionActionNameEnum;
  /**
   *
   * @type {boolean}
   * @memberof ThreadGetResponseExternalFollowOnAction
   */
  actionEnabled?: boolean;
  /**
   *
   * @type {object}
   * @memberof ThreadGetResponseExternalFollowOnAction
   */
  actionMetadata?: object;
}

export const ThreadGetResponseExternalFollowOnActionActionNameEnum = {
  UploadFile: "UPLOAD_FILE",
} as const;

export type ThreadGetResponseExternalFollowOnActionActionNameEnum =
  (typeof ThreadGetResponseExternalFollowOnActionActionNameEnum)[keyof typeof ThreadGetResponseExternalFollowOnActionActionNameEnum];

/**
 *
 * @export
 * @interface ThreadGetResponseExternalMessages
 */
export interface ThreadGetResponseExternalMessages {
  /**
   *
   * @type {string}
   * @memberof ThreadGetResponseExternalMessages
   */
  messageUid: string;
  /**
   *
   * @type {string}
   * @memberof ThreadGetResponseExternalMessages
   */
  messageBody: string;
  /**
   *
   * @type {string}
   * @memberof ThreadGetResponseExternalMessages
   */
  senderUid: string;
  /**
   *
   * @type {ThreadMessageType}
   * @memberof ThreadGetResponseExternalMessages
   */
  messageType: ThreadMessageType;
  /**
   *
   * @type {string}
   * @memberof ThreadGetResponseExternalMessages
   */
  createdAt?: string;
  /**
   *
   * @type {ThreadGetResponseExternalFollowOnAction}
   * @memberof ThreadGetResponseExternalMessages
   */
  followOnAction?: ThreadGetResponseExternalFollowOnAction;
}

/**
 *
 * @export
 * @interface ThreadGetResponseExternalParticipants
 */
export interface ThreadGetResponseExternalParticipants {
  /**
   *
   * @type {UserSummaryExternal}
   * @memberof ThreadGetResponseExternalParticipants
   */
  participant: UserSummaryExternal;
  /**
   *
   * @type {boolean}
   * @memberof ThreadGetResponseExternalParticipants
   */
  isRead: boolean;
}
/**
 *
 * @export
 * @interface ThreadMessageRequest
 */
export interface ThreadMessageRequest {
  /**
   *
   * @type {ThreadMessageRequestMessageBody}
   * @memberof ThreadMessageRequest
   */
  messageBody: ThreadMessageRequestMessageBody;
  /**
   *
   * @type {ThreadMessageType}
   * @memberof ThreadMessageRequest
   */
  messageType: ThreadMessageType;
  /**
   *
   * @type {string}
   * @memberof ThreadMessageRequest
   */
  source?: string;
  /**
   *
   * @type {string}
   * @memberof ThreadMessageRequest
   */
  taskUid: string;
  /**
   *
   * @type {ThreadGetResponseExternalFollowOnAction}
   * @memberof ThreadMessageRequest
   */
  followOnAction?: ThreadGetResponseExternalFollowOnAction;
}

/**
 *
 * @export
 * @interface ThreadMessageRequestMessageBody
 */
export interface ThreadMessageRequestMessageBody {
  /**
   *
   * @type {string}
   * @memberof ThreadMessageRequestMessageBody
   */
  content?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ThreadMessageType = {
  Message: "MESSAGE",
  ActionFileUpload: "ACTION_FILE_UPLOAD",
} as const;

export type ThreadMessageType = (typeof ThreadMessageType)[keyof typeof ThreadMessageType];

/**
 *
 * @export
 * @interface ThreadSendRequest
 */
export interface ThreadSendRequest {
  /**
   *
   * @type {ThreadMessageRequest}
   * @memberof ThreadSendRequest
   */
  message: ThreadMessageRequest;
  /**
   *
   * @type {string}
   * @memberof ThreadSendRequest
   */
  subject: string;
  /**
   *
   * @type {boolean}
   * @memberof ThreadSendRequest
   */
  replyAllowed?: boolean;
  /**
   *
   * @type {Array<ThreadSendRequestParticipants>}
   * @memberof ThreadSendRequest
   */
  participants: Array<ThreadSendRequestParticipants>;
}
/**
 *
 * @export
 * @interface ThreadSendRequestParticipant
 */
export interface ThreadSendRequestParticipant {
  /**
   *
   * @type {string}
   * @memberof ThreadSendRequestParticipant
   */
  userRef: string;
}
/**
 *
 * @export
 * @interface ThreadSendRequestParticipants
 */
export interface ThreadSendRequestParticipants {
  /**
   *
   * @type {ThreadSendRequestParticipant}
   * @memberof ThreadSendRequestParticipants
   */
  participant: ThreadSendRequestParticipant;
  /**
   *
   * @type {boolean}
   * @memberof ThreadSendRequestParticipants
   */
  isRead: boolean;
}
/**
 *
 * @export
 * @interface TransferCancelledEventType
 */
export interface TransferCancelledEventType {
  /**
   *
   * @type {string}
   * @memberof TransferCancelledEventType
   */
  eventType: TransferCancelledEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TransferCancelledEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof TransferCancelledEventType
   */
  transferSid?: string;
  /**
   *
   * @type {TransferMode}
   * @memberof TransferCancelledEventType
   */
  transferMode?: TransferMode;
  /**
   *
   * @type {TransferType}
   * @memberof TransferCancelledEventType
   */
  transferType?: TransferType;
  /**
   *
   * @type {string}
   * @memberof TransferCancelledEventType
   */
  transferToWorkerSid?: string;
  /**
   *
   * @type {string}
   * @memberof TransferCancelledEventType
   */
  transferToQueueSid?: string;
}

export const TransferCancelledEventTypeEventTypeEnum = {
  TransferCancelled: "TRANSFER_CANCELLED",
} as const;

export type TransferCancelledEventTypeEventTypeEnum =
  (typeof TransferCancelledEventTypeEventTypeEnum)[keyof typeof TransferCancelledEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface TransferCompletedEventType
 */
export interface TransferCompletedEventType {
  /**
   *
   * @type {string}
   * @memberof TransferCompletedEventType
   */
  eventType: TransferCompletedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TransferCompletedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof TransferCompletedEventType
   */
  transferSid?: string;
  /**
   *
   * @type {TransferMode}
   * @memberof TransferCompletedEventType
   */
  transferMode?: TransferMode;
  /**
   *
   * @type {TransferType}
   * @memberof TransferCompletedEventType
   */
  transferType?: TransferType;
  /**
   *
   * @type {string}
   * @memberof TransferCompletedEventType
   */
  transferToWorkerSid?: string;
  /**
   *
   * @type {string}
   * @memberof TransferCompletedEventType
   */
  transferToQueueSid?: string;
}

export const TransferCompletedEventTypeEventTypeEnum = {
  TransferCompleted: "TRANSFER_COMPLETED",
} as const;

export type TransferCompletedEventTypeEventTypeEnum =
  (typeof TransferCompletedEventTypeEventTypeEnum)[keyof typeof TransferCompletedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface TransferFailedEventType
 */
export interface TransferFailedEventType {
  /**
   *
   * @type {string}
   * @memberof TransferFailedEventType
   */
  eventType: TransferFailedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TransferFailedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof TransferFailedEventType
   */
  transferSid?: string;
  /**
   *
   * @type {TransferMode}
   * @memberof TransferFailedEventType
   */
  transferMode?: TransferMode;
  /**
   *
   * @type {TransferType}
   * @memberof TransferFailedEventType
   */
  transferType?: TransferType;
  /**
   *
   * @type {string}
   * @memberof TransferFailedEventType
   */
  transferToWorkerSid?: string;
  /**
   *
   * @type {string}
   * @memberof TransferFailedEventType
   */
  transferToQueueSid?: string;
}

export const TransferFailedEventTypeEventTypeEnum = {
  TransferFailed: "TRANSFER_FAILED",
} as const;

export type TransferFailedEventTypeEventTypeEnum =
  (typeof TransferFailedEventTypeEventTypeEnum)[keyof typeof TransferFailedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @interface TransferInitiatedEventType
 */
export interface TransferInitiatedEventType {
  /**
   *
   * @type {string}
   * @memberof TransferInitiatedEventType
   */
  eventType: TransferInitiatedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof TransferInitiatedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof TransferInitiatedEventType
   */
  transferSid?: string;
  /**
   *
   * @type {TransferMode}
   * @memberof TransferInitiatedEventType
   */
  transferMode?: TransferMode;
  /**
   *
   * @type {TransferType}
   * @memberof TransferInitiatedEventType
   */
  transferType?: TransferType;
  /**
   *
   * @type {string}
   * @memberof TransferInitiatedEventType
   */
  transferToWorkerSid?: string;
  /**
   *
   * @type {string}
   * @memberof TransferInitiatedEventType
   */
  transferToQueueSid?: string;
}

export const TransferInitiatedEventTypeEventTypeEnum = {
  TransferInitiated: "TRANSFER_INITIATED",
} as const;

export type TransferInitiatedEventTypeEventTypeEnum =
  (typeof TransferInitiatedEventTypeEventTypeEnum)[keyof typeof TransferInitiatedEventTypeEventTypeEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const TransferMode = {
  Warm: "WARM",
  Cold: "COLD",
} as const;

export type TransferMode = (typeof TransferMode)[keyof typeof TransferMode];

/**
 *
 * @export
 * @enum {string}
 */

export const TransferType = {
  Worker: "WORKER",
  Queue: "QUEUE",
} as const;

export type TransferType = (typeof TransferType)[keyof typeof TransferType];

/**
 *
 * @export
 * @enum {string}
 */

export const TwilioFlexInsightsRole = {
  FullAccess: "wfo.full_access",
  TeamLeader: "wfo.team_leader",
  DataAnalyst: "wfo.data_analyst",
  DataAuditor: "wfo.data_auditor",
  QualityManager: "wfo.quality_manager",
  QualityProcessManager: "wfo.quality_process_manager",
  DashboardViewer: "wfo.dashboard_viewer",
} as const;

export type TwilioFlexInsightsRole = (typeof TwilioFlexInsightsRole)[keyof typeof TwilioFlexInsightsRole];

/**
 *
 * @export
 * @enum {string}
 */

export const TwilioFlexRole = {
  Agent: "agent",
  Supervisor: "supervisor",
  Admin: "admin",
} as const;

export type TwilioFlexRole = (typeof TwilioFlexRole)[keyof typeof TwilioFlexRole];

/**
 *
 * @export
 * @interface UnmutedEventType
 */
export interface UnmutedEventType {
  /**
   *
   * @type {string}
   * @memberof UnmutedEventType
   */
  eventType: UnmutedEventTypeEventTypeEnum;
  /**
   *
   * @type {string}
   * @memberof UnmutedEventType
   */
  eventAt: string;
  /**
   *
   * @type {string}
   * @memberof UnmutedEventType
   */
  participant?: string;
}

export const UnmutedEventTypeEventTypeEnum = {
  Unmuted: "UNMUTED",
} as const;

export type UnmutedEventTypeEventTypeEnum =
  (typeof UnmutedEventTypeEventTypeEnum)[keyof typeof UnmutedEventTypeEventTypeEnum];

/**
 * Details of created file and upload path
 * @export
 * @interface UploadData
 */
export interface UploadData {
  /**
   *
   * @type {string}
   * @memberof UploadData
   */
  uid?: string;
  /**
   *
   * @type {string}
   * @memberof UploadData
   */
  urn?: string;
  /**
   *
   * @type {string}
   * @memberof UploadData
   */
  signedUploadPath?: string;
}
/**
 *
 * @export
 * @interface UserAdminSimple
 */
export interface UserAdminSimple {
  /**
   *
   * @type {string}
   * @memberof UserAdminSimple
   */
  userUid: string;
}
/**
 *
 * @export
 * @interface UserExportCreate
 */
export interface UserExportCreate {
  /**
   *
   * @type {string}
   * @memberof UserExportCreate
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof UserExportCreate
   */
  timezone: string;
  /**
   *
   * @type {string}
   * @memberof UserExportCreate
   */
  freeText?: string;
  /**
   *
   * @type {string}
   * @memberof UserExportCreate
   */
  format: UserExportCreateFormatEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof UserExportCreate
   */
  fields?: Array<UserExportCreateFieldsEnum>;
  /**
   *
   * @type {SearchUserFilter}
   * @memberof UserExportCreate
   */
  filter?: SearchUserFilter;
  /**
   *
   * @type {SearchUserSort}
   * @memberof UserExportCreate
   */
  sort?: SearchUserSort;
}

export const UserExportCreateFormatEnum = {
  Standard: "STANDARD",
  ExcelCompatible: "EXCEL_COMPATIBLE",
} as const;

export type UserExportCreateFormatEnum = (typeof UserExportCreateFormatEnum)[keyof typeof UserExportCreateFormatEnum];
export const UserExportCreateFieldsEnum = {
  AccountSettings: "ACCOUNT_SETTINGS",
  LinkedToUser: "LINKED_TO_USER",
} as const;

export type UserExportCreateFieldsEnum = (typeof UserExportCreateFieldsEnum)[keyof typeof UserExportCreateFieldsEnum];

/**
 *
 * @export
 * @interface UserExportReadExternal
 */
export interface UserExportReadExternal {
  /**
   *
   * @type {string}
   * @memberof UserExportReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof UserExportReadExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof UserExportReadExternal
   */
  name: string;
  /**
   * Language code including locale
   * @type {string}
   * @memberof UserExportReadExternal
   */
  languageCode: string;
  /**
   *
   * @type {string}
   * @memberof UserExportReadExternal
   */
  timezone: string;
  /**
   *
   * @type {number}
   * @memberof UserExportReadExternal
   */
  resultCount?: number;
  /**
   *
   * @type {TaskExportReadExternalProgress}
   * @memberof UserExportReadExternal
   */
  progress: TaskExportReadExternalProgress;
  /**
   *
   * @type {string}
   * @memberof UserExportReadExternal
   */
  requestedAt: string;
  /**
   *
   * @type {string}
   * @memberof UserExportReadExternal
   */
  freeText?: string;
  /**
   *
   * @type {string}
   * @memberof UserExportReadExternal
   */
  format: UserExportReadExternalFormatEnum;
  /**
   *
   * @type {UserRefHydrated}
   * @memberof UserExportReadExternal
   */
  createdBy: UserRefHydrated;
  /**
   *
   * @type {string}
   * @memberof UserExportReadExternal
   */
  type: UserExportReadExternalTypeEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof UserExportReadExternal
   */
  fields: Array<UserExportReadExternalFieldsEnum>;
  /**
   *
   * @type {SearchUserFilter}
   * @memberof UserExportReadExternal
   */
  filter: SearchUserFilter;
  /**
   *
   * @type {SearchUserSort}
   * @memberof UserExportReadExternal
   */
  sort: SearchUserSort;
}

export const UserExportReadExternalFormatEnum = {
  Standard: "STANDARD",
  ExcelCompatible: "EXCEL_COMPATIBLE",
} as const;

export type UserExportReadExternalFormatEnum =
  (typeof UserExportReadExternalFormatEnum)[keyof typeof UserExportReadExternalFormatEnum];
export const UserExportReadExternalTypeEnum = {
  User: "USER",
} as const;

export type UserExportReadExternalTypeEnum =
  (typeof UserExportReadExternalTypeEnum)[keyof typeof UserExportReadExternalTypeEnum];
export const UserExportReadExternalFieldsEnum = {
  AccountSettings: "ACCOUNT_SETTINGS",
  LinkedToUser: "LINKED_TO_USER",
} as const;

export type UserExportReadExternalFieldsEnum =
  (typeof UserExportReadExternalFieldsEnum)[keyof typeof UserExportReadExternalFieldsEnum];

/**
 *
 * @export
 * @interface UserFilterValuesExternal
 */
export interface UserFilterValuesExternal {
  /**
   *
   * @type {Array<ExtendedMetadataAttributeFilterSummaryExternal>}
   * @memberof UserFilterValuesExternal
   */
  extendedMetadata?: Array<ExtendedMetadataAttributeFilterSummaryExternal>;
}
/**
 *
 * @export
 * @interface UserInvite
 */
export interface UserInvite {
  /**
   *
   * @type {string}
   * @memberof UserInvite
   */
  givenName?: string;
  /**
   *
   * @type {string}
   * @memberof UserInvite
   */
  familyName?: string;
  /**
   *
   * @type {RoleSlug}
   * @memberof UserInvite
   */
  roleSlug: RoleSlug;
  /**
   *
   * @type {string}
   * @memberof UserInvite
   */
  email: string;
  /**
   * E.164 format phone number
   * @type {string}
   * @memberof UserInvite
   */
  phoneNumber?: string;
  /**
   *
   * @type {Array<AssetCreateRelationships>}
   * @memberof UserInvite
   */
  relationships?: Array<AssetCreateRelationships>;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof UserInvite
   */
  extendedMetadata?: { [key: string]: any };
}

/**
 *
 * @export
 * @interface UserNoteCreate
 */
export interface UserNoteCreate {
  /**
   *
   * @type {string}
   * @memberof UserNoteCreate
   */
  uid?: string;
  /**
   *
   * @type {string}
   * @memberof UserNoteCreate
   */
  body: string;
  /**
   *
   * @type {boolean}
   * @memberof UserNoteCreate
   */
  pinned?: boolean;
  /**
   *
   * @type {string}
   * @memberof UserNoteCreate
   */
  userUid: string;
}
/**
 *
 * @export
 * @interface UserNoteUpdate
 */
export interface UserNoteUpdate {
  /**
   *
   * @type {string}
   * @memberof UserNoteUpdate
   */
  body?: string;
  /**
   *
   * @type {boolean}
   * @memberof UserNoteUpdate
   */
  pinned?: boolean;
  /**
   *
   * @type {string}
   * @memberof UserNoteUpdate
   */
  userUid: string;
}
/**
 *
 * @export
 * @interface UserNoteWriteResponse
 */
export interface UserNoteWriteResponse {
  /**
   *
   * @type {string}
   * @memberof UserNoteWriteResponse
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof UserNoteWriteResponse
   */
  body: string;
  /**
   *
   * @type {boolean}
   * @memberof UserNoteWriteResponse
   */
  pinned?: boolean;
}
/**
 *
 * @export
 * @interface UserReadExternal
 */
export interface UserReadExternal {
  /**
   *
   * @type {string}
   * @memberof UserReadExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof UserReadExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof UserReadExternal
   */
  givenName?: string;
  /**
   *
   * @type {string}
   * @memberof UserReadExternal
   */
  familyName?: string;
  /**
   *
   * @type {RoleSlug}
   * @memberof UserReadExternal
   */
  roleSlug: RoleSlug;
  /**
   *
   * @type {boolean}
   * @memberof UserReadExternal
   */
  skipMobile?: boolean;
  /**
   *
   * @type {Array<ProfileReadExternalCommsChannels>}
   * @memberof UserReadExternal
   */
  commsChannels?: Array<ProfileReadExternalCommsChannels>;
  /**
   * Language code including locale
   * @type {string}
   * @memberof UserReadExternal
   */
  preferredLanguage?: string;
  /**
   *
   * @type {string}
   * @memberof UserReadExternal
   */
  username?: string;
  /**
   *
   * @type {boolean}
   * @memberof UserReadExternal
   */
  enabled?: boolean;
  /**
   *
   * @type {RegistrationStatus}
   * @memberof UserReadExternal
   */
  registrationStatus?: RegistrationStatus;
  /**
   *
   * @type {Array<string>}
   * @memberof UserReadExternal
   */
  userFeatureFlags?: Array<string>;
  /**
   *
   * @type {ProfileReadExternalAskAgentRoles}
   * @memberof UserReadExternal
   */
  askAgentRoles?: ProfileReadExternalAskAgentRoles;
  /**
   *
   * @type {boolean}
   * @memberof UserReadExternal
   */
  vip?: boolean;
  /**
   *
   * @type {Array<ProfileReadExternalChannelPreferences>}
   * @memberof UserReadExternal
   */
  channelPreferences?: Array<ProfileReadExternalChannelPreferences>;
  /**
   *
   * @type {string}
   * @memberof UserReadExternal
   */
  email?: string;
  /**
   * E.164 format phone number
   * @type {string}
   * @memberof UserReadExternal
   */
  phoneNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof UserReadExternal
   */
  emailVerified?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UserReadExternal
   */
  phoneVerified?: boolean;
  /**
   *
   * @type {Array<UserReadExternalUserNotes>}
   * @memberof UserReadExternal
   */
  userNotes?: Array<UserReadExternalUserNotes>;
  /**
   *
   * @type {FilePath}
   * @memberof UserReadExternal
   */
  profilePhoto?: FilePath;
  /**
   *
   * @type {number}
   * @memberof UserReadExternal
   */
  taskCount?: number;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof UserReadExternal
   */
  extendedMetadata?: { [key: string]: any };
  /**
   *
   * @type {Array<TaskFullLinkedTeams>}
   * @memberof UserReadExternal
   */
  linkedTeams?: Array<TaskFullLinkedTeams>;
  /**
   *
   * @type {Array<TaskFullLinkedAssets>}
   * @memberof UserReadExternal
   */
  linkedAssets?: Array<TaskFullLinkedAssets>;
  /**
   *
   * @type {Array<TaskFullLinkedOrgs>}
   * @memberof UserReadExternal
   */
  linkedOrgs?: Array<TaskFullLinkedOrgs>;
  /**
   *
   * @type {TaskFullExternalLink}
   * @memberof UserReadExternal
   */
  externalLink?: TaskFullExternalLink;
  /**
   *
   * @type {ChangeSummary}
   * @memberof UserReadExternal
   */
  changeSummary?: ChangeSummary;
}

/**
 *
 * @export
 * @interface UserReadExternalUserNotes
 */
export interface UserReadExternalUserNotes {
  /**
   *
   * @type {string}
   * @memberof UserReadExternalUserNotes
   */
  uid?: string;
  /**
   *
   * @type {string}
   * @memberof UserReadExternalUserNotes
   */
  userUid: string;
  /**
   *
   * @type {string}
   * @memberof UserReadExternalUserNotes
   */
  body: string;
  /**
   *
   * @type {boolean}
   * @memberof UserReadExternalUserNotes
   */
  pinned?: boolean;
  /**
   *
   * @type {UserSummaryExternal}
   * @memberof UserReadExternalUserNotes
   */
  author?: UserSummaryExternal;
  /**
   *
   * @type {ChangeSummary}
   * @memberof UserReadExternalUserNotes
   */
  changeSummary?: ChangeSummary;
}
/**
 *
 * @export
 * @interface UserRefHydrated
 */
export interface UserRefHydrated {
  /**
   *
   * @type {string}
   * @memberof UserRefHydrated
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof UserRefHydrated
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof UserRefHydrated
   */
  givenName?: string;
  /**
   *
   * @type {string}
   * @memberof UserRefHydrated
   */
  familyName?: string;
  /**
   *
   * @type {RoleSlug}
   * @memberof UserRefHydrated
   */
  roleSlug: RoleSlug;
  /**
   *
   * @type {RegistrationStatus}
   * @memberof UserRefHydrated
   */
  registrationStatus?: RegistrationStatus;
  /**
   *
   * @type {boolean}
   * @memberof UserRefHydrated
   */
  vip?: boolean;
  /**
   *
   * @type {FilePath}
   * @memberof UserRefHydrated
   */
  profilePhoto?: FilePath;
}

/**
 *
 * @export
 * @interface UserRoleChangeSimple
 */
export interface UserRoleChangeSimple {
  /**
   *
   * @type {string}
   * @memberof UserRoleChangeSimple
   */
  userUid: string;
  /**
   *
   * @type {RoleSlug}
   * @memberof UserRoleChangeSimple
   */
  newRole: RoleSlug;
}

/**
 *
 * @export
 * @interface UserSearchResultExternal
 */
export interface UserSearchResultExternal {
  /**
   *
   * @type {string}
   * @memberof UserSearchResultExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof UserSearchResultExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof UserSearchResultExternal
   */
  givenName?: string;
  /**
   *
   * @type {string}
   * @memberof UserSearchResultExternal
   */
  familyName?: string;
  /**
   *
   * @type {RoleSlug}
   * @memberof UserSearchResultExternal
   */
  roleSlug: RoleSlug;
  /**
   *
   * @type {RegistrationStatus}
   * @memberof UserSearchResultExternal
   */
  registrationStatus?: RegistrationStatus;
  /**
   *
   * @type {boolean}
   * @memberof UserSearchResultExternal
   */
  vip?: boolean;
  /**
   *
   * @type {Array<OrgSummaryExternal>}
   * @memberof UserSearchResultExternal
   */
  linkedOrgs?: Array<OrgSummaryExternal>;
  /**
   *
   * @type {Array<TeamRef>}
   * @memberof UserSearchResultExternal
   */
  linkedTeams?: Array<TeamRef>;
  /**
   *
   * @type {string}
   * @memberof UserSearchResultExternal
   */
  email?: string;
  /**
   * E.164 format phone number
   * @type {string}
   * @memberof UserSearchResultExternal
   */
  phoneNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof UserSearchResultExternal
   */
  emailVerified?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UserSearchResultExternal
   */
  phoneVerified?: boolean;
  /**
   *
   * @type {FilePath}
   * @memberof UserSearchResultExternal
   */
  profilePhoto?: FilePath;
}

/**
 *
 * @export
 * @interface UserSummaryExternal
 */
export interface UserSummaryExternal {
  /**
   *
   * @type {string}
   * @memberof UserSummaryExternal
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof UserSummaryExternal
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof UserSummaryExternal
   */
  givenName?: string;
  /**
   *
   * @type {string}
   * @memberof UserSummaryExternal
   */
  familyName?: string;
  /**
   *
   * @type {RoleSlug}
   * @memberof UserSummaryExternal
   */
  roleSlug: RoleSlug;
  /**
   *
   * @type {RegistrationStatus}
   * @memberof UserSummaryExternal
   */
  registrationStatus?: RegistrationStatus;
  /**
   *
   * @type {boolean}
   * @memberof UserSummaryExternal
   */
  vip?: boolean;
  /**
   *
   * @type {FilePath}
   * @memberof UserSummaryExternal
   */
  profilePhoto?: FilePath;
}

/**
 *
 * @export
 * @interface UserUpdateExternal
 */
export interface UserUpdateExternal {
  /**
   *
   * @type {string}
   * @memberof UserUpdateExternal
   */
  givenName?: string;
  /**
   *
   * @type {string}
   * @memberof UserUpdateExternal
   */
  familyName?: string;
  /**
   *
   * @type {boolean}
   * @memberof UserUpdateExternal
   */
  skipMobile?: boolean;
  /**
   *
   * @type {FileRef}
   * @memberof UserUpdateExternal
   */
  profilePhoto?: FileRef;
  /**
   * Language code including locale
   * @type {string}
   * @memberof UserUpdateExternal
   */
  preferredLanguage?: string;
  /**
   *
   * @type {Array<ProfileReadExternalCommsChannels>}
   * @memberof UserUpdateExternal
   */
  commsChannels?: Array<ProfileReadExternalCommsChannels>;
  /**
   *
   * @type {Array<string>}
   * @memberof UserUpdateExternal
   */
  userFeatureFlags?: Array<string>;
  /**
   *
   * @type {ProfileReadExternalAskAgentRoles}
   * @memberof UserUpdateExternal
   */
  askAgentRoles?: ProfileReadExternalAskAgentRoles;
  /**
   *
   * @type {boolean}
   * @memberof UserUpdateExternal
   */
  vip?: boolean;
  /**
   *
   * @type {Array<ProfileReadExternalChannelPreferences>}
   * @memberof UserUpdateExternal
   */
  channelPreferences?: Array<ProfileReadExternalChannelPreferences>;
  /**
   *
   * @type {TaskFullExternalLink}
   * @memberof UserUpdateExternal
   */
  externalLink?: TaskFullExternalLink;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof UserUpdateExternal
   */
  extendedMetadata?: { [key: string]: any };
}
/**
 *
 * @export
 * @interface UserWriteResponse
 */
export interface UserWriteResponse {
  /**
   *
   * @type {string}
   * @memberof UserWriteResponse
   */
  uid: string;
  /**
   *
   * @type {string}
   * @memberof UserWriteResponse
   */
  urn: string;
  /**
   *
   * @type {string}
   * @memberof UserWriteResponse
   */
  givenName?: string;
  /**
   *
   * @type {string}
   * @memberof UserWriteResponse
   */
  familyName?: string;
  /**
   *
   * @type {RoleSlug}
   * @memberof UserWriteResponse
   */
  roleSlug: RoleSlug;
  /**
   *
   * @type {string}
   * @memberof UserWriteResponse
   */
  contactUrn?: string;
  /**
   *
   * @type {boolean}
   * @memberof UserWriteResponse
   */
  vip?: boolean;
}

/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create holiday calendars
     * @param {number} [offset] The number of items to skip before returning the results
     * @param {number} [limit] The number of items to return
     * @param {HolidayCalendarCreate} [holidayCalendarCreate] Create a new Holiday Calendar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminHolidayCalendarsCreate: async (
      offset?: number,
      limit?: number,
      holidayCalendarCreate?: HolidayCalendarCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/admin/holiday-calendars`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(holidayCalendarCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a holiday calendar
     * @param {string} uid Object UID
     * @param {GriegLyricAdminHolidayCalendarsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminHolidayCalendarsFetch: async (
      uid: string,
      xApCacheControl?: GriegLyricAdminHolidayCalendarsFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricAdminHolidayCalendarsFetch", "uid", uid);
      const localVarPath = `/api/v1/admin/holiday-calendars/{uid}`.replace(
        `{${"uid"}}`,
        encodeURIComponent(String(uid)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List holiday calendars
     * @param {number} [offset] The number of items to skip before returning the results
     * @param {number} [limit] The number of items to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminHolidayCalendarsList: async (
      offset?: number,
      limit?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/admin/holiday-calendars`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a holiday calendar
     * @param {string} uid Object UID
     * @param {HolidayCalendarUpdate} [holidayCalendarUpdate] Update a Holiday Calendar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminHolidayCalendarsUpdate: async (
      uid: string,
      holidayCalendarUpdate?: HolidayCalendarUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricAdminHolidayCalendarsUpdate", "uid", uid);
      const localVarPath = `/api/v1/admin/holiday-calendars/{uid}`.replace(
        `{${"uid"}}`,
        encodeURIComponent(String(uid)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(holidayCalendarUpdate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a service level
     * @param {ServiceLevelCreate} [serviceLevelCreate] Details of the new service level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminServiceLevelsCreate: async (
      serviceLevelCreate?: ServiceLevelCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/admin/service-levels`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(serviceLevelCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a service level
     * @param {string} uid Object UID
     * @param {GriegLyricAdminServiceLevelsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminServiceLevelsFetch: async (
      uid: string,
      xApCacheControl?: GriegLyricAdminServiceLevelsFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricAdminServiceLevelsFetch", "uid", uid);
      const localVarPath = `/api/v1/admin/service-levels/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List service levels
     * @param {number} [offset] The number of items to skip before returning the results
     * @param {number} [limit] The number of items to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminServiceLevelsList: async (
      offset?: number,
      limit?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/admin/service-levels`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a service level
     * @param {string} uid Object UID
     * @param {ServiceLevelUpdate} [serviceLevelUpdate] Updated details of the service level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminServiceLevelsUpdate: async (
      uid: string,
      serviceLevelUpdate?: ServiceLevelUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricAdminServiceLevelsUpdate", "uid", uid);
      const localVarPath = `/api/v1/admin/service-levels/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(serviceLevelUpdate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List task priorities
     * @param {string} xApLang Language
     * @param {GriegLyricAdminTaskPrioritiesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminTaskPrioritiesList: async (
      xApLang: string,
      xApCacheControl?: GriegLyricAdminTaskPrioritiesListXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricAdminTaskPrioritiesList", "xApLang", xApLang);
      const localVarPath = `/api/v1/admin/task-priorities`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a task type
     * @param {string} uid Object UID
     * @param {GriegLyricAdminTaskTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminTaskTypesFetch: async (
      uid: string,
      xApCacheControl?: GriegLyricAdminTaskTypesFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricAdminTaskTypesFetch", "uid", uid);
      const localVarPath = `/api/v1/admin/task-types/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List task types
     * @param {number} [offset] The number of items to skip before returning the results
     * @param {number} [limit] The number of items to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminTaskTypesList: async (
      offset?: number,
      limit?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/admin/task-types`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a task type
     * @param {string} uid Object UID
     * @param {AdminTaskTypeUpdate} [adminTaskTypeUpdate] Updated details of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminTaskTypesUpdate: async (
      uid: string,
      adminTaskTypeUpdate?: AdminTaskTypeUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricAdminTaskTypesUpdate", "uid", uid);
      const localVarPath = `/api/v1/admin/task-types/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(adminTaskTypeUpdate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create holiday calendars
     * @param {number} [offset] The number of items to skip before returning the results
     * @param {number} [limit] The number of items to return
     * @param {HolidayCalendarCreate} [holidayCalendarCreate] Create a new Holiday Calendar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAdminHolidayCalendarsCreate(
      offset?: number,
      limit?: number,
      holidayCalendarCreate?: HolidayCalendarCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HolidayCalendarWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAdminHolidayCalendarsCreate(
        offset,
        limit,
        holidayCalendarCreate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.griegLyricAdminHolidayCalendarsCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a holiday calendar
     * @param {string} uid Object UID
     * @param {GriegLyricAdminHolidayCalendarsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAdminHolidayCalendarsFetch(
      uid: string,
      xApCacheControl?: GriegLyricAdminHolidayCalendarsFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HolidayCalendarRead>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAdminHolidayCalendarsFetch(
        uid,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.griegLyricAdminHolidayCalendarsFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List holiday calendars
     * @param {number} [offset] The number of items to skip before returning the results
     * @param {number} [limit] The number of items to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAdminHolidayCalendarsList(
      offset?: number,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HolidayCalendarList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAdminHolidayCalendarsList(
        offset,
        limit,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.griegLyricAdminHolidayCalendarsList"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a holiday calendar
     * @param {string} uid Object UID
     * @param {HolidayCalendarUpdate} [holidayCalendarUpdate] Update a Holiday Calendar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAdminHolidayCalendarsUpdate(
      uid: string,
      holidayCalendarUpdate?: HolidayCalendarUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HolidayCalendarWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAdminHolidayCalendarsUpdate(
        uid,
        holidayCalendarUpdate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.griegLyricAdminHolidayCalendarsUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a service level
     * @param {ServiceLevelCreate} [serviceLevelCreate] Details of the new service level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAdminServiceLevelsCreate(
      serviceLevelCreate?: ServiceLevelCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceLevelRead>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAdminServiceLevelsCreate(
        serviceLevelCreate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.griegLyricAdminServiceLevelsCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a service level
     * @param {string} uid Object UID
     * @param {GriegLyricAdminServiceLevelsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAdminServiceLevelsFetch(
      uid: string,
      xApCacheControl?: GriegLyricAdminServiceLevelsFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceLevelRead>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAdminServiceLevelsFetch(
        uid,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.griegLyricAdminServiceLevelsFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List service levels
     * @param {number} [offset] The number of items to skip before returning the results
     * @param {number} [limit] The number of items to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAdminServiceLevelsList(
      offset?: number,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceLevelList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAdminServiceLevelsList(
        offset,
        limit,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.griegLyricAdminServiceLevelsList"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a service level
     * @param {string} uid Object UID
     * @param {ServiceLevelUpdate} [serviceLevelUpdate] Updated details of the service level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAdminServiceLevelsUpdate(
      uid: string,
      serviceLevelUpdate?: ServiceLevelUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceLevelRead>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAdminServiceLevelsUpdate(
        uid,
        serviceLevelUpdate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.griegLyricAdminServiceLevelsUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List task priorities
     * @param {string} xApLang Language
     * @param {GriegLyricAdminTaskPrioritiesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAdminTaskPrioritiesList(
      xApLang: string,
      xApCacheControl?: GriegLyricAdminTaskPrioritiesListXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskPriorityListExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAdminTaskPrioritiesList(
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.griegLyricAdminTaskPrioritiesList"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a task type
     * @param {string} uid Object UID
     * @param {GriegLyricAdminTaskTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAdminTaskTypesFetch(
      uid: string,
      xApCacheControl?: GriegLyricAdminTaskTypesFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTaskTypeReadExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAdminTaskTypesFetch(
        uid,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.griegLyricAdminTaskTypesFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List task types
     * @param {number} [offset] The number of items to skip before returning the results
     * @param {number} [limit] The number of items to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAdminTaskTypesList(
      offset?: number,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTaskTypeListExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAdminTaskTypesList(offset, limit, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.griegLyricAdminTaskTypesList"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a task type
     * @param {string} uid Object UID
     * @param {AdminTaskTypeUpdate} [adminTaskTypeUpdate] Updated details of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAdminTaskTypesUpdate(
      uid: string,
      adminTaskTypeUpdate?: AdminTaskTypeUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTaskTypeWriteExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAdminTaskTypesUpdate(
        uid,
        adminTaskTypeUpdate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AdminApi.griegLyricAdminTaskTypesUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = AdminApiFp(configuration);
  return {
    /**
     *
     * @summary Create holiday calendars
     * @param {number} [offset] The number of items to skip before returning the results
     * @param {number} [limit] The number of items to return
     * @param {HolidayCalendarCreate} [holidayCalendarCreate] Create a new Holiday Calendar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminHolidayCalendarsCreate(
      offset?: number,
      limit?: number,
      holidayCalendarCreate?: HolidayCalendarCreate,
      options?: any,
    ): AxiosPromise<HolidayCalendarWriteResponse> {
      return localVarFp
        .griegLyricAdminHolidayCalendarsCreate(offset, limit, holidayCalendarCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a holiday calendar
     * @param {string} uid Object UID
     * @param {GriegLyricAdminHolidayCalendarsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminHolidayCalendarsFetch(
      uid: string,
      xApCacheControl?: GriegLyricAdminHolidayCalendarsFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<HolidayCalendarRead> {
      return localVarFp
        .griegLyricAdminHolidayCalendarsFetch(uid, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List holiday calendars
     * @param {number} [offset] The number of items to skip before returning the results
     * @param {number} [limit] The number of items to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminHolidayCalendarsList(
      offset?: number,
      limit?: number,
      options?: any,
    ): AxiosPromise<HolidayCalendarList> {
      return localVarFp
        .griegLyricAdminHolidayCalendarsList(offset, limit, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a holiday calendar
     * @param {string} uid Object UID
     * @param {HolidayCalendarUpdate} [holidayCalendarUpdate] Update a Holiday Calendar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminHolidayCalendarsUpdate(
      uid: string,
      holidayCalendarUpdate?: HolidayCalendarUpdate,
      options?: any,
    ): AxiosPromise<HolidayCalendarWriteResponse> {
      return localVarFp
        .griegLyricAdminHolidayCalendarsUpdate(uid, holidayCalendarUpdate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a service level
     * @param {ServiceLevelCreate} [serviceLevelCreate] Details of the new service level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminServiceLevelsCreate(
      serviceLevelCreate?: ServiceLevelCreate,
      options?: any,
    ): AxiosPromise<ServiceLevelRead> {
      return localVarFp
        .griegLyricAdminServiceLevelsCreate(serviceLevelCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a service level
     * @param {string} uid Object UID
     * @param {GriegLyricAdminServiceLevelsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminServiceLevelsFetch(
      uid: string,
      xApCacheControl?: GriegLyricAdminServiceLevelsFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<ServiceLevelRead> {
      return localVarFp
        .griegLyricAdminServiceLevelsFetch(uid, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List service levels
     * @param {number} [offset] The number of items to skip before returning the results
     * @param {number} [limit] The number of items to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminServiceLevelsList(offset?: number, limit?: number, options?: any): AxiosPromise<ServiceLevelList> {
      return localVarFp
        .griegLyricAdminServiceLevelsList(offset, limit, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a service level
     * @param {string} uid Object UID
     * @param {ServiceLevelUpdate} [serviceLevelUpdate] Updated details of the service level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminServiceLevelsUpdate(
      uid: string,
      serviceLevelUpdate?: ServiceLevelUpdate,
      options?: any,
    ): AxiosPromise<ServiceLevelRead> {
      return localVarFp
        .griegLyricAdminServiceLevelsUpdate(uid, serviceLevelUpdate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List task priorities
     * @param {string} xApLang Language
     * @param {GriegLyricAdminTaskPrioritiesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminTaskPrioritiesList(
      xApLang: string,
      xApCacheControl?: GriegLyricAdminTaskPrioritiesListXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<TaskPriorityListExternal> {
      return localVarFp
        .griegLyricAdminTaskPrioritiesList(xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a task type
     * @param {string} uid Object UID
     * @param {GriegLyricAdminTaskTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminTaskTypesFetch(
      uid: string,
      xApCacheControl?: GriegLyricAdminTaskTypesFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<AdminTaskTypeReadExternal> {
      return localVarFp
        .griegLyricAdminTaskTypesFetch(uid, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List task types
     * @param {number} [offset] The number of items to skip before returning the results
     * @param {number} [limit] The number of items to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminTaskTypesList(
      offset?: number,
      limit?: number,
      options?: any,
    ): AxiosPromise<AdminTaskTypeListExternal> {
      return localVarFp
        .griegLyricAdminTaskTypesList(offset, limit, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a task type
     * @param {string} uid Object UID
     * @param {AdminTaskTypeUpdate} [adminTaskTypeUpdate] Updated details of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAdminTaskTypesUpdate(
      uid: string,
      adminTaskTypeUpdate?: AdminTaskTypeUpdate,
      options?: any,
    ): AxiosPromise<AdminTaskTypeWriteExternal> {
      return localVarFp
        .griegLyricAdminTaskTypesUpdate(uid, adminTaskTypeUpdate, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
  /**
   *
   * @summary Create holiday calendars
   * @param {number} [offset] The number of items to skip before returning the results
   * @param {number} [limit] The number of items to return
   * @param {HolidayCalendarCreate} [holidayCalendarCreate] Create a new Holiday Calendar
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public griegLyricAdminHolidayCalendarsCreate(
    offset?: number,
    limit?: number,
    holidayCalendarCreate?: HolidayCalendarCreate,
    options?: RawAxiosRequestConfig,
  ) {
    return AdminApiFp(this.configuration)
      .griegLyricAdminHolidayCalendarsCreate(offset, limit, holidayCalendarCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a holiday calendar
   * @param {string} uid Object UID
   * @param {GriegLyricAdminHolidayCalendarsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public griegLyricAdminHolidayCalendarsFetch(
    uid: string,
    xApCacheControl?: GriegLyricAdminHolidayCalendarsFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return AdminApiFp(this.configuration)
      .griegLyricAdminHolidayCalendarsFetch(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List holiday calendars
   * @param {number} [offset] The number of items to skip before returning the results
   * @param {number} [limit] The number of items to return
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public griegLyricAdminHolidayCalendarsList(offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
    return AdminApiFp(this.configuration)
      .griegLyricAdminHolidayCalendarsList(offset, limit, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a holiday calendar
   * @param {string} uid Object UID
   * @param {HolidayCalendarUpdate} [holidayCalendarUpdate] Update a Holiday Calendar
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public griegLyricAdminHolidayCalendarsUpdate(
    uid: string,
    holidayCalendarUpdate?: HolidayCalendarUpdate,
    options?: RawAxiosRequestConfig,
  ) {
    return AdminApiFp(this.configuration)
      .griegLyricAdminHolidayCalendarsUpdate(uid, holidayCalendarUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a service level
   * @param {ServiceLevelCreate} [serviceLevelCreate] Details of the new service level
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public griegLyricAdminServiceLevelsCreate(serviceLevelCreate?: ServiceLevelCreate, options?: RawAxiosRequestConfig) {
    return AdminApiFp(this.configuration)
      .griegLyricAdminServiceLevelsCreate(serviceLevelCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a service level
   * @param {string} uid Object UID
   * @param {GriegLyricAdminServiceLevelsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public griegLyricAdminServiceLevelsFetch(
    uid: string,
    xApCacheControl?: GriegLyricAdminServiceLevelsFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return AdminApiFp(this.configuration)
      .griegLyricAdminServiceLevelsFetch(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List service levels
   * @param {number} [offset] The number of items to skip before returning the results
   * @param {number} [limit] The number of items to return
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public griegLyricAdminServiceLevelsList(offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
    return AdminApiFp(this.configuration)
      .griegLyricAdminServiceLevelsList(offset, limit, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a service level
   * @param {string} uid Object UID
   * @param {ServiceLevelUpdate} [serviceLevelUpdate] Updated details of the service level
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public griegLyricAdminServiceLevelsUpdate(
    uid: string,
    serviceLevelUpdate?: ServiceLevelUpdate,
    options?: RawAxiosRequestConfig,
  ) {
    return AdminApiFp(this.configuration)
      .griegLyricAdminServiceLevelsUpdate(uid, serviceLevelUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List task priorities
   * @param {string} xApLang Language
   * @param {GriegLyricAdminTaskPrioritiesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public griegLyricAdminTaskPrioritiesList(
    xApLang: string,
    xApCacheControl?: GriegLyricAdminTaskPrioritiesListXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return AdminApiFp(this.configuration)
      .griegLyricAdminTaskPrioritiesList(xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a task type
   * @param {string} uid Object UID
   * @param {GriegLyricAdminTaskTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public griegLyricAdminTaskTypesFetch(
    uid: string,
    xApCacheControl?: GriegLyricAdminTaskTypesFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return AdminApiFp(this.configuration)
      .griegLyricAdminTaskTypesFetch(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List task types
   * @param {number} [offset] The number of items to skip before returning the results
   * @param {number} [limit] The number of items to return
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public griegLyricAdminTaskTypesList(offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
    return AdminApiFp(this.configuration)
      .griegLyricAdminTaskTypesList(offset, limit, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a task type
   * @param {string} uid Object UID
   * @param {AdminTaskTypeUpdate} [adminTaskTypeUpdate] Updated details of the task
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */
  public griegLyricAdminTaskTypesUpdate(
    uid: string,
    adminTaskTypeUpdate?: AdminTaskTypeUpdate,
    options?: RawAxiosRequestConfig,
  ) {
    return AdminApiFp(this.configuration)
      .griegLyricAdminTaskTypesUpdate(uid, adminTaskTypeUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GriegLyricAdminHolidayCalendarsFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricAdminHolidayCalendarsFetchXApCacheControlEnum =
  (typeof GriegLyricAdminHolidayCalendarsFetchXApCacheControlEnum)[keyof typeof GriegLyricAdminHolidayCalendarsFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricAdminServiceLevelsFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricAdminServiceLevelsFetchXApCacheControlEnum =
  (typeof GriegLyricAdminServiceLevelsFetchXApCacheControlEnum)[keyof typeof GriegLyricAdminServiceLevelsFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricAdminTaskPrioritiesListXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricAdminTaskPrioritiesListXApCacheControlEnum =
  (typeof GriegLyricAdminTaskPrioritiesListXApCacheControlEnum)[keyof typeof GriegLyricAdminTaskPrioritiesListXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricAdminTaskTypesFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricAdminTaskTypesFetchXApCacheControlEnum =
  (typeof GriegLyricAdminTaskTypesFetchXApCacheControlEnum)[keyof typeof GriegLyricAdminTaskTypesFetchXApCacheControlEnum];

/**
 * AskAgentApi - axios parameter creator
 * @export
 */
export const AskAgentApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Summarise brands
     * @param {GriegLyricBrandSummaryFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricBrandSummaryFetch: async (
      xApCacheControl?: GriegLyricBrandSummaryFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/brand-summary`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a brand
     * @param {string} brandSlug
     * @param {BrandCreate} [brandCreate] Details of the new brand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricBrandsCreate: async (
      brandSlug: string,
      brandCreate?: BrandCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'brandSlug' is not null or undefined
      assertParamExists("griegLyricBrandsCreate", "brandSlug", brandSlug);
      const localVarPath = `/api/v1/brands/{brandSlug}/create`.replace(
        `{${"brandSlug"}}`,
        encodeURIComponent(String(brandSlug)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(brandCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Set a brand as default
     * @param {string} brandSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricBrandsDefault: async (brandSlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'brandSlug' is not null or undefined
      assertParamExists("griegLyricBrandsDefault", "brandSlug", brandSlug);
      const localVarPath = `/api/v1/brands/{brandSlug}/default`.replace(
        `{${"brandSlug"}}`,
        encodeURIComponent(String(brandSlug)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a brand
     * @param {string} brandSlug
     * @param {GriegLyricBrandsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricBrandsFetch: async (
      brandSlug: string,
      xApCacheControl?: GriegLyricBrandsFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'brandSlug' is not null or undefined
      assertParamExists("griegLyricBrandsFetch", "brandSlug", brandSlug);
      const localVarPath = `/api/v1/brands/{brandSlug}`.replace(
        `{${"brandSlug"}}`,
        encodeURIComponent(String(brandSlug)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List brands
     * @param {string} [pageToken]
     * @param {number} [limit] The number of items to return
     * @param {GriegLyricBrandsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {boolean} [active] Filter for active items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricBrandsList: async (
      pageToken?: string,
      limit?: number,
      xApCacheControl?: GriegLyricBrandsListXApCacheControlEnum,
      active?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/brands`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (pageToken !== undefined) {
        localVarQueryParameter["page_token"] = pageToken;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (active !== undefined) {
        localVarQueryParameter["active"] = active;
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a brand
     * @param {string} brandSlug
     * @param {BrandUpdate} [brandUpdate] Updated details of the brand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricBrandsUpdate: async (
      brandSlug: string,
      brandUpdate?: BrandUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'brandSlug' is not null or undefined
      assertParamExists("griegLyricBrandsUpdate", "brandSlug", brandSlug);
      const localVarPath = `/api/v1/brands/{brandSlug}/update`.replace(
        `{${"brandSlug"}}`,
        encodeURIComponent(String(brandSlug)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(brandUpdate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Hand-off a call to webchat
     * @param {HandOffSend} [handOffSend] Details of the hand-off request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricHandOffCallWeb: async (
      handOffSend?: HandOffSend,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/hand-off/call-to-web`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(handOffSend, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Mark a call resolved by IVR
     * @param {IvrResolved} [ivrResolved]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricMarkIvrResolved: async (
      ivrResolved?: IvrResolved,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/ivr/mark-resolved`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(ivrResolved, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a notice
     * @param {NoticeCreate} [noticeCreate] Details of the new notice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricNoticesCreate: async (
      noticeCreate?: NoticeCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/notices`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(noticeCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a notice
     * @param {string} uid Object UID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricNoticesDelete: async (uid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricNoticesDelete", "uid", uid);
      const localVarPath = `/api/v1/notices/{uid}/delete`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a notice
     * @param {string} uid Object UID
     * @param {GriegLyricNoticesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricNoticesFetch: async (
      uid: string,
      xApCacheControl?: GriegLyricNoticesFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricNoticesFetch", "uid", uid);
      const localVarPath = `/api/v1/notices/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List notices
     * @param {string} [pageToken]
     * @param {number} [limit] The number of items to return
     * @param {GriegLyricNoticesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {boolean} [active] Filter for active items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricNoticesList: async (
      pageToken?: string,
      limit?: number,
      xApCacheControl?: GriegLyricNoticesListXApCacheControlEnum,
      active?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/notices`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (pageToken !== undefined) {
        localVarQueryParameter["page_token"] = pageToken;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (active !== undefined) {
        localVarQueryParameter["active"] = active;
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a notice
     * @param {string} uid Object UID
     * @param {NoticeUpdate} [noticeUpdate] Updated details of the notice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricNoticesUpdate: async (
      uid: string,
      noticeUpdate?: NoticeUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricNoticesUpdate", "uid", uid);
      const localVarPath = `/api/v1/notices/{uid}/update`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(noticeUpdate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AskAgentApi - functional programming interface
 * @export
 */
export const AskAgentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AskAgentApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Summarise brands
     * @param {GriegLyricBrandSummaryFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricBrandSummaryFetch(
      xApCacheControl?: GriegLyricBrandSummaryFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandFullListExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricBrandSummaryFetch(xApCacheControl, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AskAgentApi.griegLyricBrandSummaryFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a brand
     * @param {string} brandSlug
     * @param {BrandCreate} [brandCreate] Details of the new brand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricBrandsCreate(
      brandSlug: string,
      brandCreate?: BrandCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandRead>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricBrandsCreate(brandSlug, brandCreate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AskAgentApi.griegLyricBrandsCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Set a brand as default
     * @param {string} brandSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricBrandsDefault(
      brandSlug: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricBrandsDefault(brandSlug, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AskAgentApi.griegLyricBrandsDefault"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a brand
     * @param {string} brandSlug
     * @param {GriegLyricBrandsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricBrandsFetch(
      brandSlug: string,
      xApCacheControl?: GriegLyricBrandsFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandReadExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricBrandsFetch(
        brandSlug,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AskAgentApi.griegLyricBrandsFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List brands
     * @param {string} [pageToken]
     * @param {number} [limit] The number of items to return
     * @param {GriegLyricBrandsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {boolean} [active] Filter for active items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricBrandsList(
      pageToken?: string,
      limit?: number,
      xApCacheControl?: GriegLyricBrandsListXApCacheControlEnum,
      active?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricBrandsList(
        pageToken,
        limit,
        xApCacheControl,
        active,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AskAgentApi.griegLyricBrandsList"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a brand
     * @param {string} brandSlug
     * @param {BrandUpdate} [brandUpdate] Updated details of the brand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricBrandsUpdate(
      brandSlug: string,
      brandUpdate?: BrandUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandRead>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricBrandsUpdate(brandSlug, brandUpdate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AskAgentApi.griegLyricBrandsUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Hand-off a call to webchat
     * @param {HandOffSend} [handOffSend] Details of the hand-off request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricHandOffCallWeb(
      handOffSend?: HandOffSend,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricHandOffCallWeb(handOffSend, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AskAgentApi.griegLyricHandOffCallWeb"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Mark a call resolved by IVR
     * @param {IvrResolved} [ivrResolved]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricMarkIvrResolved(
      ivrResolved?: IvrResolved,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActionResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricMarkIvrResolved(ivrResolved, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AskAgentApi.griegLyricMarkIvrResolved"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a notice
     * @param {NoticeCreate} [noticeCreate] Details of the new notice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricNoticesCreate(
      noticeCreate?: NoticeCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoticeRead>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricNoticesCreate(noticeCreate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AskAgentApi.griegLyricNoticesCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete a notice
     * @param {string} uid Object UID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricNoticesDelete(
      uid: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricNoticesDelete(uid, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AskAgentApi.griegLyricNoticesDelete"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a notice
     * @param {string} uid Object UID
     * @param {GriegLyricNoticesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricNoticesFetch(
      uid: string,
      xApCacheControl?: GriegLyricNoticesFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoticeRead>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricNoticesFetch(uid, xApCacheControl, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AskAgentApi.griegLyricNoticesFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List notices
     * @param {string} [pageToken]
     * @param {number} [limit] The number of items to return
     * @param {GriegLyricNoticesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {boolean} [active] Filter for active items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricNoticesList(
      pageToken?: string,
      limit?: number,
      xApCacheControl?: GriegLyricNoticesListXApCacheControlEnum,
      active?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoticeList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricNoticesList(
        pageToken,
        limit,
        xApCacheControl,
        active,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AskAgentApi.griegLyricNoticesList"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a notice
     * @param {string} uid Object UID
     * @param {NoticeUpdate} [noticeUpdate] Updated details of the notice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricNoticesUpdate(
      uid: string,
      noticeUpdate?: NoticeUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoticeRead>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricNoticesUpdate(uid, noticeUpdate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AskAgentApi.griegLyricNoticesUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AskAgentApi - factory interface
 * @export
 */
export const AskAgentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = AskAgentApiFp(configuration);
  return {
    /**
     *
     * @summary Summarise brands
     * @param {GriegLyricBrandSummaryFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricBrandSummaryFetch(
      xApCacheControl?: GriegLyricBrandSummaryFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<BrandFullListExternal> {
      return localVarFp
        .griegLyricBrandSummaryFetch(xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a brand
     * @param {string} brandSlug
     * @param {BrandCreate} [brandCreate] Details of the new brand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricBrandsCreate(brandSlug: string, brandCreate?: BrandCreate, options?: any): AxiosPromise<BrandRead> {
      return localVarFp
        .griegLyricBrandsCreate(brandSlug, brandCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Set a brand as default
     * @param {string} brandSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricBrandsDefault(brandSlug: string, options?: any): AxiosPromise<void> {
      return localVarFp.griegLyricBrandsDefault(brandSlug, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a brand
     * @param {string} brandSlug
     * @param {GriegLyricBrandsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricBrandsFetch(
      brandSlug: string,
      xApCacheControl?: GriegLyricBrandsFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<BrandReadExternal> {
      return localVarFp
        .griegLyricBrandsFetch(brandSlug, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List brands
     * @param {string} [pageToken]
     * @param {number} [limit] The number of items to return
     * @param {GriegLyricBrandsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {boolean} [active] Filter for active items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricBrandsList(
      pageToken?: string,
      limit?: number,
      xApCacheControl?: GriegLyricBrandsListXApCacheControlEnum,
      active?: boolean,
      options?: any,
    ): AxiosPromise<BrandList> {
      return localVarFp
        .griegLyricBrandsList(pageToken, limit, xApCacheControl, active, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a brand
     * @param {string} brandSlug
     * @param {BrandUpdate} [brandUpdate] Updated details of the brand
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricBrandsUpdate(brandSlug: string, brandUpdate?: BrandUpdate, options?: any): AxiosPromise<BrandRead> {
      return localVarFp
        .griegLyricBrandsUpdate(brandSlug, brandUpdate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Hand-off a call to webchat
     * @param {HandOffSend} [handOffSend] Details of the hand-off request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricHandOffCallWeb(handOffSend?: HandOffSend, options?: any): AxiosPromise<ActionResult> {
      return localVarFp.griegLyricHandOffCallWeb(handOffSend, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Mark a call resolved by IVR
     * @param {IvrResolved} [ivrResolved]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricMarkIvrResolved(ivrResolved?: IvrResolved, options?: any): AxiosPromise<ActionResult> {
      return localVarFp.griegLyricMarkIvrResolved(ivrResolved, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a notice
     * @param {NoticeCreate} [noticeCreate] Details of the new notice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricNoticesCreate(noticeCreate?: NoticeCreate, options?: any): AxiosPromise<NoticeRead> {
      return localVarFp.griegLyricNoticesCreate(noticeCreate, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a notice
     * @param {string} uid Object UID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricNoticesDelete(uid: string, options?: any): AxiosPromise<void> {
      return localVarFp.griegLyricNoticesDelete(uid, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a notice
     * @param {string} uid Object UID
     * @param {GriegLyricNoticesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricNoticesFetch(
      uid: string,
      xApCacheControl?: GriegLyricNoticesFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<NoticeRead> {
      return localVarFp
        .griegLyricNoticesFetch(uid, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List notices
     * @param {string} [pageToken]
     * @param {number} [limit] The number of items to return
     * @param {GriegLyricNoticesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {boolean} [active] Filter for active items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricNoticesList(
      pageToken?: string,
      limit?: number,
      xApCacheControl?: GriegLyricNoticesListXApCacheControlEnum,
      active?: boolean,
      options?: any,
    ): AxiosPromise<NoticeList> {
      return localVarFp
        .griegLyricNoticesList(pageToken, limit, xApCacheControl, active, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a notice
     * @param {string} uid Object UID
     * @param {NoticeUpdate} [noticeUpdate] Updated details of the notice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricNoticesUpdate(uid: string, noticeUpdate?: NoticeUpdate, options?: any): AxiosPromise<NoticeRead> {
      return localVarFp.griegLyricNoticesUpdate(uid, noticeUpdate, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * AskAgentApi - object-oriented interface
 * @export
 * @class AskAgentApi
 * @extends {BaseAPI}
 */
export class AskAgentApi extends BaseAPI {
  /**
   *
   * @summary Summarise brands
   * @param {GriegLyricBrandSummaryFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AskAgentApi
   */
  public griegLyricBrandSummaryFetch(
    xApCacheControl?: GriegLyricBrandSummaryFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return AskAgentApiFp(this.configuration)
      .griegLyricBrandSummaryFetch(xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a brand
   * @param {string} brandSlug
   * @param {BrandCreate} [brandCreate] Details of the new brand
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AskAgentApi
   */
  public griegLyricBrandsCreate(brandSlug: string, brandCreate?: BrandCreate, options?: RawAxiosRequestConfig) {
    return AskAgentApiFp(this.configuration)
      .griegLyricBrandsCreate(brandSlug, brandCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Set a brand as default
   * @param {string} brandSlug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AskAgentApi
   */
  public griegLyricBrandsDefault(brandSlug: string, options?: RawAxiosRequestConfig) {
    return AskAgentApiFp(this.configuration)
      .griegLyricBrandsDefault(brandSlug, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a brand
   * @param {string} brandSlug
   * @param {GriegLyricBrandsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AskAgentApi
   */
  public griegLyricBrandsFetch(
    brandSlug: string,
    xApCacheControl?: GriegLyricBrandsFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return AskAgentApiFp(this.configuration)
      .griegLyricBrandsFetch(brandSlug, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List brands
   * @param {string} [pageToken]
   * @param {number} [limit] The number of items to return
   * @param {GriegLyricBrandsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {boolean} [active] Filter for active items
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AskAgentApi
   */
  public griegLyricBrandsList(
    pageToken?: string,
    limit?: number,
    xApCacheControl?: GriegLyricBrandsListXApCacheControlEnum,
    active?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return AskAgentApiFp(this.configuration)
      .griegLyricBrandsList(pageToken, limit, xApCacheControl, active, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a brand
   * @param {string} brandSlug
   * @param {BrandUpdate} [brandUpdate] Updated details of the brand
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AskAgentApi
   */
  public griegLyricBrandsUpdate(brandSlug: string, brandUpdate?: BrandUpdate, options?: RawAxiosRequestConfig) {
    return AskAgentApiFp(this.configuration)
      .griegLyricBrandsUpdate(brandSlug, brandUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Hand-off a call to webchat
   * @param {HandOffSend} [handOffSend] Details of the hand-off request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AskAgentApi
   */
  public griegLyricHandOffCallWeb(handOffSend?: HandOffSend, options?: RawAxiosRequestConfig) {
    return AskAgentApiFp(this.configuration)
      .griegLyricHandOffCallWeb(handOffSend, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Mark a call resolved by IVR
   * @param {IvrResolved} [ivrResolved]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AskAgentApi
   */
  public griegLyricMarkIvrResolved(ivrResolved?: IvrResolved, options?: RawAxiosRequestConfig) {
    return AskAgentApiFp(this.configuration)
      .griegLyricMarkIvrResolved(ivrResolved, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a notice
   * @param {NoticeCreate} [noticeCreate] Details of the new notice
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AskAgentApi
   */
  public griegLyricNoticesCreate(noticeCreate?: NoticeCreate, options?: RawAxiosRequestConfig) {
    return AskAgentApiFp(this.configuration)
      .griegLyricNoticesCreate(noticeCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete a notice
   * @param {string} uid Object UID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AskAgentApi
   */
  public griegLyricNoticesDelete(uid: string, options?: RawAxiosRequestConfig) {
    return AskAgentApiFp(this.configuration)
      .griegLyricNoticesDelete(uid, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a notice
   * @param {string} uid Object UID
   * @param {GriegLyricNoticesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AskAgentApi
   */
  public griegLyricNoticesFetch(
    uid: string,
    xApCacheControl?: GriegLyricNoticesFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return AskAgentApiFp(this.configuration)
      .griegLyricNoticesFetch(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List notices
   * @param {string} [pageToken]
   * @param {number} [limit] The number of items to return
   * @param {GriegLyricNoticesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {boolean} [active] Filter for active items
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AskAgentApi
   */
  public griegLyricNoticesList(
    pageToken?: string,
    limit?: number,
    xApCacheControl?: GriegLyricNoticesListXApCacheControlEnum,
    active?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return AskAgentApiFp(this.configuration)
      .griegLyricNoticesList(pageToken, limit, xApCacheControl, active, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a notice
   * @param {string} uid Object UID
   * @param {NoticeUpdate} [noticeUpdate] Updated details of the notice
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AskAgentApi
   */
  public griegLyricNoticesUpdate(uid: string, noticeUpdate?: NoticeUpdate, options?: RawAxiosRequestConfig) {
    return AskAgentApiFp(this.configuration)
      .griegLyricNoticesUpdate(uid, noticeUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GriegLyricBrandSummaryFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricBrandSummaryFetchXApCacheControlEnum =
  (typeof GriegLyricBrandSummaryFetchXApCacheControlEnum)[keyof typeof GriegLyricBrandSummaryFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricBrandsFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricBrandsFetchXApCacheControlEnum =
  (typeof GriegLyricBrandsFetchXApCacheControlEnum)[keyof typeof GriegLyricBrandsFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricBrandsListXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricBrandsListXApCacheControlEnum =
  (typeof GriegLyricBrandsListXApCacheControlEnum)[keyof typeof GriegLyricBrandsListXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricNoticesFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricNoticesFetchXApCacheControlEnum =
  (typeof GriegLyricNoticesFetchXApCacheControlEnum)[keyof typeof GriegLyricNoticesFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricNoticesListXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricNoticesListXApCacheControlEnum =
  (typeof GriegLyricNoticesListXApCacheControlEnum)[keyof typeof GriegLyricNoticesListXApCacheControlEnum];

/**
 * AssetsApi - axios parameter creator
 * @export
 */
export const AssetsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get the asset filter values
     * @param {string} xApLang Language
     * @param {GriegLyricAssetFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetFilterValuesFetch: async (
      xApLang: string,
      xApCacheControl?: GriegLyricAssetFilterValuesFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricAssetFilterValuesFetch", "xApLang", xApLang);
      const localVarPath = `/api/v1/asset-filter-values`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new asset note
     * @param {AssetNoteCreate} [assetNoteCreate] Details of the new asset note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetNotesCreate: async (
      assetNoteCreate?: AssetNoteCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/asset-notes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(assetNoteCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a asset note
     * @param {string} uid Object UID
     * @param {AssetNoteUpdate} [assetNoteUpdate] Updated details of the asset note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetNotesUpdate: async (
      uid: string,
      assetNoteUpdate?: AssetNoteUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricAssetNotesUpdate", "uid", uid);
      const localVarPath = `/api/v1/asset-notes/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(assetNoteUpdate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get an asset type
     * @param {string} uid Object UID
     * @param {string} xApLang Language
     * @param {GriegLyricAssetTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetTypesFetch: async (
      uid: string,
      xApLang: string,
      xApCacheControl?: GriegLyricAssetTypesFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricAssetTypesFetch", "uid", uid);
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricAssetTypesFetch", "xApLang", xApLang);
      const localVarPath = `/api/v1/asset-types/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List of asset types
     * @param {string} xApLang Language
     * @param {GriegLyricAssetTypesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetTypesList: async (
      xApLang: string,
      xApCacheControl?: GriegLyricAssetTypesListXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricAssetTypesList", "xApLang", xApLang);
      const localVarPath = `/api/v1/asset-types`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new asset
     * @param {AssetCreate} [assetCreate] Details of the new asset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetsCreate: async (
      assetCreate?: AssetCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/assets`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(assetCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get an asset
     * @param {string} uid Object UID
     * @param {GriegLyricAssetsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetsFetch: async (
      uid: string,
      xApCacheControl?: GriegLyricAssetsFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricAssetsFetch", "uid", uid);
      const localVarPath = `/api/v1/assets/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List assets
     * @param {string} xApLang Language
     * @param {SearchAssetRequest} [searchAssetRequest] Asset search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetsSearch: async (
      xApLang: string,
      searchAssetRequest?: SearchAssetRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricAssetsSearch", "xApLang", xApLang);
      const localVarPath = `/api/v1/assets/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(searchAssetRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update an asset
     * @param {string} uid Object UID
     * @param {AssetUpdate} [assetUpdate] Updated details of the asset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetsUpdate: async (
      uid: string,
      assetUpdate?: AssetUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricAssetsUpdate", "uid", uid);
      const localVarPath = `/api/v1/assets/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(assetUpdate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List of holiday calendars
     * @param {string} xApLang Language
     * @param {number} [offset] The number of items to skip before returning the results
     * @param {number} [limit] The number of items to return
     * @param {GriegLyricHolidayCalendarsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricHolidayCalendarsList: async (
      xApLang: string,
      offset?: number,
      limit?: number,
      xApCacheControl?: GriegLyricHolidayCalendarsListXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricHolidayCalendarsList", "xApLang", xApLang);
      const localVarPath = `/api/v1/holiday-calendars`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (offset !== undefined) {
        localVarQueryParameter["offset"] = offset;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List of service levels
     * @param {string} xApLang Language
     * @param {GriegLyricServiceLevelsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricServiceLevelsList: async (
      xApLang: string,
      xApCacheControl?: GriegLyricServiceLevelsListXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricServiceLevelsList", "xApLang", xApLang);
      const localVarPath = `/api/v1/service-levels`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AssetsApi - functional programming interface
 * @export
 */
export const AssetsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AssetsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get the asset filter values
     * @param {string} xApLang Language
     * @param {GriegLyricAssetFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAssetFilterValuesFetch(
      xApLang: string,
      xApCacheControl?: GriegLyricAssetFilterValuesFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetFilterValuesExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAssetFilterValuesFetch(
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssetsApi.griegLyricAssetFilterValuesFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new asset note
     * @param {AssetNoteCreate} [assetNoteCreate] Details of the new asset note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAssetNotesCreate(
      assetNoteCreate?: AssetNoteCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetNoteWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAssetNotesCreate(assetNoteCreate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssetsApi.griegLyricAssetNotesCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a asset note
     * @param {string} uid Object UID
     * @param {AssetNoteUpdate} [assetNoteUpdate] Updated details of the asset note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAssetNotesUpdate(
      uid: string,
      assetNoteUpdate?: AssetNoteUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetNoteWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAssetNotesUpdate(
        uid,
        assetNoteUpdate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssetsApi.griegLyricAssetNotesUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get an asset type
     * @param {string} uid Object UID
     * @param {string} xApLang Language
     * @param {GriegLyricAssetTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAssetTypesFetch(
      uid: string,
      xApLang: string,
      xApCacheControl?: GriegLyricAssetTypesFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetTypeReadExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAssetTypesFetch(
        uid,
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssetsApi.griegLyricAssetTypesFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List of asset types
     * @param {string} xApLang Language
     * @param {GriegLyricAssetTypesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAssetTypesList(
      xApLang: string,
      xApCacheControl?: GriegLyricAssetTypesListXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetTypeListExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAssetTypesList(
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssetsApi.griegLyricAssetTypesList"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new asset
     * @param {AssetCreate} [assetCreate] Details of the new asset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAssetsCreate(
      assetCreate?: AssetCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAssetsCreate(assetCreate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssetsApi.griegLyricAssetsCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get an asset
     * @param {string} uid Object UID
     * @param {GriegLyricAssetsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAssetsFetch(
      uid: string,
      xApCacheControl?: GriegLyricAssetsFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetReadExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAssetsFetch(uid, xApCacheControl, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssetsApi.griegLyricAssetsFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List assets
     * @param {string} xApLang Language
     * @param {SearchAssetRequest} [searchAssetRequest] Asset search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAssetsSearch(
      xApLang: string,
      searchAssetRequest?: SearchAssetRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchAssetResultExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAssetsSearch(
        xApLang,
        searchAssetRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssetsApi.griegLyricAssetsSearch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update an asset
     * @param {string} uid Object UID
     * @param {AssetUpdate} [assetUpdate] Updated details of the asset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAssetsUpdate(
      uid: string,
      assetUpdate?: AssetUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAssetsUpdate(uid, assetUpdate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssetsApi.griegLyricAssetsUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List of holiday calendars
     * @param {string} xApLang Language
     * @param {number} [offset] The number of items to skip before returning the results
     * @param {number} [limit] The number of items to return
     * @param {GriegLyricHolidayCalendarsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricHolidayCalendarsList(
      xApLang: string,
      offset?: number,
      limit?: number,
      xApCacheControl?: GriegLyricHolidayCalendarsListXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HolidayCalendarList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricHolidayCalendarsList(
        xApLang,
        offset,
        limit,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssetsApi.griegLyricHolidayCalendarsList"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List of service levels
     * @param {string} xApLang Language
     * @param {GriegLyricServiceLevelsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricServiceLevelsList(
      xApLang: string,
      xApCacheControl?: GriegLyricServiceLevelsListXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceLevelList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricServiceLevelsList(
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssetsApi.griegLyricServiceLevelsList"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AssetsApi - factory interface
 * @export
 */
export const AssetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = AssetsApiFp(configuration);
  return {
    /**
     *
     * @summary Get the asset filter values
     * @param {string} xApLang Language
     * @param {GriegLyricAssetFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetFilterValuesFetch(
      xApLang: string,
      xApCacheControl?: GriegLyricAssetFilterValuesFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<AssetFilterValuesExternal> {
      return localVarFp
        .griegLyricAssetFilterValuesFetch(xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new asset note
     * @param {AssetNoteCreate} [assetNoteCreate] Details of the new asset note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetNotesCreate(assetNoteCreate?: AssetNoteCreate, options?: any): AxiosPromise<AssetNoteWriteResponse> {
      return localVarFp
        .griegLyricAssetNotesCreate(assetNoteCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a asset note
     * @param {string} uid Object UID
     * @param {AssetNoteUpdate} [assetNoteUpdate] Updated details of the asset note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetNotesUpdate(
      uid: string,
      assetNoteUpdate?: AssetNoteUpdate,
      options?: any,
    ): AxiosPromise<AssetNoteWriteResponse> {
      return localVarFp
        .griegLyricAssetNotesUpdate(uid, assetNoteUpdate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get an asset type
     * @param {string} uid Object UID
     * @param {string} xApLang Language
     * @param {GriegLyricAssetTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetTypesFetch(
      uid: string,
      xApLang: string,
      xApCacheControl?: GriegLyricAssetTypesFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<AssetTypeReadExternal> {
      return localVarFp
        .griegLyricAssetTypesFetch(uid, xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List of asset types
     * @param {string} xApLang Language
     * @param {GriegLyricAssetTypesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetTypesList(
      xApLang: string,
      xApCacheControl?: GriegLyricAssetTypesListXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<AssetTypeListExternal> {
      return localVarFp
        .griegLyricAssetTypesList(xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new asset
     * @param {AssetCreate} [assetCreate] Details of the new asset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetsCreate(assetCreate?: AssetCreate, options?: any): AxiosPromise<AssetWriteResponse> {
      return localVarFp.griegLyricAssetsCreate(assetCreate, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get an asset
     * @param {string} uid Object UID
     * @param {GriegLyricAssetsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetsFetch(
      uid: string,
      xApCacheControl?: GriegLyricAssetsFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<AssetReadExternal> {
      return localVarFp
        .griegLyricAssetsFetch(uid, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List assets
     * @param {string} xApLang Language
     * @param {SearchAssetRequest} [searchAssetRequest] Asset search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetsSearch(
      xApLang: string,
      searchAssetRequest?: SearchAssetRequest,
      options?: any,
    ): AxiosPromise<SearchAssetResultExternal> {
      return localVarFp
        .griegLyricAssetsSearch(xApLang, searchAssetRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update an asset
     * @param {string} uid Object UID
     * @param {AssetUpdate} [assetUpdate] Updated details of the asset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetsUpdate(uid: string, assetUpdate?: AssetUpdate, options?: any): AxiosPromise<AssetWriteResponse> {
      return localVarFp.griegLyricAssetsUpdate(uid, assetUpdate, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List of holiday calendars
     * @param {string} xApLang Language
     * @param {number} [offset] The number of items to skip before returning the results
     * @param {number} [limit] The number of items to return
     * @param {GriegLyricHolidayCalendarsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricHolidayCalendarsList(
      xApLang: string,
      offset?: number,
      limit?: number,
      xApCacheControl?: GriegLyricHolidayCalendarsListXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<HolidayCalendarList> {
      return localVarFp
        .griegLyricHolidayCalendarsList(xApLang, offset, limit, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List of service levels
     * @param {string} xApLang Language
     * @param {GriegLyricServiceLevelsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricServiceLevelsList(
      xApLang: string,
      xApCacheControl?: GriegLyricServiceLevelsListXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<ServiceLevelList> {
      return localVarFp
        .griegLyricServiceLevelsList(xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AssetsApi - object-oriented interface
 * @export
 * @class AssetsApi
 * @extends {BaseAPI}
 */
export class AssetsApi extends BaseAPI {
  /**
   *
   * @summary Get the asset filter values
   * @param {string} xApLang Language
   * @param {GriegLyricAssetFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public griegLyricAssetFilterValuesFetch(
    xApLang: string,
    xApCacheControl?: GriegLyricAssetFilterValuesFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return AssetsApiFp(this.configuration)
      .griegLyricAssetFilterValuesFetch(xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new asset note
   * @param {AssetNoteCreate} [assetNoteCreate] Details of the new asset note
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public griegLyricAssetNotesCreate(assetNoteCreate?: AssetNoteCreate, options?: RawAxiosRequestConfig) {
    return AssetsApiFp(this.configuration)
      .griegLyricAssetNotesCreate(assetNoteCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a asset note
   * @param {string} uid Object UID
   * @param {AssetNoteUpdate} [assetNoteUpdate] Updated details of the asset note
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public griegLyricAssetNotesUpdate(uid: string, assetNoteUpdate?: AssetNoteUpdate, options?: RawAxiosRequestConfig) {
    return AssetsApiFp(this.configuration)
      .griegLyricAssetNotesUpdate(uid, assetNoteUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get an asset type
   * @param {string} uid Object UID
   * @param {string} xApLang Language
   * @param {GriegLyricAssetTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public griegLyricAssetTypesFetch(
    uid: string,
    xApLang: string,
    xApCacheControl?: GriegLyricAssetTypesFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return AssetsApiFp(this.configuration)
      .griegLyricAssetTypesFetch(uid, xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List of asset types
   * @param {string} xApLang Language
   * @param {GriegLyricAssetTypesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public griegLyricAssetTypesList(
    xApLang: string,
    xApCacheControl?: GriegLyricAssetTypesListXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return AssetsApiFp(this.configuration)
      .griegLyricAssetTypesList(xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new asset
   * @param {AssetCreate} [assetCreate] Details of the new asset
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public griegLyricAssetsCreate(assetCreate?: AssetCreate, options?: RawAxiosRequestConfig) {
    return AssetsApiFp(this.configuration)
      .griegLyricAssetsCreate(assetCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get an asset
   * @param {string} uid Object UID
   * @param {GriegLyricAssetsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public griegLyricAssetsFetch(
    uid: string,
    xApCacheControl?: GriegLyricAssetsFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return AssetsApiFp(this.configuration)
      .griegLyricAssetsFetch(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List assets
   * @param {string} xApLang Language
   * @param {SearchAssetRequest} [searchAssetRequest] Asset search filter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public griegLyricAssetsSearch(
    xApLang: string,
    searchAssetRequest?: SearchAssetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AssetsApiFp(this.configuration)
      .griegLyricAssetsSearch(xApLang, searchAssetRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update an asset
   * @param {string} uid Object UID
   * @param {AssetUpdate} [assetUpdate] Updated details of the asset
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public griegLyricAssetsUpdate(uid: string, assetUpdate?: AssetUpdate, options?: RawAxiosRequestConfig) {
    return AssetsApiFp(this.configuration)
      .griegLyricAssetsUpdate(uid, assetUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List of holiday calendars
   * @param {string} xApLang Language
   * @param {number} [offset] The number of items to skip before returning the results
   * @param {number} [limit] The number of items to return
   * @param {GriegLyricHolidayCalendarsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public griegLyricHolidayCalendarsList(
    xApLang: string,
    offset?: number,
    limit?: number,
    xApCacheControl?: GriegLyricHolidayCalendarsListXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return AssetsApiFp(this.configuration)
      .griegLyricHolidayCalendarsList(xApLang, offset, limit, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List of service levels
   * @param {string} xApLang Language
   * @param {GriegLyricServiceLevelsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsApi
   */
  public griegLyricServiceLevelsList(
    xApLang: string,
    xApCacheControl?: GriegLyricServiceLevelsListXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return AssetsApiFp(this.configuration)
      .griegLyricServiceLevelsList(xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GriegLyricAssetFilterValuesFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricAssetFilterValuesFetchXApCacheControlEnum =
  (typeof GriegLyricAssetFilterValuesFetchXApCacheControlEnum)[keyof typeof GriegLyricAssetFilterValuesFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricAssetTypesFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricAssetTypesFetchXApCacheControlEnum =
  (typeof GriegLyricAssetTypesFetchXApCacheControlEnum)[keyof typeof GriegLyricAssetTypesFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricAssetTypesListXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricAssetTypesListXApCacheControlEnum =
  (typeof GriegLyricAssetTypesListXApCacheControlEnum)[keyof typeof GriegLyricAssetTypesListXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricAssetsFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricAssetsFetchXApCacheControlEnum =
  (typeof GriegLyricAssetsFetchXApCacheControlEnum)[keyof typeof GriegLyricAssetsFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricHolidayCalendarsListXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricHolidayCalendarsListXApCacheControlEnum =
  (typeof GriegLyricHolidayCalendarsListXApCacheControlEnum)[keyof typeof GriegLyricHolidayCalendarsListXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricServiceLevelsListXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricServiceLevelsListXApCacheControlEnum =
  (typeof GriegLyricServiceLevelsListXApCacheControlEnum)[keyof typeof GriegLyricServiceLevelsListXApCacheControlEnum];

/**
 * AssistantApi - axios parameter creator
 * @export
 */
export const AssistantApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get details required to join a webchat
     * @param {JoinChat} [joinChat] Details of the chat to join
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChatJoin: async (joinChat?: JoinChat, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/webchat/join`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(joinChat, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Start a guest chat
     * @param {string} xApLang Language
     * @param {NewConversationTaskTypeExternal} [newConversationTaskTypeExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChatStartGuest: async (
      xApLang: string,
      newConversationTaskTypeExternal?: NewConversationTaskTypeExternal,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricChatStartGuest", "xApLang", xApLang);
      const localVarPath = `/api/v1/webchat/guest-start`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        newConversationTaskTypeExternal,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Start a manager chat
     * @param {string} xApLang Language
     * @param {NewManagerConversationExternal} [newManagerConversationExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChatStartManager: async (
      xApLang: string,
      newManagerConversationExternal?: NewManagerConversationExternal,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricChatStartManager", "xApLang", xApLang);
      const localVarPath = `/api/v1/webchat/manager-start`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        newManagerConversationExternal,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Start an on-site chat
     * @param {string} uid Object UID
     * @param {string} xApLang Language
     * @param {NewConversationAssetExternal} [newConversationAssetExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChatStartOnsite: async (
      uid: string,
      xApLang: string,
      newConversationAssetExternal?: NewConversationAssetExternal,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricChatStartOnsite", "uid", uid);
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricChatStartOnsite", "xApLang", xApLang);
      const localVarPath = `/api/v1/webchat/onsite/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        newConversationAssetExternal,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Start an outbound chat from invite
     * @param {string} xApLang Language
     * @param {NewOutboundConversationExternal} [newOutboundConversationExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChatStartOutbound: async (
      xApLang: string,
      newOutboundConversationExternal?: NewOutboundConversationExternal,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricChatStartOutbound", "xApLang", xApLang);
      const localVarPath = `/api/v1/webchat/outbound-start`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        newOutboundConversationExternal,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Start a principal chat
     * @param {string} xApLang Language
     * @param {NewPrincipalConversationExternal} [newPrincipalConversationExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChatStartPrincipal: async (
      xApLang: string,
      newPrincipalConversationExternal?: NewPrincipalConversationExternal,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricChatStartPrincipal", "xApLang", xApLang);
      const localVarPath = `/api/v1/webchat/principal-start`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        newPrincipalConversationExternal,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Start a chat from a chat start token
     * @param {string} xApLang Language
     * @param {NewTokenConversationExternal} [newTokenConversationExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChatStartToken: async (
      xApLang: string,
      newTokenConversationExternal?: NewTokenConversationExternal,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricChatStartToken", "xApLang", xApLang);
      const localVarPath = `/api/v1/webchat/token-start`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        newTokenConversationExternal,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AssistantApi - functional programming interface
 * @export
 */
export const AssistantApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AssistantApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get details required to join a webchat
     * @param {JoinChat} [joinChat] Details of the chat to join
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricChatJoin(
      joinChat?: JoinChat,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrincipalChatDetails>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricChatJoin(joinChat, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssistantApi.griegLyricChatJoin"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Start a guest chat
     * @param {string} xApLang Language
     * @param {NewConversationTaskTypeExternal} [newConversationTaskTypeExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricChatStartGuest(
      xApLang: string,
      newConversationTaskTypeExternal?: NewConversationTaskTypeExternal,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuestChatDetails>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricChatStartGuest(
        xApLang,
        newConversationTaskTypeExternal,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssistantApi.griegLyricChatStartGuest"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Start a manager chat
     * @param {string} xApLang Language
     * @param {NewManagerConversationExternal} [newManagerConversationExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricChatStartManager(
      xApLang: string,
      newManagerConversationExternal?: NewManagerConversationExternal,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrincipalChatDetails>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricChatStartManager(
        xApLang,
        newManagerConversationExternal,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssistantApi.griegLyricChatStartManager"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Start an on-site chat
     * @param {string} uid Object UID
     * @param {string} xApLang Language
     * @param {NewConversationAssetExternal} [newConversationAssetExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricChatStartOnsite(
      uid: string,
      xApLang: string,
      newConversationAssetExternal?: NewConversationAssetExternal,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetChatDetails>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricChatStartOnsite(
        uid,
        xApLang,
        newConversationAssetExternal,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssistantApi.griegLyricChatStartOnsite"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Start an outbound chat from invite
     * @param {string} xApLang Language
     * @param {NewOutboundConversationExternal} [newOutboundConversationExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricChatStartOutbound(
      xApLang: string,
      newOutboundConversationExternal?: NewOutboundConversationExternal,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuestChatDetails>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricChatStartOutbound(
        xApLang,
        newOutboundConversationExternal,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssistantApi.griegLyricChatStartOutbound"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Start a principal chat
     * @param {string} xApLang Language
     * @param {NewPrincipalConversationExternal} [newPrincipalConversationExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricChatStartPrincipal(
      xApLang: string,
      newPrincipalConversationExternal?: NewPrincipalConversationExternal,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrincipalChatDetails>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricChatStartPrincipal(
        xApLang,
        newPrincipalConversationExternal,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssistantApi.griegLyricChatStartPrincipal"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Start a chat from a chat start token
     * @param {string} xApLang Language
     * @param {NewTokenConversationExternal} [newTokenConversationExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricChatStartToken(
      xApLang: string,
      newTokenConversationExternal?: NewTokenConversationExternal,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrincipalChatDetails>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricChatStartToken(
        xApLang,
        newTokenConversationExternal,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AssistantApi.griegLyricChatStartToken"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AssistantApi - factory interface
 * @export
 */
export const AssistantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = AssistantApiFp(configuration);
  return {
    /**
     *
     * @summary Get details required to join a webchat
     * @param {JoinChat} [joinChat] Details of the chat to join
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChatJoin(joinChat?: JoinChat, options?: any): AxiosPromise<PrincipalChatDetails> {
      return localVarFp.griegLyricChatJoin(joinChat, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Start a guest chat
     * @param {string} xApLang Language
     * @param {NewConversationTaskTypeExternal} [newConversationTaskTypeExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChatStartGuest(
      xApLang: string,
      newConversationTaskTypeExternal?: NewConversationTaskTypeExternal,
      options?: any,
    ): AxiosPromise<GuestChatDetails> {
      return localVarFp
        .griegLyricChatStartGuest(xApLang, newConversationTaskTypeExternal, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Start a manager chat
     * @param {string} xApLang Language
     * @param {NewManagerConversationExternal} [newManagerConversationExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChatStartManager(
      xApLang: string,
      newManagerConversationExternal?: NewManagerConversationExternal,
      options?: any,
    ): AxiosPromise<PrincipalChatDetails> {
      return localVarFp
        .griegLyricChatStartManager(xApLang, newManagerConversationExternal, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Start an on-site chat
     * @param {string} uid Object UID
     * @param {string} xApLang Language
     * @param {NewConversationAssetExternal} [newConversationAssetExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChatStartOnsite(
      uid: string,
      xApLang: string,
      newConversationAssetExternal?: NewConversationAssetExternal,
      options?: any,
    ): AxiosPromise<AssetChatDetails> {
      return localVarFp
        .griegLyricChatStartOnsite(uid, xApLang, newConversationAssetExternal, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Start an outbound chat from invite
     * @param {string} xApLang Language
     * @param {NewOutboundConversationExternal} [newOutboundConversationExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChatStartOutbound(
      xApLang: string,
      newOutboundConversationExternal?: NewOutboundConversationExternal,
      options?: any,
    ): AxiosPromise<GuestChatDetails> {
      return localVarFp
        .griegLyricChatStartOutbound(xApLang, newOutboundConversationExternal, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Start a principal chat
     * @param {string} xApLang Language
     * @param {NewPrincipalConversationExternal} [newPrincipalConversationExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChatStartPrincipal(
      xApLang: string,
      newPrincipalConversationExternal?: NewPrincipalConversationExternal,
      options?: any,
    ): AxiosPromise<PrincipalChatDetails> {
      return localVarFp
        .griegLyricChatStartPrincipal(xApLang, newPrincipalConversationExternal, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Start a chat from a chat start token
     * @param {string} xApLang Language
     * @param {NewTokenConversationExternal} [newTokenConversationExternal] Details of the new chat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChatStartToken(
      xApLang: string,
      newTokenConversationExternal?: NewTokenConversationExternal,
      options?: any,
    ): AxiosPromise<PrincipalChatDetails> {
      return localVarFp
        .griegLyricChatStartToken(xApLang, newTokenConversationExternal, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AssistantApi - object-oriented interface
 * @export
 * @class AssistantApi
 * @extends {BaseAPI}
 */
export class AssistantApi extends BaseAPI {
  /**
   *
   * @summary Get details required to join a webchat
   * @param {JoinChat} [joinChat] Details of the chat to join
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssistantApi
   */
  public griegLyricChatJoin(joinChat?: JoinChat, options?: RawAxiosRequestConfig) {
    return AssistantApiFp(this.configuration)
      .griegLyricChatJoin(joinChat, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Start a guest chat
   * @param {string} xApLang Language
   * @param {NewConversationTaskTypeExternal} [newConversationTaskTypeExternal] Details of the new chat
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssistantApi
   */
  public griegLyricChatStartGuest(
    xApLang: string,
    newConversationTaskTypeExternal?: NewConversationTaskTypeExternal,
    options?: RawAxiosRequestConfig,
  ) {
    return AssistantApiFp(this.configuration)
      .griegLyricChatStartGuest(xApLang, newConversationTaskTypeExternal, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Start a manager chat
   * @param {string} xApLang Language
   * @param {NewManagerConversationExternal} [newManagerConversationExternal] Details of the new chat
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssistantApi
   */
  public griegLyricChatStartManager(
    xApLang: string,
    newManagerConversationExternal?: NewManagerConversationExternal,
    options?: RawAxiosRequestConfig,
  ) {
    return AssistantApiFp(this.configuration)
      .griegLyricChatStartManager(xApLang, newManagerConversationExternal, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Start an on-site chat
   * @param {string} uid Object UID
   * @param {string} xApLang Language
   * @param {NewConversationAssetExternal} [newConversationAssetExternal] Details of the new chat
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssistantApi
   */
  public griegLyricChatStartOnsite(
    uid: string,
    xApLang: string,
    newConversationAssetExternal?: NewConversationAssetExternal,
    options?: RawAxiosRequestConfig,
  ) {
    return AssistantApiFp(this.configuration)
      .griegLyricChatStartOnsite(uid, xApLang, newConversationAssetExternal, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Start an outbound chat from invite
   * @param {string} xApLang Language
   * @param {NewOutboundConversationExternal} [newOutboundConversationExternal] Details of the new chat
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssistantApi
   */
  public griegLyricChatStartOutbound(
    xApLang: string,
    newOutboundConversationExternal?: NewOutboundConversationExternal,
    options?: RawAxiosRequestConfig,
  ) {
    return AssistantApiFp(this.configuration)
      .griegLyricChatStartOutbound(xApLang, newOutboundConversationExternal, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Start a principal chat
   * @param {string} xApLang Language
   * @param {NewPrincipalConversationExternal} [newPrincipalConversationExternal] Details of the new chat
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssistantApi
   */
  public griegLyricChatStartPrincipal(
    xApLang: string,
    newPrincipalConversationExternal?: NewPrincipalConversationExternal,
    options?: RawAxiosRequestConfig,
  ) {
    return AssistantApiFp(this.configuration)
      .griegLyricChatStartPrincipal(xApLang, newPrincipalConversationExternal, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Start a chat from a chat start token
   * @param {string} xApLang Language
   * @param {NewTokenConversationExternal} [newTokenConversationExternal] Details of the new chat
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssistantApi
   */
  public griegLyricChatStartToken(
    xApLang: string,
    newTokenConversationExternal?: NewTokenConversationExternal,
    options?: RawAxiosRequestConfig,
  ) {
    return AssistantApiFp(this.configuration)
      .griegLyricChatStartToken(xApLang, newTokenConversationExternal, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * AutocompleteApi - axios parameter creator
 * @export
 */
export const AutocompleteApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Autocomplete assets
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetsAutocomplete: async (
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/autocomplete/assets`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchAutocompleteRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Autocomplete messages
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricMessagesAutocomplete: async (
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/autocomplete/messages`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchAutocompleteRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Autocomplete orgs
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOrgsAutocomplete: async (
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/autocomplete/orgs`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchAutocompleteRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Autocomplete people
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricPeopleAutocomplete: async (
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/autocomplete/people`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchAutocompleteRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Autocomplete product catalogues
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductCataloguesAutocomplete: async (
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/autocomplete/product-catalogues`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchAutocompleteRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Autocomplete products
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductsAutocomplete: async (
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/autocomplete/products`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchAutocompleteRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Autocomplete tags
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTagsAutocomplete: async (
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/autocomplete/tags`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchAutocompleteRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Autocomplete tasks
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksAutocomplete: async (
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/autocomplete/tasks`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchAutocompleteRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Autocomplete teams
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTeamsAutocomplete: async (
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/autocomplete/teams`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchAutocompleteRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Autocomplete users
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUsersAutocomplete: async (
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/autocomplete/users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchAutocompleteRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AutocompleteApi - functional programming interface
 * @export
 */
export const AutocompleteApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AutocompleteApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Autocomplete assets
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricAssetsAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchAutocompleteResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricAssetsAutocomplete(
        searchAutocompleteRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AutocompleteApi.griegLyricAssetsAutocomplete"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Autocomplete messages
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricMessagesAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchAutocompleteResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricMessagesAutocomplete(
        searchAutocompleteRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AutocompleteApi.griegLyricMessagesAutocomplete"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Autocomplete orgs
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricOrgsAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchAutocompleteResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricOrgsAutocomplete(
        searchAutocompleteRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AutocompleteApi.griegLyricOrgsAutocomplete"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Autocomplete people
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricPeopleAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchAutocompleteResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricPeopleAutocomplete(
        searchAutocompleteRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AutocompleteApi.griegLyricPeopleAutocomplete"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Autocomplete product catalogues
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProductCataloguesAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchAutocompleteResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProductCataloguesAutocomplete(
        searchAutocompleteRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AutocompleteApi.griegLyricProductCataloguesAutocomplete"]?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Autocomplete products
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProductsAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchAutocompleteResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProductsAutocomplete(
        searchAutocompleteRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AutocompleteApi.griegLyricProductsAutocomplete"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Autocomplete tags
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTagsAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchAutocompleteResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTagsAutocomplete(
        searchAutocompleteRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AutocompleteApi.griegLyricTagsAutocomplete"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Autocomplete tasks
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTasksAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchAutocompleteResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTasksAutocomplete(
        searchAutocompleteRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AutocompleteApi.griegLyricTasksAutocomplete"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Autocomplete teams
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTeamsAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchAutocompleteResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTeamsAutocomplete(
        searchAutocompleteRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AutocompleteApi.griegLyricTeamsAutocomplete"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Autocomplete users
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricUsersAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchAutocompleteResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricUsersAutocomplete(
        searchAutocompleteRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["AutocompleteApi.griegLyricUsersAutocomplete"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AutocompleteApi - factory interface
 * @export
 */
export const AutocompleteApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AutocompleteApiFp(configuration);
  return {
    /**
     *
     * @summary Autocomplete assets
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricAssetsAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: any,
    ): AxiosPromise<SearchAutocompleteResult> {
      return localVarFp
        .griegLyricAssetsAutocomplete(searchAutocompleteRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Autocomplete messages
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricMessagesAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: any,
    ): AxiosPromise<SearchAutocompleteResult> {
      return localVarFp
        .griegLyricMessagesAutocomplete(searchAutocompleteRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Autocomplete orgs
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOrgsAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: any,
    ): AxiosPromise<SearchAutocompleteResult> {
      return localVarFp
        .griegLyricOrgsAutocomplete(searchAutocompleteRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Autocomplete people
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricPeopleAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: any,
    ): AxiosPromise<SearchAutocompleteResult> {
      return localVarFp
        .griegLyricPeopleAutocomplete(searchAutocompleteRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Autocomplete product catalogues
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductCataloguesAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: any,
    ): AxiosPromise<SearchAutocompleteResult> {
      return localVarFp
        .griegLyricProductCataloguesAutocomplete(searchAutocompleteRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Autocomplete products
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductsAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: any,
    ): AxiosPromise<SearchAutocompleteResult> {
      return localVarFp
        .griegLyricProductsAutocomplete(searchAutocompleteRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Autocomplete tags
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTagsAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: any,
    ): AxiosPromise<SearchAutocompleteResult> {
      return localVarFp
        .griegLyricTagsAutocomplete(searchAutocompleteRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Autocomplete tasks
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: any,
    ): AxiosPromise<SearchAutocompleteResult> {
      return localVarFp
        .griegLyricTasksAutocomplete(searchAutocompleteRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Autocomplete teams
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTeamsAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: any,
    ): AxiosPromise<SearchAutocompleteResult> {
      return localVarFp
        .griegLyricTeamsAutocomplete(searchAutocompleteRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Autocomplete users
     * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUsersAutocomplete(
      searchAutocompleteRequest?: SearchAutocompleteRequest,
      options?: any,
    ): AxiosPromise<SearchAutocompleteResult> {
      return localVarFp
        .griegLyricUsersAutocomplete(searchAutocompleteRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AutocompleteApi - object-oriented interface
 * @export
 * @class AutocompleteApi
 * @extends {BaseAPI}
 */
export class AutocompleteApi extends BaseAPI {
  /**
   *
   * @summary Autocomplete assets
   * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutocompleteApi
   */
  public griegLyricAssetsAutocomplete(
    searchAutocompleteRequest?: SearchAutocompleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AutocompleteApiFp(this.configuration)
      .griegLyricAssetsAutocomplete(searchAutocompleteRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Autocomplete messages
   * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutocompleteApi
   */
  public griegLyricMessagesAutocomplete(
    searchAutocompleteRequest?: SearchAutocompleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AutocompleteApiFp(this.configuration)
      .griegLyricMessagesAutocomplete(searchAutocompleteRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Autocomplete orgs
   * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutocompleteApi
   */
  public griegLyricOrgsAutocomplete(
    searchAutocompleteRequest?: SearchAutocompleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AutocompleteApiFp(this.configuration)
      .griegLyricOrgsAutocomplete(searchAutocompleteRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Autocomplete people
   * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutocompleteApi
   */
  public griegLyricPeopleAutocomplete(
    searchAutocompleteRequest?: SearchAutocompleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AutocompleteApiFp(this.configuration)
      .griegLyricPeopleAutocomplete(searchAutocompleteRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Autocomplete product catalogues
   * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutocompleteApi
   */
  public griegLyricProductCataloguesAutocomplete(
    searchAutocompleteRequest?: SearchAutocompleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AutocompleteApiFp(this.configuration)
      .griegLyricProductCataloguesAutocomplete(searchAutocompleteRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Autocomplete products
   * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutocompleteApi
   */
  public griegLyricProductsAutocomplete(
    searchAutocompleteRequest?: SearchAutocompleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AutocompleteApiFp(this.configuration)
      .griegLyricProductsAutocomplete(searchAutocompleteRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Autocomplete tags
   * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutocompleteApi
   */
  public griegLyricTagsAutocomplete(
    searchAutocompleteRequest?: SearchAutocompleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AutocompleteApiFp(this.configuration)
      .griegLyricTagsAutocomplete(searchAutocompleteRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Autocomplete tasks
   * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutocompleteApi
   */
  public griegLyricTasksAutocomplete(
    searchAutocompleteRequest?: SearchAutocompleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AutocompleteApiFp(this.configuration)
      .griegLyricTasksAutocomplete(searchAutocompleteRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Autocomplete teams
   * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutocompleteApi
   */
  public griegLyricTeamsAutocomplete(
    searchAutocompleteRequest?: SearchAutocompleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AutocompleteApiFp(this.configuration)
      .griegLyricTeamsAutocomplete(searchAutocompleteRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Autocomplete users
   * @param {SearchAutocompleteRequest} [searchAutocompleteRequest] Request autocompletion suggestions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AutocompleteApi
   */
  public griegLyricUsersAutocomplete(
    searchAutocompleteRequest?: SearchAutocompleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AutocompleteApiFp(this.configuration)
      .griegLyricUsersAutocomplete(searchAutocompleteRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * CallRecordsApi - axios parameter creator
 * @export
 */
export const CallRecordsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get a call record recording
     * @param {string} uid Object UID
     * @param {GriegLyricCallRecordsEventsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricCallRecordsEventsFetch: async (
      uid: string,
      xApCacheControl?: GriegLyricCallRecordsEventsFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricCallRecordsEventsFetch", "uid", uid);
      const localVarPath = `/api/v1/call-records/{uid}/events`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a call record
     * @param {string} uid Object UID
     * @param {GriegLyricCallRecordsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricCallRecordsFetch: async (
      uid: string,
      xApCacheControl?: GriegLyricCallRecordsFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricCallRecordsFetch", "uid", uid);
      const localVarPath = `/api/v1/call-records/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a call record recording
     * @param {string} uid Object UID
     * @param {string} recordingUid Object UID
     * @param {GriegLyricCallRecordsRecordingFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricCallRecordsRecordingFetch: async (
      uid: string,
      recordingUid: string,
      xApCacheControl?: GriegLyricCallRecordsRecordingFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricCallRecordsRecordingFetch", "uid", uid);
      // verify required parameter 'recordingUid' is not null or undefined
      assertParamExists("griegLyricCallRecordsRecordingFetch", "recordingUid", recordingUid);
      const localVarPath = `/api/v1/call-records/{uid}/recordings/{recordingUid}`
        .replace(`{${"uid"}}`, encodeURIComponent(String(uid)))
        .replace(`{${"recordingUid"}}`, encodeURIComponent(String(recordingUid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a call record recording
     * @param {string} uid Object UID
     * @param {string} recordingUid Object UID
     * @param {GriegLyricCallRecordsRecordingTranscriptFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricCallRecordsRecordingTranscriptFetch: async (
      uid: string,
      recordingUid: string,
      xApCacheControl?: GriegLyricCallRecordsRecordingTranscriptFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricCallRecordsRecordingTranscriptFetch", "uid", uid);
      // verify required parameter 'recordingUid' is not null or undefined
      assertParamExists("griegLyricCallRecordsRecordingTranscriptFetch", "recordingUid", recordingUid);
      const localVarPath = `/api/v1/call-records/{uid}/recordings/{recordingUid}/transcript`
        .replace(`{${"uid"}}`, encodeURIComponent(String(uid)))
        .replace(`{${"recordingUid"}}`, encodeURIComponent(String(recordingUid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List call records
     * @param {string} xApLang Language
     * @param {SearchCallRecordRequest} [searchCallRecordRequest] Call record search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricCallRecordsSearch: async (
      xApLang: string,
      searchCallRecordRequest?: SearchCallRecordRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricCallRecordsSearch", "xApLang", xApLang);
      const localVarPath = `/api/v1/call-records/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchCallRecordRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CallRecordsApi - functional programming interface
 * @export
 */
export const CallRecordsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CallRecordsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get a call record recording
     * @param {string} uid Object UID
     * @param {GriegLyricCallRecordsEventsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricCallRecordsEventsFetch(
      uid: string,
      xApCacheControl?: GriegLyricCallRecordsEventsFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallRecordEvents>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricCallRecordsEventsFetch(
        uid,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CallRecordsApi.griegLyricCallRecordsEventsFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a call record
     * @param {string} uid Object UID
     * @param {GriegLyricCallRecordsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricCallRecordsFetch(
      uid: string,
      xApCacheControl?: GriegLyricCallRecordsFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallRecordReadExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricCallRecordsFetch(
        uid,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CallRecordsApi.griegLyricCallRecordsFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a call record recording
     * @param {string} uid Object UID
     * @param {string} recordingUid Object UID
     * @param {GriegLyricCallRecordsRecordingFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricCallRecordsRecordingFetch(
      uid: string,
      recordingUid: string,
      xApCacheControl?: GriegLyricCallRecordsRecordingFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleLocationResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricCallRecordsRecordingFetch(
        uid,
        recordingUid,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CallRecordsApi.griegLyricCallRecordsRecordingFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a call record recording
     * @param {string} uid Object UID
     * @param {string} recordingUid Object UID
     * @param {GriegLyricCallRecordsRecordingTranscriptFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricCallRecordsRecordingTranscriptFetch(
      uid: string,
      recordingUid: string,
      xApCacheControl?: GriegLyricCallRecordsRecordingTranscriptFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CallRecordRecordingTranscript>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricCallRecordsRecordingTranscriptFetch(
        uid,
        recordingUid,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CallRecordsApi.griegLyricCallRecordsRecordingTranscriptFetch"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List call records
     * @param {string} xApLang Language
     * @param {SearchCallRecordRequest} [searchCallRecordRequest] Call record search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricCallRecordsSearch(
      xApLang: string,
      searchCallRecordRequest?: SearchCallRecordRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchCallRecordResultExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricCallRecordsSearch(
        xApLang,
        searchCallRecordRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CallRecordsApi.griegLyricCallRecordsSearch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * CallRecordsApi - factory interface
 * @export
 */
export const CallRecordsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CallRecordsApiFp(configuration);
  return {
    /**
     *
     * @summary Get a call record recording
     * @param {string} uid Object UID
     * @param {GriegLyricCallRecordsEventsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricCallRecordsEventsFetch(
      uid: string,
      xApCacheControl?: GriegLyricCallRecordsEventsFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<CallRecordEvents> {
      return localVarFp
        .griegLyricCallRecordsEventsFetch(uid, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a call record
     * @param {string} uid Object UID
     * @param {GriegLyricCallRecordsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricCallRecordsFetch(
      uid: string,
      xApCacheControl?: GriegLyricCallRecordsFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<CallRecordReadExternal> {
      return localVarFp
        .griegLyricCallRecordsFetch(uid, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a call record recording
     * @param {string} uid Object UID
     * @param {string} recordingUid Object UID
     * @param {GriegLyricCallRecordsRecordingFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricCallRecordsRecordingFetch(
      uid: string,
      recordingUid: string,
      xApCacheControl?: GriegLyricCallRecordsRecordingFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<SimpleLocationResponse> {
      return localVarFp
        .griegLyricCallRecordsRecordingFetch(uid, recordingUid, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a call record recording
     * @param {string} uid Object UID
     * @param {string} recordingUid Object UID
     * @param {GriegLyricCallRecordsRecordingTranscriptFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricCallRecordsRecordingTranscriptFetch(
      uid: string,
      recordingUid: string,
      xApCacheControl?: GriegLyricCallRecordsRecordingTranscriptFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<CallRecordRecordingTranscript> {
      return localVarFp
        .griegLyricCallRecordsRecordingTranscriptFetch(uid, recordingUid, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List call records
     * @param {string} xApLang Language
     * @param {SearchCallRecordRequest} [searchCallRecordRequest] Call record search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricCallRecordsSearch(
      xApLang: string,
      searchCallRecordRequest?: SearchCallRecordRequest,
      options?: any,
    ): AxiosPromise<SearchCallRecordResultExternal> {
      return localVarFp
        .griegLyricCallRecordsSearch(xApLang, searchCallRecordRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * CallRecordsApi - object-oriented interface
 * @export
 * @class CallRecordsApi
 * @extends {BaseAPI}
 */
export class CallRecordsApi extends BaseAPI {
  /**
   *
   * @summary Get a call record recording
   * @param {string} uid Object UID
   * @param {GriegLyricCallRecordsEventsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CallRecordsApi
   */
  public griegLyricCallRecordsEventsFetch(
    uid: string,
    xApCacheControl?: GriegLyricCallRecordsEventsFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return CallRecordsApiFp(this.configuration)
      .griegLyricCallRecordsEventsFetch(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a call record
   * @param {string} uid Object UID
   * @param {GriegLyricCallRecordsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CallRecordsApi
   */
  public griegLyricCallRecordsFetch(
    uid: string,
    xApCacheControl?: GriegLyricCallRecordsFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return CallRecordsApiFp(this.configuration)
      .griegLyricCallRecordsFetch(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a call record recording
   * @param {string} uid Object UID
   * @param {string} recordingUid Object UID
   * @param {GriegLyricCallRecordsRecordingFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CallRecordsApi
   */
  public griegLyricCallRecordsRecordingFetch(
    uid: string,
    recordingUid: string,
    xApCacheControl?: GriegLyricCallRecordsRecordingFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return CallRecordsApiFp(this.configuration)
      .griegLyricCallRecordsRecordingFetch(uid, recordingUid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a call record recording
   * @param {string} uid Object UID
   * @param {string} recordingUid Object UID
   * @param {GriegLyricCallRecordsRecordingTranscriptFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CallRecordsApi
   */
  public griegLyricCallRecordsRecordingTranscriptFetch(
    uid: string,
    recordingUid: string,
    xApCacheControl?: GriegLyricCallRecordsRecordingTranscriptFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return CallRecordsApiFp(this.configuration)
      .griegLyricCallRecordsRecordingTranscriptFetch(uid, recordingUid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List call records
   * @param {string} xApLang Language
   * @param {SearchCallRecordRequest} [searchCallRecordRequest] Call record search filter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CallRecordsApi
   */
  public griegLyricCallRecordsSearch(
    xApLang: string,
    searchCallRecordRequest?: SearchCallRecordRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CallRecordsApiFp(this.configuration)
      .griegLyricCallRecordsSearch(xApLang, searchCallRecordRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GriegLyricCallRecordsEventsFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricCallRecordsEventsFetchXApCacheControlEnum =
  (typeof GriegLyricCallRecordsEventsFetchXApCacheControlEnum)[keyof typeof GriegLyricCallRecordsEventsFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricCallRecordsFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricCallRecordsFetchXApCacheControlEnum =
  (typeof GriegLyricCallRecordsFetchXApCacheControlEnum)[keyof typeof GriegLyricCallRecordsFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricCallRecordsRecordingFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricCallRecordsRecordingFetchXApCacheControlEnum =
  (typeof GriegLyricCallRecordsRecordingFetchXApCacheControlEnum)[keyof typeof GriegLyricCallRecordsRecordingFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricCallRecordsRecordingTranscriptFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricCallRecordsRecordingTranscriptFetchXApCacheControlEnum =
  (typeof GriegLyricCallRecordsRecordingTranscriptFetchXApCacheControlEnum)[keyof typeof GriegLyricCallRecordsRecordingTranscriptFetchXApCacheControlEnum];

/**
 * ExportsApi - axios parameter creator
 * @export
 */
export const ExportsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create an asset export
     * @param {string} xApLang Language
     * @param {GriegLyricExportsAssetCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {AssetExportCreate} [assetExportCreate] Create an asset export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsAssetCreate: async (
      xApLang: string,
      xApCacheControl?: GriegLyricExportsAssetCreateXApCacheControlEnum,
      assetExportCreate?: AssetExportCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricExportsAssetCreate", "xApLang", xApLang);
      const localVarPath = `/api/v1/exports/asset`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(assetExportCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Download a CSV or zip file created by an export
     * @param {string} uid Object UID
     * @param {GriegLyricExportsDownloadXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsDownload: async (
      uid: string,
      xApCacheControl?: GriegLyricExportsDownloadXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricExportsDownload", "uid", uid);
      const localVarPath = `/api/v1/exports/{uid}/download`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Details of an export
     * @param {string} uid Object UID
     * @param {GriegLyricExportsGetXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsGet: async (
      uid: string,
      xApCacheControl?: GriegLyricExportsGetXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricExportsGet", "uid", uid);
      const localVarPath = `/api/v1/exports/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List of exports
     * @param {GriegLyricExportsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsList: async (
      xApCacheControl?: GriegLyricExportsListXApCacheControlEnum,
      pageToken?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/exports`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (pageToken !== undefined) {
        localVarQueryParameter["page_token"] = pageToken;
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create an org export
     * @param {string} xApLang Language
     * @param {GriegLyricExportsOrgCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {OrgExportCreate} [orgExportCreate] Create an org export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsOrgCreate: async (
      xApLang: string,
      xApCacheControl?: GriegLyricExportsOrgCreateXApCacheControlEnum,
      orgExportCreate?: OrgExportCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricExportsOrgCreate", "xApLang", xApLang);
      const localVarPath = `/api/v1/exports/org`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(orgExportCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a task export
     * @param {string} xApLang Language
     * @param {GriegLyricExportsTaskCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {TaskExportCreate} [taskExportCreate] Create a task export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsTaskCreate: async (
      xApLang: string,
      xApCacheControl?: GriegLyricExportsTaskCreateXApCacheControlEnum,
      taskExportCreate?: TaskExportCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricExportsTaskCreate", "xApLang", xApLang);
      const localVarPath = `/api/v1/exports/task`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(taskExportCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create an team export
     * @param {string} xApLang Language
     * @param {GriegLyricExportsTeamCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {TeamExportCreate} [teamExportCreate] Create a team export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsTeamCreate: async (
      xApLang: string,
      xApCacheControl?: GriegLyricExportsTeamCreateXApCacheControlEnum,
      teamExportCreate?: TeamExportCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricExportsTeamCreate", "xApLang", xApLang);
      const localVarPath = `/api/v1/exports/team`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(teamExportCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a user export
     * @param {string} xApLang Language
     * @param {GriegLyricExportsUserCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {UserExportCreate} [userExportCreate] Create a user export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsUserCreate: async (
      xApLang: string,
      xApCacheControl?: GriegLyricExportsUserCreateXApCacheControlEnum,
      userExportCreate?: UserExportCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricExportsUserCreate", "xApLang", xApLang);
      const localVarPath = `/api/v1/exports/user`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userExportCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ExportsApi - functional programming interface
 * @export
 */
export const ExportsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ExportsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create an asset export
     * @param {string} xApLang Language
     * @param {GriegLyricExportsAssetCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {AssetExportCreate} [assetExportCreate] Create an asset export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricExportsAssetCreate(
      xApLang: string,
      xApCacheControl?: GriegLyricExportsAssetCreateXApCacheControlEnum,
      assetExportCreate?: AssetExportCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2011>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricExportsAssetCreate(
        xApLang,
        xApCacheControl,
        assetExportCreate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ExportsApi.griegLyricExportsAssetCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Download a CSV or zip file created by an export
     * @param {string} uid Object UID
     * @param {GriegLyricExportsDownloadXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricExportsDownload(
      uid: string,
      xApCacheControl?: GriegLyricExportsDownloadXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricExportsDownload(
        uid,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ExportsApi.griegLyricExportsDownload"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Details of an export
     * @param {string} uid Object UID
     * @param {GriegLyricExportsGetXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricExportsGet(
      uid: string,
      xApCacheControl?: GriegLyricExportsGetXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricExportsGet(uid, xApCacheControl, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ExportsApi.griegLyricExportsGet"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List of exports
     * @param {GriegLyricExportsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricExportsList(
      xApCacheControl?: GriegLyricExportsListXApCacheControlEnum,
      pageToken?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportsListExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricExportsList(
        xApCacheControl,
        pageToken,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ExportsApi.griegLyricExportsList"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create an org export
     * @param {string} xApLang Language
     * @param {GriegLyricExportsOrgCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {OrgExportCreate} [orgExportCreate] Create an org export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricExportsOrgCreate(
      xApLang: string,
      xApCacheControl?: GriegLyricExportsOrgCreateXApCacheControlEnum,
      orgExportCreate?: OrgExportCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2013>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricExportsOrgCreate(
        xApLang,
        xApCacheControl,
        orgExportCreate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ExportsApi.griegLyricExportsOrgCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a task export
     * @param {string} xApLang Language
     * @param {GriegLyricExportsTaskCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {TaskExportCreate} [taskExportCreate] Create a task export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricExportsTaskCreate(
      xApLang: string,
      xApCacheControl?: GriegLyricExportsTaskCreateXApCacheControlEnum,
      taskExportCreate?: TaskExportCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse201>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricExportsTaskCreate(
        xApLang,
        xApCacheControl,
        taskExportCreate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ExportsApi.griegLyricExportsTaskCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create an team export
     * @param {string} xApLang Language
     * @param {GriegLyricExportsTeamCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {TeamExportCreate} [teamExportCreate] Create a team export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricExportsTeamCreate(
      xApLang: string,
      xApCacheControl?: GriegLyricExportsTeamCreateXApCacheControlEnum,
      teamExportCreate?: TeamExportCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2014>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricExportsTeamCreate(
        xApLang,
        xApCacheControl,
        teamExportCreate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ExportsApi.griegLyricExportsTeamCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a user export
     * @param {string} xApLang Language
     * @param {GriegLyricExportsUserCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {UserExportCreate} [userExportCreate] Create a user export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricExportsUserCreate(
      xApLang: string,
      xApCacheControl?: GriegLyricExportsUserCreateXApCacheControlEnum,
      userExportCreate?: UserExportCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2012>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricExportsUserCreate(
        xApLang,
        xApCacheControl,
        userExportCreate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ExportsApi.griegLyricExportsUserCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ExportsApi - factory interface
 * @export
 */
export const ExportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ExportsApiFp(configuration);
  return {
    /**
     *
     * @summary Create an asset export
     * @param {string} xApLang Language
     * @param {GriegLyricExportsAssetCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {AssetExportCreate} [assetExportCreate] Create an asset export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsAssetCreate(
      xApLang: string,
      xApCacheControl?: GriegLyricExportsAssetCreateXApCacheControlEnum,
      assetExportCreate?: AssetExportCreate,
      options?: any,
    ): AxiosPromise<InlineResponse2011> {
      return localVarFp
        .griegLyricExportsAssetCreate(xApLang, xApCacheControl, assetExportCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Download a CSV or zip file created by an export
     * @param {string} uid Object UID
     * @param {GriegLyricExportsDownloadXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsDownload(
      uid: string,
      xApCacheControl?: GriegLyricExportsDownloadXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<ErrorModel> {
      return localVarFp
        .griegLyricExportsDownload(uid, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Details of an export
     * @param {string} uid Object UID
     * @param {GriegLyricExportsGetXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsGet(
      uid: string,
      xApCacheControl?: GriegLyricExportsGetXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<InlineResponse200> {
      return localVarFp.griegLyricExportsGet(uid, xApCacheControl, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List of exports
     * @param {GriegLyricExportsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {string} [pageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsList(
      xApCacheControl?: GriegLyricExportsListXApCacheControlEnum,
      pageToken?: string,
      options?: any,
    ): AxiosPromise<ExportsListExternal> {
      return localVarFp
        .griegLyricExportsList(xApCacheControl, pageToken, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create an org export
     * @param {string} xApLang Language
     * @param {GriegLyricExportsOrgCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {OrgExportCreate} [orgExportCreate] Create an org export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsOrgCreate(
      xApLang: string,
      xApCacheControl?: GriegLyricExportsOrgCreateXApCacheControlEnum,
      orgExportCreate?: OrgExportCreate,
      options?: any,
    ): AxiosPromise<InlineResponse2013> {
      return localVarFp
        .griegLyricExportsOrgCreate(xApLang, xApCacheControl, orgExportCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a task export
     * @param {string} xApLang Language
     * @param {GriegLyricExportsTaskCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {TaskExportCreate} [taskExportCreate] Create a task export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsTaskCreate(
      xApLang: string,
      xApCacheControl?: GriegLyricExportsTaskCreateXApCacheControlEnum,
      taskExportCreate?: TaskExportCreate,
      options?: any,
    ): AxiosPromise<InlineResponse201> {
      return localVarFp
        .griegLyricExportsTaskCreate(xApLang, xApCacheControl, taskExportCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create an team export
     * @param {string} xApLang Language
     * @param {GriegLyricExportsTeamCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {TeamExportCreate} [teamExportCreate] Create a team export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsTeamCreate(
      xApLang: string,
      xApCacheControl?: GriegLyricExportsTeamCreateXApCacheControlEnum,
      teamExportCreate?: TeamExportCreate,
      options?: any,
    ): AxiosPromise<InlineResponse2014> {
      return localVarFp
        .griegLyricExportsTeamCreate(xApLang, xApCacheControl, teamExportCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a user export
     * @param {string} xApLang Language
     * @param {GriegLyricExportsUserCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {UserExportCreate} [userExportCreate] Create a user export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricExportsUserCreate(
      xApLang: string,
      xApCacheControl?: GriegLyricExportsUserCreateXApCacheControlEnum,
      userExportCreate?: UserExportCreate,
      options?: any,
    ): AxiosPromise<InlineResponse2012> {
      return localVarFp
        .griegLyricExportsUserCreate(xApLang, xApCacheControl, userExportCreate, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ExportsApi - object-oriented interface
 * @export
 * @class ExportsApi
 * @extends {BaseAPI}
 */
export class ExportsApi extends BaseAPI {
  /**
   *
   * @summary Create an asset export
   * @param {string} xApLang Language
   * @param {GriegLyricExportsAssetCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {AssetExportCreate} [assetExportCreate] Create an asset export
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportsApi
   */
  public griegLyricExportsAssetCreate(
    xApLang: string,
    xApCacheControl?: GriegLyricExportsAssetCreateXApCacheControlEnum,
    assetExportCreate?: AssetExportCreate,
    options?: RawAxiosRequestConfig,
  ) {
    return ExportsApiFp(this.configuration)
      .griegLyricExportsAssetCreate(xApLang, xApCacheControl, assetExportCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Download a CSV or zip file created by an export
   * @param {string} uid Object UID
   * @param {GriegLyricExportsDownloadXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportsApi
   */
  public griegLyricExportsDownload(
    uid: string,
    xApCacheControl?: GriegLyricExportsDownloadXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return ExportsApiFp(this.configuration)
      .griegLyricExportsDownload(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Details of an export
   * @param {string} uid Object UID
   * @param {GriegLyricExportsGetXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportsApi
   */
  public griegLyricExportsGet(
    uid: string,
    xApCacheControl?: GriegLyricExportsGetXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return ExportsApiFp(this.configuration)
      .griegLyricExportsGet(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List of exports
   * @param {GriegLyricExportsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {string} [pageToken]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportsApi
   */
  public griegLyricExportsList(
    xApCacheControl?: GriegLyricExportsListXApCacheControlEnum,
    pageToken?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ExportsApiFp(this.configuration)
      .griegLyricExportsList(xApCacheControl, pageToken, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create an org export
   * @param {string} xApLang Language
   * @param {GriegLyricExportsOrgCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {OrgExportCreate} [orgExportCreate] Create an org export
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportsApi
   */
  public griegLyricExportsOrgCreate(
    xApLang: string,
    xApCacheControl?: GriegLyricExportsOrgCreateXApCacheControlEnum,
    orgExportCreate?: OrgExportCreate,
    options?: RawAxiosRequestConfig,
  ) {
    return ExportsApiFp(this.configuration)
      .griegLyricExportsOrgCreate(xApLang, xApCacheControl, orgExportCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a task export
   * @param {string} xApLang Language
   * @param {GriegLyricExportsTaskCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {TaskExportCreate} [taskExportCreate] Create a task export
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportsApi
   */
  public griegLyricExportsTaskCreate(
    xApLang: string,
    xApCacheControl?: GriegLyricExportsTaskCreateXApCacheControlEnum,
    taskExportCreate?: TaskExportCreate,
    options?: RawAxiosRequestConfig,
  ) {
    return ExportsApiFp(this.configuration)
      .griegLyricExportsTaskCreate(xApLang, xApCacheControl, taskExportCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create an team export
   * @param {string} xApLang Language
   * @param {GriegLyricExportsTeamCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {TeamExportCreate} [teamExportCreate] Create a team export
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportsApi
   */
  public griegLyricExportsTeamCreate(
    xApLang: string,
    xApCacheControl?: GriegLyricExportsTeamCreateXApCacheControlEnum,
    teamExportCreate?: TeamExportCreate,
    options?: RawAxiosRequestConfig,
  ) {
    return ExportsApiFp(this.configuration)
      .griegLyricExportsTeamCreate(xApLang, xApCacheControl, teamExportCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a user export
   * @param {string} xApLang Language
   * @param {GriegLyricExportsUserCreateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {UserExportCreate} [userExportCreate] Create a user export
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportsApi
   */
  public griegLyricExportsUserCreate(
    xApLang: string,
    xApCacheControl?: GriegLyricExportsUserCreateXApCacheControlEnum,
    userExportCreate?: UserExportCreate,
    options?: RawAxiosRequestConfig,
  ) {
    return ExportsApiFp(this.configuration)
      .griegLyricExportsUserCreate(xApLang, xApCacheControl, userExportCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GriegLyricExportsAssetCreateXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricExportsAssetCreateXApCacheControlEnum =
  (typeof GriegLyricExportsAssetCreateXApCacheControlEnum)[keyof typeof GriegLyricExportsAssetCreateXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricExportsDownloadXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricExportsDownloadXApCacheControlEnum =
  (typeof GriegLyricExportsDownloadXApCacheControlEnum)[keyof typeof GriegLyricExportsDownloadXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricExportsGetXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricExportsGetXApCacheControlEnum =
  (typeof GriegLyricExportsGetXApCacheControlEnum)[keyof typeof GriegLyricExportsGetXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricExportsListXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricExportsListXApCacheControlEnum =
  (typeof GriegLyricExportsListXApCacheControlEnum)[keyof typeof GriegLyricExportsListXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricExportsOrgCreateXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricExportsOrgCreateXApCacheControlEnum =
  (typeof GriegLyricExportsOrgCreateXApCacheControlEnum)[keyof typeof GriegLyricExportsOrgCreateXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricExportsTaskCreateXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricExportsTaskCreateXApCacheControlEnum =
  (typeof GriegLyricExportsTaskCreateXApCacheControlEnum)[keyof typeof GriegLyricExportsTaskCreateXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricExportsTeamCreateXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricExportsTeamCreateXApCacheControlEnum =
  (typeof GriegLyricExportsTeamCreateXApCacheControlEnum)[keyof typeof GriegLyricExportsTeamCreateXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricExportsUserCreateXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricExportsUserCreateXApCacheControlEnum =
  (typeof GriegLyricExportsUserCreateXApCacheControlEnum)[keyof typeof GriegLyricExportsUserCreateXApCacheControlEnum];

/**
 * FilesApi - axios parameter creator
 * @export
 */
export const FilesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a new file
     * @param {NewFile} [newFile] Request to create a file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricFilesCreate: async (newFile?: NewFile, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/files`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(newFile, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Redirect to a file URL
     * @param {string} uid Object UID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricFilesRedirect: async (uid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricFilesRedirect", "uid", uid);
      const localVarPath = `/api/v1/files/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FilesApi - functional programming interface
 * @export
 */
export const FilesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FilesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a new file
     * @param {NewFile} [newFile] Request to create a file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricFilesCreate(
      newFile?: NewFile,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadData>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricFilesCreate(newFile, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["FilesApi.griegLyricFilesCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Redirect to a file URL
     * @param {string} uid Object UID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricFilesRedirect(
      uid: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricFilesRedirect(uid, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["FilesApi.griegLyricFilesRedirect"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * FilesApi - factory interface
 * @export
 */
export const FilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = FilesApiFp(configuration);
  return {
    /**
     *
     * @summary Create a new file
     * @param {NewFile} [newFile] Request to create a file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricFilesCreate(newFile?: NewFile, options?: any): AxiosPromise<UploadData> {
      return localVarFp.griegLyricFilesCreate(newFile, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Redirect to a file URL
     * @param {string} uid Object UID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricFilesRedirect(uid: string, options?: any): AxiosPromise<ErrorModel> {
      return localVarFp.griegLyricFilesRedirect(uid, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * FilesApi - object-oriented interface
 * @export
 * @class FilesApi
 * @extends {BaseAPI}
 */
export class FilesApi extends BaseAPI {
  /**
   *
   * @summary Create a new file
   * @param {NewFile} [newFile] Request to create a file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FilesApi
   */
  public griegLyricFilesCreate(newFile?: NewFile, options?: RawAxiosRequestConfig) {
    return FilesApiFp(this.configuration)
      .griegLyricFilesCreate(newFile, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Redirect to a file URL
   * @param {string} uid Object UID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FilesApi
   */
  public griegLyricFilesRedirect(uid: string, options?: RawAxiosRequestConfig) {
    return FilesApiFp(this.configuration)
      .griegLyricFilesRedirect(uid, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Perform a health check on the service and return a summary.  If all is healthy, a 200 response is returned.  If the service is capable of responding but there is a detected issue (e.g. DB connection) then a 503 error is returned  Some services may perform additional checks which can be recorded in the `additionalChecks` element - e.g. a database call
     * @summary Service health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricHealth: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/health-check`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration);
  return {
    /**
     * Perform a health check on the service and return a summary.  If all is healthy, a 200 response is returned.  If the service is capable of responding but there is a detected issue (e.g. DB connection) then a 503 error is returned  Some services may perform additional checks which can be recorded in the `additionalChecks` element - e.g. a database call
     * @summary Service health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricHealth(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HealthCheckSummary>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricHealth(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["HealthApi.griegLyricHealth"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = HealthApiFp(configuration);
  return {
    /**
     * Perform a health check on the service and return a summary.  If all is healthy, a 200 response is returned.  If the service is capable of responding but there is a detected issue (e.g. DB connection) then a 503 error is returned  Some services may perform additional checks which can be recorded in the `additionalChecks` element - e.g. a database call
     * @summary Service health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricHealth(options?: any): AxiosPromise<HealthCheckSummary> {
      return localVarFp.griegLyricHealth(options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
  /**
   * Perform a health check on the service and return a summary.  If all is healthy, a 200 response is returned.  If the service is capable of responding but there is a detected issue (e.g. DB connection) then a 503 error is returned  Some services may perform additional checks which can be recorded in the `additionalChecks` element - e.g. a database call
   * @summary Service health check
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HealthApi
   */
  public griegLyricHealth(options?: RawAxiosRequestConfig) {
    return HealthApiFp(this.configuration)
      .griegLyricHealth(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MessagesApi - axios parameter creator
 * @export
 */
export const MessagesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get read only details of a conversation
     * @param {string} uid Object UID
     * @param {GriegLyricTaskMessagesConversationsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskMessagesConversationsFetch: async (
      uid: string,
      xApCacheControl?: GriegLyricTaskMessagesConversationsFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricTaskMessagesConversationsFetch", "uid", uid);
      const localVarPath = `/api/v1/task-messages/conversations/{uid}`.replace(
        `{${"uid"}}`,
        encodeURIComponent(String(uid)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List / search task messages
     * @param {SearchMessageRequest} [searchMessageRequest] Message search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskMessagesSearch: async (
      searchMessageRequest?: SearchMessageRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/task-messages/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(searchMessageRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new thread
     * @param {ThreadSendRequest} [threadSendRequest] Details of the new thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskMessagesThreadsCreate: async (
      threadSendRequest?: ThreadSendRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/task-messages/threads`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(threadSendRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Reply to a thread
     * @param {string} uid Object UID
     * @param {MessageSendRequest} [messageSendRequest] Details of the reply to a thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskMessagesThreadsReply: async (
      uid: string,
      messageSendRequest?: MessageSendRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricTaskMessagesThreadsReply", "uid", uid);
      const localVarPath = `/api/v1/task-messages/threads/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(messageSendRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a message thread
     * @param {string} uid Object UID
     * @param {GriegLyricTaskMessagesThreadsUpdateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskMessagesThreadsUpdate: async (
      uid: string,
      xApCacheControl?: GriegLyricTaskMessagesThreadsUpdateXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricTaskMessagesThreadsUpdate", "uid", uid);
      const localVarPath = `/api/v1/task-messages/threads/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Mark a thread as read / unread
     * @param {string} uid Object UID
     * @param {SetUnreadRequest} [setUnreadRequest] Thread to mark as read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskMessagesThreadsUpdateRead: async (
      uid: string,
      setUnreadRequest?: SetUnreadRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricTaskMessagesThreadsUpdateRead", "uid", uid);
      const localVarPath = `/api/v1/task-messages/threads/{uid}/read`.replace(
        `{${"uid"}}`,
        encodeURIComponent(String(uid)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(setUnreadRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MessagesApi - functional programming interface
 * @export
 */
export const MessagesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MessagesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get read only details of a conversation
     * @param {string} uid Object UID
     * @param {GriegLyricTaskMessagesConversationsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskMessagesConversationsFetch(
      uid: string,
      xApCacheControl?: GriegLyricTaskMessagesConversationsFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationRecordExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskMessagesConversationsFetch(
        uid,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MessagesApi.griegLyricTaskMessagesConversationsFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List / search task messages
     * @param {SearchMessageRequest} [searchMessageRequest] Message search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskMessagesSearch(
      searchMessageRequest?: SearchMessageRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchMessageResultExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskMessagesSearch(
        searchMessageRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MessagesApi.griegLyricTaskMessagesSearch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new thread
     * @param {ThreadSendRequest} [threadSendRequest] Details of the new thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskMessagesThreadsCreate(
      threadSendRequest?: ThreadSendRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadGetResponseExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskMessagesThreadsCreate(
        threadSendRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MessagesApi.griegLyricTaskMessagesThreadsCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Reply to a thread
     * @param {string} uid Object UID
     * @param {MessageSendRequest} [messageSendRequest] Details of the reply to a thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskMessagesThreadsReply(
      uid: string,
      messageSendRequest?: MessageSendRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadGetResponseExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskMessagesThreadsReply(
        uid,
        messageSendRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MessagesApi.griegLyricTaskMessagesThreadsReply"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a message thread
     * @param {string} uid Object UID
     * @param {GriegLyricTaskMessagesThreadsUpdateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskMessagesThreadsUpdate(
      uid: string,
      xApCacheControl?: GriegLyricTaskMessagesThreadsUpdateXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadGetResponseExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskMessagesThreadsUpdate(
        uid,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MessagesApi.griegLyricTaskMessagesThreadsUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Mark a thread as read / unread
     * @param {string} uid Object UID
     * @param {SetUnreadRequest} [setUnreadRequest] Thread to mark as read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskMessagesThreadsUpdateRead(
      uid: string,
      setUnreadRequest?: SetUnreadRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskMessagesThreadsUpdateRead(
        uid,
        setUnreadRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MessagesApi.griegLyricTaskMessagesThreadsUpdateRead"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MessagesApi - factory interface
 * @export
 */
export const MessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = MessagesApiFp(configuration);
  return {
    /**
     *
     * @summary Get read only details of a conversation
     * @param {string} uid Object UID
     * @param {GriegLyricTaskMessagesConversationsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskMessagesConversationsFetch(
      uid: string,
      xApCacheControl?: GriegLyricTaskMessagesConversationsFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<ConversationRecordExternal> {
      return localVarFp
        .griegLyricTaskMessagesConversationsFetch(uid, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List / search task messages
     * @param {SearchMessageRequest} [searchMessageRequest] Message search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskMessagesSearch(
      searchMessageRequest?: SearchMessageRequest,
      options?: any,
    ): AxiosPromise<SearchMessageResultExternal> {
      return localVarFp
        .griegLyricTaskMessagesSearch(searchMessageRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new thread
     * @param {ThreadSendRequest} [threadSendRequest] Details of the new thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskMessagesThreadsCreate(
      threadSendRequest?: ThreadSendRequest,
      options?: any,
    ): AxiosPromise<ThreadGetResponseExternal> {
      return localVarFp
        .griegLyricTaskMessagesThreadsCreate(threadSendRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Reply to a thread
     * @param {string} uid Object UID
     * @param {MessageSendRequest} [messageSendRequest] Details of the reply to a thread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskMessagesThreadsReply(
      uid: string,
      messageSendRequest?: MessageSendRequest,
      options?: any,
    ): AxiosPromise<ThreadGetResponseExternal> {
      return localVarFp
        .griegLyricTaskMessagesThreadsReply(uid, messageSendRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a message thread
     * @param {string} uid Object UID
     * @param {GriegLyricTaskMessagesThreadsUpdateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskMessagesThreadsUpdate(
      uid: string,
      xApCacheControl?: GriegLyricTaskMessagesThreadsUpdateXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<ThreadGetResponseExternal> {
      return localVarFp
        .griegLyricTaskMessagesThreadsUpdate(uid, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Mark a thread as read / unread
     * @param {string} uid Object UID
     * @param {SetUnreadRequest} [setUnreadRequest] Thread to mark as read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskMessagesThreadsUpdateRead(
      uid: string,
      setUnreadRequest?: SetUnreadRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .griegLyricTaskMessagesThreadsUpdateRead(uid, setUnreadRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MessagesApi - object-oriented interface
 * @export
 * @class MessagesApi
 * @extends {BaseAPI}
 */
export class MessagesApi extends BaseAPI {
  /**
   *
   * @summary Get read only details of a conversation
   * @param {string} uid Object UID
   * @param {GriegLyricTaskMessagesConversationsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessagesApi
   */
  public griegLyricTaskMessagesConversationsFetch(
    uid: string,
    xApCacheControl?: GriegLyricTaskMessagesConversationsFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return MessagesApiFp(this.configuration)
      .griegLyricTaskMessagesConversationsFetch(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List / search task messages
   * @param {SearchMessageRequest} [searchMessageRequest] Message search filter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessagesApi
   */
  public griegLyricTaskMessagesSearch(searchMessageRequest?: SearchMessageRequest, options?: RawAxiosRequestConfig) {
    return MessagesApiFp(this.configuration)
      .griegLyricTaskMessagesSearch(searchMessageRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new thread
   * @param {ThreadSendRequest} [threadSendRequest] Details of the new thread
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessagesApi
   */
  public griegLyricTaskMessagesThreadsCreate(threadSendRequest?: ThreadSendRequest, options?: RawAxiosRequestConfig) {
    return MessagesApiFp(this.configuration)
      .griegLyricTaskMessagesThreadsCreate(threadSendRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Reply to a thread
   * @param {string} uid Object UID
   * @param {MessageSendRequest} [messageSendRequest] Details of the reply to a thread
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessagesApi
   */
  public griegLyricTaskMessagesThreadsReply(
    uid: string,
    messageSendRequest?: MessageSendRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MessagesApiFp(this.configuration)
      .griegLyricTaskMessagesThreadsReply(uid, messageSendRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a message thread
   * @param {string} uid Object UID
   * @param {GriegLyricTaskMessagesThreadsUpdateXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessagesApi
   */
  public griegLyricTaskMessagesThreadsUpdate(
    uid: string,
    xApCacheControl?: GriegLyricTaskMessagesThreadsUpdateXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return MessagesApiFp(this.configuration)
      .griegLyricTaskMessagesThreadsUpdate(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Mark a thread as read / unread
   * @param {string} uid Object UID
   * @param {SetUnreadRequest} [setUnreadRequest] Thread to mark as read
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessagesApi
   */
  public griegLyricTaskMessagesThreadsUpdateRead(
    uid: string,
    setUnreadRequest?: SetUnreadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MessagesApiFp(this.configuration)
      .griegLyricTaskMessagesThreadsUpdateRead(uid, setUnreadRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GriegLyricTaskMessagesConversationsFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricTaskMessagesConversationsFetchXApCacheControlEnum =
  (typeof GriegLyricTaskMessagesConversationsFetchXApCacheControlEnum)[keyof typeof GriegLyricTaskMessagesConversationsFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricTaskMessagesThreadsUpdateXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricTaskMessagesThreadsUpdateXApCacheControlEnum =
  (typeof GriegLyricTaskMessagesThreadsUpdateXApCacheControlEnum)[keyof typeof GriegLyricTaskMessagesThreadsUpdateXApCacheControlEnum];

/**
 * PeopleApi - axios parameter creator
 * @export
 */
export const PeopleApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get channel preference types
     * @param {string} xApLang Language
     * @param {GriegLyricChannelPreferenceTypesXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChannelPreferenceTypes: async (
      xApLang: string,
      xApCacheControl?: GriegLyricChannelPreferenceTypesXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricChannelPreferenceTypes", "xApLang", xApLang);
      const localVarPath = `/api/v1/channel-preference-types`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a contact and unregistered user
     * @param {ContactIdentityRecord} [contactIdentityRecord] Details of the new contact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricContactsCreate: async (
      contactIdentityRecord?: ContactIdentityRecord,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/contacts`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(contactIdentityRecord, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get the org filter values
     * @param {string} xApLang Language
     * @param {GriegLyricOrgFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOrgFilterValuesFetch: async (
      xApLang: string,
      xApCacheControl?: GriegLyricOrgFilterValuesFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricOrgFilterValuesFetch", "xApLang", xApLang);
      const localVarPath = `/api/v1/org-filter-values`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get org type specific metadata config
     * @param {OrgTypeSlug} orgTypeSlug Org Type Slug
     * @param {string} xApLang Language
     * @param {GriegLyricOrgTypeEmdFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOrgTypeEmdFetch: async (
      orgTypeSlug: OrgTypeSlug,
      xApLang: string,
      xApCacheControl?: GriegLyricOrgTypeEmdFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgTypeSlug' is not null or undefined
      assertParamExists("griegLyricOrgTypeEmdFetch", "orgTypeSlug", orgTypeSlug);
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricOrgTypeEmdFetch", "xApLang", xApLang);
      const localVarPath = `/api/v1/org-ext-metadata/{orgTypeSlug}`.replace(
        `{${"orgTypeSlug"}}`,
        encodeURIComponent(String(orgTypeSlug)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new org
     * @param {OrgCreate} [orgCreate] Details of the new org
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOrgsCreate: async (orgCreate?: OrgCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/orgs`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(orgCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a org
     * @param {string} uid Object UID
     * @param {GriegLyricOrgsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOrgsFetch: async (
      uid: string,
      xApCacheControl?: GriegLyricOrgsFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricOrgsFetch", "uid", uid);
      const localVarPath = `/api/v1/orgs/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List orgs
     * @param {string} xApLang Language
     * @param {SearchOrgRequest} [searchOrgRequest] Org search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOrgsSearch: async (
      xApLang: string,
      searchOrgRequest?: SearchOrgRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricOrgsSearch", "xApLang", xApLang);
      const localVarPath = `/api/v1/orgs/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(searchOrgRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a org
     * @param {string} uid Object UID
     * @param {OrgUpdate} [orgUpdate] Updated details of the org
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOrgsUpdate: async (
      uid: string,
      orgUpdate?: OrgUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricOrgsUpdate", "uid", uid);
      const localVarPath = `/api/v1/orgs/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(orgUpdate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List people (users/teams/orgs)
     * @param {string} xApLang Language
     * @param {SearchPeopleRequest} [searchPeopleRequest] People search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricPeopleSearch: async (
      xApLang: string,
      searchPeopleRequest?: SearchPeopleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricPeopleSearch", "xApLang", xApLang);
      const localVarPath = `/api/v1/people/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(searchPeopleRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get the current users profile
     * @param {string} [k] Arbitary query string used to cache bust
     * @param {GriegLyricProfileFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProfileFetch: async (
      k?: string,
      xApCacheControl?: GriegLyricProfileFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/profile`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (k !== undefined) {
        localVarQueryParameter["k"] = k;
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update the current users profile
     * @param {ProfileUpdateExternal} [profileUpdateExternal] Updated details of the profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProfileUpdate: async (
      profileUpdateExternal?: ProfileUpdateExternal,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/profile`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(profileUpdateExternal, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get role specific metadata config
     * @param {RoleSlug} roleSlug Role Slug
     * @param {string} xApLang Language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricRoleEmdFetch: async (
      roleSlug: RoleSlug,
      xApLang: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'roleSlug' is not null or undefined
      assertParamExists("griegLyricRoleEmdFetch", "roleSlug", roleSlug);
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricRoleEmdFetch", "xApLang", xApLang);
      const localVarPath = `/api/v1/role-ext-metadata/{roleSlug}`.replace(
        `{${"roleSlug"}}`,
        encodeURIComponent(String(roleSlug)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new team
     * @param {TeamCreate} [teamCreate] Details of the new team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTeamsCreate: async (
      teamCreate?: TeamCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/teams`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(teamCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a team
     * @param {string} uid Object UID
     * @param {GriegLyricTeamsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTeamsFetch: async (
      uid: string,
      xApCacheControl?: GriegLyricTeamsFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricTeamsFetch", "uid", uid);
      const localVarPath = `/api/v1/teams/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List teams
     * @param {string} xApLang Language
     * @param {SearchTeamRequest} [searchTeamRequest] Team search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTeamsSearch: async (
      xApLang: string,
      searchTeamRequest?: SearchTeamRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricTeamsSearch", "xApLang", xApLang);
      const localVarPath = `/api/v1/teams/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(searchTeamRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a team
     * @param {string} uid Object UID
     * @param {TeamUpdate} [teamUpdate] Updated details of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTeamsUpdate: async (
      uid: string,
      teamUpdate?: TeamUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricTeamsUpdate", "uid", uid);
      const localVarPath = `/api/v1/teams/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(teamUpdate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Disable a user currently enabled
     * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserAdminDisable: async (
      userAdminSimple?: UserAdminSimple,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/user-admin/disable`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userAdminSimple, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Enable a user currently disabled
     * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserAdminEnable: async (
      userAdminSimple?: UserAdminSimple,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/user-admin/enable`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userAdminSimple, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Trigger a password reset for the user and invalidate current sessions
     * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserAdminForceResetPassword: async (
      userAdminSimple?: UserAdminSimple,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/user-admin/force-reset-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userAdminSimple, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Invite a new user
     * @param {UserInvite} [userInvite] Invite user request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserAdminInvite: async (
      userInvite?: UserInvite,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/user-admin/invite`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userInvite, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Resend an invite to a new user
     * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserAdminReinvite: async (
      userAdminSimple?: UserAdminSimple,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/user-admin/reinvite`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userAdminSimple, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Trigger a password reset for the user
     * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserAdminResetPassword: async (
      userAdminSimple?: UserAdminSimple,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/user-admin/reset-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userAdminSimple, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Change a users role
     * @param {UserRoleChangeSimple} [userRoleChangeSimple] Details of the new user note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserAdminRoleChange: async (
      userRoleChangeSimple?: UserRoleChangeSimple,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/user-admin/role-change`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userRoleChangeSimple, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get the user filter values
     * @param {string} xApLang Language
     * @param {GriegLyricUserFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserFilterValuesFetch: async (
      xApLang: string,
      xApCacheControl?: GriegLyricUserFilterValuesFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricUserFilterValuesFetch", "xApLang", xApLang);
      const localVarPath = `/api/v1/user-filter-values`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new user note
     * @param {UserNoteCreate} [userNoteCreate] Details of the new user note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserNotesCreate: async (
      userNoteCreate?: UserNoteCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/user-notes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userNoteCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a user note
     * @param {string} uid Object UID
     * @param {UserNoteUpdate} [userNoteUpdate] Updated details of the user note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserNotesUpdate: async (
      uid: string,
      userNoteUpdate?: UserNoteUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricUserNotesUpdate", "uid", uid);
      const localVarPath = `/api/v1/user-notes/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userNoteUpdate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a user
     * @param {string} uid Object UID
     * @param {GriegLyricUsersFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUsersFetch: async (
      uid: string,
      xApCacheControl?: GriegLyricUsersFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricUsersFetch", "uid", uid);
      const localVarPath = `/api/v1/users/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List users
     * @param {string} xApLang Language
     * @param {SearchUserRequest} [searchUserRequest] User search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUsersSearch: async (
      xApLang: string,
      searchUserRequest?: SearchUserRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricUsersSearch", "xApLang", xApLang);
      const localVarPath = `/api/v1/users/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(searchUserRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a user
     * @param {string} uid Object UID
     * @param {UserUpdateExternal} [userUpdateExternal] Updated details of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUsersUpdate: async (
      uid: string,
      userUpdateExternal?: UserUpdateExternal,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricUsersUpdate", "uid", uid);
      const localVarPath = `/api/v1/users/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userUpdateExternal, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PeopleApi - functional programming interface
 * @export
 */
export const PeopleApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PeopleApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get channel preference types
     * @param {string} xApLang Language
     * @param {GriegLyricChannelPreferenceTypesXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricChannelPreferenceTypes(
      xApLang: string,
      xApCacheControl?: GriegLyricChannelPreferenceTypesXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChannelPreferenceTypeListExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricChannelPreferenceTypes(
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricChannelPreferenceTypes"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a contact and unregistered user
     * @param {ContactIdentityRecord} [contactIdentityRecord] Details of the new contact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricContactsCreate(
      contactIdentityRecord?: ContactIdentityRecord,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactIdentityCreateResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricContactsCreate(
        contactIdentityRecord,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricContactsCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get the org filter values
     * @param {string} xApLang Language
     * @param {GriegLyricOrgFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricOrgFilterValuesFetch(
      xApLang: string,
      xApCacheControl?: GriegLyricOrgFilterValuesFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgFilterValuesExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricOrgFilterValuesFetch(
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricOrgFilterValuesFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get org type specific metadata config
     * @param {OrgTypeSlug} orgTypeSlug Org Type Slug
     * @param {string} xApLang Language
     * @param {GriegLyricOrgTypeEmdFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricOrgTypeEmdFetch(
      orgTypeSlug: OrgTypeSlug,
      xApLang: string,
      xApCacheControl?: GriegLyricOrgTypeEmdFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgTypeExtMetadataReadExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricOrgTypeEmdFetch(
        orgTypeSlug,
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricOrgTypeEmdFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new org
     * @param {OrgCreate} [orgCreate] Details of the new org
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricOrgsCreate(
      orgCreate?: OrgCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricOrgsCreate(orgCreate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricOrgsCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a org
     * @param {string} uid Object UID
     * @param {GriegLyricOrgsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricOrgsFetch(
      uid: string,
      xApCacheControl?: GriegLyricOrgsFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgReadExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricOrgsFetch(uid, xApCacheControl, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricOrgsFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List orgs
     * @param {string} xApLang Language
     * @param {SearchOrgRequest} [searchOrgRequest] Org search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricOrgsSearch(
      xApLang: string,
      searchOrgRequest?: SearchOrgRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchOrgResultExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricOrgsSearch(
        xApLang,
        searchOrgRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricOrgsSearch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a org
     * @param {string} uid Object UID
     * @param {OrgUpdate} [orgUpdate] Updated details of the org
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricOrgsUpdate(
      uid: string,
      orgUpdate?: OrgUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrgWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricOrgsUpdate(uid, orgUpdate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricOrgsUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List people (users/teams/orgs)
     * @param {string} xApLang Language
     * @param {SearchPeopleRequest} [searchPeopleRequest] People search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricPeopleSearch(
      xApLang: string,
      searchPeopleRequest?: SearchPeopleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchPeopleResultExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricPeopleSearch(
        xApLang,
        searchPeopleRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricPeopleSearch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get the current users profile
     * @param {string} [k] Arbitary query string used to cache bust
     * @param {GriegLyricProfileFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProfileFetch(
      k?: string,
      xApCacheControl?: GriegLyricProfileFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileReadExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProfileFetch(k, xApCacheControl, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricProfileFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update the current users profile
     * @param {ProfileUpdateExternal} [profileUpdateExternal] Updated details of the profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProfileUpdate(
      profileUpdateExternal?: ProfileUpdateExternal,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProfileUpdate(profileUpdateExternal, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricProfileUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get role specific metadata config
     * @param {RoleSlug} roleSlug Role Slug
     * @param {string} xApLang Language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricRoleEmdFetch(
      roleSlug: RoleSlug,
      xApLang: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleExtMetadataReadExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricRoleEmdFetch(roleSlug, xApLang, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricRoleEmdFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new team
     * @param {TeamCreate} [teamCreate] Details of the new team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTeamsCreate(
      teamCreate?: TeamCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTeamsCreate(teamCreate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricTeamsCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a team
     * @param {string} uid Object UID
     * @param {GriegLyricTeamsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTeamsFetch(
      uid: string,
      xApCacheControl?: GriegLyricTeamsFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamReadExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTeamsFetch(uid, xApCacheControl, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricTeamsFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List teams
     * @param {string} xApLang Language
     * @param {SearchTeamRequest} [searchTeamRequest] Team search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTeamsSearch(
      xApLang: string,
      searchTeamRequest?: SearchTeamRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchTeamResultExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTeamsSearch(
        xApLang,
        searchTeamRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricTeamsSearch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a team
     * @param {string} uid Object UID
     * @param {TeamUpdate} [teamUpdate] Updated details of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTeamsUpdate(
      uid: string,
      teamUpdate?: TeamUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTeamsUpdate(uid, teamUpdate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricTeamsUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Disable a user currently enabled
     * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricUserAdminDisable(
      userAdminSimple?: UserAdminSimple,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricUserAdminDisable(userAdminSimple, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricUserAdminDisable"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Enable a user currently disabled
     * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricUserAdminEnable(
      userAdminSimple?: UserAdminSimple,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricUserAdminEnable(userAdminSimple, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricUserAdminEnable"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Trigger a password reset for the user and invalidate current sessions
     * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricUserAdminForceResetPassword(
      userAdminSimple?: UserAdminSimple,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricUserAdminForceResetPassword(
        userAdminSimple,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricUserAdminForceResetPassword"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Invite a new user
     * @param {UserInvite} [userInvite] Invite user request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricUserAdminInvite(
      userInvite?: UserInvite,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricUserAdminInvite(userInvite, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricUserAdminInvite"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Resend an invite to a new user
     * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricUserAdminReinvite(
      userAdminSimple?: UserAdminSimple,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricUserAdminReinvite(userAdminSimple, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricUserAdminReinvite"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Trigger a password reset for the user
     * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricUserAdminResetPassword(
      userAdminSimple?: UserAdminSimple,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricUserAdminResetPassword(
        userAdminSimple,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricUserAdminResetPassword"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Change a users role
     * @param {UserRoleChangeSimple} [userRoleChangeSimple] Details of the new user note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricUserAdminRoleChange(
      userRoleChangeSimple?: UserRoleChangeSimple,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricUserAdminRoleChange(
        userRoleChangeSimple,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricUserAdminRoleChange"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get the user filter values
     * @param {string} xApLang Language
     * @param {GriegLyricUserFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricUserFilterValuesFetch(
      xApLang: string,
      xApCacheControl?: GriegLyricUserFilterValuesFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserFilterValuesExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricUserFilterValuesFetch(
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricUserFilterValuesFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new user note
     * @param {UserNoteCreate} [userNoteCreate] Details of the new user note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricUserNotesCreate(
      userNoteCreate?: UserNoteCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNoteWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricUserNotesCreate(userNoteCreate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricUserNotesCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a user note
     * @param {string} uid Object UID
     * @param {UserNoteUpdate} [userNoteUpdate] Updated details of the user note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricUserNotesUpdate(
      uid: string,
      userNoteUpdate?: UserNoteUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNoteWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricUserNotesUpdate(uid, userNoteUpdate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricUserNotesUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a user
     * @param {string} uid Object UID
     * @param {GriegLyricUsersFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricUsersFetch(
      uid: string,
      xApCacheControl?: GriegLyricUsersFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserReadExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricUsersFetch(uid, xApCacheControl, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricUsersFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List users
     * @param {string} xApLang Language
     * @param {SearchUserRequest} [searchUserRequest] User search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricUsersSearch(
      xApLang: string,
      searchUserRequest?: SearchUserRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchUserResultExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricUsersSearch(
        xApLang,
        searchUserRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricUsersSearch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a user
     * @param {string} uid Object UID
     * @param {UserUpdateExternal} [userUpdateExternal] Updated details of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricUsersUpdate(
      uid: string,
      userUpdateExternal?: UserUpdateExternal,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricUsersUpdate(uid, userUpdateExternal, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PeopleApi.griegLyricUsersUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PeopleApi - factory interface
 * @export
 */
export const PeopleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = PeopleApiFp(configuration);
  return {
    /**
     *
     * @summary Get channel preference types
     * @param {string} xApLang Language
     * @param {GriegLyricChannelPreferenceTypesXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricChannelPreferenceTypes(
      xApLang: string,
      xApCacheControl?: GriegLyricChannelPreferenceTypesXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<ChannelPreferenceTypeListExternal> {
      return localVarFp
        .griegLyricChannelPreferenceTypes(xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a contact and unregistered user
     * @param {ContactIdentityRecord} [contactIdentityRecord] Details of the new contact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricContactsCreate(
      contactIdentityRecord?: ContactIdentityRecord,
      options?: any,
    ): AxiosPromise<ContactIdentityCreateResponse> {
      return localVarFp
        .griegLyricContactsCreate(contactIdentityRecord, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get the org filter values
     * @param {string} xApLang Language
     * @param {GriegLyricOrgFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOrgFilterValuesFetch(
      xApLang: string,
      xApCacheControl?: GriegLyricOrgFilterValuesFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<OrgFilterValuesExternal> {
      return localVarFp
        .griegLyricOrgFilterValuesFetch(xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get org type specific metadata config
     * @param {OrgTypeSlug} orgTypeSlug Org Type Slug
     * @param {string} xApLang Language
     * @param {GriegLyricOrgTypeEmdFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOrgTypeEmdFetch(
      orgTypeSlug: OrgTypeSlug,
      xApLang: string,
      xApCacheControl?: GriegLyricOrgTypeEmdFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<OrgTypeExtMetadataReadExternal> {
      return localVarFp
        .griegLyricOrgTypeEmdFetch(orgTypeSlug, xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new org
     * @param {OrgCreate} [orgCreate] Details of the new org
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOrgsCreate(orgCreate?: OrgCreate, options?: any): AxiosPromise<OrgWriteResponse> {
      return localVarFp.griegLyricOrgsCreate(orgCreate, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a org
     * @param {string} uid Object UID
     * @param {GriegLyricOrgsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOrgsFetch(
      uid: string,
      xApCacheControl?: GriegLyricOrgsFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<OrgReadExternal> {
      return localVarFp.griegLyricOrgsFetch(uid, xApCacheControl, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List orgs
     * @param {string} xApLang Language
     * @param {SearchOrgRequest} [searchOrgRequest] Org search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOrgsSearch(
      xApLang: string,
      searchOrgRequest?: SearchOrgRequest,
      options?: any,
    ): AxiosPromise<SearchOrgResultExternal> {
      return localVarFp
        .griegLyricOrgsSearch(xApLang, searchOrgRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a org
     * @param {string} uid Object UID
     * @param {OrgUpdate} [orgUpdate] Updated details of the org
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOrgsUpdate(uid: string, orgUpdate?: OrgUpdate, options?: any): AxiosPromise<OrgWriteResponse> {
      return localVarFp.griegLyricOrgsUpdate(uid, orgUpdate, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List people (users/teams/orgs)
     * @param {string} xApLang Language
     * @param {SearchPeopleRequest} [searchPeopleRequest] People search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricPeopleSearch(
      xApLang: string,
      searchPeopleRequest?: SearchPeopleRequest,
      options?: any,
    ): AxiosPromise<SearchPeopleResultExternal> {
      return localVarFp
        .griegLyricPeopleSearch(xApLang, searchPeopleRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get the current users profile
     * @param {string} [k] Arbitary query string used to cache bust
     * @param {GriegLyricProfileFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProfileFetch(
      k?: string,
      xApCacheControl?: GriegLyricProfileFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<ProfileReadExternal> {
      return localVarFp.griegLyricProfileFetch(k, xApCacheControl, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update the current users profile
     * @param {ProfileUpdateExternal} [profileUpdateExternal] Updated details of the profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProfileUpdate(
      profileUpdateExternal?: ProfileUpdateExternal,
      options?: any,
    ): AxiosPromise<UserWriteResponse> {
      return localVarFp
        .griegLyricProfileUpdate(profileUpdateExternal, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get role specific metadata config
     * @param {RoleSlug} roleSlug Role Slug
     * @param {string} xApLang Language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricRoleEmdFetch(
      roleSlug: RoleSlug,
      xApLang: string,
      options?: any,
    ): AxiosPromise<RoleExtMetadataReadExternal> {
      return localVarFp.griegLyricRoleEmdFetch(roleSlug, xApLang, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new team
     * @param {TeamCreate} [teamCreate] Details of the new team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTeamsCreate(teamCreate?: TeamCreate, options?: any): AxiosPromise<TeamWriteResponse> {
      return localVarFp.griegLyricTeamsCreate(teamCreate, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a team
     * @param {string} uid Object UID
     * @param {GriegLyricTeamsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTeamsFetch(
      uid: string,
      xApCacheControl?: GriegLyricTeamsFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<TeamReadExternal> {
      return localVarFp.griegLyricTeamsFetch(uid, xApCacheControl, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List teams
     * @param {string} xApLang Language
     * @param {SearchTeamRequest} [searchTeamRequest] Team search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTeamsSearch(
      xApLang: string,
      searchTeamRequest?: SearchTeamRequest,
      options?: any,
    ): AxiosPromise<SearchTeamResultExternal> {
      return localVarFp
        .griegLyricTeamsSearch(xApLang, searchTeamRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a team
     * @param {string} uid Object UID
     * @param {TeamUpdate} [teamUpdate] Updated details of the team
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTeamsUpdate(uid: string, teamUpdate?: TeamUpdate, options?: any): AxiosPromise<TeamWriteResponse> {
      return localVarFp.griegLyricTeamsUpdate(uid, teamUpdate, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Disable a user currently enabled
     * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserAdminDisable(userAdminSimple?: UserAdminSimple, options?: any): AxiosPromise<ErrorModel> {
      return localVarFp
        .griegLyricUserAdminDisable(userAdminSimple, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Enable a user currently disabled
     * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserAdminEnable(userAdminSimple?: UserAdminSimple, options?: any): AxiosPromise<ErrorModel> {
      return localVarFp.griegLyricUserAdminEnable(userAdminSimple, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Trigger a password reset for the user and invalidate current sessions
     * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserAdminForceResetPassword(userAdminSimple?: UserAdminSimple, options?: any): AxiosPromise<ErrorModel> {
      return localVarFp
        .griegLyricUserAdminForceResetPassword(userAdminSimple, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Invite a new user
     * @param {UserInvite} [userInvite] Invite user request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserAdminInvite(userInvite?: UserInvite, options?: any): AxiosPromise<ErrorModel> {
      return localVarFp.griegLyricUserAdminInvite(userInvite, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Resend an invite to a new user
     * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserAdminReinvite(userAdminSimple?: UserAdminSimple, options?: any): AxiosPromise<ErrorModel> {
      return localVarFp
        .griegLyricUserAdminReinvite(userAdminSimple, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Trigger a password reset for the user
     * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserAdminResetPassword(userAdminSimple?: UserAdminSimple, options?: any): AxiosPromise<ErrorModel> {
      return localVarFp
        .griegLyricUserAdminResetPassword(userAdminSimple, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Change a users role
     * @param {UserRoleChangeSimple} [userRoleChangeSimple] Details of the new user note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserAdminRoleChange(
      userRoleChangeSimple?: UserRoleChangeSimple,
      options?: any,
    ): AxiosPromise<ErrorModel> {
      return localVarFp
        .griegLyricUserAdminRoleChange(userRoleChangeSimple, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get the user filter values
     * @param {string} xApLang Language
     * @param {GriegLyricUserFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserFilterValuesFetch(
      xApLang: string,
      xApCacheControl?: GriegLyricUserFilterValuesFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<UserFilterValuesExternal> {
      return localVarFp
        .griegLyricUserFilterValuesFetch(xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new user note
     * @param {UserNoteCreate} [userNoteCreate] Details of the new user note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserNotesCreate(userNoteCreate?: UserNoteCreate, options?: any): AxiosPromise<UserNoteWriteResponse> {
      return localVarFp.griegLyricUserNotesCreate(userNoteCreate, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a user note
     * @param {string} uid Object UID
     * @param {UserNoteUpdate} [userNoteUpdate] Updated details of the user note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUserNotesUpdate(
      uid: string,
      userNoteUpdate?: UserNoteUpdate,
      options?: any,
    ): AxiosPromise<UserNoteWriteResponse> {
      return localVarFp
        .griegLyricUserNotesUpdate(uid, userNoteUpdate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a user
     * @param {string} uid Object UID
     * @param {GriegLyricUsersFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUsersFetch(
      uid: string,
      xApCacheControl?: GriegLyricUsersFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<UserReadExternal> {
      return localVarFp.griegLyricUsersFetch(uid, xApCacheControl, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List users
     * @param {string} xApLang Language
     * @param {SearchUserRequest} [searchUserRequest] User search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUsersSearch(
      xApLang: string,
      searchUserRequest?: SearchUserRequest,
      options?: any,
    ): AxiosPromise<SearchUserResultExternal> {
      return localVarFp
        .griegLyricUsersSearch(xApLang, searchUserRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a user
     * @param {string} uid Object UID
     * @param {UserUpdateExternal} [userUpdateExternal] Updated details of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricUsersUpdate(
      uid: string,
      userUpdateExternal?: UserUpdateExternal,
      options?: any,
    ): AxiosPromise<UserWriteResponse> {
      return localVarFp
        .griegLyricUsersUpdate(uid, userUpdateExternal, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PeopleApi - object-oriented interface
 * @export
 * @class PeopleApi
 * @extends {BaseAPI}
 */
export class PeopleApi extends BaseAPI {
  /**
   *
   * @summary Get channel preference types
   * @param {string} xApLang Language
   * @param {GriegLyricChannelPreferenceTypesXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricChannelPreferenceTypes(
    xApLang: string,
    xApCacheControl?: GriegLyricChannelPreferenceTypesXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return PeopleApiFp(this.configuration)
      .griegLyricChannelPreferenceTypes(xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a contact and unregistered user
   * @param {ContactIdentityRecord} [contactIdentityRecord] Details of the new contact
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricContactsCreate(contactIdentityRecord?: ContactIdentityRecord, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricContactsCreate(contactIdentityRecord, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get the org filter values
   * @param {string} xApLang Language
   * @param {GriegLyricOrgFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricOrgFilterValuesFetch(
    xApLang: string,
    xApCacheControl?: GriegLyricOrgFilterValuesFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return PeopleApiFp(this.configuration)
      .griegLyricOrgFilterValuesFetch(xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get org type specific metadata config
   * @param {OrgTypeSlug} orgTypeSlug Org Type Slug
   * @param {string} xApLang Language
   * @param {GriegLyricOrgTypeEmdFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricOrgTypeEmdFetch(
    orgTypeSlug: OrgTypeSlug,
    xApLang: string,
    xApCacheControl?: GriegLyricOrgTypeEmdFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return PeopleApiFp(this.configuration)
      .griegLyricOrgTypeEmdFetch(orgTypeSlug, xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new org
   * @param {OrgCreate} [orgCreate] Details of the new org
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricOrgsCreate(orgCreate?: OrgCreate, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricOrgsCreate(orgCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a org
   * @param {string} uid Object UID
   * @param {GriegLyricOrgsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricOrgsFetch(
    uid: string,
    xApCacheControl?: GriegLyricOrgsFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return PeopleApiFp(this.configuration)
      .griegLyricOrgsFetch(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List orgs
   * @param {string} xApLang Language
   * @param {SearchOrgRequest} [searchOrgRequest] Org search filter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricOrgsSearch(xApLang: string, searchOrgRequest?: SearchOrgRequest, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricOrgsSearch(xApLang, searchOrgRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a org
   * @param {string} uid Object UID
   * @param {OrgUpdate} [orgUpdate] Updated details of the org
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricOrgsUpdate(uid: string, orgUpdate?: OrgUpdate, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricOrgsUpdate(uid, orgUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List people (users/teams/orgs)
   * @param {string} xApLang Language
   * @param {SearchPeopleRequest} [searchPeopleRequest] People search filter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricPeopleSearch(
    xApLang: string,
    searchPeopleRequest?: SearchPeopleRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PeopleApiFp(this.configuration)
      .griegLyricPeopleSearch(xApLang, searchPeopleRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get the current users profile
   * @param {string} [k] Arbitary query string used to cache bust
   * @param {GriegLyricProfileFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricProfileFetch(
    k?: string,
    xApCacheControl?: GriegLyricProfileFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return PeopleApiFp(this.configuration)
      .griegLyricProfileFetch(k, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update the current users profile
   * @param {ProfileUpdateExternal} [profileUpdateExternal] Updated details of the profile
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricProfileUpdate(profileUpdateExternal?: ProfileUpdateExternal, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricProfileUpdate(profileUpdateExternal, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get role specific metadata config
   * @param {RoleSlug} roleSlug Role Slug
   * @param {string} xApLang Language
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricRoleEmdFetch(roleSlug: RoleSlug, xApLang: string, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricRoleEmdFetch(roleSlug, xApLang, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new team
   * @param {TeamCreate} [teamCreate] Details of the new team
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricTeamsCreate(teamCreate?: TeamCreate, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricTeamsCreate(teamCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a team
   * @param {string} uid Object UID
   * @param {GriegLyricTeamsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricTeamsFetch(
    uid: string,
    xApCacheControl?: GriegLyricTeamsFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return PeopleApiFp(this.configuration)
      .griegLyricTeamsFetch(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List teams
   * @param {string} xApLang Language
   * @param {SearchTeamRequest} [searchTeamRequest] Team search filter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricTeamsSearch(
    xApLang: string,
    searchTeamRequest?: SearchTeamRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PeopleApiFp(this.configuration)
      .griegLyricTeamsSearch(xApLang, searchTeamRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a team
   * @param {string} uid Object UID
   * @param {TeamUpdate} [teamUpdate] Updated details of the team
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricTeamsUpdate(uid: string, teamUpdate?: TeamUpdate, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricTeamsUpdate(uid, teamUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Disable a user currently enabled
   * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricUserAdminDisable(userAdminSimple?: UserAdminSimple, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricUserAdminDisable(userAdminSimple, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Enable a user currently disabled
   * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricUserAdminEnable(userAdminSimple?: UserAdminSimple, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricUserAdminEnable(userAdminSimple, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Trigger a password reset for the user and invalidate current sessions
   * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricUserAdminForceResetPassword(userAdminSimple?: UserAdminSimple, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricUserAdminForceResetPassword(userAdminSimple, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Invite a new user
   * @param {UserInvite} [userInvite] Invite user request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricUserAdminInvite(userInvite?: UserInvite, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricUserAdminInvite(userInvite, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Resend an invite to a new user
   * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricUserAdminReinvite(userAdminSimple?: UserAdminSimple, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricUserAdminReinvite(userAdminSimple, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Trigger a password reset for the user
   * @param {UserAdminSimple} [userAdminSimple] Generic user admin request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricUserAdminResetPassword(userAdminSimple?: UserAdminSimple, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricUserAdminResetPassword(userAdminSimple, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Change a users role
   * @param {UserRoleChangeSimple} [userRoleChangeSimple] Details of the new user note
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricUserAdminRoleChange(userRoleChangeSimple?: UserRoleChangeSimple, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricUserAdminRoleChange(userRoleChangeSimple, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get the user filter values
   * @param {string} xApLang Language
   * @param {GriegLyricUserFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricUserFilterValuesFetch(
    xApLang: string,
    xApCacheControl?: GriegLyricUserFilterValuesFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return PeopleApiFp(this.configuration)
      .griegLyricUserFilterValuesFetch(xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new user note
   * @param {UserNoteCreate} [userNoteCreate] Details of the new user note
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricUserNotesCreate(userNoteCreate?: UserNoteCreate, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricUserNotesCreate(userNoteCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a user note
   * @param {string} uid Object UID
   * @param {UserNoteUpdate} [userNoteUpdate] Updated details of the user note
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricUserNotesUpdate(uid: string, userNoteUpdate?: UserNoteUpdate, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricUserNotesUpdate(uid, userNoteUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a user
   * @param {string} uid Object UID
   * @param {GriegLyricUsersFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricUsersFetch(
    uid: string,
    xApCacheControl?: GriegLyricUsersFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return PeopleApiFp(this.configuration)
      .griegLyricUsersFetch(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List users
   * @param {string} xApLang Language
   * @param {SearchUserRequest} [searchUserRequest] User search filter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricUsersSearch(
    xApLang: string,
    searchUserRequest?: SearchUserRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PeopleApiFp(this.configuration)
      .griegLyricUsersSearch(xApLang, searchUserRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a user
   * @param {string} uid Object UID
   * @param {UserUpdateExternal} [userUpdateExternal] Updated details of the user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PeopleApi
   */
  public griegLyricUsersUpdate(uid: string, userUpdateExternal?: UserUpdateExternal, options?: RawAxiosRequestConfig) {
    return PeopleApiFp(this.configuration)
      .griegLyricUsersUpdate(uid, userUpdateExternal, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GriegLyricChannelPreferenceTypesXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricChannelPreferenceTypesXApCacheControlEnum =
  (typeof GriegLyricChannelPreferenceTypesXApCacheControlEnum)[keyof typeof GriegLyricChannelPreferenceTypesXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricOrgFilterValuesFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricOrgFilterValuesFetchXApCacheControlEnum =
  (typeof GriegLyricOrgFilterValuesFetchXApCacheControlEnum)[keyof typeof GriegLyricOrgFilterValuesFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricOrgTypeEmdFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricOrgTypeEmdFetchXApCacheControlEnum =
  (typeof GriegLyricOrgTypeEmdFetchXApCacheControlEnum)[keyof typeof GriegLyricOrgTypeEmdFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricOrgsFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricOrgsFetchXApCacheControlEnum =
  (typeof GriegLyricOrgsFetchXApCacheControlEnum)[keyof typeof GriegLyricOrgsFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricProfileFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricProfileFetchXApCacheControlEnum =
  (typeof GriegLyricProfileFetchXApCacheControlEnum)[keyof typeof GriegLyricProfileFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricTeamsFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricTeamsFetchXApCacheControlEnum =
  (typeof GriegLyricTeamsFetchXApCacheControlEnum)[keyof typeof GriegLyricTeamsFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricUserFilterValuesFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricUserFilterValuesFetchXApCacheControlEnum =
  (typeof GriegLyricUserFilterValuesFetchXApCacheControlEnum)[keyof typeof GriegLyricUserFilterValuesFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricUsersFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricUsersFetchXApCacheControlEnum =
  (typeof GriegLyricUsersFetchXApCacheControlEnum)[keyof typeof GriegLyricUsersFetchXApCacheControlEnum];

/**
 * PoliciesApi - axios parameter creator
 * @export
 */
export const PoliciesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Check the access to an object
     * @param {PolicyCheckExternal} [policyCheckExternal] Details of the policy check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricPolicyCheck: async (
      policyCheckExternal?: PolicyCheckExternal,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/policy-check`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(policyCheckExternal, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PoliciesApi - functional programming interface
 * @export
 */
export const PoliciesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PoliciesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Check the access to an object
     * @param {PolicyCheckExternal} [policyCheckExternal] Details of the policy check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricPolicyCheck(
      policyCheckExternal?: PolicyCheckExternal,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyAnswer>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricPolicyCheck(policyCheckExternal, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PoliciesApi.griegLyricPolicyCheck"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PoliciesApi - factory interface
 * @export
 */
export const PoliciesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = PoliciesApiFp(configuration);
  return {
    /**
     *
     * @summary Check the access to an object
     * @param {PolicyCheckExternal} [policyCheckExternal] Details of the policy check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricPolicyCheck(policyCheckExternal?: PolicyCheckExternal, options?: any): AxiosPromise<PolicyAnswer> {
      return localVarFp.griegLyricPolicyCheck(policyCheckExternal, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * PoliciesApi - object-oriented interface
 * @export
 * @class PoliciesApi
 * @extends {BaseAPI}
 */
export class PoliciesApi extends BaseAPI {
  /**
   *
   * @summary Check the access to an object
   * @param {PolicyCheckExternal} [policyCheckExternal] Details of the policy check
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PoliciesApi
   */
  public griegLyricPolicyCheck(policyCheckExternal?: PolicyCheckExternal, options?: RawAxiosRequestConfig) {
    return PoliciesApiFp(this.configuration)
      .griegLyricPolicyCheck(policyCheckExternal, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary List of offerings
     * @param {string} xApLang Language
     * @param {GriegLyricOfferingsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOfferingsList: async (
      xApLang: string,
      xApCacheControl?: GriegLyricOfferingsListXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricOfferingsList", "xApLang", xApLang);
      const localVarPath = `/api/v1/offerings`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new product catalogue
     * @param {ProductCatalogueCreate} [productCatalogueCreate] Details of the new product catalogue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductCataloguesCreate: async (
      productCatalogueCreate?: ProductCatalogueCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/product-catalogues`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        productCatalogueCreate,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a product catalogue
     * @param {string} uid Object UID
     * @param {GriegLyricProductCataloguesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductCataloguesFetch: async (
      uid: string,
      xApCacheControl?: GriegLyricProductCataloguesFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricProductCataloguesFetch", "uid", uid);
      const localVarPath = `/api/v1/product-catalogues/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a product catalogue with price resolution
     * @param {string} uid Object UID
     * @param {GriegLyricProductCataloguesFetchResolvedXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductCataloguesFetchResolved: async (
      uid: string,
      xApCacheControl?: GriegLyricProductCataloguesFetchResolvedXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricProductCataloguesFetchResolved", "uid", uid);
      const localVarPath = `/api/v1/product-catalogues-resolved/{uid}`.replace(
        `{${"uid"}}`,
        encodeURIComponent(String(uid)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List product catalogues
     * @param {string} xApLang Language
     * @param {SearchProductCatalogueRequest} [searchProductCatalogueRequest] Product catalogue search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductCataloguesSearch: async (
      xApLang: string,
      searchProductCatalogueRequest?: SearchProductCatalogueRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricProductCataloguesSearch", "xApLang", xApLang);
      const localVarPath = `/api/v1/product-catalogues/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchProductCatalogueRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a product catalogue
     * @param {string} uid Object UID
     * @param {ProductCatalogueUpdate} [productCatalogueUpdate] Updated details of the product catalogue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductCataloguesUpdate: async (
      uid: string,
      productCatalogueUpdate?: ProductCatalogueUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricProductCataloguesUpdate", "uid", uid);
      const localVarPath = `/api/v1/product-catalogues/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        productCatalogueUpdate,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get the product filter values
     * @param {string} xApLang Language
     * @param {GriegLyricProductFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductFilterValuesFetch: async (
      xApLang: string,
      xApCacheControl?: GriegLyricProductFilterValuesFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricProductFilterValuesFetch", "xApLang", xApLang);
      const localVarPath = `/api/v1/product-filter-values`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Product type details
     * @param {string} uid Object UID
     * @param {string} xApLang Language
     * @param {GriegLyricProductTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductTypesFetch: async (
      uid: string,
      xApLang: string,
      xApCacheControl?: GriegLyricProductTypesFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricProductTypesFetch", "uid", uid);
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricProductTypesFetch", "xApLang", xApLang);
      const localVarPath = `/api/v1/product-types/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List of product types
     * @param {string} xApLang Language
     * @param {GriegLyricProductTypesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductTypesList: async (
      xApLang: string,
      xApCacheControl?: GriegLyricProductTypesListXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricProductTypesList", "xApLang", xApLang);
      const localVarPath = `/api/v1/product-types`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new product
     * @param {ProductCreate} [productCreate] Details of the new product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductsCreate: async (
      productCreate?: ProductCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/products`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(productCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a product
     * @param {string} uid Object UID
     * @param {GriegLyricProductsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductsFetch: async (
      uid: string,
      xApCacheControl?: GriegLyricProductsFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricProductsFetch", "uid", uid);
      const localVarPath = `/api/v1/products/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List products
     * @param {string} xApLang Language
     * @param {SearchProductRequest} [searchProductRequest] Product search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductsSearch: async (
      xApLang: string,
      searchProductRequest?: SearchProductRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricProductsSearch", "xApLang", xApLang);
      const localVarPath = `/api/v1/products/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(searchProductRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a product
     * @param {string} uid Object UID
     * @param {ProductUpdate} [productUpdate] Updated details of the
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductsUpdate: async (
      uid: string,
      productUpdate?: ProductUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricProductsUpdate", "uid", uid);
      const localVarPath = `/api/v1/products/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(productUpdate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary List of offerings
     * @param {string} xApLang Language
     * @param {GriegLyricOfferingsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricOfferingsList(
      xApLang: string,
      xApCacheControl?: GriegLyricOfferingsListXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferingListExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricOfferingsList(
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ProductsApi.griegLyricOfferingsList"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new product catalogue
     * @param {ProductCatalogueCreate} [productCatalogueCreate] Details of the new product catalogue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProductCataloguesCreate(
      productCatalogueCreate?: ProductCatalogueCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCatalogueWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProductCataloguesCreate(
        productCatalogueCreate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ProductsApi.griegLyricProductCataloguesCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a product catalogue
     * @param {string} uid Object UID
     * @param {GriegLyricProductCataloguesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProductCataloguesFetch(
      uid: string,
      xApCacheControl?: GriegLyricProductCataloguesFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCatalogueReadAdminExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProductCataloguesFetch(
        uid,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ProductsApi.griegLyricProductCataloguesFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a product catalogue with price resolution
     * @param {string} uid Object UID
     * @param {GriegLyricProductCataloguesFetchResolvedXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProductCataloguesFetchResolved(
      uid: string,
      xApCacheControl?: GriegLyricProductCataloguesFetchResolvedXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCatalogueReadExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProductCataloguesFetchResolved(
        uid,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ProductsApi.griegLyricProductCataloguesFetchResolved"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List product catalogues
     * @param {string} xApLang Language
     * @param {SearchProductCatalogueRequest} [searchProductCatalogueRequest] Product catalogue search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProductCataloguesSearch(
      xApLang: string,
      searchProductCatalogueRequest?: SearchProductCatalogueRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchProductCatalogueResultExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProductCataloguesSearch(
        xApLang,
        searchProductCatalogueRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ProductsApi.griegLyricProductCataloguesSearch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a product catalogue
     * @param {string} uid Object UID
     * @param {ProductCatalogueUpdate} [productCatalogueUpdate] Updated details of the product catalogue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProductCataloguesUpdate(
      uid: string,
      productCatalogueUpdate?: ProductCatalogueUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCatalogueWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProductCataloguesUpdate(
        uid,
        productCatalogueUpdate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ProductsApi.griegLyricProductCataloguesUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get the product filter values
     * @param {string} xApLang Language
     * @param {GriegLyricProductFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProductFilterValuesFetch(
      xApLang: string,
      xApCacheControl?: GriegLyricProductFilterValuesFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductFilterValuesExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProductFilterValuesFetch(
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ProductsApi.griegLyricProductFilterValuesFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Product type details
     * @param {string} uid Object UID
     * @param {string} xApLang Language
     * @param {GriegLyricProductTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProductTypesFetch(
      uid: string,
      xApLang: string,
      xApCacheControl?: GriegLyricProductTypesFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductTypeReadExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProductTypesFetch(
        uid,
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ProductsApi.griegLyricProductTypesFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List of product types
     * @param {string} xApLang Language
     * @param {GriegLyricProductTypesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProductTypesList(
      xApLang: string,
      xApCacheControl?: GriegLyricProductTypesListXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductTypeListExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProductTypesList(
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ProductsApi.griegLyricProductTypesList"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new product
     * @param {ProductCreate} [productCreate] Details of the new product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProductsCreate(
      productCreate?: ProductCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProductsCreate(productCreate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ProductsApi.griegLyricProductsCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a product
     * @param {string} uid Object UID
     * @param {GriegLyricProductsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProductsFetch(
      uid: string,
      xApCacheControl?: GriegLyricProductsFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductReadExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProductsFetch(uid, xApCacheControl, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ProductsApi.griegLyricProductsFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List products
     * @param {string} xApLang Language
     * @param {SearchProductRequest} [searchProductRequest] Product search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProductsSearch(
      xApLang: string,
      searchProductRequest?: SearchProductRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchProductResultExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProductsSearch(
        xApLang,
        searchProductRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ProductsApi.griegLyricProductsSearch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a product
     * @param {string} uid Object UID
     * @param {ProductUpdate} [productUpdate] Updated details of the
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricProductsUpdate(
      uid: string,
      productUpdate?: ProductUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricProductsUpdate(uid, productUpdate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ProductsApi.griegLyricProductsUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ProductsApiFp(configuration);
  return {
    /**
     *
     * @summary List of offerings
     * @param {string} xApLang Language
     * @param {GriegLyricOfferingsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricOfferingsList(
      xApLang: string,
      xApCacheControl?: GriegLyricOfferingsListXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<OfferingListExternal> {
      return localVarFp
        .griegLyricOfferingsList(xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new product catalogue
     * @param {ProductCatalogueCreate} [productCatalogueCreate] Details of the new product catalogue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductCataloguesCreate(
      productCatalogueCreate?: ProductCatalogueCreate,
      options?: any,
    ): AxiosPromise<ProductCatalogueWriteResponse> {
      return localVarFp
        .griegLyricProductCataloguesCreate(productCatalogueCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a product catalogue
     * @param {string} uid Object UID
     * @param {GriegLyricProductCataloguesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductCataloguesFetch(
      uid: string,
      xApCacheControl?: GriegLyricProductCataloguesFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<ProductCatalogueReadAdminExternal> {
      return localVarFp
        .griegLyricProductCataloguesFetch(uid, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a product catalogue with price resolution
     * @param {string} uid Object UID
     * @param {GriegLyricProductCataloguesFetchResolvedXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductCataloguesFetchResolved(
      uid: string,
      xApCacheControl?: GriegLyricProductCataloguesFetchResolvedXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<ProductCatalogueReadExternal> {
      return localVarFp
        .griegLyricProductCataloguesFetchResolved(uid, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List product catalogues
     * @param {string} xApLang Language
     * @param {SearchProductCatalogueRequest} [searchProductCatalogueRequest] Product catalogue search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductCataloguesSearch(
      xApLang: string,
      searchProductCatalogueRequest?: SearchProductCatalogueRequest,
      options?: any,
    ): AxiosPromise<SearchProductCatalogueResultExternal> {
      return localVarFp
        .griegLyricProductCataloguesSearch(xApLang, searchProductCatalogueRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a product catalogue
     * @param {string} uid Object UID
     * @param {ProductCatalogueUpdate} [productCatalogueUpdate] Updated details of the product catalogue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductCataloguesUpdate(
      uid: string,
      productCatalogueUpdate?: ProductCatalogueUpdate,
      options?: any,
    ): AxiosPromise<ProductCatalogueWriteResponse> {
      return localVarFp
        .griegLyricProductCataloguesUpdate(uid, productCatalogueUpdate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get the product filter values
     * @param {string} xApLang Language
     * @param {GriegLyricProductFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductFilterValuesFetch(
      xApLang: string,
      xApCacheControl?: GriegLyricProductFilterValuesFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<ProductFilterValuesExternal> {
      return localVarFp
        .griegLyricProductFilterValuesFetch(xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Product type details
     * @param {string} uid Object UID
     * @param {string} xApLang Language
     * @param {GriegLyricProductTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductTypesFetch(
      uid: string,
      xApLang: string,
      xApCacheControl?: GriegLyricProductTypesFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<ProductTypeReadExternal> {
      return localVarFp
        .griegLyricProductTypesFetch(uid, xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List of product types
     * @param {string} xApLang Language
     * @param {GriegLyricProductTypesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductTypesList(
      xApLang: string,
      xApCacheControl?: GriegLyricProductTypesListXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<ProductTypeListExternal> {
      return localVarFp
        .griegLyricProductTypesList(xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new product
     * @param {ProductCreate} [productCreate] Details of the new product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductsCreate(productCreate?: ProductCreate, options?: any): AxiosPromise<ProductWriteResponse> {
      return localVarFp.griegLyricProductsCreate(productCreate, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a product
     * @param {string} uid Object UID
     * @param {GriegLyricProductsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductsFetch(
      uid: string,
      xApCacheControl?: GriegLyricProductsFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<ProductReadExternal> {
      return localVarFp
        .griegLyricProductsFetch(uid, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List products
     * @param {string} xApLang Language
     * @param {SearchProductRequest} [searchProductRequest] Product search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductsSearch(
      xApLang: string,
      searchProductRequest?: SearchProductRequest,
      options?: any,
    ): AxiosPromise<SearchProductResultExternal> {
      return localVarFp
        .griegLyricProductsSearch(xApLang, searchProductRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a product
     * @param {string} uid Object UID
     * @param {ProductUpdate} [productUpdate] Updated details of the
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricProductsUpdate(
      uid: string,
      productUpdate?: ProductUpdate,
      options?: any,
    ): AxiosPromise<ProductWriteResponse> {
      return localVarFp
        .griegLyricProductsUpdate(uid, productUpdate, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
  /**
   *
   * @summary List of offerings
   * @param {string} xApLang Language
   * @param {GriegLyricOfferingsListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApi
   */
  public griegLyricOfferingsList(
    xApLang: string,
    xApCacheControl?: GriegLyricOfferingsListXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return ProductsApiFp(this.configuration)
      .griegLyricOfferingsList(xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new product catalogue
   * @param {ProductCatalogueCreate} [productCatalogueCreate] Details of the new product catalogue
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApi
   */
  public griegLyricProductCataloguesCreate(
    productCatalogueCreate?: ProductCatalogueCreate,
    options?: RawAxiosRequestConfig,
  ) {
    return ProductsApiFp(this.configuration)
      .griegLyricProductCataloguesCreate(productCatalogueCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a product catalogue
   * @param {string} uid Object UID
   * @param {GriegLyricProductCataloguesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApi
   */
  public griegLyricProductCataloguesFetch(
    uid: string,
    xApCacheControl?: GriegLyricProductCataloguesFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return ProductsApiFp(this.configuration)
      .griegLyricProductCataloguesFetch(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a product catalogue with price resolution
   * @param {string} uid Object UID
   * @param {GriegLyricProductCataloguesFetchResolvedXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApi
   */
  public griegLyricProductCataloguesFetchResolved(
    uid: string,
    xApCacheControl?: GriegLyricProductCataloguesFetchResolvedXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return ProductsApiFp(this.configuration)
      .griegLyricProductCataloguesFetchResolved(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List product catalogues
   * @param {string} xApLang Language
   * @param {SearchProductCatalogueRequest} [searchProductCatalogueRequest] Product catalogue search filter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApi
   */
  public griegLyricProductCataloguesSearch(
    xApLang: string,
    searchProductCatalogueRequest?: SearchProductCatalogueRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProductsApiFp(this.configuration)
      .griegLyricProductCataloguesSearch(xApLang, searchProductCatalogueRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a product catalogue
   * @param {string} uid Object UID
   * @param {ProductCatalogueUpdate} [productCatalogueUpdate] Updated details of the product catalogue
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApi
   */
  public griegLyricProductCataloguesUpdate(
    uid: string,
    productCatalogueUpdate?: ProductCatalogueUpdate,
    options?: RawAxiosRequestConfig,
  ) {
    return ProductsApiFp(this.configuration)
      .griegLyricProductCataloguesUpdate(uid, productCatalogueUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get the product filter values
   * @param {string} xApLang Language
   * @param {GriegLyricProductFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApi
   */
  public griegLyricProductFilterValuesFetch(
    xApLang: string,
    xApCacheControl?: GriegLyricProductFilterValuesFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return ProductsApiFp(this.configuration)
      .griegLyricProductFilterValuesFetch(xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Product type details
   * @param {string} uid Object UID
   * @param {string} xApLang Language
   * @param {GriegLyricProductTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApi
   */
  public griegLyricProductTypesFetch(
    uid: string,
    xApLang: string,
    xApCacheControl?: GriegLyricProductTypesFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return ProductsApiFp(this.configuration)
      .griegLyricProductTypesFetch(uid, xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List of product types
   * @param {string} xApLang Language
   * @param {GriegLyricProductTypesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApi
   */
  public griegLyricProductTypesList(
    xApLang: string,
    xApCacheControl?: GriegLyricProductTypesListXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return ProductsApiFp(this.configuration)
      .griegLyricProductTypesList(xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new product
   * @param {ProductCreate} [productCreate] Details of the new product
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApi
   */
  public griegLyricProductsCreate(productCreate?: ProductCreate, options?: RawAxiosRequestConfig) {
    return ProductsApiFp(this.configuration)
      .griegLyricProductsCreate(productCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a product
   * @param {string} uid Object UID
   * @param {GriegLyricProductsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApi
   */
  public griegLyricProductsFetch(
    uid: string,
    xApCacheControl?: GriegLyricProductsFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return ProductsApiFp(this.configuration)
      .griegLyricProductsFetch(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List products
   * @param {string} xApLang Language
   * @param {SearchProductRequest} [searchProductRequest] Product search filter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApi
   */
  public griegLyricProductsSearch(
    xApLang: string,
    searchProductRequest?: SearchProductRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ProductsApiFp(this.configuration)
      .griegLyricProductsSearch(xApLang, searchProductRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a product
   * @param {string} uid Object UID
   * @param {ProductUpdate} [productUpdate] Updated details of the
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProductsApi
   */
  public griegLyricProductsUpdate(uid: string, productUpdate?: ProductUpdate, options?: RawAxiosRequestConfig) {
    return ProductsApiFp(this.configuration)
      .griegLyricProductsUpdate(uid, productUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GriegLyricOfferingsListXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricOfferingsListXApCacheControlEnum =
  (typeof GriegLyricOfferingsListXApCacheControlEnum)[keyof typeof GriegLyricOfferingsListXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricProductCataloguesFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricProductCataloguesFetchXApCacheControlEnum =
  (typeof GriegLyricProductCataloguesFetchXApCacheControlEnum)[keyof typeof GriegLyricProductCataloguesFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricProductCataloguesFetchResolvedXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricProductCataloguesFetchResolvedXApCacheControlEnum =
  (typeof GriegLyricProductCataloguesFetchResolvedXApCacheControlEnum)[keyof typeof GriegLyricProductCataloguesFetchResolvedXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricProductFilterValuesFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricProductFilterValuesFetchXApCacheControlEnum =
  (typeof GriegLyricProductFilterValuesFetchXApCacheControlEnum)[keyof typeof GriegLyricProductFilterValuesFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricProductTypesFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricProductTypesFetchXApCacheControlEnum =
  (typeof GriegLyricProductTypesFetchXApCacheControlEnum)[keyof typeof GriegLyricProductTypesFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricProductTypesListXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricProductTypesListXApCacheControlEnum =
  (typeof GriegLyricProductTypesListXApCacheControlEnum)[keyof typeof GriegLyricProductTypesListXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricProductsFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricProductsFetchXApCacheControlEnum =
  (typeof GriegLyricProductsFetchXApCacheControlEnum)[keyof typeof GriegLyricProductsFetchXApCacheControlEnum];

/**
 * RelationshipsApi - axios parameter creator
 * @export
 */
export const RelationshipsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a new relationship
     * @param {RelationshipCreate} [relationshipCreate] Details of the new relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricRelationshipsCreate: async (
      relationshipCreate?: RelationshipCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/relationships`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(relationshipCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a relationship
     * @param {RelationshipDeleteExternal} [relationshipDeleteExternal] Details of the relationship to be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricRelationshipsDelete: async (
      relationshipDeleteExternal?: RelationshipDeleteExternal,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/relationships/delete`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        relationshipDeleteExternal,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create many new relationships
     * @param {RelationshipMultiCreate} [relationshipMultiCreate] Details of the new relationships
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricRelationshipsMultiCreate: async (
      relationshipMultiCreate?: RelationshipMultiCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/relationships-multi`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        relationshipMultiCreate,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a relationship
     * @param {RelationshipUpdate} [relationshipUpdate] Updated details of the relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricRelationshipsUpdate: async (
      relationshipUpdate?: RelationshipUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/relationships/update`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(relationshipUpdate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RelationshipsApi - functional programming interface
 * @export
 */
export const RelationshipsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RelationshipsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a new relationship
     * @param {RelationshipCreate} [relationshipCreate] Details of the new relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricRelationshipsCreate(
      relationshipCreate?: RelationshipCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelationshipWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricRelationshipsCreate(
        relationshipCreate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RelationshipsApi.griegLyricRelationshipsCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete a relationship
     * @param {RelationshipDeleteExternal} [relationshipDeleteExternal] Details of the relationship to be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricRelationshipsDelete(
      relationshipDeleteExternal?: RelationshipDeleteExternal,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricRelationshipsDelete(
        relationshipDeleteExternal,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RelationshipsApi.griegLyricRelationshipsDelete"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create many new relationships
     * @param {RelationshipMultiCreate} [relationshipMultiCreate] Details of the new relationships
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricRelationshipsMultiCreate(
      relationshipMultiCreate?: RelationshipMultiCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelationshipList>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricRelationshipsMultiCreate(
        relationshipMultiCreate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RelationshipsApi.griegLyricRelationshipsMultiCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a relationship
     * @param {RelationshipUpdate} [relationshipUpdate] Updated details of the relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricRelationshipsUpdate(
      relationshipUpdate?: RelationshipUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelationshipWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricRelationshipsUpdate(
        relationshipUpdate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RelationshipsApi.griegLyricRelationshipsUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * RelationshipsApi - factory interface
 * @export
 */
export const RelationshipsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RelationshipsApiFp(configuration);
  return {
    /**
     *
     * @summary Create a new relationship
     * @param {RelationshipCreate} [relationshipCreate] Details of the new relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricRelationshipsCreate(
      relationshipCreate?: RelationshipCreate,
      options?: any,
    ): AxiosPromise<RelationshipWriteResponse> {
      return localVarFp
        .griegLyricRelationshipsCreate(relationshipCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a relationship
     * @param {RelationshipDeleteExternal} [relationshipDeleteExternal] Details of the relationship to be deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricRelationshipsDelete(
      relationshipDeleteExternal?: RelationshipDeleteExternal,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .griegLyricRelationshipsDelete(relationshipDeleteExternal, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create many new relationships
     * @param {RelationshipMultiCreate} [relationshipMultiCreate] Details of the new relationships
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricRelationshipsMultiCreate(
      relationshipMultiCreate?: RelationshipMultiCreate,
      options?: any,
    ): AxiosPromise<RelationshipList> {
      return localVarFp
        .griegLyricRelationshipsMultiCreate(relationshipMultiCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a relationship
     * @param {RelationshipUpdate} [relationshipUpdate] Updated details of the relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricRelationshipsUpdate(
      relationshipUpdate?: RelationshipUpdate,
      options?: any,
    ): AxiosPromise<RelationshipWriteResponse> {
      return localVarFp
        .griegLyricRelationshipsUpdate(relationshipUpdate, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RelationshipsApi - object-oriented interface
 * @export
 * @class RelationshipsApi
 * @extends {BaseAPI}
 */
export class RelationshipsApi extends BaseAPI {
  /**
   *
   * @summary Create a new relationship
   * @param {RelationshipCreate} [relationshipCreate] Details of the new relationship
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RelationshipsApi
   */
  public griegLyricRelationshipsCreate(relationshipCreate?: RelationshipCreate, options?: RawAxiosRequestConfig) {
    return RelationshipsApiFp(this.configuration)
      .griegLyricRelationshipsCreate(relationshipCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete a relationship
   * @param {RelationshipDeleteExternal} [relationshipDeleteExternal] Details of the relationship to be deleted
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RelationshipsApi
   */
  public griegLyricRelationshipsDelete(
    relationshipDeleteExternal?: RelationshipDeleteExternal,
    options?: RawAxiosRequestConfig,
  ) {
    return RelationshipsApiFp(this.configuration)
      .griegLyricRelationshipsDelete(relationshipDeleteExternal, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create many new relationships
   * @param {RelationshipMultiCreate} [relationshipMultiCreate] Details of the new relationships
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RelationshipsApi
   */
  public griegLyricRelationshipsMultiCreate(
    relationshipMultiCreate?: RelationshipMultiCreate,
    options?: RawAxiosRequestConfig,
  ) {
    return RelationshipsApiFp(this.configuration)
      .griegLyricRelationshipsMultiCreate(relationshipMultiCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a relationship
   * @param {RelationshipUpdate} [relationshipUpdate] Updated details of the relationship
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RelationshipsApi
   */
  public griegLyricRelationshipsUpdate(relationshipUpdate?: RelationshipUpdate, options?: RawAxiosRequestConfig) {
    return RelationshipsApiFp(this.configuration)
      .griegLyricRelationshipsUpdate(relationshipUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ReportingApi - axios parameter creator
 * @export
 */
export const ReportingApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get performance related reporting stats
     * @param {GriegLyricPerfStatsXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {PerformanceStatsRequest} [performanceStatsRequest] Performance stats filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricPerfStats: async (
      xApCacheControl?: GriegLyricPerfStatsXApCacheControlEnum,
      performanceStatsRequest?: PerformanceStatsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/reporting/performance`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        performanceStatsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ReportingApi - functional programming interface
 * @export
 */
export const ReportingApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ReportingApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get performance related reporting stats
     * @param {GriegLyricPerfStatsXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {PerformanceStatsRequest} [performanceStatsRequest] Performance stats filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricPerfStats(
      xApCacheControl?: GriegLyricPerfStatsXApCacheControlEnum,
      performanceStatsRequest?: PerformanceStatsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PerformanceStatsInternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricPerfStats(
        xApCacheControl,
        performanceStatsRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportingApi.griegLyricPerfStats"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ReportingApi - factory interface
 * @export
 */
export const ReportingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ReportingApiFp(configuration);
  return {
    /**
     *
     * @summary Get performance related reporting stats
     * @param {GriegLyricPerfStatsXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {PerformanceStatsRequest} [performanceStatsRequest] Performance stats filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricPerfStats(
      xApCacheControl?: GriegLyricPerfStatsXApCacheControlEnum,
      performanceStatsRequest?: PerformanceStatsRequest,
      options?: any,
    ): AxiosPromise<PerformanceStatsInternal> {
      return localVarFp
        .griegLyricPerfStats(xApCacheControl, performanceStatsRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ReportingApi - object-oriented interface
 * @export
 * @class ReportingApi
 * @extends {BaseAPI}
 */
export class ReportingApi extends BaseAPI {
  /**
   *
   * @summary Get performance related reporting stats
   * @param {GriegLyricPerfStatsXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {PerformanceStatsRequest} [performanceStatsRequest] Performance stats filter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public griegLyricPerfStats(
    xApCacheControl?: GriegLyricPerfStatsXApCacheControlEnum,
    performanceStatsRequest?: PerformanceStatsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ReportingApiFp(this.configuration)
      .griegLyricPerfStats(xApCacheControl, performanceStatsRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GriegLyricPerfStatsXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricPerfStatsXApCacheControlEnum =
  (typeof GriegLyricPerfStatsXApCacheControlEnum)[keyof typeof GriegLyricPerfStatsXApCacheControlEnum];

/**
 * ShortLinksApi - axios parameter creator
 * @export
 */
export const ShortLinksApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a new short link
     * @param {ShortLinkCreate} [shortLinkCreate] Details of the new short link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricShortLinksCreate: async (
      shortLinkCreate?: ShortLinkCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/short-links`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(shortLinkCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a short link path
     * @param {string} uid Object UID
     * @param {ShortLinkUpdate} [shortLinkUpdate] Updated details of the short link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricShortLinksUpdate: async (
      uid: string,
      shortLinkUpdate?: ShortLinkUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricShortLinksUpdate", "uid", uid);
      const localVarPath = `/api/v1/short-links/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(shortLinkUpdate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ShortLinksApi - functional programming interface
 * @export
 */
export const ShortLinksApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ShortLinksApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a new short link
     * @param {ShortLinkCreate} [shortLinkCreate] Details of the new short link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricShortLinksCreate(
      shortLinkCreate?: ShortLinkCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShortLinkFetch>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricShortLinksCreate(shortLinkCreate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ShortLinksApi.griegLyricShortLinksCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a short link path
     * @param {string} uid Object UID
     * @param {ShortLinkUpdate} [shortLinkUpdate] Updated details of the short link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricShortLinksUpdate(
      uid: string,
      shortLinkUpdate?: ShortLinkUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShortLinkFetch>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricShortLinksUpdate(
        uid,
        shortLinkUpdate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ShortLinksApi.griegLyricShortLinksUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ShortLinksApi - factory interface
 * @export
 */
export const ShortLinksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ShortLinksApiFp(configuration);
  return {
    /**
     *
     * @summary Create a new short link
     * @param {ShortLinkCreate} [shortLinkCreate] Details of the new short link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricShortLinksCreate(shortLinkCreate?: ShortLinkCreate, options?: any): AxiosPromise<ShortLinkFetch> {
      return localVarFp
        .griegLyricShortLinksCreate(shortLinkCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a short link path
     * @param {string} uid Object UID
     * @param {ShortLinkUpdate} [shortLinkUpdate] Updated details of the short link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricShortLinksUpdate(
      uid: string,
      shortLinkUpdate?: ShortLinkUpdate,
      options?: any,
    ): AxiosPromise<ShortLinkFetch> {
      return localVarFp
        .griegLyricShortLinksUpdate(uid, shortLinkUpdate, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ShortLinksApi - object-oriented interface
 * @export
 * @class ShortLinksApi
 * @extends {BaseAPI}
 */
export class ShortLinksApi extends BaseAPI {
  /**
   *
   * @summary Create a new short link
   * @param {ShortLinkCreate} [shortLinkCreate] Details of the new short link
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShortLinksApi
   */
  public griegLyricShortLinksCreate(shortLinkCreate?: ShortLinkCreate, options?: RawAxiosRequestConfig) {
    return ShortLinksApiFp(this.configuration)
      .griegLyricShortLinksCreate(shortLinkCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a short link path
   * @param {string} uid Object UID
   * @param {ShortLinkUpdate} [shortLinkUpdate] Updated details of the short link
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShortLinksApi
   */
  public griegLyricShortLinksUpdate(uid: string, shortLinkUpdate?: ShortLinkUpdate, options?: RawAxiosRequestConfig) {
    return ShortLinksApiFp(this.configuration)
      .griegLyricShortLinksUpdate(uid, shortLinkUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * StaticConfigApi - axios parameter creator
 * @export
 */
export const StaticConfigApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get platform strings
     * @param {string} xApLang Language
     * @param {GriegLyricStringsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricStringsFetch: async (
      xApLang: string,
      xApCacheControl?: GriegLyricStringsFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricStringsFetch", "xApLang", xApLang);
      const localVarPath = `/api/v1/static/strings`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get details of the tenant configuration
     * @param {GriegLyricTenantFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTenantFetch: async (
      xApCacheControl?: GriegLyricTenantFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/static/tenant`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * StaticConfigApi - functional programming interface
 * @export
 */
export const StaticConfigApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = StaticConfigApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get platform strings
     * @param {string} xApLang Language
     * @param {GriegLyricStringsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricStringsFetch(
      xApLang: string,
      xApCacheControl?: GriegLyricStringsFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string }>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricStringsFetch(
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["StaticConfigApi.griegLyricStringsFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get details of the tenant configuration
     * @param {GriegLyricTenantFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTenantFetch(
      xApCacheControl?: GriegLyricTenantFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantConfig>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTenantFetch(xApCacheControl, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["StaticConfigApi.griegLyricTenantFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * StaticConfigApi - factory interface
 * @export
 */
export const StaticConfigApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = StaticConfigApiFp(configuration);
  return {
    /**
     *
     * @summary Get platform strings
     * @param {string} xApLang Language
     * @param {GriegLyricStringsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricStringsFetch(
      xApLang: string,
      xApCacheControl?: GriegLyricStringsFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<{ [key: string]: string }> {
      return localVarFp
        .griegLyricStringsFetch(xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get details of the tenant configuration
     * @param {GriegLyricTenantFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTenantFetch(
      xApCacheControl?: GriegLyricTenantFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<TenantConfig> {
      return localVarFp.griegLyricTenantFetch(xApCacheControl, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * StaticConfigApi - object-oriented interface
 * @export
 * @class StaticConfigApi
 * @extends {BaseAPI}
 */
export class StaticConfigApi extends BaseAPI {
  /**
   *
   * @summary Get platform strings
   * @param {string} xApLang Language
   * @param {GriegLyricStringsFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StaticConfigApi
   */
  public griegLyricStringsFetch(
    xApLang: string,
    xApCacheControl?: GriegLyricStringsFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return StaticConfigApiFp(this.configuration)
      .griegLyricStringsFetch(xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get details of the tenant configuration
   * @param {GriegLyricTenantFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StaticConfigApi
   */
  public griegLyricTenantFetch(
    xApCacheControl?: GriegLyricTenantFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return StaticConfigApiFp(this.configuration)
      .griegLyricTenantFetch(xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GriegLyricStringsFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricStringsFetchXApCacheControlEnum =
  (typeof GriegLyricStringsFetchXApCacheControlEnum)[keyof typeof GriegLyricStringsFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricTenantFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricTenantFetchXApCacheControlEnum =
  (typeof GriegLyricTenantFetchXApCacheControlEnum)[keyof typeof GriegLyricTenantFetchXApCacheControlEnum];

/**
 * TagsApi - axios parameter creator
 * @export
 */
export const TagsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a new tag
     * @param {TagCreate} [tagCreate] Details of the new tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTagsCreate: async (tagCreate?: TagCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tags`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(tagCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List tags
     * @param {string} xApLang Language
     * @param {SearchTagRequest} [searchTagRequest] Tag search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTagsSearch: async (
      xApLang: string,
      searchTagRequest?: SearchTagRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricTagsSearch", "xApLang", xApLang);
      const localVarPath = `/api/v1/tags/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(searchTagRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TagsApi - functional programming interface
 * @export
 */
export const TagsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TagsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a new tag
     * @param {TagCreate} [tagCreate] Details of the new tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTagsCreate(
      tagCreate?: TagCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTagsCreate(tagCreate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TagsApi.griegLyricTagsCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List tags
     * @param {string} xApLang Language
     * @param {SearchTagRequest} [searchTagRequest] Tag search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTagsSearch(
      xApLang: string,
      searchTagRequest?: SearchTagRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchTagResultExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTagsSearch(
        xApLang,
        searchTagRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TagsApi.griegLyricTagsSearch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * TagsApi - factory interface
 * @export
 */
export const TagsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = TagsApiFp(configuration);
  return {
    /**
     *
     * @summary Create a new tag
     * @param {TagCreate} [tagCreate] Details of the new tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTagsCreate(tagCreate?: TagCreate, options?: any): AxiosPromise<TagWriteResponse> {
      return localVarFp.griegLyricTagsCreate(tagCreate, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List tags
     * @param {string} xApLang Language
     * @param {SearchTagRequest} [searchTagRequest] Tag search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTagsSearch(
      xApLang: string,
      searchTagRequest?: SearchTagRequest,
      options?: any,
    ): AxiosPromise<SearchTagResultExternal> {
      return localVarFp
        .griegLyricTagsSearch(xApLang, searchTagRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TagsApi - object-oriented interface
 * @export
 * @class TagsApi
 * @extends {BaseAPI}
 */
export class TagsApi extends BaseAPI {
  /**
   *
   * @summary Create a new tag
   * @param {TagCreate} [tagCreate] Details of the new tag
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TagsApi
   */
  public griegLyricTagsCreate(tagCreate?: TagCreate, options?: RawAxiosRequestConfig) {
    return TagsApiFp(this.configuration)
      .griegLyricTagsCreate(tagCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List tags
   * @param {string} xApLang Language
   * @param {SearchTagRequest} [searchTagRequest] Tag search filter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TagsApi
   */
  public griegLyricTagsSearch(xApLang: string, searchTagRequest?: SearchTagRequest, options?: RawAxiosRequestConfig) {
    return TagsApiFp(this.configuration)
      .griegLyricTagsSearch(xApLang, searchTagRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TaskExtensionsApi - axios parameter creator
 * @export
 */
export const TaskExtensionsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Generic write to a task extension action
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} actionSlug Action Slug
     * @param {string} extensionSlug Extension Slug
     * @param {{ [key: string]: any; }} [requestBody] Generic task extension related request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskExtensionActionCreate: async (
      taskUid: string,
      activityUid: string,
      actionSlug: string,
      extensionSlug: string,
      requestBody?: { [key: string]: any },
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'taskUid' is not null or undefined
      assertParamExists("griegLyricTaskExtensionActionCreate", "taskUid", taskUid);
      // verify required parameter 'activityUid' is not null or undefined
      assertParamExists("griegLyricTaskExtensionActionCreate", "activityUid", activityUid);
      // verify required parameter 'actionSlug' is not null or undefined
      assertParamExists("griegLyricTaskExtensionActionCreate", "actionSlug", actionSlug);
      // verify required parameter 'extensionSlug' is not null or undefined
      assertParamExists("griegLyricTaskExtensionActionCreate", "extensionSlug", extensionSlug);
      const localVarPath = `/api/v1/task-extensions/{extensionSlug}/{taskUid}/{activityUid}/{actionSlug}`
        .replace(`{${"taskUid"}}`, encodeURIComponent(String(taskUid)))
        .replace(`{${"activityUid"}}`, encodeURIComponent(String(activityUid)))
        .replace(`{${"actionSlug"}}`, encodeURIComponent(String(actionSlug)))
        .replace(`{${"extensionSlug"}}`, encodeURIComponent(String(extensionSlug)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Generic read from a task extension action
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} actionSlug Action Slug
     * @param {string} extensionSlug Extension Slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskExtensionActionFetch: async (
      taskUid: string,
      activityUid: string,
      actionSlug: string,
      extensionSlug: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'taskUid' is not null or undefined
      assertParamExists("griegLyricTaskExtensionActionFetch", "taskUid", taskUid);
      // verify required parameter 'activityUid' is not null or undefined
      assertParamExists("griegLyricTaskExtensionActionFetch", "activityUid", activityUid);
      // verify required parameter 'actionSlug' is not null or undefined
      assertParamExists("griegLyricTaskExtensionActionFetch", "actionSlug", actionSlug);
      // verify required parameter 'extensionSlug' is not null or undefined
      assertParamExists("griegLyricTaskExtensionActionFetch", "extensionSlug", extensionSlug);
      const localVarPath = `/api/v1/task-extensions/{extensionSlug}/{taskUid}/{activityUid}/{actionSlug}`
        .replace(`{${"taskUid"}}`, encodeURIComponent(String(taskUid)))
        .replace(`{${"activityUid"}}`, encodeURIComponent(String(activityUid)))
        .replace(`{${"actionSlug"}}`, encodeURIComponent(String(actionSlug)))
        .replace(`{${"extensionSlug"}}`, encodeURIComponent(String(extensionSlug)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Generic write to a task extension
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} extensionSlug Extension Slug
     * @param {{ [key: string]: any; }} [requestBody] Generic task extension related request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskExtensionActivityAct: async (
      taskUid: string,
      activityUid: string,
      extensionSlug: string,
      requestBody?: { [key: string]: any },
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'taskUid' is not null or undefined
      assertParamExists("griegLyricTaskExtensionActivityAct", "taskUid", taskUid);
      // verify required parameter 'activityUid' is not null or undefined
      assertParamExists("griegLyricTaskExtensionActivityAct", "activityUid", activityUid);
      // verify required parameter 'extensionSlug' is not null or undefined
      assertParamExists("griegLyricTaskExtensionActivityAct", "extensionSlug", extensionSlug);
      const localVarPath = `/api/v1/task-extensions/{extensionSlug}/{taskUid}/{activityUid}`
        .replace(`{${"taskUid"}}`, encodeURIComponent(String(taskUid)))
        .replace(`{${"activityUid"}}`, encodeURIComponent(String(activityUid)))
        .replace(`{${"extensionSlug"}}`, encodeURIComponent(String(extensionSlug)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Generic read from a task extension
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} extensionSlug Extension Slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskExtensionActivityFetch: async (
      taskUid: string,
      activityUid: string,
      extensionSlug: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'taskUid' is not null or undefined
      assertParamExists("griegLyricTaskExtensionActivityFetch", "taskUid", taskUid);
      // verify required parameter 'activityUid' is not null or undefined
      assertParamExists("griegLyricTaskExtensionActivityFetch", "activityUid", activityUid);
      // verify required parameter 'extensionSlug' is not null or undefined
      assertParamExists("griegLyricTaskExtensionActivityFetch", "extensionSlug", extensionSlug);
      const localVarPath = `/api/v1/task-extensions/{extensionSlug}/{taskUid}/{activityUid}`
        .replace(`{${"taskUid"}}`, encodeURIComponent(String(taskUid)))
        .replace(`{${"activityUid"}}`, encodeURIComponent(String(activityUid)))
        .replace(`{${"extensionSlug"}}`, encodeURIComponent(String(extensionSlug)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Generic write to a task extension action sub-resource
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} actionSlug Action Slug
     * @param {string} subResource Action Sub Resource
     * @param {string} extensionSlug Extension Slug
     * @param {{ [key: string]: any; }} [requestBody] Generic task extension related request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskExtensionSubActionCreate: async (
      taskUid: string,
      activityUid: string,
      actionSlug: string,
      subResource: string,
      extensionSlug: string,
      requestBody?: { [key: string]: any },
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'taskUid' is not null or undefined
      assertParamExists("griegLyricTaskExtensionSubActionCreate", "taskUid", taskUid);
      // verify required parameter 'activityUid' is not null or undefined
      assertParamExists("griegLyricTaskExtensionSubActionCreate", "activityUid", activityUid);
      // verify required parameter 'actionSlug' is not null or undefined
      assertParamExists("griegLyricTaskExtensionSubActionCreate", "actionSlug", actionSlug);
      // verify required parameter 'subResource' is not null or undefined
      assertParamExists("griegLyricTaskExtensionSubActionCreate", "subResource", subResource);
      // verify required parameter 'extensionSlug' is not null or undefined
      assertParamExists("griegLyricTaskExtensionSubActionCreate", "extensionSlug", extensionSlug);
      const localVarPath = `/api/v1/task-extensions/{extensionSlug}/{taskUid}/{activityUid}/{subResource}/{actionSlug}`
        .replace(`{${"taskUid"}}`, encodeURIComponent(String(taskUid)))
        .replace(`{${"activityUid"}}`, encodeURIComponent(String(activityUid)))
        .replace(`{${"actionSlug"}}`, encodeURIComponent(String(actionSlug)))
        .replace(`{${"subResource"}}`, encodeURIComponent(String(subResource)))
        .replace(`{${"extensionSlug"}}`, encodeURIComponent(String(extensionSlug)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Generic read from a task extension action sub-resource
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} actionSlug Action Slug
     * @param {string} subResource Action Sub Resource
     * @param {string} extensionSlug Extension Slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskExtensionSubActionFetch: async (
      taskUid: string,
      activityUid: string,
      actionSlug: string,
      subResource: string,
      extensionSlug: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'taskUid' is not null or undefined
      assertParamExists("griegLyricTaskExtensionSubActionFetch", "taskUid", taskUid);
      // verify required parameter 'activityUid' is not null or undefined
      assertParamExists("griegLyricTaskExtensionSubActionFetch", "activityUid", activityUid);
      // verify required parameter 'actionSlug' is not null or undefined
      assertParamExists("griegLyricTaskExtensionSubActionFetch", "actionSlug", actionSlug);
      // verify required parameter 'subResource' is not null or undefined
      assertParamExists("griegLyricTaskExtensionSubActionFetch", "subResource", subResource);
      // verify required parameter 'extensionSlug' is not null or undefined
      assertParamExists("griegLyricTaskExtensionSubActionFetch", "extensionSlug", extensionSlug);
      const localVarPath = `/api/v1/task-extensions/{extensionSlug}/{taskUid}/{activityUid}/{subResource}/{actionSlug}`
        .replace(`{${"taskUid"}}`, encodeURIComponent(String(taskUid)))
        .replace(`{${"activityUid"}}`, encodeURIComponent(String(activityUid)))
        .replace(`{${"actionSlug"}}`, encodeURIComponent(String(actionSlug)))
        .replace(`{${"subResource"}}`, encodeURIComponent(String(subResource)))
        .replace(`{${"extensionSlug"}}`, encodeURIComponent(String(extensionSlug)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TaskExtensionsApi - functional programming interface
 * @export
 */
export const TaskExtensionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TaskExtensionsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Generic write to a task extension action
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} actionSlug Action Slug
     * @param {string} extensionSlug Extension Slug
     * @param {{ [key: string]: any; }} [requestBody] Generic task extension related request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskExtensionActionCreate(
      taskUid: string,
      activityUid: string,
      actionSlug: string,
      extensionSlug: string,
      requestBody?: { [key: string]: any },
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any }>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskExtensionActionCreate(
        taskUid,
        activityUid,
        actionSlug,
        extensionSlug,
        requestBody,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TaskExtensionsApi.griegLyricTaskExtensionActionCreate"]?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Generic read from a task extension action
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} actionSlug Action Slug
     * @param {string} extensionSlug Extension Slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskExtensionActionFetch(
      taskUid: string,
      activityUid: string,
      actionSlug: string,
      extensionSlug: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any }>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskExtensionActionFetch(
        taskUid,
        activityUid,
        actionSlug,
        extensionSlug,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TaskExtensionsApi.griegLyricTaskExtensionActionFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Generic write to a task extension
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} extensionSlug Extension Slug
     * @param {{ [key: string]: any; }} [requestBody] Generic task extension related request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskExtensionActivityAct(
      taskUid: string,
      activityUid: string,
      extensionSlug: string,
      requestBody?: { [key: string]: any },
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any }>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskExtensionActivityAct(
        taskUid,
        activityUid,
        extensionSlug,
        requestBody,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TaskExtensionsApi.griegLyricTaskExtensionActivityAct"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Generic read from a task extension
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} extensionSlug Extension Slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskExtensionActivityFetch(
      taskUid: string,
      activityUid: string,
      extensionSlug: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any }>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskExtensionActivityFetch(
        taskUid,
        activityUid,
        extensionSlug,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TaskExtensionsApi.griegLyricTaskExtensionActivityFetch"]?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Generic write to a task extension action sub-resource
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} actionSlug Action Slug
     * @param {string} subResource Action Sub Resource
     * @param {string} extensionSlug Extension Slug
     * @param {{ [key: string]: any; }} [requestBody] Generic task extension related request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskExtensionSubActionCreate(
      taskUid: string,
      activityUid: string,
      actionSlug: string,
      subResource: string,
      extensionSlug: string,
      requestBody?: { [key: string]: any },
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any }>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskExtensionSubActionCreate(
        taskUid,
        activityUid,
        actionSlug,
        subResource,
        extensionSlug,
        requestBody,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TaskExtensionsApi.griegLyricTaskExtensionSubActionCreate"]?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Generic read from a task extension action sub-resource
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} actionSlug Action Slug
     * @param {string} subResource Action Sub Resource
     * @param {string} extensionSlug Extension Slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskExtensionSubActionFetch(
      taskUid: string,
      activityUid: string,
      actionSlug: string,
      subResource: string,
      extensionSlug: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any }>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskExtensionSubActionFetch(
        taskUid,
        activityUid,
        actionSlug,
        subResource,
        extensionSlug,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TaskExtensionsApi.griegLyricTaskExtensionSubActionFetch"]?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * TaskExtensionsApi - factory interface
 * @export
 */
export const TaskExtensionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = TaskExtensionsApiFp(configuration);
  return {
    /**
     *
     * @summary Generic write to a task extension action
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} actionSlug Action Slug
     * @param {string} extensionSlug Extension Slug
     * @param {{ [key: string]: any; }} [requestBody] Generic task extension related request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskExtensionActionCreate(
      taskUid: string,
      activityUid: string,
      actionSlug: string,
      extensionSlug: string,
      requestBody?: { [key: string]: any },
      options?: any,
    ): AxiosPromise<{ [key: string]: any }> {
      return localVarFp
        .griegLyricTaskExtensionActionCreate(taskUid, activityUid, actionSlug, extensionSlug, requestBody, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Generic read from a task extension action
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} actionSlug Action Slug
     * @param {string} extensionSlug Extension Slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskExtensionActionFetch(
      taskUid: string,
      activityUid: string,
      actionSlug: string,
      extensionSlug: string,
      options?: any,
    ): AxiosPromise<{ [key: string]: any }> {
      return localVarFp
        .griegLyricTaskExtensionActionFetch(taskUid, activityUid, actionSlug, extensionSlug, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Generic write to a task extension
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} extensionSlug Extension Slug
     * @param {{ [key: string]: any; }} [requestBody] Generic task extension related request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskExtensionActivityAct(
      taskUid: string,
      activityUid: string,
      extensionSlug: string,
      requestBody?: { [key: string]: any },
      options?: any,
    ): AxiosPromise<{ [key: string]: any }> {
      return localVarFp
        .griegLyricTaskExtensionActivityAct(taskUid, activityUid, extensionSlug, requestBody, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Generic read from a task extension
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} extensionSlug Extension Slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskExtensionActivityFetch(
      taskUid: string,
      activityUid: string,
      extensionSlug: string,
      options?: any,
    ): AxiosPromise<{ [key: string]: any }> {
      return localVarFp
        .griegLyricTaskExtensionActivityFetch(taskUid, activityUid, extensionSlug, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Generic write to a task extension action sub-resource
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} actionSlug Action Slug
     * @param {string} subResource Action Sub Resource
     * @param {string} extensionSlug Extension Slug
     * @param {{ [key: string]: any; }} [requestBody] Generic task extension related request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskExtensionSubActionCreate(
      taskUid: string,
      activityUid: string,
      actionSlug: string,
      subResource: string,
      extensionSlug: string,
      requestBody?: { [key: string]: any },
      options?: any,
    ): AxiosPromise<{ [key: string]: any }> {
      return localVarFp
        .griegLyricTaskExtensionSubActionCreate(
          taskUid,
          activityUid,
          actionSlug,
          subResource,
          extensionSlug,
          requestBody,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Generic read from a task extension action sub-resource
     * @param {string} taskUid Task UID
     * @param {string} activityUid Activity UID
     * @param {string} actionSlug Action Slug
     * @param {string} subResource Action Sub Resource
     * @param {string} extensionSlug Extension Slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskExtensionSubActionFetch(
      taskUid: string,
      activityUid: string,
      actionSlug: string,
      subResource: string,
      extensionSlug: string,
      options?: any,
    ): AxiosPromise<{ [key: string]: any }> {
      return localVarFp
        .griegLyricTaskExtensionSubActionFetch(taskUid, activityUid, actionSlug, subResource, extensionSlug, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TaskExtensionsApi - object-oriented interface
 * @export
 * @class TaskExtensionsApi
 * @extends {BaseAPI}
 */
export class TaskExtensionsApi extends BaseAPI {
  /**
   *
   * @summary Generic write to a task extension action
   * @param {string} taskUid Task UID
   * @param {string} activityUid Activity UID
   * @param {string} actionSlug Action Slug
   * @param {string} extensionSlug Extension Slug
   * @param {{ [key: string]: any; }} [requestBody] Generic task extension related request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaskExtensionsApi
   */
  public griegLyricTaskExtensionActionCreate(
    taskUid: string,
    activityUid: string,
    actionSlug: string,
    extensionSlug: string,
    requestBody?: { [key: string]: any },
    options?: RawAxiosRequestConfig,
  ) {
    return TaskExtensionsApiFp(this.configuration)
      .griegLyricTaskExtensionActionCreate(taskUid, activityUid, actionSlug, extensionSlug, requestBody, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Generic read from a task extension action
   * @param {string} taskUid Task UID
   * @param {string} activityUid Activity UID
   * @param {string} actionSlug Action Slug
   * @param {string} extensionSlug Extension Slug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaskExtensionsApi
   */
  public griegLyricTaskExtensionActionFetch(
    taskUid: string,
    activityUid: string,
    actionSlug: string,
    extensionSlug: string,
    options?: RawAxiosRequestConfig,
  ) {
    return TaskExtensionsApiFp(this.configuration)
      .griegLyricTaskExtensionActionFetch(taskUid, activityUid, actionSlug, extensionSlug, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Generic write to a task extension
   * @param {string} taskUid Task UID
   * @param {string} activityUid Activity UID
   * @param {string} extensionSlug Extension Slug
   * @param {{ [key: string]: any; }} [requestBody] Generic task extension related request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaskExtensionsApi
   */
  public griegLyricTaskExtensionActivityAct(
    taskUid: string,
    activityUid: string,
    extensionSlug: string,
    requestBody?: { [key: string]: any },
    options?: RawAxiosRequestConfig,
  ) {
    return TaskExtensionsApiFp(this.configuration)
      .griegLyricTaskExtensionActivityAct(taskUid, activityUid, extensionSlug, requestBody, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Generic read from a task extension
   * @param {string} taskUid Task UID
   * @param {string} activityUid Activity UID
   * @param {string} extensionSlug Extension Slug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaskExtensionsApi
   */
  public griegLyricTaskExtensionActivityFetch(
    taskUid: string,
    activityUid: string,
    extensionSlug: string,
    options?: RawAxiosRequestConfig,
  ) {
    return TaskExtensionsApiFp(this.configuration)
      .griegLyricTaskExtensionActivityFetch(taskUid, activityUid, extensionSlug, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Generic write to a task extension action sub-resource
   * @param {string} taskUid Task UID
   * @param {string} activityUid Activity UID
   * @param {string} actionSlug Action Slug
   * @param {string} subResource Action Sub Resource
   * @param {string} extensionSlug Extension Slug
   * @param {{ [key: string]: any; }} [requestBody] Generic task extension related request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaskExtensionsApi
   */
  public griegLyricTaskExtensionSubActionCreate(
    taskUid: string,
    activityUid: string,
    actionSlug: string,
    subResource: string,
    extensionSlug: string,
    requestBody?: { [key: string]: any },
    options?: RawAxiosRequestConfig,
  ) {
    return TaskExtensionsApiFp(this.configuration)
      .griegLyricTaskExtensionSubActionCreate(
        taskUid,
        activityUid,
        actionSlug,
        subResource,
        extensionSlug,
        requestBody,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Generic read from a task extension action sub-resource
   * @param {string} taskUid Task UID
   * @param {string} activityUid Activity UID
   * @param {string} actionSlug Action Slug
   * @param {string} subResource Action Sub Resource
   * @param {string} extensionSlug Extension Slug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TaskExtensionsApi
   */
  public griegLyricTaskExtensionSubActionFetch(
    taskUid: string,
    activityUid: string,
    actionSlug: string,
    subResource: string,
    extensionSlug: string,
    options?: RawAxiosRequestConfig,
  ) {
    return TaskExtensionsApiFp(this.configuration)
      .griegLyricTaskExtensionSubActionFetch(taskUid, activityUid, actionSlug, subResource, extensionSlug, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TasksApi - axios parameter creator
 * @export
 */
export const TasksApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Add an optional activity to a task
     * @param {TaskActivityCreate} [taskActivityCreate] Details of the new task activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskActivitiesCreate: async (
      taskActivityCreate?: TaskActivityCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/task-activities`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(taskActivityCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update the status of a task activity
     * @param {string} uid Object UID
     * @param {TaskActivityUpdateExternal} [taskActivityUpdateExternal] Updated details of the task activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskActivitiesUpdate: async (
      uid: string,
      taskActivityUpdateExternal?: TaskActivityUpdateExternal,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricTaskActivitiesUpdate", "uid", uid);
      const localVarPath = `/api/v1/task-activities/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        taskActivityUpdateExternal,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get the task filter values
     * @param {string} xApLang Language
     * @param {GriegLyricTaskFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskFilterValuesFetch: async (
      xApLang: string,
      xApCacheControl?: GriegLyricTaskFilterValuesFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricTaskFilterValuesFetch", "xApLang", xApLang);
      const localVarPath = `/api/v1/task-filter-values`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new task note
     * @param {TaskNoteCreate} [taskNoteCreate] Details of the new task note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskNotesCreate: async (
      taskNoteCreate?: TaskNoteCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/task-notes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(taskNoteCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a task note
     * @param {string} uid Object UID
     * @param {TaskNoteUpdate} [taskNoteUpdate] Updated details of the task note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskNotesUpdate: async (
      uid: string,
      taskNoteUpdate?: TaskNoteUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricTaskNotesUpdate", "uid", uid);
      const localVarPath = `/api/v1/task-notes/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(taskNoteUpdate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a task type
     * @param {string} uid Object UID
     * @param {string} xApLang Language
     * @param {GriegLyricTaskTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskTypesFetch: async (
      uid: string,
      xApLang: string,
      xApCacheControl?: GriegLyricTaskTypesFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricTaskTypesFetch", "uid", uid);
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricTaskTypesFetch", "xApLang", xApLang);
      const localVarPath = `/api/v1/task-types/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List of task types
     * @param {string} xApLang Language
     * @param {GriegLyricTaskTypesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskTypesList: async (
      xApLang: string,
      xApCacheControl?: GriegLyricTaskTypesListXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricTaskTypesList", "xApLang", xApLang);
      const localVarPath = `/api/v1/task-types`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Change a task type
     * @param {string} uid Object UID
     * @param {GriegLyricTasksChangeTaskTypeXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {TaskChangeTaskType} [taskChangeTaskType] Change a task type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksChangeTaskType: async (
      uid: string,
      xApCacheControl?: GriegLyricTasksChangeTaskTypeXApCacheControlEnum,
      taskChangeTaskType?: TaskChangeTaskType,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricTasksChangeTaskType", "uid", uid);
      const localVarPath = `/api/v1/tasks/{uid}/change-task-type`.replace(
        `{${"uid"}}`,
        encodeURIComponent(String(uid)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(taskChangeTaskType, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new task
     * @param {TaskCreate} [taskCreate] Details of the new task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksCreate: async (
      taskCreate?: TaskCreate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tasks`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(taskCreate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a task
     * @param {string} uid Object UID
     * @param {GriegLyricTasksFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksFetch: async (
      uid: string,
      xApCacheControl?: GriegLyricTasksFetchXApCacheControlEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricTasksFetch", "uid", uid);
      const localVarPath = `/api/v1/tasks/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApCacheControl != null) {
        localVarHeaderParameter["x-ap-cache-control"] = String(xApCacheControl);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Search for tasks
     * @param {string} xApLang Language
     * @param {SearchTaskRequest} [searchTaskRequest] Task search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksSearch: async (
      xApLang: string,
      searchTaskRequest?: SearchTaskRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xApLang' is not null or undefined
      assertParamExists("griegLyricTasksSearch", "xApLang", xApLang);
      const localVarPath = `/api/v1/tasks/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (xApLang != null) {
        localVarHeaderParameter["x-ap-lang"] = String(xApLang);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(searchTaskRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a task
     * @param {string} uid Object UID
     * @param {TaskUpdate} [taskUpdate] Updated details of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksUpdate: async (
      uid: string,
      taskUpdate?: TaskUpdate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'uid' is not null or undefined
      assertParamExists("griegLyricTasksUpdate", "uid", uid);
      const localVarPath = `/api/v1/tasks/{uid}`.replace(`{${"uid"}}`, encodeURIComponent(String(uid)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(taskUpdate, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a tasks assignee
     * @param {TaskUpdateAssignee} [taskUpdateAssignee] Updated assignee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksUpdateAssignee: async (
      taskUpdateAssignee?: TaskUpdateAssignee,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/task-assignee`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(taskUpdateAssignee, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a tasks initiator
     * @param {TaskUpdateInitiator} [taskUpdateInitiator] Updated status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksUpdateInitiator: async (
      taskUpdateInitiator?: TaskUpdateInitiator,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/task-initiator`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(taskUpdateInitiator, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a tasks assignee
     * @param {TaskUpdatePrincipalAsset} [taskUpdatePrincipalAsset] Updated principal asset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksUpdatePrincipalAsset: async (
      taskUpdatePrincipalAsset?: TaskUpdatePrincipalAsset,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/task-principal-asset`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        taskUpdatePrincipalAsset,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TasksApi - functional programming interface
 * @export
 */
export const TasksApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TasksApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Add an optional activity to a task
     * @param {TaskActivityCreate} [taskActivityCreate] Details of the new task activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskActivitiesCreate(
      taskActivityCreate?: TaskActivityCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskActivityWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskActivitiesCreate(
        taskActivityCreate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TasksApi.griegLyricTaskActivitiesCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update the status of a task activity
     * @param {string} uid Object UID
     * @param {TaskActivityUpdateExternal} [taskActivityUpdateExternal] Updated details of the task activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskActivitiesUpdate(
      uid: string,
      taskActivityUpdateExternal?: TaskActivityUpdateExternal,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskActivityWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskActivitiesUpdate(
        uid,
        taskActivityUpdateExternal,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TasksApi.griegLyricTaskActivitiesUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get the task filter values
     * @param {string} xApLang Language
     * @param {GriegLyricTaskFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskFilterValuesFetch(
      xApLang: string,
      xApCacheControl?: GriegLyricTaskFilterValuesFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskFilterValuesExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskFilterValuesFetch(
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TasksApi.griegLyricTaskFilterValuesFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new task note
     * @param {TaskNoteCreate} [taskNoteCreate] Details of the new task note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskNotesCreate(
      taskNoteCreate?: TaskNoteCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskNoteWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskNotesCreate(taskNoteCreate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TasksApi.griegLyricTaskNotesCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a task note
     * @param {string} uid Object UID
     * @param {TaskNoteUpdate} [taskNoteUpdate] Updated details of the task note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskNotesUpdate(
      uid: string,
      taskNoteUpdate?: TaskNoteUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskNoteWriteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskNotesUpdate(uid, taskNoteUpdate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TasksApi.griegLyricTaskNotesUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a task type
     * @param {string} uid Object UID
     * @param {string} xApLang Language
     * @param {GriegLyricTaskTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskTypesFetch(
      uid: string,
      xApLang: string,
      xApCacheControl?: GriegLyricTaskTypesFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskTypeReadExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskTypesFetch(
        uid,
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TasksApi.griegLyricTaskTypesFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary List of task types
     * @param {string} xApLang Language
     * @param {GriegLyricTaskTypesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTaskTypesList(
      xApLang: string,
      xApCacheControl?: GriegLyricTaskTypesListXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskTypeGroupListExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTaskTypesList(
        xApLang,
        xApCacheControl,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TasksApi.griegLyricTaskTypesList"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Change a task type
     * @param {string} uid Object UID
     * @param {GriegLyricTasksChangeTaskTypeXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {TaskChangeTaskType} [taskChangeTaskType] Change a task type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTasksChangeTaskType(
      uid: string,
      xApCacheControl?: GriegLyricTasksChangeTaskTypeXApCacheControlEnum,
      taskChangeTaskType?: TaskChangeTaskType,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskWriteResponseExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTasksChangeTaskType(
        uid,
        xApCacheControl,
        taskChangeTaskType,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TasksApi.griegLyricTasksChangeTaskType"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new task
     * @param {TaskCreate} [taskCreate] Details of the new task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTasksCreate(
      taskCreate?: TaskCreate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskWriteResponseExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTasksCreate(taskCreate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TasksApi.griegLyricTasksCreate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a task
     * @param {string} uid Object UID
     * @param {GriegLyricTasksFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTasksFetch(
      uid: string,
      xApCacheControl?: GriegLyricTasksFetchXApCacheControlEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskFull>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTasksFetch(uid, xApCacheControl, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TasksApi.griegLyricTasksFetch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Search for tasks
     * @param {string} xApLang Language
     * @param {SearchTaskRequest} [searchTaskRequest] Task search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTasksSearch(
      xApLang: string,
      searchTaskRequest?: SearchTaskRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchTaskResultExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTasksSearch(
        xApLang,
        searchTaskRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TasksApi.griegLyricTasksSearch"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a task
     * @param {string} uid Object UID
     * @param {TaskUpdate} [taskUpdate] Updated details of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTasksUpdate(
      uid: string,
      taskUpdate?: TaskUpdate,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskWriteResponseExternal>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTasksUpdate(uid, taskUpdate, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TasksApi.griegLyricTasksUpdate"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a tasks assignee
     * @param {TaskUpdateAssignee} [taskUpdateAssignee] Updated assignee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTasksUpdateAssignee(
      taskUpdateAssignee?: TaskUpdateAssignee,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTasksUpdateAssignee(
        taskUpdateAssignee,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TasksApi.griegLyricTasksUpdateAssignee"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a tasks initiator
     * @param {TaskUpdateInitiator} [taskUpdateInitiator] Updated status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTasksUpdateInitiator(
      taskUpdateInitiator?: TaskUpdateInitiator,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTasksUpdateInitiator(
        taskUpdateInitiator,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TasksApi.griegLyricTasksUpdateInitiator"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a tasks assignee
     * @param {TaskUpdatePrincipalAsset} [taskUpdatePrincipalAsset] Updated principal asset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async griegLyricTasksUpdatePrincipalAsset(
      taskUpdatePrincipalAsset?: TaskUpdatePrincipalAsset,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.griegLyricTasksUpdatePrincipalAsset(
        taskUpdatePrincipalAsset,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["TasksApi.griegLyricTasksUpdatePrincipalAsset"]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * TasksApi - factory interface
 * @export
 */
export const TasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = TasksApiFp(configuration);
  return {
    /**
     *
     * @summary Add an optional activity to a task
     * @param {TaskActivityCreate} [taskActivityCreate] Details of the new task activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskActivitiesCreate(
      taskActivityCreate?: TaskActivityCreate,
      options?: any,
    ): AxiosPromise<TaskActivityWriteResponse> {
      return localVarFp
        .griegLyricTaskActivitiesCreate(taskActivityCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update the status of a task activity
     * @param {string} uid Object UID
     * @param {TaskActivityUpdateExternal} [taskActivityUpdateExternal] Updated details of the task activity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskActivitiesUpdate(
      uid: string,
      taskActivityUpdateExternal?: TaskActivityUpdateExternal,
      options?: any,
    ): AxiosPromise<TaskActivityWriteResponse> {
      return localVarFp
        .griegLyricTaskActivitiesUpdate(uid, taskActivityUpdateExternal, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get the task filter values
     * @param {string} xApLang Language
     * @param {GriegLyricTaskFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskFilterValuesFetch(
      xApLang: string,
      xApCacheControl?: GriegLyricTaskFilterValuesFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<TaskFilterValuesExternal> {
      return localVarFp
        .griegLyricTaskFilterValuesFetch(xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new task note
     * @param {TaskNoteCreate} [taskNoteCreate] Details of the new task note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskNotesCreate(taskNoteCreate?: TaskNoteCreate, options?: any): AxiosPromise<TaskNoteWriteResponse> {
      return localVarFp.griegLyricTaskNotesCreate(taskNoteCreate, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a task note
     * @param {string} uid Object UID
     * @param {TaskNoteUpdate} [taskNoteUpdate] Updated details of the task note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskNotesUpdate(
      uid: string,
      taskNoteUpdate?: TaskNoteUpdate,
      options?: any,
    ): AxiosPromise<TaskNoteWriteResponse> {
      return localVarFp
        .griegLyricTaskNotesUpdate(uid, taskNoteUpdate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a task type
     * @param {string} uid Object UID
     * @param {string} xApLang Language
     * @param {GriegLyricTaskTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskTypesFetch(
      uid: string,
      xApLang: string,
      xApCacheControl?: GriegLyricTaskTypesFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<TaskTypeReadExternal> {
      return localVarFp
        .griegLyricTaskTypesFetch(uid, xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List of task types
     * @param {string} xApLang Language
     * @param {GriegLyricTaskTypesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTaskTypesList(
      xApLang: string,
      xApCacheControl?: GriegLyricTaskTypesListXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<TaskTypeGroupListExternal> {
      return localVarFp
        .griegLyricTaskTypesList(xApLang, xApCacheControl, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Change a task type
     * @param {string} uid Object UID
     * @param {GriegLyricTasksChangeTaskTypeXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {TaskChangeTaskType} [taskChangeTaskType] Change a task type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksChangeTaskType(
      uid: string,
      xApCacheControl?: GriegLyricTasksChangeTaskTypeXApCacheControlEnum,
      taskChangeTaskType?: TaskChangeTaskType,
      options?: any,
    ): AxiosPromise<TaskWriteResponseExternal> {
      return localVarFp
        .griegLyricTasksChangeTaskType(uid, xApCacheControl, taskChangeTaskType, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new task
     * @param {TaskCreate} [taskCreate] Details of the new task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksCreate(taskCreate?: TaskCreate, options?: any): AxiosPromise<TaskWriteResponseExternal> {
      return localVarFp.griegLyricTasksCreate(taskCreate, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a task
     * @param {string} uid Object UID
     * @param {GriegLyricTasksFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksFetch(
      uid: string,
      xApCacheControl?: GriegLyricTasksFetchXApCacheControlEnum,
      options?: any,
    ): AxiosPromise<TaskFull> {
      return localVarFp.griegLyricTasksFetch(uid, xApCacheControl, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Search for tasks
     * @param {string} xApLang Language
     * @param {SearchTaskRequest} [searchTaskRequest] Task search filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksSearch(
      xApLang: string,
      searchTaskRequest?: SearchTaskRequest,
      options?: any,
    ): AxiosPromise<SearchTaskResultExternal> {
      return localVarFp
        .griegLyricTasksSearch(xApLang, searchTaskRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a task
     * @param {string} uid Object UID
     * @param {TaskUpdate} [taskUpdate] Updated details of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksUpdate(
      uid: string,
      taskUpdate?: TaskUpdate,
      options?: any,
    ): AxiosPromise<TaskWriteResponseExternal> {
      return localVarFp.griegLyricTasksUpdate(uid, taskUpdate, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a tasks assignee
     * @param {TaskUpdateAssignee} [taskUpdateAssignee] Updated assignee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksUpdateAssignee(taskUpdateAssignee?: TaskUpdateAssignee, options?: any): AxiosPromise<ErrorModel> {
      return localVarFp
        .griegLyricTasksUpdateAssignee(taskUpdateAssignee, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a tasks initiator
     * @param {TaskUpdateInitiator} [taskUpdateInitiator] Updated status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksUpdateInitiator(taskUpdateInitiator?: TaskUpdateInitiator, options?: any): AxiosPromise<ErrorModel> {
      return localVarFp
        .griegLyricTasksUpdateInitiator(taskUpdateInitiator, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a tasks assignee
     * @param {TaskUpdatePrincipalAsset} [taskUpdatePrincipalAsset] Updated principal asset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    griegLyricTasksUpdatePrincipalAsset(
      taskUpdatePrincipalAsset?: TaskUpdatePrincipalAsset,
      options?: any,
    ): AxiosPromise<ErrorModel> {
      return localVarFp
        .griegLyricTasksUpdatePrincipalAsset(taskUpdatePrincipalAsset, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TasksApi - object-oriented interface
 * @export
 * @class TasksApi
 * @extends {BaseAPI}
 */
export class TasksApi extends BaseAPI {
  /**
   *
   * @summary Add an optional activity to a task
   * @param {TaskActivityCreate} [taskActivityCreate] Details of the new task activity
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public griegLyricTaskActivitiesCreate(taskActivityCreate?: TaskActivityCreate, options?: RawAxiosRequestConfig) {
    return TasksApiFp(this.configuration)
      .griegLyricTaskActivitiesCreate(taskActivityCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update the status of a task activity
   * @param {string} uid Object UID
   * @param {TaskActivityUpdateExternal} [taskActivityUpdateExternal] Updated details of the task activity
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public griegLyricTaskActivitiesUpdate(
    uid: string,
    taskActivityUpdateExternal?: TaskActivityUpdateExternal,
    options?: RawAxiosRequestConfig,
  ) {
    return TasksApiFp(this.configuration)
      .griegLyricTaskActivitiesUpdate(uid, taskActivityUpdateExternal, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get the task filter values
   * @param {string} xApLang Language
   * @param {GriegLyricTaskFilterValuesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public griegLyricTaskFilterValuesFetch(
    xApLang: string,
    xApCacheControl?: GriegLyricTaskFilterValuesFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return TasksApiFp(this.configuration)
      .griegLyricTaskFilterValuesFetch(xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new task note
   * @param {TaskNoteCreate} [taskNoteCreate] Details of the new task note
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public griegLyricTaskNotesCreate(taskNoteCreate?: TaskNoteCreate, options?: RawAxiosRequestConfig) {
    return TasksApiFp(this.configuration)
      .griegLyricTaskNotesCreate(taskNoteCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a task note
   * @param {string} uid Object UID
   * @param {TaskNoteUpdate} [taskNoteUpdate] Updated details of the task note
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public griegLyricTaskNotesUpdate(uid: string, taskNoteUpdate?: TaskNoteUpdate, options?: RawAxiosRequestConfig) {
    return TasksApiFp(this.configuration)
      .griegLyricTaskNotesUpdate(uid, taskNoteUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a task type
   * @param {string} uid Object UID
   * @param {string} xApLang Language
   * @param {GriegLyricTaskTypesFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public griegLyricTaskTypesFetch(
    uid: string,
    xApLang: string,
    xApCacheControl?: GriegLyricTaskTypesFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return TasksApiFp(this.configuration)
      .griegLyricTaskTypesFetch(uid, xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List of task types
   * @param {string} xApLang Language
   * @param {GriegLyricTaskTypesListXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public griegLyricTaskTypesList(
    xApLang: string,
    xApCacheControl?: GriegLyricTaskTypesListXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return TasksApiFp(this.configuration)
      .griegLyricTaskTypesList(xApLang, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Change a task type
   * @param {string} uid Object UID
   * @param {GriegLyricTasksChangeTaskTypeXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {TaskChangeTaskType} [taskChangeTaskType] Change a task type
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public griegLyricTasksChangeTaskType(
    uid: string,
    xApCacheControl?: GriegLyricTasksChangeTaskTypeXApCacheControlEnum,
    taskChangeTaskType?: TaskChangeTaskType,
    options?: RawAxiosRequestConfig,
  ) {
    return TasksApiFp(this.configuration)
      .griegLyricTasksChangeTaskType(uid, xApCacheControl, taskChangeTaskType, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new task
   * @param {TaskCreate} [taskCreate] Details of the new task
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public griegLyricTasksCreate(taskCreate?: TaskCreate, options?: RawAxiosRequestConfig) {
    return TasksApiFp(this.configuration)
      .griegLyricTasksCreate(taskCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a task
   * @param {string} uid Object UID
   * @param {GriegLyricTasksFetchXApCacheControlEnum} [xApCacheControl] Bypass Grieg cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public griegLyricTasksFetch(
    uid: string,
    xApCacheControl?: GriegLyricTasksFetchXApCacheControlEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return TasksApiFp(this.configuration)
      .griegLyricTasksFetch(uid, xApCacheControl, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Search for tasks
   * @param {string} xApLang Language
   * @param {SearchTaskRequest} [searchTaskRequest] Task search filter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public griegLyricTasksSearch(
    xApLang: string,
    searchTaskRequest?: SearchTaskRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return TasksApiFp(this.configuration)
      .griegLyricTasksSearch(xApLang, searchTaskRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a task
   * @param {string} uid Object UID
   * @param {TaskUpdate} [taskUpdate] Updated details of the task
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public griegLyricTasksUpdate(uid: string, taskUpdate?: TaskUpdate, options?: RawAxiosRequestConfig) {
    return TasksApiFp(this.configuration)
      .griegLyricTasksUpdate(uid, taskUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a tasks assignee
   * @param {TaskUpdateAssignee} [taskUpdateAssignee] Updated assignee
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public griegLyricTasksUpdateAssignee(taskUpdateAssignee?: TaskUpdateAssignee, options?: RawAxiosRequestConfig) {
    return TasksApiFp(this.configuration)
      .griegLyricTasksUpdateAssignee(taskUpdateAssignee, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a tasks initiator
   * @param {TaskUpdateInitiator} [taskUpdateInitiator] Updated status
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public griegLyricTasksUpdateInitiator(taskUpdateInitiator?: TaskUpdateInitiator, options?: RawAxiosRequestConfig) {
    return TasksApiFp(this.configuration)
      .griegLyricTasksUpdateInitiator(taskUpdateInitiator, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a tasks assignee
   * @param {TaskUpdatePrincipalAsset} [taskUpdatePrincipalAsset] Updated principal asset
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TasksApi
   */
  public griegLyricTasksUpdatePrincipalAsset(
    taskUpdatePrincipalAsset?: TaskUpdatePrincipalAsset,
    options?: RawAxiosRequestConfig,
  ) {
    return TasksApiFp(this.configuration)
      .griegLyricTasksUpdatePrincipalAsset(taskUpdatePrincipalAsset, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const GriegLyricTaskFilterValuesFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricTaskFilterValuesFetchXApCacheControlEnum =
  (typeof GriegLyricTaskFilterValuesFetchXApCacheControlEnum)[keyof typeof GriegLyricTaskFilterValuesFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricTaskTypesFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricTaskTypesFetchXApCacheControlEnum =
  (typeof GriegLyricTaskTypesFetchXApCacheControlEnum)[keyof typeof GriegLyricTaskTypesFetchXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricTaskTypesListXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricTaskTypesListXApCacheControlEnum =
  (typeof GriegLyricTaskTypesListXApCacheControlEnum)[keyof typeof GriegLyricTaskTypesListXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricTasksChangeTaskTypeXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricTasksChangeTaskTypeXApCacheControlEnum =
  (typeof GriegLyricTasksChangeTaskTypeXApCacheControlEnum)[keyof typeof GriegLyricTasksChangeTaskTypeXApCacheControlEnum];
/**
 * @export
 */
export const GriegLyricTasksFetchXApCacheControlEnum = {
  Bypass: "BYPASS",
} as const;
export type GriegLyricTasksFetchXApCacheControlEnum =
  (typeof GriegLyricTasksFetchXApCacheControlEnum)[keyof typeof GriegLyricTasksFetchXApCacheControlEnum];
